//#region
import jan_27_21 from "../images/assets/news/ReadyfortheNewNormal.jpg";
import jan_14_21 from "../images/assets/news/makar-sankranti.png";
import dec_06_20 from "../images/assets/news/geetachanting.jpg";
import nov_29_20 from "../images/assets/news/seniorfelicitation.png";
import nov_29_20_2 from "../images/assets/news/primaryfelicitation.png";
import oct_02_20 from "../images/assets/news/hindidiwas.jpg";
import sept_14_20 from "../images/assets/news/hindidiwas2.jpg";
import aug_15_20 from "../images/assets/news/independenceday2020.jpg";
import aug_15_20_2 from "../images/assets/news/independenceday2020_2.jpg";
import aug_03_20 from "../images/assets/news/devotionfaith.jpg";
import july_05_20 from "../images/assets/news/gurupurnima.jpg";
import may_08_20 from "../images/assets/news/foundersday.jpg";
// const july_08_21 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews4.jpeg";
import geetajayanti1 from "../images/assets/news/geetajayanti/geetajayanti1.jpg";
import geetajayanti2 from "../images/assets/news/geetajayanti/geetajayanti2.jpg";
import geetajayanti3 from "../images/assets/news/geetajayanti/geetajayanti3.jpg";
import geetajayanti4 from "../images/assets/news/geetajayanti/geetajayanti4.jpg";
import geetajayanti5 from "../images/assets/news/geetajayanti/geetajayanti5.jpg";

import hindiDiwasPdf from "../assets/pdfs/hindidiwas.pdf";

import yoga1 from "../images/assets/news/yoga/yoga-1.png";
import yoga2 from "../images/assets/news/yoga/yoga-2.png";
import yoga3 from "../images/assets/news/yoga/yoga-3.png";
import yoga4 from "../images/assets/news/yoga/yoga-4.png";
import yoga5 from "../images/assets/news/yoga/yoga-5.png";
import yoga6 from "../images/assets/news/yoga/yoga-6.png";
import yoga7 from "../images/assets/news/yoga/yoga-7.png";
import yoga8 from "../images/assets/news/yoga/yoga-8.png";
import yoga9 from "../images/assets/news/yoga/yoga-9.png";
import yoga10 from "../images/assets/news/yoga/yoga-10.png";
import yoga11 from "../images/assets/news/yoga/yoga-11.png";
import yoga12 from "../images/assets/news/yoga/yoga-12.png";
import yoga13 from "../images/assets/news/yoga/yoga-13.png";

import jan_12_21_1 from "../images/assets/news/12jan/1.jpeg";
import jan_12_21_2 from "../images/assets/news/12jan/2.jpeg";
import jan_12_21_3 from "../images/assets/news/12jan/3.jpeg";
import jan_12_21_4 from "../images/assets/news/12jan/4.jpeg";

import jan_13 from "../images/assets/news/13_jan.png";

import jan_30_21_1 from "../images/assets/news/30jan/1.jpeg";
import jan_30_21_2 from "../images/assets/news/30jan/2.jpeg";
import jan_30_21_3 from "../images/assets/news/30jan/3.jpeg";

import feb_08_21_1 from "../images/assets/news/08feb/1.jpeg";
import feb_08_21_2 from "../images/assets/news/08feb/2.jpeg";
import feb_08_21_3 from "../images/assets/news/08feb/3.jpeg";

import feb_18_21_1 from "../images/assets/news/18feb/1.jpeg";
import feb_18_21_2 from "../images/assets/news/18feb/2.jpeg";
import feb_18_21_3 from "../images/assets/news/18feb/3.jpeg";
import feb_18_21_4 from "../images/assets/news/18feb/4.jpeg";

import feb_25_21_1 from "../images/assets/news/25feb/1.jpeg";
import feb_25_21_2 from "../images/assets/news/25feb/2.jpeg";
import feb_25_21_3 from "../images/assets/news/25feb/3.jpeg";
import feb_25_21_4 from "../images/assets/news/25feb/4.jpeg";
import feb_25_21_5 from "../images/assets/news/25feb/5.jpeg";

import mar_06_21 from "../images/assets/news/06_march_2021.png";

import mar_08_21_1 from "../images/assets/news/08march/1.jpeg";
import mar_08_21_2 from "../images/assets/news/08march/2.jpeg";
import mar_08_21_3 from "../images/assets/news/08march/3.jpeg";

import mar_08_21_2_1 from "../images/assets/news/08march2/1.jpeg";
import mar_08_21_2_2 from "../images/assets/news/08march2/2.jpeg";
import mar_08_21_2_3 from "../images/assets/news/08march2/3.jpeg";
import mar_08_21_2_4 from "../images/assets/news/08march2/4.jpeg";

import mar_16_21_1 from "../images/assets/news/16march/1.jpeg";
import mar_16_21_2 from "../images/assets/news/16march/2.jpeg";
import mar_16_21_3 from "../images/assets/news/16march/3.jpeg";
import mar_16_21_4 from "../images/assets/news/16march/4.jpeg";
import mar_16_21_5 from "../images/assets/news/16march/5.jpeg";

import april_08_21_1 from "../images/assets/news/08april/1.jpeg";
import april_08_21_2 from "../images/assets/news/08april/2.jpeg";
import april_08_21_3 from "../images/assets/news/08april/3.jpeg";
import april_08_21_4 from "../images/assets/news/08april/4.jpeg";

import april_13_21_1 from "../images/assets/news/13april/1.jpeg";
import april_13_21_2 from "../images/assets/news/13april/2.jpeg";
import april_13_21_3 from "../images/assets/news/13april/3.jpeg";
import april_13_21_4 from "../images/assets/news/13april/4.jpeg";

import april_17_21_1 from "../images/assets/news/17april/1.jpeg";
import april_17_21_2 from "../images/assets/news/17april/2.jpeg";
import april_17_21_3 from "../images/assets/news/17april/3.jpeg";

import april_21_21_1 from "../images/assets/news/21april/1.jpeg";
import april_21_21_2 from "../images/assets/news/21april/2.jpeg";
import april_21_21_3 from "../images/assets/news/21april/3.jpeg";
import april_21_21_4 from "../images/assets/news/21april/4.jpeg";

import april_22_21 from "../images/assets/news/22_april_2021.png";

import april_22_21_1 from "../images/assets/news/22april/1.jpeg";
import april_22_21_2 from "../images/assets/news/22april/2.jpeg";
import april_22_21_3 from "../images/assets/news/22april/3.jpeg";
import april_22_21_4 from "../images/assets/news/22april/4.jpeg";
import april_22_21_5 from "../images/assets/news/22april/5.jpeg";

import april_27_21_1 from "../images/assets/news/27april/1.jpeg";
import april_27_21_2 from "../images/assets/news/27april/2.jpeg";
import april_27_21_3 from "../images/assets/news/27april/3.jpeg";
import april_27_21_4 from "../images/assets/news/27april/4.jpeg";

import may_08_21_1 from "../images/assets/news/08may/1.jpeg";
import may_08_21_2 from "../images/assets/news/08may/2.jpeg";
import may_08_21_3 from "../images/assets/news/08may/3.jpeg";
import may_08_21_4 from "../images/assets/news/08may/4.jpeg";

import june_05_21_1 from "../images/assets/news/05june/1.jpeg";
import june_05_21_2 from "../images/assets/news/05june/2.jpeg";
import june_05_21_3 from "../images/assets/news/05june/3.jpeg";
import june_05_21_4 from "../images/assets/news/05june/4.jpeg";

import june_05_21 from "../images/assets/news/05june.png";

import june_10_21_1 from "../images/assets/news/10june/1.jpeg";
import june_10_21_2 from "../images/assets/news/10june/2.jpeg";
import june_10_21_3 from "../images/assets/news/10june/3.jpeg";
import june_10_21_4 from "../images/assets/news/10june/4.jpeg";

import june_10_21_2_1 from "../images/assets/news/10june2/1.jpeg";
import june_10_21_2_2 from "../images/assets/news/10june2/2.jpeg";
import june_10_21_2_3 from "../images/assets/news/10june2/3.jpeg";
import june_10_21_2_4 from "../images/assets/news/10june2/4.jpeg";

import june_10_21_3_1 from "../images/assets/news/10june3/1.jpeg";
import june_10_21_3_2 from "../images/assets/news/10june3/2.jpeg";
import june_10_21_3_3 from "../images/assets/news/10june3/3.jpeg";
import june_10_21_3_4 from "../images/assets/news/10june3/4.jpeg";

import june_16_21_1 from "../images/assets/news/16june/1.jpeg";
import june_16_21_2 from "../images/assets/news/16june/2.jpeg";
import june_16_21_3 from "../images/assets/news/16june/3.jpeg";
import june_16_21_4 from "../images/assets/news/16june/4.jpeg";
import june_16_21_5 from "../images/assets/news/16june/5.jpeg";

import june_19_21_1 from "../images/assets/news/19june/1.jpeg";
import june_19_21_2 from "../images/assets/news/19june/2.jpeg";
import june_19_21_3 from "../images/assets/news/19june/3.jpeg";
import june_19_21_4 from "../images/assets/news/19june/4.jpeg";

import june_21_21_1 from "../images/assets/news/21june/1.jpeg";
import june_21_21_2 from "../images/assets/news/21june/2.jpeg";
import june_21_21_3 from "../images/assets/news/21june/3.jpeg";

import june_21_21_2_1 from "../images/assets/news/21june2/1.jpeg";
import june_21_21_2_2 from "../images/assets/news/21june2/2.jpeg";
import june_21_21_2_3 from "../images/assets/news/21june2/3.jpeg";

import june_29_21_1 from "../images/assets/news/29june/1.jpeg";
import june_29_21_2 from "../images/assets/news/29june/2.jpeg";
import june_29_21_3 from "../images/assets/news/29june/3.jpeg";
import june_29_21_4 from "../images/assets/news/29june/4.jpeg";

import july_01_21_1 from "../images/assets/news/01july/1.jpeg";
import july_01_21_2 from "../images/assets/news/01july/2.jpeg";
import july_01_21_3 from "../images/assets/news/01july/3.jpeg";
import july_01_21_4 from "../images/assets/news/01july/4.jpeg";

import july_02_21_1 from "../images/assets/news/02july/1.jpeg";
import july_02_21_2 from "../images/assets/news/02july/2.jpeg";
import july_02_21_3 from "../images/assets/news/02july/3.jpeg";
import july_02_21_4 from "../images/assets/news/02july/4.jpeg";

import july_02_21_2_1 from "../images/assets/news/02july2/1.jpeg";
import july_02_21_2_2 from "../images/assets/news/02july2/2.jpeg";
import july_02_21_2_3 from "../images/assets/news/02july2/3.jpeg";
import july_02_21_2_4 from "../images/assets/news/02july2/4.jpeg";

import july_09_21_1 from "../images/assets/news/09july2/1.jpeg";
import july_09_21_2 from "../images/assets/news/09july2/2.jpeg";
import july_09_21_3 from "../images/assets/news/09july2/3.jpeg";
import july_09_21_4 from "../images/assets/news/09july2/4.jpeg";

import july_16_21_1 from "../images/assets/news/16july/1.jpeg";
import july_16_21_2 from "../images/assets/news/16july/2.jpeg";
import july_16_21_3 from "../images/assets/news/16july/3.jpeg";
import july_16_21_4 from "../images/assets/news/16july/4.jpeg";
import july_16_21_5 from "../images/assets/news/16july/5.jpeg";

import july_16_21_2_1 from "../images/assets/news/16july2/1.jpeg";
import july_16_21_2_2 from "../images/assets/news/16july2/2.jpeg";
import july_16_21_2_3 from "../images/assets/news/16july2/3.jpeg";
import july_16_21_2_4 from "../images/assets/news/16july2/4.jpeg";
import july_16_21_2_5 from "../images/assets/news/16july2/5.jpeg";

import july_17_21_1 from "../images/assets/news/17july/1.jpeg";
import july_17_21_2 from "../images/assets/news/17july/2.jpeg";
import july_17_21_3 from "../images/assets/news/17july/3.jpeg";
import july_17_21_4 from "../images/assets/news/17july/4.jpeg";

import july_22_21_1 from "../images/assets/news/22july/1.jpeg";
import july_22_21_2 from "../images/assets/news/22july/2.jpeg";
import july_22_21_3 from "../images/assets/news/22july/3.jpeg";
import july_22_21_4 from "../images/assets/news/22july/4.jpeg";

import july_22_21_2_1 from "../images/assets/news/22july2/1.jpeg";
import july_22_21_2_2 from "../images/assets/news/22july2/2.jpeg";
import july_22_21_2_3 from "../images/assets/news/22july2/3.jpeg";
import july_22_21_2_4 from "../images/assets/news/22july2/4.jpeg";

import july_24_21_1 from "../images/assets/news/24july/1.jpeg";
import july_24_21_2 from "../images/assets/news/24july/2.jpeg";
import july_24_21_3 from "../images/assets/news/24july/3.jpeg";
import july_24_21_4 from "../images/assets/news/24july/4.jpeg";

import july_24_21_2_1 from "../images/assets/news/24july2/1.jpeg";
import july_24_21_2_2 from "../images/assets/news/24july2/2.jpeg";
import july_24_21_2_3 from "../images/assets/news/24july2/3.jpeg";
import july_24_21_2_4 from "../images/assets/news/24july2/4.jpeg";

import july_24_21_3_1 from "../images/assets/news/24july3/1.jpeg";
import july_24_21_3_2 from "../images/assets/news/24july3/2.jpeg";
import july_24_21_3_3 from "../images/assets/news/24july3/3.jpeg";
import july_24_21_3_4 from "../images/assets/news/24july3/4.jpeg";

import july_28_21_1 from "../images/assets/news/28july/1.jpeg";
import july_28_21_2 from "../images/assets/news/28july/2.jpeg";
import july_28_21_3 from "../images/assets/news/28july/3.jpeg";
import july_28_21_4 from "../images/assets/news/28july/4.jpeg";

import july_29_21_1 from "../images/assets/news/29july/1.jpeg";
import july_29_21_2 from "../images/assets/news/29july/2.jpeg";
import july_29_21_3 from "../images/assets/news/29july/3.jpeg";
import july_29_21_4 from "../images/assets/news/29july/4.jpeg";
import july_29_21_5 from "../images/assets/news/29july/5.jpeg";

import july_31_21_1 from "../images/assets/news/31july/1.jpeg";
import july_31_21_2 from "../images/assets/news/31july/2.jpeg";
import july_31_21_3 from "../images/assets/news/31july/3.jpeg";
import july_31_21_4 from "../images/assets/news/31july/4.jpeg";
import july_31_21_5 from "../images/assets/news/29july/5.jpeg";

import july_31_21_2_1 from "../images/assets/news/31july2/1.jpeg";
import july_31_21_2_2 from "../images/assets/news/31july2/2.jpeg";
import july_31_21_2_3 from "../images/assets/news/31july2/3.jpeg";
import july_31_21_2_4 from "../images/assets/news/31july2/4.jpeg";
import july_31_21_2_5 from "../images/assets/news/31july2/5.jpeg";

import aug_03_21_1 from "../images/assets/news/03aug/1.jpeg";
import aug_03_21_2 from "../images/assets/news/03aug/2.jpeg";
import aug_03_21_3 from "../images/assets/news/03aug/3.jpeg";
import aug_03_21_4 from "../images/assets/news/03aug/4.jpeg";

import aug_04_21_1 from "../images/assets/news/04aug/1.jpeg";
import aug_04_21_2 from "../images/assets/news/04aug/2.jpeg";
import aug_04_21_3 from "../images/assets/news/04aug/3.jpeg";
import aug_04_21_4 from "../images/assets/news/04aug/4.jpeg";

import aug_07_21_1 from "../images/assets/news/07aug/1.jpeg";
import aug_07_21_2 from "../images/assets/news/07aug/2.jpeg";
import aug_07_21_3 from "../images/assets/news/07aug/3.jpeg";
import aug_07_21_4 from "../images/assets/news/07aug/4.jpeg";
import aug_07_21_5 from "../images/assets/news/07aug/5.jpeg";

import aug_15_21 from "../images/assets/news/15_aug_2021.png";

import aug_19_21_1 from "../images/assets/news/19aug/1.jpeg";
import aug_19_21_2 from "../images/assets/news/19aug/2.jpeg";
import aug_19_21_3 from "../images/assets/news/19aug/3.jpeg";
import aug_19_21_4 from "../images/assets/news/19aug/4.jpeg";
import aug_19_21_5 from "../images/assets/news/19aug/5.jpeg";

import aug_22_21_1 from "../images/assets/news/22aug/1.jpeg";
import aug_22_21_2 from "../images/assets/news/22aug/2.jpeg";
import aug_22_21_3 from "../images/assets/news/22aug/3.jpeg";
import aug_22_21_4 from "../images/assets/news/22aug/4.jpeg";
import aug_22_21_5 from "../images/assets/news/22aug/5.jpeg";

import aug_24_21_1 from "../images/assets/news/24aug/1.jpeg";
import aug_24_21_2 from "../images/assets/news/24aug/2.jpeg";
import aug_24_21_3 from "../images/assets/news/24aug/3.jpeg";
import aug_24_21_4 from "../images/assets/news/24aug/4.jpeg";
import aug_24_21_5 from "../images/assets/news/24aug/5.jpeg";

import aug_24_21_2_1 from "../images/assets/news/24aug2/1.jpeg";
import aug_24_21_2_2 from "../images/assets/news/24aug2/2.jpeg";
import aug_24_21_2_3 from "../images/assets/news/24aug2/3.jpeg";
import aug_24_21_2_4 from "../images/assets/news/24aug2/4.jpeg";

import aug_25_21_1 from "../images/assets/news/25aug/1.jpeg";
import aug_25_21_2 from "../images/assets/news/25aug/2.jpeg";
import aug_25_21_3 from "../images/assets/news/25aug/3.jpeg";
import aug_25_21_4 from "../images/assets/news/25aug/4.jpeg";
import aug_25_21_5 from "../images/assets/news/25aug/5.jpeg";

import aug_29_21 from "../images/assets/news/29_aug_21.png";

import aug_30_21_1 from "../images/assets/news/30aug/1.jpeg";
import aug_30_21_2 from "../images/assets/news/30aug/2.jpeg";
import aug_30_21_3 from "../images/assets/news/30aug/3.jpeg";
import aug_30_21_4 from "../images/assets/news/30aug/4.jpeg";

import aug_30_21_2_1 from "../images/assets/news/30aug2/1.jpeg";
import aug_30_21_2_2 from "../images/assets/news/30aug2/2.jpeg";
import aug_30_21_2_3 from "../images/assets/news/30aug2/3.jpeg";
import aug_30_21_2_4 from "../images/assets/news/30aug2/4.jpeg";
import aug_30_21_2_5 from "../images/assets/news/30aug2/5.jpeg";
import aug_30_21_2_6 from "../images/assets/news/30aug2/6.jpeg";

import sep_05_21_1 from "../images/assets/news/05sep/1.jpeg";
import sep_05_21_2 from "../images/assets/news/05sep/2.jpeg";

import sep_05_21_2_1 from "../images/assets/news/05sep2/1.jpeg";
import sep_05_21_2_2 from "../images/assets/news/05sep2/2.jpeg";
import sep_05_21_2_3 from "../images/assets/news/05sep2/3.jpeg";
import sep_05_21_2_4 from "../images/assets/news/05sep2/4.jpeg";
import sep_05_21_2_5 from "../images/assets/news/05sep2/5.jpeg";

import sep_10_21_1 from "../images/assets/news/10sep/1.jpeg";
import sep_10_21_2 from "../images/assets/news/10sep/2.jpeg";
import sep_10_21_3 from "../images/assets/news/10sep/3.jpeg";
import sep_10_21_4 from "../images/assets/news/10sep/4.jpeg";
import sep_10_21_5 from "../images/assets/news/10sep/5.jpeg";

import sep_14_21_1 from "../images/assets/news/14sep/1.jpeg";
import sep_14_21_2 from "../images/assets/news/14sep/2.jpeg";
import sep_14_21_3 from "../images/assets/news/14sep/3.jpeg";
import sep_14_21_4 from "../images/assets/news/14sep/4.jpeg";
import sep_14_21_5 from "../images/assets/news/14sep/5.jpeg";

import sep_17_21_1 from "../images/assets/news/17sep/1.jpeg";
import sep_17_21_2 from "../images/assets/news/17sep/2.jpeg";
import sep_17_21_3 from "../images/assets/news/17sep/3.jpeg";
import sep_17_21_4 from "../images/assets/news/17sep/4.jpeg";
import sep_17_21_5 from "../images/assets/news/17sep/5.jpeg";

import sep_17_21_2_1 from "../images/assets/news/17sep2/1.jpeg";
import sep_17_21_2_2 from "../images/assets/news/17sep2/2.jpeg";
import sep_17_21_2_3 from "../images/assets/news/17sep2/3.jpeg";
import sep_17_21_2_4 from "../images/assets/news/17sep2/4.jpeg";
import sep_17_21_2_5 from "../images/assets/news/17sep2/5.jpeg";

import sep_18_21_1 from "../images/assets/news/18sep/1.jpeg";
import sep_18_21_2 from "../images/assets/news/18sep/2.jpeg";
import sep_18_21_3 from "../images/assets/news/18sep/3.jpeg";
import sep_18_21_4 from "../images/assets/news/18sep/4.jpeg";

import sep_24_21_1 from "../images/assets/news/24sep/1.jpeg";
import sep_24_21_2 from "../images/assets/news/24sep/2.jpeg";
import sep_24_21_3 from "../images/assets/news/24sep/3.jpeg";
import sep_24_21_4 from "../images/assets/news/24sep/4.jpeg";
import sep_24_21_5 from "../images/assets/news/24sep/5.jpeg";

import oct_01_21_1 from "../images/assets/news/01oct/1.jpeg";
import oct_01_21_2 from "../images/assets/news/01oct/2.jpeg";
import oct_01_21_3 from "../images/assets/news/01oct/3.jpeg";
import oct_01_21_4 from "../images/assets/news/01oct/4.jpeg";
import oct_01_21_5 from "../images/assets/news/01oct/5.jpeg";

import oct_03_21_1 from "../images/assets/news/03oct/1.jpeg";
import oct_03_21_2 from "../images/assets/news/03oct/2.jpeg";
import oct_03_21_3 from "../images/assets/news/03oct/3.jpeg";
import oct_03_21_4 from "../images/assets/news/03oct/4.jpeg";

import oct_03_21_2_1 from "../images/assets/news/03oct2/1.jpeg";
import oct_03_21_2_2 from "../images/assets/news/03oct2/2.jpeg";
import oct_03_21_2_3 from "../images/assets/news/03oct2/3.jpeg";
import oct_03_21_2_4 from "../images/assets/news/03oct2/4.jpeg";

import oct_06_21_1 from "../images/assets/news/06oct/1.jpeg";
import oct_06_21_2 from "../images/assets/news/06oct/2.jpeg";
import oct_06_21_3 from "../images/assets/news/06oct/3.jpeg";
import oct_06_21_4 from "../images/assets/news/06oct/4.jpeg";
import oct_06_21_5 from "../images/assets/news/06oct/5.jpeg";

import oct_06_21_2_1 from "../images/assets/news/06oct2/1.jpeg";
import oct_06_21_2_2 from "../images/assets/news/06oct2/2.jpeg";
import oct_06_21_2_3 from "../images/assets/news/06oct2/3.jpeg";
import oct_06_21_2_4 from "../images/assets/news/06oct2/4.jpeg";
import oct_06_21_2_5 from "../images/assets/news/06oct2/5.jpeg";

import oct_07_21_1 from "../images/assets/news/oct07/1.jpeg";
import oct_07_21_2 from "../images/assets/news/oct07/2.jpeg";
import oct_07_21_3 from "../images/assets/news/oct07/3.jpeg";
import oct_07_21_4 from "../images/assets/news/oct07/4.jpeg";
import oct_07_21_5 from "../images/assets/news/oct07/5.jpeg";

import oct_08_21_1 from "../images/assets/news/08oct/1.jpeg";
import oct_08_21_2 from "../images/assets/news/08oct/2.jpeg";
import oct_08_21_3 from "../images/assets/news/08oct/3.jpeg";
import oct_08_21_4 from "../images/assets/news/08oct/4.jpeg";

import oct_11_21_1 from "../images/assets/news/11oct/1.jpeg";
import oct_11_21_2 from "../images/assets/news/11oct/2.jpeg";
import oct_11_21_3 from "../images/assets/news/11oct/3.jpeg";
import oct_11_21_4 from "../images/assets/news/11oct/4.jpeg";
import oct_11_21_5 from "../images/assets/news/11oct/5.jpeg";

import oct_11_21_2_1 from "../images/assets/news/11oct2/1.jpeg";
import oct_11_21_2_2 from "../images/assets/news/11oct2/2.jpeg";
import oct_11_21_2_3 from "../images/assets/news/11oct2/3.jpeg";
import oct_11_21_2_4 from "../images/assets/news/11oct2/4.jpeg";

import oct_14_21_1 from "../images/assets/news/14oct/pic1.jpeg";
import oct_14_21_2 from "../images/assets/news/14oct/pic2.jpeg";
import oct_14_21_3 from "../images/assets/news/14oct/pic3.jpeg";
import oct_14_21_4 from "../images/assets/news/14oct/pic4.jpeg";
import oct_14_21_5 from "../images/assets/news/14oct/pic5.jpeg";
import oct_14_21_6 from "../images/assets/news/14oct/pic6.jpeg";
import oct_14_21_7 from "../images/assets/news/14oct/pic7.jpeg";

import oct_15_21_1 from "../images/assets/news/15oct/1.jpeg";
import oct_15_21_2 from "../images/assets/news/15oct/2.jpeg";
import oct_15_21_3 from "../images/assets/news/15oct/3.jpeg";
import oct_15_21_4 from "../images/assets/news/15oct/4.jpeg";
import oct_15_21_5 from "../images/assets/news/15oct/5.jpeg";

import oct_23_21_1 from "../images/assets/news/23oct/1.jpeg";
import oct_23_21_2 from "../images/assets/news/23oct/2.jpeg";
import oct_23_21_3 from "../images/assets/news/23oct/3.jpeg";
import oct_23_21_4 from "../images/assets/news/23oct/4.jpeg";
import oct_23_21_5 from "../images/assets/news/23oct/5.jpeg";

import oct_24_21_1 from "../images/assets/news/24oct/1.jpeg";
import oct_24_21_2 from "../images/assets/news/24oct/2.jpeg";
import oct_24_21_3 from "../images/assets/news/24oct/3.jpeg";
import oct_24_21_4 from "../images/assets/news/24oct/4.jpeg";
import oct_24_21_5 from "../images/assets/news/24oct/5.jpeg";

import oct_29_21_1 from "../images/assets/news/29oct/1.jpeg";
import oct_29_21_2 from "../images/assets/news/29oct/2.jpeg";
import oct_29_21_3 from "../images/assets/news/29oct/3.jpeg";

import oct_31_21_1 from "../images/assets/news/31oct/1.jpeg";
import oct_31_21_2 from "../images/assets/news/31oct/2.jpeg";
import oct_31_21_3 from "../images/assets/news/31oct/3.jpeg";
import oct_31_21_4 from "../images/assets/news/31oct/4.jpeg";
import oct_31_21_5 from "../images/assets/news/31oct/5.jpeg";

import nov_01_21_1 from "../images/assets/news/nov1/1.jpeg";
import nov_01_21_2 from "../images/assets/news/nov1/2.jpeg";
import nov_01_21_3 from "../images/assets/news/nov1/3.jpeg";

import nov_04_21_1 from "../images/assets/news/nov2/1.jpeg";
import nov_04_21_2 from "../images/assets/news/nov2/2.jpeg";
import nov_04_21_3 from "../images/assets/news/nov2/3.jpeg";
import nov_04_21_4 from "../images/assets/news/nov2/4.jpeg";
import nov_04_21_5 from "../images/assets/news/nov2/5.jpeg";

import nov_08_21_1 from "../images/assets/news/nov8/1.jpeg";
import nov_08_21_2 from "../images/assets/news/nov8/2.jpeg";
import nov_08_21_3 from "../images/assets/news/nov8/3.jpeg";
import nov_08_21_4 from "../images/assets/news/nov8/4.jpeg";
import nov_08_21_5 from "../images/assets/news/nov8/5.jpeg";

import nov_09_21_1 from "../images/assets/news/nov9/1.jpeg";
import nov_09_21_2 from "../images/assets/news/nov9/2.jpeg";
import nov_09_21_3 from "../images/assets/news/nov9/3.jpeg";
import nov_09_21_4 from "../images/assets/news/nov9/4.jpeg";
import nov_09_21_5 from "../images/assets/news/nov9/5.jpeg";

import nov_11_21_1 from "../images/assets/news/nov11/1.jpeg";
import nov_11_21_2 from "../images/assets/news/nov11/2.jpeg";
import nov_11_21_3 from "../images/assets/news/nov11/3.jpeg";
import nov_11_21_4 from "../images/assets/news/nov11/4.jpeg";
import nov_11_21_5 from "../images/assets/news/nov11/5.jpeg";

import nov_13_21_1 from "../images/assets/news/nov13/1.jpeg";
import nov_13_21_2 from "../images/assets/news/nov13/2.jpeg";
import nov_13_21_3 from "../images/assets/news/nov13/3.jpeg";
import nov_13_21_4 from "../images/assets/news/nov13/4.jpeg";
import nov_13_21_5 from "../images/assets/news/nov13/5.jpeg";

import nov_14_21_1 from "../images/assets/news/nov14/1.jpeg";
import nov_14_21_2 from "../images/assets/news/nov14/2.jpeg";
import nov_14_21_3 from "../images/assets/news/nov14/3.jpeg";
import nov_14_21_4 from "../images/assets/news/nov14/4.jpeg";
import nov_14_21_5 from "../images/assets/news/nov14/5.jpeg";

import nov_17_21_1 from "../images/assets/news/nov17/1.jpeg";
import nov_17_21_2 from "../images/assets/news/nov17/2.jpeg";
import nov_17_21_3 from "../images/assets/news/nov17/3.jpeg";
import nov_17_21_4 from "../images/assets/news/nov17/4.jpeg";
import nov_17_21_5 from "../images/assets/news/nov17/5.jpeg";

import nov_18_21_1 from "../images/assets/news/nov18/1.jpeg";
import nov_18_21_2 from "../images/assets/news/nov18/2.jpeg";
import nov_18_21_3 from "../images/assets/news/nov18/3.jpeg";
import nov_18_21_4 from "../images/assets/news/nov18/4.jpeg";
import nov_18_21_5 from "../images/assets/news/nov18/5.jpeg";

import nov_19_21_1 from "../images/assets/news/nov19/1.jpeg";
import nov_19_21_2 from "../images/assets/news/nov19/2.jpeg";
import nov_19_21_3 from "../images/assets/news/nov19/3.jpeg";
import nov_19_21_4 from "../images/assets/news/nov19/4.jpeg";
import nov_19_21_5 from "../images/assets/news/nov19/5.jpeg";

import nov_24_21_1 from "../images/assets/news/nov24/1.jpeg";
import nov_24_21_2 from "../images/assets/news/nov24/2.jpeg";
import nov_24_21_3 from "../images/assets/news/nov24/3.jpeg";
import nov_24_21_4 from "../images/assets/news/nov24/4.jpeg";
import nov_24_21_5 from "../images/assets/news/nov24/5.jpeg";

import nov_25_21_1 from "../images/assets/news/nov25/1.jpeg";
import nov_25_21_2 from "../images/assets/news/nov25/2.jpeg";
import nov_25_21_3 from "../images/assets/news/nov25/3.jpeg";
import nov_25_21_4 from "../images/assets/news/nov25/4.jpeg";
import nov_25_21_5 from "../images/assets/news/nov25/5.jpeg";

import nov_26_21_1 from "../images/assets/news/nov26/1.jpeg";
import nov_26_21_2 from "../images/assets/news/nov26/2.jpeg";
import nov_26_21_3 from "../images/assets/news/nov26/3.jpeg";
import nov_26_21_4 from "../images/assets/news/nov26/4.jpeg";
import nov_26_21_5 from "../images/assets/news/nov26/5.jpeg";

import nov_30_21_1 from "../images/assets/news/nov30/1.jpeg";
import nov_30_21_2 from "../images/assets/news/nov30/2.jpeg";
import nov_30_21_3 from "../images/assets/news/nov30/3.jpeg";
import nov_30_21_4 from "../images/assets/news/nov30/4.jpeg";
import nov_30_21_5 from "../images/assets/news/nov30/5.jpeg";

import dec_03_21_1 from "../images/assets/news/dec3/1.jpeg";
import dec_03_21_2 from "../images/assets/news/dec3/2.jpeg";
import dec_03_21_3 from "../images/assets/news/dec3/3.jpeg";
import dec_03_21_4 from "../images/assets/news/dec3/4.jpeg";
import dec_03_21_5 from "../images/assets/news/dec3/5.jpeg";

import dec_04_21_1 from "../images/assets/news/dec4/1.jpeg";
import dec_04_21_2 from "../images/assets/news/dec4/2.jpeg";
import dec_04_21_3 from "../images/assets/news/dec4/3.jpeg";
import dec_04_21_4 from "../images/assets/news/dec4/4.jpeg";
import dec_04_21_5 from "../images/assets/news/dec4/5.jpeg";

import dec_07_21_1 from "../images/assets/news/dec7/1.jpeg";
import dec_07_21_2 from "../images/assets/news/dec7/2.jpeg";
import dec_07_21_3 from "../images/assets/news/dec7/3.jpeg";
import dec_07_21_4 from "../images/assets/news/dec7/4.jpeg";
import dec_07_21_5 from "../images/assets/news/dec7/5.jpeg";

import dec_09_21_1 from "../images/assets/news/dec8/1.jpeg";
import dec_09_21_2 from "../images/assets/news/dec8/2.jpeg";
import dec_09_21_3 from "../images/assets/news/dec8/3.jpeg";
import dec_09_21_4 from "../images/assets/news/dec8/4.jpeg";
import dec_09_21_5 from "../images/assets/news/dec8/5.jpeg";

import dec_11_21_1 from "../images/assets/news/dec11/1.jpeg";
import dec_11_21_2 from "../images/assets/news/dec11/2.jpeg";
import dec_11_21_3 from "../images/assets/news/dec11/3.jpeg";
import dec_11_21_4 from "../images/assets/news/dec11/4.jpeg";
import dec_11_21_5 from "../images/assets/news/dec11/5.jpeg";

import dec_16_21_1 from "../images/assets/news/dec16/1.jpeg";
import dec_16_21_2 from "../images/assets/news/dec16/2.jpeg";
import dec_16_21_3 from "../images/assets/news/dec16/3.jpeg";
import dec_16_21_4 from "../images/assets/news/dec16/4.jpeg";
import dec_16_21_5 from "../images/assets/news/dec16/5.jpeg";

import dec_24_21_1 from "../images/assets/news/dec24/1.jpeg";
import dec_24_21_2 from "../images/assets/news/dec24/2.jpeg";
import dec_24_21_3 from "../images/assets/news/dec24/3.jpeg";
import dec_24_21_4 from "../images/assets/news/dec24/4.jpeg";
import dec_24_21_5 from "../images/assets/news/dec24/5.jpeg";

import dec_24_21_2_1 from "../images/assets/news/dec24-2/1.jpeg";
import dec_24_21_2_2 from "../images/assets/news/dec24-2/2.jpeg";
import dec_24_21_2_3 from "../images/assets/news/dec24-2/3.jpeg";
import dec_24_21_2_4 from "../images/assets/news/dec24-2/4.jpeg";
import dec_24_21_2_5 from "../images/assets/news/dec24-2/5.jpeg";

import dec_25_21_1 from "../images/assets/news/dec25/1.jpeg";
import dec_25_21_2 from "../images/assets/news/dec25/2.jpeg";
import dec_25_21_3 from "../images/assets/news/dec25/3.jpeg";
import dec_25_21_4 from "../images/assets/news/dec25/4.jpeg";
import dec_25_21_5 from "../images/assets/news/dec25/5.jpeg";

import dec_25_21_2_1 from "../images/assets/news/dec25-2/1.jpeg";
import dec_25_21_2_2 from "../images/assets/news/dec25-2/2.jpeg";
import dec_25_21_2_3 from "../images/assets/news/dec25-2/3.jpeg";
import dec_25_21_2_4 from "../images/assets/news/dec25-2/4.jpeg";
import dec_25_21_2_5 from "../images/assets/news/dec25-2/5.jpeg";

import dec_29_21_1 from "../images/assets/news/dec29/1.jpeg";
import dec_29_21_2 from "../images/assets/news/dec29/2.jpeg";
import dec_29_21_3 from "../images/assets/news/dec29/3.jpeg";
import dec_29_21_4 from "../images/assets/news/dec29/4.jpeg";
import dec_29_21_5 from "../images/assets/news/dec29/5.jpeg";

import july_31_21 from "../images/assets/news/31_july_2021.jpeg";

import may_08_20_message from "../images/assets/news/messagefromtheprincipal.png";

import jan_01_21 from "../images/assets/news/26_01_2021.png";

const ews1 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews1.jpeg";
const ews2 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews2.jpeg";
const ews3 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews3.jpeg";
const ews4 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews4.jpeg";
const ews5 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews5.jpeg";
const ews6 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews6.jpeg";
const ews7 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews7.jpeg";
const ews8 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews8.jpeg";
const ews9 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews9.jpeg";
const ews10 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews10.jpeg";
const ews11 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews11.jpeg";
const ews12 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews12.jpeg";
const ews13 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews13.jpeg";
const ews14 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews14.jpeg";
const ews15 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews15.jpeg";
const ews16 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews16.jpeg";
const ews17 = "https://chinmayavvdelhi.ac.in/assets/images/ews/ews17.jpeg";

const june_21_20_1 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_1.png";
const june_21_20_2 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_2.png";
const june_21_20_3 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_3.png";
const june_21_20_4 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_4.png";
const june_21_20_5 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_5.png";
const june_21_20_6 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_6.png";
const june_21_20_7 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_7.png";
const june_21_20_8 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_8.png";
const june_21_20_9 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_9.png";
const june_21_20_10 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_10.png";
const june_21_20_11 = "https://chinmayavvdelhi.ac.in/images/Blackele/21_june_11.png";

const may_02_20_1 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Healthsetgo_1.png";
const may_02_20_2 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Healthsetgo_2.png";
const may_02_20_3 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Healthsetgo_3.png";
const may_02_20_4 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Healthsetgo_4.png";
const may_02_20_5 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Healthsetgo_5.png";
const may_02_20_6 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Healthsetgo_6.png";

const may_01_20_1 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Fun_crafy_1.png";
const may_01_20_2 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Fun_crafy_2.png";
const may_01_20_3 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Fun_crafy_3.png";
const may_01_20_4 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Fun_crafy_4.png";
const may_01_20_5 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Fun_crafy_5.png";

const april_30_20_1 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Brushing_1.png";
const april_30_20_2 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Brushing_2.png";
const april_30_20_3 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Brushing_3.png";
const april_30_20_4 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Brushing_4.png";
const april_30_20_5 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Brushing_5.png";
const april_30_20_6 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Brushing_6.png";

const april_27_20_1 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Earth_day_1.png";
const april_27_20_2 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Earth_day_2.png";
const april_27_20_3 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Earth_day_3.png";
const april_27_20_4 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Earth_day_4.png";
const april_27_20_5 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Earth_day_5.png";

const april_24_20_1 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/HRed_day_1.png";
const april_24_20_2 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/HRed_day_2.png";
const april_24_20_3 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/HRed_day_3.png";
const april_24_20_4 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/HRed_day_4.png";
const april_24_20_5 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/HRed_day_5.png";
const april_24_20_6 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/HRed_day_6.png";

const april_20_20_1 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Chinamaya_1.png";
const april_20_20_2 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Chinamaya_2.png";
const april_20_20_3 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Chinamaya_3.png";
const april_20_20_4 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Chinamaya_4.png";
const april_20_20_5 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Chinamaya_5.png";
const april_20_20_6 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Chinamaya_6.png";
const april_20_20_7 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Chinamaya_7.png";
const april_20_20_8 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Chinamaya_8.png";

const april_11_20_1 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Action_4_mask_1.png";
const april_11_20_2 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Action_4_mask_2.png";
const april_11_20_3 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Action_4_mask_3.png";
const april_11_20_4 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Action_4_mask_4.png";
const april_11_20_5 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Action_4_mask_5.png";
const april_11_20_6 = "https://chinmayavvdelhi.ac.in/images/Blackele/eventsImages/Action_4_mask_6.png";

//#endregion

//MARK: Data here
const data = [
  {
    d: "11",
    fullDate: "11 July 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-5/pic12.jpg",
    ],
    isVideo: false,
    link: "/school-events/hand-and-feet-hopscotch-activity-pre-primary-department-2025",
    m: "Jul",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/hand-and-feet-hopscotch-activity-pre-primary-department-2025",
    text: "On 11 July 2025, the Pre-Primary deparment of Chinmaya Vidyalaya, New Delhi, turned into a lively and colourful space as young learners took part in a specially designed Hand and Feet Hopscotch activity.<br/><br/>The setup was simple but engaging, with bright patterns laid out on the floor, encouraging children to match their hands and feet to the shapes as they moved through the course. With each hop, step and stretch, the children explored movement in a playful yet purposeful way.<br/><br/>Beyond the fun, the activity supported important aspects of early development. It helped improve gross motor skills, balance and coordination, while also promoting spatial awareness and body control. The challenge of placing hands and feet correctly encouraged focus, while the rhythm of movement helped build confidence.<br/><br/>Laughter filled the air as children navigated the course, often pausing to cheer each other on. The excitement was matched by determination, and by the end of the session, the pride on their faces spoke volumes.<br/><br/>The Hand and Feet Hopscotch activity was a perfect blend of learning and fun. It gave students the freedom to move, explore and grow, while reinforcing the value of active play in early childhood education.",
    title: "Hand and Feet Hopscotch Activity – Pre-Primary Department",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "10",
    fullDate: "10 July 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-07-25-4/pic6.jpg",
    ],
    isVideo: false,
    link: "/school-events/guru-purnima-celebrations-2025",
    m: "Jul",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/guru-purnima-celebrations-2025",
    text: "Chinmaya Vidyalaya, New Delhi, observed the sacred occasion of Guru Purnima with deep reverence, celebrating the timeless bond between the Guru and the disciple. The event served as a reminder of the Guru’s role as a beacon of knowledge, compassion and inner strength.<br/><br/>The ceremony began with a traditional Paduka Pooja, gracefully led by the Principal, Ms Archana Soni, and the Primary Head, Ms Archana Gaur. This symbolic act of worship offered gratitude to the Guru as the guiding presence in one's life, both spiritual and personal.<br/><br/>Members of the Student Council took part in the pooja with sincerity and devotion. With flowers in hand and prayers in their hearts, they paid homage to the Guru, embodying the values of respect and humility.<br/><br/>During the programme, the significance of Guru Purnima was shared with the student body. The message underscored the importance of learning from and honouring one’s Guru, not only in academics but in all aspects of life. Students were encouraged to reflect on the role of teachers and mentors who shape their thinking and guide their growth.<br/><br/>The celebration served as more than a ritual. It was a meaningful experience that instilled key values such as faith, humility and devotion. Through this observance, students developed a deeper sense of gratitude and respect for those who guide them, helping to shape both character and understanding.<br/><br/>Guru Purnima at Chinmaya Vidyalaya was a heartfelt tribute to the spirit of learning and mentorship, reminding all present that true growth begins with reverence for the one who shows the path.",
    title: "Guru Purnima Celebrations",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "10",
    fullDate: "10 July 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-3/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/guru-poornima-celebrations-primary-section-2025",
    m: "Jul",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/guru-poornima-celebrations-primary-section-2025",
    text: "On 10 July 2025, the Primary section of Chinmaya Vidyalaya, New Delhi, observed Guru Poornima with a deep sense of respect and purpose. The day provided young learners with a chance to reflect on the role of the Guru and to celebrate the values they represent.<br/><br/>The programme opened with the chanting of the Guru Stotram. The verses, recited with sincerity, brought a calm focus to the gathering and served as a reminder of the Guru’s presence as a guiding light in one’s life.<br/><br/>As part of the tribute to Pujya Gurudev Swami Chinmayananda, students participated in an origami activity. With care and enthusiasm, they folded bright paper into flowers, which they then offered before Gurudev’s photograph. This simple act became a meaningful way for the children to express respect and affection.<br/><br/>A short video was shown, offering insight into Gurudev’s life and mission. Through visuals and storytelling, students learned how his clarity, compassion and vision transformed lives and shaped the Chinmaya Mission.<br/><br/>The celebration ended with a few quiet moments for personal reflection. Without prompts, the students sat still, allowing the messages of the day to settle in. It was a gentle but powerful way to close the experience.<br/><br/>Rather than a formal ceremony, the day felt like a shared journey of learning and remembrance. It helped students understand that Guru Poornima is not just about tradition, but about recognising those who help us grow in thought and character.",
    title: "Guru Poornima Celebrations – Primary Section",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "10",
    fullDate: "10 July 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-2/pic12.jpg",
    ],
    isVideo: false,
    link: "/school-events/guru-purnima-celebration-pre-primary-2025",
    m: "Jul",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/guru-purnima-celebration-pre-primary-2025",
    text: "On Thursday, 10 July 2025, the Pre-Primary department of Chinmaya Vidyalaya, New Delhi, celebrated Guru Purnima with devotion and joy. This sacred occasion honours the Guru, the one who removes ignorance and leads the seeker towards knowledge. As Pujya Gurudev Swami Chinmayananda said, “The Guru is the one who removes the darkness of ignorance and leads us to the light of knowledge.”<br/><br/>The celebration began with a special audio-visual presentation that introduced the young learners to the life and teachings of Pujya Gurudev. His gentle humour, compassionate presence and timeless wisdom made a lasting impact. The children were captivated by how he conveyed deep truths through simple, relatable stories.<br/><br/>Following this, classrooms became cheerful performance spaces where puppet shows brought spiritual stories to life. Through engaging characters and thoughtful storytelling, the children explored values such as kindness, honesty and courage. These performances were designed to entertain while also imparting important lessons in an age-appropriate way.<br/><br/>As the programme continued, the sound of bhajans and prayers filled the air. The children sang together with sincerity, creating a heartfelt atmosphere of devotion and unity. Their enthusiasm reflected their growing connection to the values being celebrated.<br/><br/>The day concluded with a quiet moment of prayer before the image of Pujya Gurudev. With hands joined, eyes shining and hearts full of reverence, the children offered their gratitude. They left inspired by his teachings and carried with them the true spirit of Guru Purnima — a celebration of knowledge, love and respect for the Guru.<br/><br/>The event was a meaningful experience for all involved, planting the seeds of devotion and understanding in every young mind.",
    title: "Guru Purnima Celebration – Pre-Primary",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "09",
    fullDate: "09 July 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-07-25-1/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/the-magic-of-storytime-in-circle-time-2025",
    m: "Jul",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/the-magic-of-storytime-in-circle-time-2025",
    text: 'On 9 July 2025, the pre-primary students of Chinmaya Vidyalaya, New Delhi, took part in a delightful Circle Time session titled "The Magic of Storytime."<br/><br/>The session created a warm and engaging atmosphere as children gathered in a circle to enjoy the wonder of storytelling. It was more than just reading aloud. It was an invitation to imagine, to dream, and to explore new ideas through stories. As each page turned, young minds travelled to faraway lands, soared with dragons, explored the ocean floor, and wandered through enchanted forests, all within the comfort of their classroom.<br/><br/>This storytelling session supported early development in multiple ways. Emotionally, it helped children recognise feelings and relate to different characters. Intellectually, it encouraged curiosity and offered insights into values, friendships, and daily life. The flow of language and the use of vivid illustrations helped build vocabulary and improve listening skills.<br/><br/>Whether the story was funny or meaningful, each one left an impact. These tales helped shape not only the children’s understanding of language, but also their awareness of kindness, courage, and empathy. The session sparked questions, encouraged conversations, and filled the room with laughter and excitement.<br/><br/>Storytime in Circle Time reminded everyone present that storytelling is a powerful tool in early education. It connects children to each other and to the world around them, one story at a time. <br/>br/>',
    title: "The Magic of Storytime in Circle Time",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "04",
    fullDate: "04 July 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-2/pic26.jpg",
    ],
    isVideo: false,
    link: "/school-events/van-mahotsav-celebration-primary-departments-sewa-day-2025",
    m: "Jul",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/van-mahotsav-celebration-primary-departments-sewa-day-2025",
    text: "On 4th July 2024, the Primary Department of Chinmaya Vidyalaya New Delhi celebrated Sewa Day with immense enthusiasm and purpose as part of the Van Mahotsav celebrations. The young learners participated in a range of eco-friendly activities, showcasing their creativity and commitment to environmental conservation.<br/><br/>The students engaged in various activities, including planting saplings, learning about composting, and exploring the benefits of medicinal plants. They also expressed their artistic side by creating conservation-themed posters, highlighting the importance of trees and nature in daily life. Through these activities, the learners gained a deeper understanding of the significance of environmental conservation and the role they can play in protecting the planet.<br/><br/>The celebration served as a powerful reminder that caring for the environment is a meaningful act of sewa, one that fosters responsibility, connection, and hope for a greener tomorrow. The event was a testament to the school's commitment to nurturing environmentally conscious and socially responsible individuals who will contribute to creating a sustainable future.",
    title: "Van Mahotsav Celebration: Primary Department's Sewa Day",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "04",
    fullDate: "04 July 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-07-25-1/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/swami-avyayananda-jis-insightful-sessions-2025",
    m: "Jul",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/swami-avyayananda-jis-insightful-sessions-2025",
    text: "On 4th July 2024, Chinmaya Vidyalaya New Delhi hosted two thought-provoking sessions for Class IX and XI students, led by the esteemed Swami Avyayananda Ji. As part of the school's commitment to holistic development, these interactive sessions aimed to foster inner awareness, intellectual growth, and emotional intelligence among the learners.<br/><br/>The first session with Class XI explored the theme of Healthy Bonds vs. Bondage in Relationships. Swamiji skillfully guided the learners in understanding the nuances of relationships during teenage years, highlighting the delicate balance between freedom and responsibility. He sensitized the students to the differences between self-centered, other-centered, and mutual relationships, encouraging them to cultivate self-awareness and emotional commitment.<br/><br/>The second session, focused on the theme of The Power of Artificial Intelligence and Conscious Living, emphasized the potential of AI as a tool for transformation when guided by human values and awareness. Swamiji highlighted three essential faculties for modern learners: Viveka (discernment between right and wrong), Leadership (the power to guide AI), and Adaptability (the ability to grow ahead of technology). He encouraged the learners to practice silence and Japa to access higher intelligence and inner clarity.<br/><br/>Through these sessions, the learners gained valuable insights into nurturing healthy relationships, developing emotional intelligence, and using technology wisely. They understood the significance of self-awareness, viveka, emotional commitment, and ethical decision-making in their personal and digital lives. By participating in these insightful sessions, the learners were equipped with essential faculties to navigate the complexities of relationships and technology with wisdom and clarity.",
    title: "Swami Avyayananda Ji's Insightful Sessions",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "01",
    fullDate: "01 July 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/vid1.mp4",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-07-25-1/vid2.mp4",
    ],
    isVideo: false,
    link: "/school-events/welcome-back-little-stars-2025",
    m: "Jul",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/welcome-back-little-stars-2025",
    text: 'Chinmaya Vidyalaya recently welcomed back its young learners for a new term, filled with excitement, creativity, and joy. The first day back was a fun-filled celebration that blended imagination, connection, and happiness, setting the tone for a fantastic term ahead.<br/><br/>The day began with a delightful Finger Puppet Fun activity, where the little stars created their own colourful finger puppets, letting their imaginations run wild. This creative exercise was followed by an engaging Puppet Show Time, where the story of "The Little Red Hen" came to life with giggles and teamwork, teaching the valuable lesson of helping hands.<br/><br/>During Circle Time Chats, the children proudly shared stories of their holiday adventures, including visits to grandparents and family outings. This sharing session helped build confidence and friendships among the young learners. Inspired by their stories, the children then created Holiday Art Diaries, turning memories into colourful drawings that captured the joy of their experiences.<br/><br/>The day was filled with heart, art, and happy beginnings, as the children settled back into school life with enthusiasm and eagerness. The event was a wonderful way to reconnect with peers and teachers, and the school community is thrilled to have the little stars back, shining bright with their sparkle and energy.',
    title: "Welcome Back, Little Stars!",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "21",
    fullDate: "21 June 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/vid1.mp4",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/vid2.mp4",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/vid3.mp4",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/30-06-25-1/vid4.mp4",
    ],
    isVideo: false,
    link: "/school-events/international-yoga-day-with-little-yogis-2025",
    m: "Jun",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/international-yoga-day-with-little-yogis-2025",
    text: "Chinmaya Vidyalaya, New Delhi, recently celebrated International Yoga Day with great enthusiasm and joy. The young learners of the school embraced the spirit of yoga with joyful hearts and curious minds, celebrating wellness and harmony from an early age.<br/><br/>The celebration was a unique and engaging experience for the students, as they explored fun Animal Yoga poses with their parents at home. The children rolled out their yoga mats and enthusiastically followed the graceful butterfly, playful dog, and cheerful monkey poses, guided lovingly by their parents. This heartwarming activity nurtured body awareness, mindfulness, and emotional bonding among the participants.<br/><br/>Through this activity, the students took playful steps towards focus, calm, and inner strength. The event was a testament to the school's commitment to raising peaceful, centered individuals who embody the values of wellness and harmony. By introducing yoga to young learners, Chinmaya Vidyalaya aims to instill a sense of balance and well-being that will benefit them throughout their lives.<br/><br/>The celebration of International Yoga Day at Chinmaya Vidyalaya New Delhi was a resounding success, highlighting the importance of yoga in promoting physical, mental, and emotional well-being. The event was a wonderful way to encourage mindfulness, self-awareness, and inner peace among the students.",
    title: "International Yoga Day with Little Yogis",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "15",
    fullDate: "15 June 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-2/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/fathers-day-celebration-2025",
    m: "Jun",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/fathers-day-celebration-2025",
    text: "The Pre-Primary section of Chinmaya Vidyalaya New Delhi, recently celebrated Father's Day with great enthusiasm and love. The little learners showered their fathers with heartfelt gestures, showcasing their creativity and appreciation for the special men in their lives.<br/><br/>The celebration was filled with delightful activities, including the creation of handmade cards that expressed the children's love and gratitude towards their fathers. The tiny tots also prepared a special treat for their dads, featuring refreshing drinks like the \"Papa Power Punch\" and \"Super Dad Smoothie.\" These thoughtful gestures brought smiles to the faces of the fathers, making the day even more special.<br/><br/>The Father's Day celebration at Chinmaya Vidyalaya was a wonderful opportunity for the children to bond with their fathers and create lasting memories. The event underscored the significance of the father-child relationship and its profound impact on a child's life. The school's effort to encourage children to express their love and appreciation for their fathers was truly commendable.<br/><br/>The celebration was a resounding success, with fathers beaming with pride as they spent quality time with their children. The event concluded with a sense of jo",
    title: "Father's Day Celebration",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "30",
    fullDate: "30 May 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-06-25-1/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/cbse-capacity-building-workshop-on-nep-2020-2025",
    m: "May",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/cbse-capacity-building-workshop-on-nep-2020-2025",
    text: "On 30th May 2025, Chinmaya Vidyalaya had the privilege of hosting a comprehensive capacity-building workshop focused on the transformative National Education Policy (NEP) 2020. The workshop was expertly guided by distinguished resource persons, Dr. Jayanti Banerjee and Dr. Hemlata Suri, who led the session with insightful discussions and practical implementation strategies.<br/><br/>The workshop commenced with a crucial segment on mental health, where the speakers emphasized the critical need to support students' emotional and psychological well-being. The session covered ways to identify and assist students experiencing mental health issues, highlighting the role of teachers in recognizing early signs of stress, anxiety, and behavioral issues among students. The importance of creating a safe and supportive learning environment was also stressed, underscoring the need for educators to prioritize student mental well-being.<br/><br/>The focus then shifted to an in-depth session on the National Education Policy (NEP) 2020, where participants gained valuable insights into implementing NEP's vision for a holistic and globally relevant education system. The workshop aimed to build awareness and understanding of NEP 2020's recommendations, CBSE initiatives, and implementation strategies in schools. The speakers provided educators with practical strategies to support students' emotional and psychological well-being, equipping them to create a future-ready learning environment.<br/><br/>Through this workshop, Chinmaya Vidyalaya demonstrated its commitment to empowering educators with the knowledge and skills necessary to implement NEP 2020 effectively. The event successfully provided a platform for educators to engage with the policy's pivotal aspects and practical implementation strategies, ultimately contributing to the creation of a holistic and supportive learning environment for students.",
    title: "CBSE Capacity Building Workshop on NEP 2020",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "29",
    fullDate: "29 May 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-06-25-1/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/say-no-to-tobacco-and-drug-awareness-assembly-2025",
    m: "May",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/say-no-to-tobacco-and-drug-awareness-assembly-2025",
    text: 'On Thursday, 29th May 2025, Class IX of Chinmaya Vidyalaya conducted a special assembly on "Say No to Tobacco and Drug Awareness" to sensitise the learners of senior school about the ill effects of substance abuse. The assembly began with an introduction to the theme, followed by a brief news update, setting the tone for a thought-provoking session.<br/><br/>A compelling Nukkad Natak presented by the students was the highlight of the event, effectively conveying the physical, emotional, and societal consequences of drug and tobacco use. The audience resonated deeply with the message, and the performance culminated in a collective pledge to remain drug-free.<br/><br/>Ms. Nadisha Goswami, Middle and Secondary Coordinator, addressed the students with an inspiring talk on making healthy life choices and resisting peer pressure. Her words of wisdom motivated the students to take a proactive approach towards a healthy and substance-free lifestyle.<br/><br/>The event successfully conveyed the importance of awareness, prevention, and collective responsibility, and the learners understood the adverse effects of substance abuse. By promoting awareness and healthy choices, the assembly empowered the students to make informed decisions and strive for a substance-free life. The assembly was a resounding success, and the school community is confident that the message will have a lasting impact on the students.',
    title: "Say No to Tobacco and Drug Awareness Assembly",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "22",
    fullDate: "22 May 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-2/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/senior-investiture-ceremony-netritva-2025",
    m: "May",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/senior-investiture-ceremony-netritva-2025",
    text: `On 22 May 2025, Chinmaya Vidyalaya, New Delhi, proudly celebrated the Senior Investiture Ceremony – Netritva, a significant milestone in the academic calendar 2025–26. The ceremony began with a soulful invocation, setting a reverent tone for the occasion.
    <br/><br/>
Principal, Ms. Archana Soni, delivered an empowering address, encouraging the newly appointed student leaders to lead by example, with humility, courage, and a sense of responsibility. The highlight of the event was the formal conferring of badges and sashes to the Student Council members by the Principal, Senior Secondary Coordinator, Middle & Secondary Coordinator, and Council Incharge.
<br/><br/>
The ceremonial handover of the school flag to the Head Boy, Manav Pandey, symbolized the transfer of responsibility. Head Girl Bhavya Jha then led the Council in the solemn oath of allegiance to the school. In their Vote of Thanks, the Head Boy and Head Girl pledged on behalf of the Council to uphold the values of the institution and fulfill their duties with utmost sincerity and dedication.
<br/><br/>
The ceremony concluded with the National Anthem, echoing a spirit of unity, purpose, and leadership. This momentous occasion marked a proud step in the journey of nurturing confident, compassionate leaders of tomorrow at Chinmaya Vidyalaya. The newly appointed student leaders are poised to make a positive impact, embodying the values and principles of the institution.`,
    title: "Senior Investiture Ceremony – Netritva",
    videoSrc: "",
    y: "2025",
  },

  {
    d: "15",
    fullDate: "15 May 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-2/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/immersive-kathak-workshop-2025",
    m: "May",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/immersive-kathak-workshop-2025",
    text: "On 15 May 2025, the girls of Classes VI and VII at Chinmaya Vidyalaya had the opportunity to immerse themselves in the rich cultural heritage of Kathak, one of India's most revered classical dance forms. The workshop, conducted by renowned Kathak dancer, choreographer, and educator Gunjan Singh, was a journey into the heart of Indian tradition.<br/><br/>Trained under the legendary Padma Vibhushan Pt. Birju Maharaj, Gunjan Singh guided the students through the fundamentals of Kathak, including mudras, chakras (spins), and the intricate connection between movement and storytelling. The workshop seamlessly wove together rhythm (taal), footwork, and expressions (abhinaya) to bring tales from mythology and history to life.<br/><br/>As the students explored the art of Kathak, their curiosity blossomed into graceful confidence. Witnessing their growth and enthusiasm was a joy, and the workshop proved to be a valuable experience for the young learners. The event was a testament to Chinmaya Vidyalaya's commitment to nurturing the cultural and artistic talents of its students.",
    title: "Immersive Kathak Workshop",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "08",
    fullDate: "08 May 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-05-25-1/pic17.jpg",
    ],
    isVideo: false,
    link: "/school-events/celebrating-pujya-gurudev-swami-chinmayananda-jayanti-sewa-diwas-2025",
    m: "May",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/celebrating-pujya-gurudev-swami-chinmayananda-jayanti-sewa-diwas-2025",
    text: "Chinmaya Vidyalaya reverently celebrated the birth anniversary of Pujya Gurudev Swami Chinmayananda with great enthusiasm and spiritual fervour from 8th May over the next few days. The celebration commenced with a serene Paduka Puja, invoking the blessings of Gurudev and expressing collective gratitude. Students, adorned in maroon kurta-pyjamas, embodied the spirit of the occasion.<br/><br/>The Principal, Ms Archana Soni, addressed the Student Council with heartfelt words of encouragement, inspiring them to lead with vision, humility, and dedication. A special screening of Swami Chinmayananda ji’s “Youth Today Talk” was organised, offering thought-provoking insights into the power of youth guided by knowledge and values. Students found the message deeply inspiring and relevant.<br/><br/>Various activities were organised for students across different grades. Grades VI to VIII participated in creative poster and eco-friendly paper bag making activities, while Grade IX students penned touching letters to Gurudev, expressing love, respect, and heartfelt gratitude. In a spiritually uplifting initiative, each section across all grades chanted Swami Chinmayananda’s 108 divine names, filling the Vidyalaya atmosphere with sacred vibrations.<br/><br/>In alignment with the spirit of SEWA (Selfless Service), Primary students joyfully served lemonade to teachers and distributed chocolates among peers, embracing simple acts of kindness with great joy and meaning.<br/><br/>The celebration's highlight was the Inter-House Guru Bhajan Competition, held at the basketball court, where students from all four houses presented devotional bhajans with remarkable enthusiasm and talent. The judges praised their heartfelt performances and offered constructive feedback to enhance their efforts further. The Principal appreciated the dedication of all participants and motivated students to continue engaging in inter-house activities with passion and team spirit.<br/><br/>The celebration was a beautiful reflection of the values that Chinmaya Vidyalaya cherishes — devotion, service, and love — and served as a powerful reminder of Gurudev’s timeless teachings. It was indeed a day filled with gratitude, inspiration, and spiritual joy.",
    title: "Celebrating Pujya Gurudev Swami Chinmayananda Jayanti - Sewa Diwas",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "07",
    fullDate: "07 May 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-3/pic24.jpg",
    ],
    isVideo: false,
    link: "/school-events/mothers-day-celebration-2025",
    m: "May",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/mothers-day-celebration-2025",
    text: `The Pre-Primary Department of Chinmaya Vidyalaya, Vasant Vihar, joyfully celebrated Mother's Day on 7th May 2025. The event honoured the invaluable role mothers play in our lives, filling the day with warmth, appreciation, and cherished moments.
    <br/><br/>
The celebration began with a heartfelt welcome speech, followed by a soulful song by the school choir and a charming dance performance by the tiny tots, setting the perfect tone for the day. A range of interactive activities added vibrance to the event, including fun games such as Balloon Toss and Cup Pyramid, and an engaging DJ session where mothers picked chits and danced with their children while participating in the Newspaper Fold dance game.
<br/><br/>
A DIY snack-making activity using Monaco bites brought smiles and creativity to the gathering. One of the most meaningful activities was the paper boat-making session, where mothers and their children created origami boats, wrote their names on them, and floated them in water — symbolizing love, bonding, and cherished memories shared together.
<br/><br/>
As a token of appreciation, each mother received a goody bag. The event concluded with heartfelt messages written by mothers on the Feedback Board, making the celebration truly memorable and deeply touching. The Mother's Day celebration at Chinmaya Vidyalaya, Vasant Vihar, was a joyous tribute to the love and dedication of mothers, creating lasting memories for all involved.`,
    title: "Mother's Day Celebration",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "03",
    fullDate: "03 May 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-05-25-1/pic25.jpg",
    ],
    isVideo: false,
    link: "/school-events/leadership-dreams-take-centre-stage-investiture-ceremony-2025",
    m: "May",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/leadership-dreams-take-centre-stage-investiture-ceremony-2025",
    text: "On 3rd May 2025, Chinmaya Vidyalaya, New Delhi, proudly celebrated its annual Investiture Ceremony, welcoming a new generation of leaders to the school's esteemed student council. The ceremony was a grand affair, recognising and celebrating the newly elected student council members, and conferring upon them badges, sashes, and new responsibilities.<br/><br/>The programme commenced with a solemn invocation, setting the tone for the occasion. Ms. Archana Gaur, Primary Headmistress, addressed the students, encouraging the elected leaders to be dutiful and responsible in their new roles. Her words of wisdom inspired the young leaders to strive for excellence and lead by example.<br/><br/>A captivating dance performance added a touch of vibrancy to the ceremony, igniting a sense of solemnity, achievement, and confidence among the students. The Prefectorial Ceremony was a proud moment for all, as the newly elected student council members were formally recognised and invested with their new roles.<br/><br/>The Head Boy delivered an inspiring speech, urging his peers to lead by example and uphold the values of the school. His words resonated with the audience, and the programme concluded with the oath-taking ceremony, where the newly elected student council members sincerely promised to carry out their duties with full dedication and effort.<br/><br/>The Investiture Ceremony was a grand success, and the school community congratulates the young achievers on their well-deserved recognition. We are confident that they will excel in their new roles and make a positive impact on the school community. The school believes that leadership is not just about holding positions, but about taking responsibility, leading by example, and making a positive impact on the community. We wish our newly elected student council members all the best in their new roles and look forward to seeing them excel.",
    title: "Leadership Dreams Take Centre Stage: Investiture Ceremony 2025",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "29",
    fullDate: "29 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-05-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-05-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-05-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-05-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-05-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-05-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-05-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-05-25-1/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/world-dance-day-celebration-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-dance-day-celebration-2025",
    text: "On 29th April 2025, the Primary Department of Chinmaya Vidyalaya presented a vibrant assembly in celebration of World Dance Day. The event showcased a diverse range of dance forms, including Irish folk dance, Chau folk dance of Bengal and Odisha, and Brazil's freehand and Zumba styles. The enthusiastic participation of teachers added to the energy, turning the assembly into a joyous celebration of rhythm, culture, and unity.<br/><br/>The celebration also included a 45-minute interactive dance workshop for Class VI students, conducted by renowned Chhau artist Mr. Sumit Mandal. During the workshop, students were introduced to the basics of Mayurbhanj Chhau, where they learned to link dance movements to everyday chores like sweeping and grinding. This engaging approach made learning fun, allowing students to explore storytelling while developing their coordination and rhythm.<br/><br/>The World Dance Day celebration beautifully reflected Chinmaya Vidyalaya's commitment to holistic education and its encouragement of artistic expression among learners. The event highlighted the importance of dance as a means of cultural expression and its role in fostering creativity, discipline, and teamwork among students.",
    title: "World Dance Day Celebration ",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "28",
    fullDate: "28 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-05-25-1/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/delhi-police-self-defense-training-program-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/delhi-police-self-defense-training-program-2025",
    text: "On 28th April 2025, Chinmaya Vidyalaya hosted a significant and commendable initiative aimed at empowering young girls – a Self-Defense Training Program conducted by the Delhi Police. The program was designed for girl students of Classes VIII to XI and focused on imparting practical self-defense techniques, building confidence, mental strength, and awareness necessary for navigating today's world safely and fearlessly.<br/><br/>Trained instructors from the Delhi Police taught the girls vital techniques for protecting themselves in various real-world scenarios, covering physical defense moves, techniques to break free from an aggressor, methods to de-escalate situations, and strategies to seek help effectively. The program also emphasized the importance of alertness, presence of mind, and quick decision-making, crucial tools in ensuring personal safety.<br/><br/>The training session was a resounding success, with the young girls participating with energy and determination. Chinmaya Vidyalaya extends its heartfelt appreciation to the Delhi Police for taking this impactful step and to all the participants for their enthusiasm and commitment. The lessons of strength and courage learned during this program will undoubtedly stay with the girls throughout their lives, empowering them to face challenges with confidence and resilience.",
    title: "Delhi Police Self-Defense Training Program",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "24",
    fullDate: "24 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic26.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic27.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic28.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic29.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic30.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-6/pic31.jpg",
    ],
    isVideo: false,
    link: "/school-events/space-club-orientation-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/space-club-orientation-2025",
    text: "The Primary Department of Chinmaya Vidyalaya recently hosted a thrilling Space Club orientation session, conducted by Space Explorers on 24th April 2025. This exciting initiative offered students hands-on learning opportunities in astronomy and space science, sparking their curiosity and interest in these fascinating fields.<br/><br/>During the session, students participated in a series of engaging experiments, including Lung Capacity, Bottle Balloon, Pop, and Hydro Rocketry. These interactive activities provided tangible experiences that reinforced fundamental scientific concepts, allowing students to grasp complex ideas in a fun and accessible way. The experiments were carefully designed to demonstrate the key highlights of the Space Club, showcasing the exciting possibilities that lie within the realm of space exploration.<br/><br/>The students had an absolute blast, participating wholeheartedly in all the activities and demonstrating their innate curiosity and enthusiasm for learning. The orientation session was a resounding success, setting the stage for a rewarding and enriching experience for the students as they embark on this exciting journey with the Space Club.",
    title: "Space Club Orientation ",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "23",
    fullDate: "23 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-7/pic12.jpg",
    ],
    isVideo: false,
    link: "/school-events/world-book-day-celebration-drop-and-read-activity-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-book-day-celebration-drop-and-read-activity-2025",
    text: 'On World Book Day, Chinmaya Vidyalaya celebrated the joy of reading with a "Drop and Read" activity on 23rd April 2025. During the Enrichment Period, students and teachers across all classes participated in a dedicated session of silent, mindful reading—this initiative aimed to foster a lifelong love for reading and encourage a distraction-free, immersive literary experience.<br/><br/>The atmosphere in every classroom was calm and focused, reflecting the deep engagement of students and teachers with their chosen books. The "Drop and Read" activity successfully encouraged mindful, undisturbed reading habits, strengthening the bond between readers and books. By immersing themselves in literature, participants enhanced their vocabulary skills and developed a greater appreciation for the written word.<br/><br/>The event was a resounding success, highlighting the importance of reading in a world filled with distractions. By promoting a culture of silent, mindful reading, the school reinforced its commitment to nurturing a love for literature and learning among its students. The "Drop and Read" activity was a wonderful way to celebrate World Book Day, and its impact is expected to be felt throughout the academic year.',
    title: 'World Book Day Celebration: "Drop and Read" Activity',
    videoSrc: "",
    y: "2025",
  },
  {
    d: "23",
    fullDate: "23 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-5/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-5/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-5/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-5/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-5/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-5/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-5/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-5/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/storytelling-session-with-ms-deepa-aggarwal-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/storytelling-session-with-ms-deepa-aggarwal-2025",
    text: "The Library Department of Chinmaya Vidyalaya New Delhi organised a captivating storytelling session for students of Classes VII and VIII in the school library on Wednesday, 23rd April 2024. Renowned writer and poet, Ms Deepa Aggarwal, interacted with the students and showcased her newly released book, \"Kashmir Kashmir\", published by Scholastic.<br/><br/>During the session, Ms Aggarwal regaled the students with selected excerpts from her book, bringing the stories to life with her engaging narrative style. The students were thoroughly enthralled, actively participating in the session by posing thoughtful questions to Ms Aggarwal. Her responses provided insights into her writing process and encouraged the students to explore different perspectives.<br/><br/>The storytelling session proved to be a resounding success, inspiring the students to develop a deeper love for reading. By exposing them to rich vocabulary and complex narratives, the event helped improve their comprehension skills and fostered a greater appreciation for literature. The interaction with Ms Aggarwal left a lasting impact on the young minds, motivating them to explore new horizons in the world of books.<br/><br/>The Library Department's efforts in organising this event were commendable, providing a unique opportunity for the students to engage with a celebrated author and poet. The session was a testament to the school's commitment to nurturing a love for reading and learning among its students.",
    title: "Storytelling Session with Ms. Deepa Aggarwal",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "23",
    fullDate: "23 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-4/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/run-o-mania-sprinting-towards-fun-and-fitness-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/run-o-mania-sprinting-towards-fun-and-fitness-2025",
    text: "On April 23, 2025, Chinmaya Vidyalaya New Delhi hosted Run-O-Mania, a high-energy event that celebrated health, teamwork, and sportsmanship through a series of thrilling races. The school grounds were abuzz with excitement as young athletes participated in a variety of fun and challenging activities designed to test their physical and mental agility.<br/><br/>The event kicked off with the Zig-Zag Race, where learners showcased their agility and control as they navigated through the course. This was followed by the Flat Race, a test of pure speed that had everyone cheering on their favourite runners. The Sticky Ball Race added a playful twist, requiring participants to skilfully balance and place their sticky balls, demonstrating coordination and focus.<br/><br/>The Relay Race was a highlight of the event, emphasizing the importance of teamwork and timing. The tiny tots worked together seamlessly, fostering a strong sense of collaboration and camaraderie. The Obstacle/Pick and Put Race challenged both physical and mental agility, pushing the young athletes to think on their feet and respond quickly.<br/><br/>Run-O-Mania was more than just a sporting event – it was a celebration of effort, determination, and joyful learning. As the young participants ran, jumped, and cheered, they not only strengthened their bodies but also built lasting memories of fun, friendship, and fearless participation. The event was a testament to the school's commitment to promoting physical activity, teamwork, and holistic development among its students.",
    title: "Run-O-Mania Sprinting Towards Fun and Fitness!",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "22",
    fullDate: "22 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-3/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/earth-day-assembly-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/earth-day-assembly-2025",
    text: "On April 22, 2025, Class X students of Chinmaya Vidyalaya New Delhi, conducted a special assembly to commemorate Earth Day, to raise awareness about environmental issues, and promote sustainable practices. The event began with students presenting the news and sharing thought-provoking messages highlighting the importance of protecting the planet.<br/><br/>A powerful street play was performed, conveying the urgent need to save the Earth and emphasizing the consequences of neglecting environmental conservation. This impactful performance was followed by a melodious musical presentation that underscored the significance of preserving nature and its resources.<br/><br/>The Principal addressed the students, emphasizing the relevance of Earth Day and the crucial role that individuals play in protecting the planet. The assembly concluded with a pledge, reinforcing the commitment to eco-friendly actions and encouraging students to adopt sustainable practices in their daily lives.<br/><br/>The Earth Day assembly instilled a sense of responsibility and care for the environment among the learners, inspiring them to participate in green initiatives both within and outside the school. The event served as a reminder of the importance of collective action in protecting the planet and promoting a more sustainable future.",
    title: "Earth Day Assembly",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "22",
    fullDate: "22 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-2/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/earth-day-celebration-pre-primary-department-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/earth-day-celebration-pre-primary-department-2025",
    text: 'On Tuesday, April 22, 2025, the Pre-Primary Department of Chinmaya Vidyalaya celebrated Earth Day with a series of engaging and meaningful activities. The event aimed to instil a sense of environmental responsibility in young learners, encouraging them to become eco-conscious citizens.<br/><br/>The celebration began with a special assembly, where students presented various ways to protect the Earth using colourful placards and posters. One student creatively dressed as the Earth delivered a brief talk, emphasizing the importance of environmental conservation. The assembly served as a thoughtful reminder of the duty to care for the planet.<br/><br/>The little learners then participated in an Earth-themed handprint painting activity, creating artistic impressions of the Earth using vibrant blue and green paints. This activity reinforced the message that "We\'ve got the whole world in our hands," highlighting the significance of protecting the planet.<br/><br/>A lively awareness drive followed, where students chanted catchy slogans such as "Save Water," "Do Not Litter," "Use Dustbins," and "Save Electricity." This spirited initiative spread awareness about eco-friendly habits and left a lasting impression on the young minds.<br/><br/>The Earth Day celebration concluded with a strong message of environmental stewardship, echoing the belief that small hands can make a big difference. The event successfully instilled a sense of responsibility and awareness in the young learners, inspiring them to contribute to a more sustainable future.',
    title: "Earth Day Celebration - Pre-Primary Department",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "21",
    fullDate: "21 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-04-25-1/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/world-earth-day-celebration-primary-department-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-earth-day-celebration-primary-department-2025",
    text: "On April 21, the Primary Department of Chinmaya Vidyalaya, New Delhi, celebrated World Earth Day with great enthusiasm. The learners of Class IV took centre stage in a beautiful assembly, highlighting the significance of protecting the planet for future generations.<br/><br/>The event began with a brief introduction to Earth Day, emphasizing the importance of reducing pollution, conserving resources, and planting trees. The students then brought the 1973 Chipko Movement to life on stage, showcasing the courageous efforts of women and children in Uttarakhand who fought to save trees from being cut down. This powerful dramatization highlighted the crucial role of forests in maintaining ecological balance, the importance of environmental conservation, and the significant role of women in conserving the environment.<br/><br/>The assembly also provided an opportunity to recognize the achievements of two outstanding students, Ayush and Tayyab, who secured third position in the National Yoga Championship in the rhythmic event. Their accomplishment was a testament to their dedication and passion for sports.<br/><br/>The assembly concluded with a pledge taken by all learners to contribute to a healthier planet by planting trees, reducing, reusing, and recycling products to conserve natural resources. This commitment underscored the importance of individual actions in protecting the environment and promoting sustainability. The World Earth Day celebration was a meaningful and engaging experience for the students, inspiring them to become responsible stewards of the planet.",
    title: "World Earth Day Celebration - Primary Department",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "19",
    fullDate: "19 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-4/pic17.jpg",
    ],
    isVideo: false,
    link: "/school-events/health-well-being-session-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/health-well-being-session-2025",
    text: `On 19th April 2025, the staff members of Chinmaya Vidyalaya, New Delhi, embarked on a journey of self-discovery and well-being through two enriching sessions. The day began with "Nurturing Well-being: Mental Health and Fitness," featuring the recitation of Medha Suktam and breathing techniques led by experts. This was followed by a high-energy 30-minute aerobic workout session conducted by Mr. Gurpreet Singh, leaving participants invigorated and refreshed.
<br/><br/>
The second session, "Rasatman – Nectar of Soulful Living," was led by Mr. Shyam Banerjee and Ms. Ruma Dasgupta. The session delved into the concepts of Sattwa, Rajas, and Tamas, highlighting the importance of aligning one's abilities, duties, and divinity to achieve Swadharma. Participants gained valuable insights into Swanubhooti, the inner joy that frees us from outcome anxiety, and the significance of Mauna (active contemplation) and selfless service.
<br/><br/>
A highlight of the session was the introduction to the Ashtangsiddhis, eight spiritual strengths that educators can cultivate to enhance their leadership and teaching abilities. These qualities, including Anima, Mahima, Garima, Laghima, Prapti, Prakamya, Ishitvam, and Vashitvam, foster humility, responsibility, flexibility, and purposeful leadership.
<br/><br/>
The day concluded on a sweet note with a surprise ice cream treat for all staff members, promoting connection, rejuvenation, and community spirit. The session featuring Mitti ka Madho, a clay Hanuman idol, now placed in Swanubhooti Vatika, served as a poignant reminder of the power of devotion and spiritual growth.
<br/><br/>
Through these sessions, the staff of Chinmaya Vidyalaya, New Delhi, were reminded of the importance of nurturing their mental, physical, and spiritual well-being, ultimately enhancing their abilities as educators and individuals.`,
    title: "Health & Well Being Session",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "17",
    fullDate: "17 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/vid1.mp4",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-05-25-1/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/gurukul-under-the-sky-qutab-minar-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/gurukul-under-the-sky-qutab-minar-2025",
    text: "As part of the 'Gurukul under the Sky' initiative, around 110 students of Class VII from Chinmaya Vidyalaya, New Delhi, visited the historic Qutub complex on 17th April. The excursion focused on the theme ‘Heritage Under Threat from Disasters and Conflicts’, raising awareness about the increasing risks faced by heritage sites due to natural calamities, human negligence, wars, and conflicts.<br/><br/>The enriching experience helped students understand the importance of preserving cultural treasures and inspired them to become mindful custodians of history. Through observation and discussion, they connected deeply with the significance of safeguarding heritage for future generations.",
    title: "Gurukul under the Sky: Qutab Minar",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "17",
    fullDate: "17 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-5/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/sunshine-chill-celebration-report-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/sunshine-chill-celebration-report-2025",
    text: "Chinmaya Vidyalaya, New Delhi, joyfully welcomed the sunny season with a delightful Sunshine & Chill celebration held on 17th April, in its Pre-Primary department. The event was a vibrant blend of creativity, hands-on learning, and refreshing treats, designed to bring smiles to the faces of our young learners.<br/><br/>Dressed in cheerful summer attire, complete with stylish hats and sunglasses, the children embarked on a day full of fun and discovery. The celebration commenced with a Fruit Punch Making activity, where the tiny chefs mixed juicy fruits and colourful beverages to create their own summer coolers. This sensory-rich experience introduced them to the world of healthy eating while exploring textures, colours, and flavours in a playful manner.<br/><br/>The Creative Craft Corner was another highlight, where imaginations ran wild as children designed vibrant ice cream cones and sweet treats using sponge painting and tearing & pasting techniques. This engaging activity enhanced their fine motor skills while showcasing their artistic expressions.<br/><br/>A special treat was in store with the Ice-Cream Vendor Visit, where an adorable ice cream cart was set up on campus. Children exchanged their special tokens for their favourite icy delights, practising early numeracy, social interaction, and the joy of turn-taking.<br/><br/>The foyer was transformed into a colourful, summery wonderland, setting the perfect backdrop for this joyful celebration. With laughter and excitement filling the air, Sunshine & Chill proved to be a heartwarming and unforgettable experience. The young learners embraced the spirit of summer with open hearts, creating cherished memories that will last a lifetime.",
    title: "Sunshine & Chill Celebration Report",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "16",
    fullDate: "16 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/videos/tarang-appriciation-day-event-reel.mp4",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-2/pic14.jpg",
    ],
    isVideo: false,
    link: "/school-events/tarang-appreciation-day-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/tarang-appreciation-day-2025",
    text: 'Chinmaya Vidyalaya celebrated TARANG – Appreciation Day 2025 with great enthusiasm on April 16, 2025. The event was a vibrant celebration of joy, pride, and achievement, marked by a series of captivating performances and inspiring speeches.<br/><br/>The day began with a soulful orchestra performance by Fusion Global Music, setting the tone for a day of celebration and pride. This was followed by a divine Ganesh Vandana, invoking blessings for an auspicious start. The Principal warmly welcomed the Chief Guest, Mr. T.S. Vijay, a proud alumnus of the 1994 batch, with a Tulsi planter, while PTA members were also honoured.<br/><br/>The Welcome Dance, "The Cosmic Tandava," was a tribute to the fierce yet graceful energy of Lord Shiva, captivating the audience with its spellbinding performance. The Primary Wing then presented a musical performance on "Koshish Karne Walon Ki Kabhi Haar Nahi Hoti," inspiring the audience with its uplifting message.<br/><br/>In her address, the Principal expressed gratitude and encouragement to the students, while Mr. Vijay, the Chief Guest, took everyone on a nostalgic journey through his Chinmaya days, evoking pride in the deep-rooted Chinmaya values. The Prize Distribution Ceremony that followed celebrated the achievements of students from Classes XII to III, recognising their hard work and dedication. Ms. Roli Chaudhry was also honoured for her 15 years of dedicated service to the school.<br/><br/>The senior students presented a motivational musical dance drama, "Family First: Smart Bhi, Saath Bhi," creatively highlighting the delicate balance between technology and relationships. The event concluded with the Grand Finale and National Anthem, leaving the learners motivated to set higher goals and strive for excellence.<br/><br/>The TARANG – Appreciation Day 2025 celebration was a glorious tribute to the achievements and values of Chinmaya Vidyalaya, inspiring students to reach new heights of excellence.',
    title: "TARANG – Appreciation Day 2025",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "16",
    fullDate: "16 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-1/pic12.jpg",
    ],
    isVideo: false,
    link: "/school-events/national-science-centre-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/national-science-centre-2025",
    text: "On 16th April 2025, learners from Classes III to VI of Chinmaya Vidyalaya, New Delhi, embarked on an exciting and educational visit to the National Science Centre. The trip, filled with curiosity and wonder, provided students with a unique opportunity to engage with scientific concepts in a hands-on environment, fostering a deeper understanding of the world of science.<br/><br/>During the visit, students explored a wide range of interactive exhibits and displays that brought various scientific fields to life. The learners had the opportunity to delve into captivating topics such as space, robotics, energy, and human biology, each of which sparked their imagination and prompted them to think critically about the world around them.<br/><br/>The students explored several fascinating galleries, each offering a distinct perspective on different aspects of science. The ‘Water – The Elixir of Life’ gallery highlighted the importance of water in sustaining life, while the Science and Technology Heritage gallery provided insight into the historical evolution of scientific inventions. The Human Biology gallery captivated the learners with its detailed exhibits about the human body, and the Prehistoric Life gallery took them on a journey through the ages of early life on Earth. The Fun Science gallery offered interactive, hands-on activities that delighted students, while the Sardar Patel Gallery focused on the contributions of the Iron Man of India.<br/><br/>Each gallery presented engaging and thought-provoking displays, including working models and interactive exhibits, that allowed students to engage directly with the concepts they were learning. The students were particularly amazed by the interactive exhibits that provided them with a deeper, more tangible understanding of the topics at hand.<br/><br/>The visit to the National Science Centre was not only a fun-filled experience but also an enriching educational journey. It helped students enhance their knowledge of scientific concepts and sparked their curiosity to explore new areas of learning. The trip was an unforgettable experience that combined education, discovery, and hands-on learning.<br/><br/>This exciting excursion further encouraged the students to see science not just as a subject in the classroom, but as a field of endless exploration and innovation. The trip has undoubtedly inspired many of the young learners to continue exploring the wonders of science and technology in their future studies.",
    title: "National Science Centre",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "15",
    fullDate: "15 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-4/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/world-art-day-celebration-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-art-day-celebration-2025",
    text: "On April 15, 2025, the Primary Department of Chinmaya Vidyalaya, New Delhi, joyfully commemorated World Art Day, embracing the theme 'Every Child is an Artist.' The event aimed to foster creativity and imagination among young learners, highlighting the significance of art in nurturing expression and confidence.<br/><br/>The festivities unfolded with classes showcasing unique artistic talents. Class I learners created vibrant floral art using onion painting techniques, while Class II students designed colourful posters. Class III students crafted intricate Mandala Art using bangles as a base, filling patterns with an array of colours. Class IV delighted everyone with quirky Doodle Art, sketching art tools and materials with freehand designs. Class V showcased serene sunrise scenes through Silhouette Paintings, blending colours beautifully.<br/><br/>Each class transformed their classrooms into mini art galleries, proudly displaying their creations. The celebration was a heartwarming tribute to the artistic talents of every child, showcasing their inner artists in a joyful and creative manner.",
    title: "World Art Day Celebration",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "14",
    fullDate: "14 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-3/pic6.jpg",
    ],
    isVideo: false,
    link: "/school-events/baisakhi-celebrations-in-the-primary-department-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/baisakhi-celebrations-in-the-primary-department-2025",
    text: "The Primary Department at Chinmaya Vidyalaya New Delhi joyfully celebrated the festival of Baisakhi with a delightful array of activities designed for its students. The festivities began with an engaging PowerPoint Presentation that illustrated the significance of Baisakhi in enriching the lives of farmers and highlighted the numerous benefits of millets, a superfood.<br/><br/>The presentation captivated the students with fascinating facts about millets, sparking their curiosity and interest. The enthusiastic learners from classes I and II indulged in a wholesome breakfast featuring millets, while class III savoured a refreshing Pearl Millet Salad.<br/><br/>Meanwhile, class IV enjoyed scrumptious millet sandwiches, and class V took pleasure in crafting millet canapé bites. The students beamed with pride as they prepared these delicacies, developing their culinary skills and appreciation for traditional foods.<br/><br/>The celebration was a wonderful way to introduce students to the cultural significance of Baisakhi and the importance of millets in our lives. The event was a resounding success, leaving a lasting impression on the young learners.",
    title: "Baisakhi Celebrations in the Primary Department",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "14",
    fullDate: "14 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-2/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/vibrant-baisakhi-celebrations-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/vibrant-baisakhi-celebrations-2025",
    text: "Vibrant Baisakhi Celebrations at Chinmaya Vidyalaya<br/><br/>The spirit of Baisakhi was joyfully celebrated at Chinmaya Vidyalaya New Delhi, as learners enthusiastically participated in a special assembly that highlighted the significance of the festival. The occasion was marked with energetic performances of Bhangra and Gidda, spreading festive cheer throughout the school.<br/><br/>The Nursery foyer was transformed into a vibrant display, showcasing a beautifully curated Baisakhi tableau and an informative millet corner, emphasizing the importance of this traditional crop. The festive atmosphere was further enhanced as learners danced enthusiastically to the lively beats of the Dhol, truly capturing the essence of Punjab's cultural heritage.<br/><br/>In the classrooms, young learners engaged in a creative corn craft activity using paper crumbling techniques, symbolizing the harvest season. A short video was also shown, enriching their understanding of Baisakhi and its cultural roots.<br/><br/>The celebration was made even more special as learners, dressed in colourful traditional kurtas, brought millet-based delicacies to share, celebrating both culture and nutrition with enthusiasm and pride. The event was a wonderful way to introduce learners to the rich cultural heritage and traditions associated with Baisakhi.",
    title: "Vibrant Baisakhi Celebrations",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "11",
    fullDate: "11 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-04-25-3/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/inter-house-sports-tournament-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/inter-house-sports-tournament-2025",
    text: "On April 11, 2025, Chinmaya Vidyalaya New Delhi hosted the semi-final matches of the Inter-House Sports Tournament, an event that brought together students from Classes VI to XII in a celebration of athleticism, teamwork, and sportsmanship. The day was filled with energy and excitement as students showcased their passion and skills in various sports.<br/><br/>The football matches featuring Classes VI-VIII were intense and strategic, with students displaying exceptional coordination and teamwork on the field. Meanwhile, Classes IX-XII took to the basketball court for high-energy volleyball and basketball matches, demonstrating precision, determination, and a strong sense of camaraderie.<br/><br/>Throughout the tournament, the spirit of competition was evident, but what truly stood out was the mutual respect and sportsmanship among all participants. The event provided a platform for students to display their athletic talents, improve their physical fitness, and develop essential skills such as teamwork, discipline, and problem-solving.<br/><br/>Chinmaya Vidyalaya takes pride in every student who participated in the tournament, giving their best and embodying the true spirit of sports. The semi-final matches were a testament to the school's commitment to fostering a culture of athletic excellence and teamwork. The grand finale of the tournament is eagerly awaited, promising to be an exciting conclusion to the event.",
    title: "Inter-House Sports Tournament",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "07",
    fullDate: "07 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-6/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-6/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-6/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-6/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-6/pic5.jpg",
    ],
    isVideo: false,
    link: "/school-events/digital-poster-making-on-world-health-day-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/digital-poster-making-on-world-health-day-2025",
    text: "To spread awareness about global health issues, healthy living, and promotes collective action,<br/><br/>Students of Class XII create digital posters on World Health Day using Adobe Express and Canva.",
    title: "Digital Poster making on world health day",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "05",
    fullDate: "05 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-04-25-1/pic14.jpg",
    ],
    isVideo: false,
    link: "/school-events/nursery-adaptation-day-3-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/nursery-adaptation-day-3-2025",
    text: "Nursery Adaptation Day 3: A Joyful Celebration at Chinmaya Vidyalaya, New Delhi<br/><br/>On 5th April 2025, Chinmaya Vidyalaya, New Delhi, organized Nursery Adaptation Day 3, a vibrant celebration designed to create a joyful and welcoming environment for its young learners. The day commenced with an exciting foyer activity, where children hopped over hoopla and hurdles, followed by an engaging easel painting session alongside their parents, filling the space with vibrant colors.<br/><br/>The little ones then embarked on a nature walk, exploring the lush greenery of their school surroundings and discovering the beauty of the natural world. Their creativity blossomed as they crafted butterflies using leaves, fostering a sense of wonder and accomplishment.<br/><br/>The day was filled with cheerful rhymes and lively musical sessions, where the learners danced and clapped along with enthusiasm. A photo booth was also set up, allowing the children to capture joyful moments with their friends.<br/><br/>The highlight of the day was a special visit from the beloved cartoon character, Donald Duck, bringing wide smiles and endless delight to the children. As the event concluded, the tiny tots left with cheerful smiles and a special goodie bag, marking the end of a fun-filled and enriching experience.<br/><br/>The Nursery Adaptation Day 3 was a resounding success, providing a warm and welcoming introduction to Chinmaya Vidyalaya, New Delhi, and setting the stage for a wonderful learning journey for its young students.",
    title: "Nursery Adaptation Day 3 ",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "04",
    fullDate: "04 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-3/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/nursery-adaptation-day-02-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/nursery-adaptation-day-02-2025",
    text: "Nursery Adaptation Day 2: Joy and Discovery at Chinmaya Vidyalaya, New Delhi<br/><br/>Chinmaya Vidyalaya, New Delhi, continued its programme of welcoming its youngest pupils with Nursery Adaptation Day 2, held on 4th April 2025. The day proved to be a vibrant and engaging experience, filled with joy and creative activities for the children. As the day's events unfolded, it was clear that the sentiment \"The beautiful thing about learning is that no one can take it away from you\" resonated with the children's experiences.<br/><br/>The morning's activities commenced with an energetic session of Alphabet Hopscotch, allowing the young learners to expend some energy. This was followed by a delightful Balloon Painting activity, in which children and their parents participated, resulting in a colourful and cheerful atmosphere.<br/><br/>The children's creative skills were further developed through a Paper Bag Creations session, which instilled in them a sense of accomplishment and pride in their handiwork. The storytelling session of The Lion and the Mouse captivated the little ones, imparting valuable lessons about kindness and friendship. An engaging rhyme session also took place, during which the children sang and danced with considerable enthusiasm.<br/><br/>A particular highlight of the day was Selfie Time, which allowed for the capturing of precious memories as the children struck adorable poses. The children's excitement reached its peak with a surprise visit from a Panda character, adding an extra element of fun to their adventure.<br/><br/>As the day drew to a close, the young learners departed with smiles and a Goodie Bag, marking the conclusion of a fulfilling and enriching experience.",
    title: "Nursery Adaptation Day 02",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "03",
    fullDate: "03 April 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-2/pic12.jpg",
    ],
    isVideo: false,
    link: "/school-events/nursery-adaptation-day-01-2025",
    m: "Apr",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/nursery-adaptation-day-01-2025",
    text: "Nursery Adaptation Day 1: A Joyful Beginning at Chinmaya Vidyalaya, New Delhi<br/><br/>On Thursday, 3rd April 2025, Chinmaya Vidyalaya, New Delhi, hosted Nursery Adaptation Day 1, a specially designed programme to welcome its newest additions – the nursery students. The event aimed to create a warm and cheerful atmosphere, setting the stage for a positive school journey.<br/><br/>The day commenced with the little learners arriving in vibrant attire, with boys dressed in bright blue and girls in lovely pink, adding to the festive spirit. The tiny tots were then immersed in a range of fun-filled activities, carefully crafted to enhance their coordination and balance. These included agility ladder walking and pattern walking, which kept the children engaged and excited.<br/><br/>The highlight of the day was a surprise appearance by Doraemon, the beloved cartoon character. The children gleefully recited rhymes alongside Doraemon, filling the atmosphere with laughter and cheer. This was followed by an enchanting magic show, which left the young learners spellbound and in awe of the tricks performed.<br/><br/>To capture the memories of this special day, a lively photo booth was set up, where the children took delightful photos with their new friends. As a keepsake of this joyful beginning, each child received a handcrafted umbrella painting made using cotton buds, along with a goody bag filled with surprises.<br/><br/>The day concluded with beaming smiles and twinkling eyes, marking the start of a wonderful school journey for these young learners. The Nursery Adaptation Day 1 was a resounding success, providing a warm and welcoming introduction to Chinmaya Vidyalaya, New Delhi.",
    title: "Nursery Adaptation Day 01",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "28",
    fullDate: "24 - 28 March 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-25-1/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/health-and-safety-week-2025",
    m: "Mar",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/health-and-safety-week-2025",
    text: "Chinmaya Vidyalaya, New Delhi, successfully conducted Health & Safety Week from 24th to 28th March 2025, reaffirming its commitment to the holistic well-being of students. The initiative focused on key areas such as cyber safety, physical fitness, mental health, and emotional well-being, ensuring that students develop essential life skills to navigate challenges effectively. Through this programme, students gained an understanding of the importance of online safety, equipping them with skills to navigate digital platforms securely and responsibly. They also engaged in yoga and Zumba sessions, enhancing their physical health by improving flexibility, strength, and overall fitness. Furthermore, they acquired techniques for managing stress and anxiety, fostering resilience in both academic and personal spheres. Exposure to mindfulness exercises helped them cultivate self-awareness and emotional regulation, while group activities enabled them to develop teamwork and social skills, reinforcing a sense of community and support. By integrating physical, mental, and emotional health, students experienced a more balanced and fulfilling school life, positively impacting their academic performance and personal growth.<br/><br/>The programme was specially curated for students of Classes 10 and 12, incorporating diverse sessions aimed at fostering a balanced and healthy school life. Recognising the growing significance of cyber safety, interactive sessions educated students on securing their online presence and protecting personal information. These workshops empowered them with crucial knowledge on safe browsing, recognising cyber threats, and maintaining digital etiquette.<br/><br/>Physical well-being was emphasised through self-defence, yoga, and Zumba sessions, enabling students to build confidence, improve focus, and enhance overall fitness. The enthusiastic participation in these activities reflected the positive impact on students' mental and physical resilience. In addition, mental health and well-being were key aspects of the programme. Dedicated counselling sessions provided students with strategies to manage stress, develop resilience, and practise mindfulness. These sessions created a supportive space for open discussions, equipping students with valuable coping mechanisms for academic and personal challenges.<br/><br/>The Health & Safety Week at Chinmaya Vidyalaya reinforced the importance of a balanced lifestyle, integrating physical, mental, and emotional health into daily routines. The programme not only enriched students’ academic experiences but also instilled lifelong skills for well-being. By prioritising health and safety, the school continues to cultivate an environment where students can thrive holistically, ensuring success both inside and outside the classroom. The initiative stands as a testament to Chinmaya Vidyalaya’s unwavering commitment to nurturing well-rounded individuals prepared for the challenges of the future.",
    title: "Health and Safety Week",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "28",
    fullDate: "28 March 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-4/pic17.jpg",
    ],
    isVideo: false,
    link: "/school-events/orientation-ceremony-a-warm-welcome-2025",
    m: "Mar",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/orientation-ceremony-a-warm-welcome-2025",
    text: "On 28 March 2025, Chinmaya Vidyalaya, New Delhi, hosted an Orientation Ceremony to welcome new students and their parents to the institution. The event aimed to familiarise incoming students with the school's pedagogical philosophy and operational framework.<br/><br/>The ceremony commenced with a visual exposition, showcasing the school's academic and extracurricular achievements through a film. This informative presentation provided attendees with a comprehensive understanding of the Vidyalaya's ethos and values.<br/><br/>The Chief Guest, Ms. Jyotsna Bhardwaj, engaged with parents and shared valuable insights on parenting skills, highlighting the significance of childhood experiences in shaping an individual's character and beliefs.<br/><br/>Mr. Anand elaborated on the Vidyalaya's core ethos, emphasizing the institution's efforts to help students establish a connection with divinity.<br/><br/>The Principal, Ms. Archana Soni, extended a warm welcome to the parents and expressed gratitude for entrusting their children to the school. She provided essential information about the school's values, academic structure, and introduced the incharges and Office Team to the audience.<br/><br/>The event concluded with a class-specific orientation, where parents were briefed on essential aspects catering to the diverse needs of students from nursery to the ninth grade.<br/><br/>The Orientation Ceremony successfully integrated new families into the Chinmaya Vidyalaya community, fostering a sense of belonging and understanding.",
    title: "Orientation Ceremony 2025: A Warm Welcome ",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "25",
    fullDate: "25 March 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-3/pic6.jpg",
    ],
    isVideo: false,
    link: "/school-events/rids-ceremony-2025",
    m: "Mar",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-ceremony-2025",
    text: "Celebrating International Collaboration in Education: RIDS Ceremony 2025<br/><br/>On 25th March 2025, educators from across the region gathered for the RIDS ceremony, a momentous celebration of bridging worlds within the classroom. This inspiring event brought together like-minded individuals to recognize and honor schools that have embraced the RIDS challenge, fostering global citizens and promoting international collaboration in education.<br/><br/>The ceremony commenced with a formal opening and a welcoming address by Duncan Wilson, Managing Director of BC Education India. Mr. Wilson's words set the stage for the day's celebration, emphasizing the importance of international collaboration in education. The heart of the ceremony was the recognition of schools that had dared to expand their horizons. Each certificate presented was a testament to the dedication of teachers and students who have worked tirelessly to foster global citizens.<br/><br/>The audience witnessed a wave of applause as Chinmaya School was awarded both a certificate and a shield, a shining symbol of their commitment to global learning. The ceremony also featured insightful sessions, including S Manish Singh's presentation, which was a deep dive into the very essence of internationalism, prompting the audience to reflect on their roles in building a more interconnected world.<br/><br/>Shivangi Gupta's presentation on the British Council Spoken English Summer School Programme highlighted the power of language as a bridge, connecting cultures and fostering understanding. As the ceremony drew to a close, Moneesha Gupta, Assistant Director of BC Education India, delivered closing remarks that resonated deeply. Her address was a call to action, challenging the audience to dismantle the \"us vs. them\" narrative and to see the shared humanity that transcends national boundaries.<br/><br/>Her words ignited a renewed commitment to global understanding, leaving a lasting impression on the audience. The ceremony concluded with a networking session, a vibrant exchange of ideas that provided a chance for educators to connect with fellow professionals and forge new partnerships. This session was a fitting end to a day that celebrated the power of collaboration and the boundless potential of global learning.<br/><br/>The RIDS event was more than just a ceremony; it was a celebration of vision, dedication, and the unwavering belief in the power of education to create a more interconnected and understanding world. The echoes of the day will undoubtedly continue to inspire educators to nurture global citizens for generations to come.",
    title: "RIDS Ceremony",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "21",
    fullDate: "21 March 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-2/pic5.jpg",
    ],
    isVideo: false,
    link: "/school-events/plastic-paper-waste-collection-drive-2025",
    m: "Mar",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/plastic-paper-waste-collection-drive-2025",
    text: "On 21st March 2025, Chinmaya Vidyalaya New Delhi in partnership with Green Dream Foundation, organised a highly successful Plastic & Paper Waste Collection Drive. This initiative aimed to promote sustainable habits, environmental awareness and reduce pollution.<br/><br/>Parents and students actively participated by collecting and segregating clean plastic waste, including bottles, wrappers, newspapers, magazines and cardboard. To encourage participation, the Eco Club introduced incentives based on the weight of waste collected, with rewards including seed pencils, seed pens and certificates of appreciation.<br/><br/>The event successfully instilled a sense of responsibility in students, highlighting the importance of waste segregation and sustainable practices. By participating in this initiative, students developed eco-friendly habits, ensuring a cleaner and greener environment both within the school and their local communities.<br/><br/>This event demonstrated Chinmaya Vidyalaya's commitment to environmental sustainability and its dedication to nurturing responsible, eco-conscious citizens.",
    title: "Plastic & Paper Waste Collection Drive",
    videoSrc: "",
    y: "2025",
  },
  {
    calendar_updated: false,
    d: "13",
    fullDate: "13 March 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-2/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/the-jungle-joyride-prep-2025",
    m: "Mar",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/the-jungle-joyride-prep-2025",
    text: 'On 13th March 2025, the tiny tots of Chinmaya Vidyalaya, New Delhi, presented a captivating and thought-provoking show, "The Jungle Joyride", which enthralled the audience with their confidence and expressive performances.<br/><br/>The event masterfully blended education and entertainment, conveying an important message about kindness, freedom, and compassion towards animals. The programme commenced with a melodious welcome song, setting a joyful and inviting tone for the event.<br/><br/>A poignant skit followed, where the young learners highlighted the plight of animals in circuses and the importance of granting them freedom. The performance took a powerful turn when the rescuers confronted the circus owner with a compelling question—"Would you like to be in a cage?"—prompting reflection on the ethical treatment of animals.<br/><br/>To reinforce this message, the learners presented a soulful rendition of the song "Prem Se Humko Jeene Do", emphasizing the significance of allowing animals to live in their natural habitats. The event concluded with a vibrant and energetic dance performance, leaving the audience inspired and deeply moved.<br/><br/>The Class Prep Presentation – "The Jungle Joyride" was a remarkable display of the children\'s enthusiasm, creativity, and empathy, fostering awareness about animal welfare and encouraging a more compassionate world.',
    title: " The Jungle Joyride (Prep)",
    videoSrc: "",
    y: "2025",
  },
  {
    calendar_updated: false,
    d: "13",
    fullDate: "13 March 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-03-25-1/pic13.jpg",
    ],
    isVideo: false,
    link: "/school-events/the-magic-garden-of-values-nursery-2025",
    m: "Mar",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/the-magic-garden-of-values-nursery-2025",
    text: "On 13th March 2025, the nursery students of Chinmaya Vidyalaya staged a captivating presentation, \"The Magic Garden of Values\", which enthralled the audience with their infectious enthusiasm and endearing innocence.<br/><br/>The event seamlessly blended learning with entertainment, as the tiny tots showcased their grasp of essential moral values through engaging performances. The programme commenced with a vibrant and colourful dance, where the children exuded joy, setting the tone for the rest of the event.<br/><br/>This was followed by an action song that reinforced the importance of kindness, honesty, sharing, and respect in a fun and interactive manner. The children's expressive gestures and energetic participation brought smiles to everyone's faces, creating a warm and lively atmosphere.<br/><br/>A heartwarming skit, depicting real-life scenarios, further added to the event's charm, teaching valuable lessons in a simple yet impactful way. The young performers, with their innocent expressions and earnest dialogues, effortlessly conveyed the importance of truthfulness, compassion, and teamwork, leaving the audience deeply moved.<br/><br/>Overall, the Class Nursery Presentation was a resounding success, showcasing the students' understanding of vital moral values while delighting the audience with their talent and charm.",
    title: "The Magic Garden of Values (Nursery)",
    videoSrc: "",
    y: "2025",
  },
  {
    calendar_updated: false,
    d: "10",
    fullDate: "10 March 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-1/pic1.png",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-1/vid1.mp4",
    ],
    isVideo: true,
    link: "/school-events/masti-ki-pathshala-2025",
    m: "Mar",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/masti-ki-pathshala-2025",
    text: `
Chinmaya Vidyalaya, New Delhi, recently hosted a captivating four-day event, "Masti Ki Pathshala," from 10th to 13th March 2025. This enchanting celebration aimed to kindle the joy of learning amongst students through an array of engaging activities.
<br/><br/>
The event commenced with an exhilarating trip to Kidzania, where students explored various professions, such as visiting the dentist, becoming radio jockeys, and even flying an aircraft. They also savoured delicious pizza, making the day an unforgettable experience.
<br/><br/>
The Primary Department's programme was replete with creative Art and Craft sessions, cooking activities, movie screenings, and lively theatre performances. Students crafted clay pots with local artisans, participated in dynamic dance and music sessions, and indulged in "From Kitchen to Canvas" vegetable printing. They also enjoyed fun sports like Loop the Loop and celebrated the festive spirit of Holi in vibrant craft sessions. The highlight of the Primary Department's programme was "Clubclusion," where students showcased their best works from the year.
<br/><br/>
For younger learners in Classes I and II, story sessions, fireless cooking, and cultural celebrations added to the enjoyment. They particularly delighted in colourful straw painting.
<br/><br/>
In the Pre-Primary Department, children engaged in rangoli-making, pottery, and finger puppetry. They flourished in teamwork through exciting parachute games, promoting social skills and camaraderie.
<br/><br/>
The Senior Department experienced enriching activities in English, Science, and Maths, transforming learning into an interactive adventure. Throughout the event, students immersed themselves in musical creativity with games like "Masti Melody Mashup." They explored the concepts of Force and Pressure through fun activities and enjoyed a non-fire cooking session featuring delicious treats.
<br/><br/>
The grand finale featured an exhilarating chess tournament, filling the air with excitement and collaboration. "Masti Ki Pathshala" was a resounding success, providing an unforgettable celebration of creativity and knowledge. The event showcased the school's commitment to fostering a love for learning and creativity amongst its students.`,
    title: "Masti Ki Pathshala",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-04-25-1/vid1.mp4",
    y: "2025",
  },
  {
    calendar_updated: false,
    d: "01",
    fullDate: "01 March 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/10-03-25-1/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/chinmaya-vidyalaya-hosts-engaging-workshop-on-vedic-maths-and-abacus-2025",
    m: "Mar",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/chinmaya-vidyalaya-hosts-engaging-workshop-on-vedic-maths-and-abacus-2025",
    text: "On 1st March 2025, Chinmaya Vidyalaya, New Delhi, welcomed esteemed guests Ms. Seema Jain and Ms. Kanika Chawla from the Indian Institute of Vedic Maths and Abacus (IIVA) to conduct a captivating workshop on Vedic Maths and Abacus. Held at the school's ATL, the session aimed to equip teachers with innovative methods to enhance students' arithmetic skills.<br/><br/>The workshop commenced with a hands-on abacus session, where teachers gained practical experience in utilising the ancient tool for mental calculations. This interactive approach enabled participants to grasp the abacus's role in fortifying students' arithmetic foundations. Following the abacus session, Ms. Chawla introduced the principles of Vedic Maths, showcasing rapid multiplication techniques rooted in ancient Indian mathematics.<br/><br/>Throughout the workshop, teachers actively engaged with the abacus and Vedic Maths techniques, exploring ways to integrate these methodologies into their teaching practices. The session's primary objective was to enhance students' speed and accuracy in problem-solving, ultimately enriching their mathematical prowess.<br/><br/>The workshop concluded with an informative presentation on IIVA's courses tailored for students and educators. This insightful discussion encouraged participants to incorporate Vedic Maths and Abacus into their modern teaching approaches, fostering a holistic learning environment.<br/><br/>By hosting this enriching workshop, Chinmaya Vidyalaya demonstrated its commitment to providing teachers with innovative tools and techniques to augment students' educational experiences.",
    title: "Chinmaya Vidyalaya Hosts Engaging Workshop on Vedic Maths and Abacus",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "25",
    fullDate: "25 February 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-02-25-1/pic13.jpg",
    ],
    isVideo: false,
    link: "/school-events/maha-shivratri-celebrations-in-pre-primary-2025",
    m: "Feb",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/maha-shivratri-celebrations-in-pre-primary-2025",
    text: 'The Pre-Primary section of Chinmaya Vidyalaya, New Delhi, joyfully celebrated Maha Shivratri on 25th February, 2025, immersing the young learners in an atmosphere of devotion and festivity. The celebration commenced with an engaging storytelling session, where the children were enthralled by the legend of Lord Shiva, helping them grasp the significance of this sacred occasion.<br/><br/>A creative hands-on activity followed, where the enthusiastic learners molded Shivlings out of clay, deepening their connection to the celebration through art. This interactive exercise not only sparked their creativity but also helped them develop their fine motor skills.<br/><br/>The event culminated with a heartfelt chant of "Om Namah Shivaya," filling the atmosphere with peace and spirituality. The celebration was a truly enriching and memorable experience for the little learners, introducing them to the rich cultural heritage and spiritual significance of Maha Shivratri.',
    title: "Maha Shivratri Celebrations in Pre-Primary",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "16",
    fullDate: "16 February 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-3/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/walk-for-life-stride-against-cancer-2025",
    m: "Feb",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/walk-for-life-stride-against-cancer-2025",
    text: 'CanSupport - Walk for Life - Stride Against Cancer 2025<br/><br/>On 16th February 2025, the Jawaharlal Nehru Stadium played host to the CanSupport "Walk for Life" event, a stirring initiative aimed at raising awareness and support for cancer patients and survivors. The event drew enthusiastic participation from individuals across various age groups, underscoring the importance of embracing a healthy lifestyle and the need for early cancer detection.<br/><br/>Chinmaya Vidyalaya was proudly represented by a team of three students and two teachers, who embarked on the 3 km walk, demonstrating their commitment to the noble cause. The walk served as a powerful platform to disseminate awareness, promote fitness, and extend solidarity to those bravely battling cancer.<br/><br/>The event was a resounding success, reinforcing the message of hope, resilience, and community involvement. By participating in the "Walk for Life", Chinmaya Vidyalaya reaffirmed its dedication to supporting meaningful initiatives that promote health, wellness, and social responsibility.',
    title: "Walk for Life - Stride Against Cancer 2025",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "14",
    fullDate: "14 February 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-2/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/class-assembly-by-classes-ia-ib-2025",
    m: "Feb",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/class-assembly-by-classes-ia-ib-2025",
    text: 'Assembly on "Values Begin from Home"<br/><br/>On 14th February 2025, the students of Classes I A and I B at Chinmaya Vidyalaya, New Delhi, presented a thought-provoking assembly on the theme "Values Begin from Home". The event aimed to emphasize the significance of inculcating good values from a young age.<br/><br/>The assembly commenced with a student reciting a meaningful shloka on respect, setting the tone for the inspiring event. Students then delivered insightful talks on essential values such as kindness, honesty, respect, and selfless service. Their thoughtful words highlighted the importance of embracing these values in daily life.<br/><br/>The highlight of the assembly was a captivating dance performance on the theme "Sharing is Caring". The energetic and expressive dance routine beautifully conveyed the value of kindness and generosity.<br/><br/>Through this assembly, the students of Classes I A and I B demonstrated their understanding of the significance of values in shaping their characters and relationships. The event was a testament to the school\'s commitment to fostering a culture of values and ethics among its students.',
    title: "Class assembly by Classes IA & IB",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "11",
    fullDate: "11 February 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-02-25-1/pic14.jpg",
    ],
    isVideo: false,
    link: "/school-events/salt-painting-activity-2025",
    m: "Feb",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/salt-painting-activity-2025",
    text: "Salt Painting Activity: Unleashing Creativity and Imagination<br/><br/>On Tuesday, 11th February 2025, the young learners of Chinmaya Vidyalaya, New Delhi, embarked on an exciting artistic adventure through the Salt Painting Activity. This engaging and hands-on experience allowed students to explore the fascinating world of colors and textures, unleashing their creativity and imagination.<br/><br/>Using a unique combination of glue, salt, and vibrant watercolors, the children created mesmerizing patterns and designs, watching in awe as the colors spread beautifully through the salt. The activity not only brought immense joy to the participants but also provided a valuable learning experience, enhancing their fine motor skills, hand-eye coordination, and artistic expression.<br/><br/>As the students experimented with different techniques, they developed essential skills such as patience and concentration. The lively classroom atmosphere was electric with enthusiasm, curiosity, and a deep sense of accomplishment as the young artists proudly showcased their masterpieces.<br/><br/>The Salt Painting Activity was a testament to the power of experiential education in fostering creativity, self-expression, and a love for learning. The beaming smiles and sparkling eyes of the students reflected their excitement and pride in their artistic creations, making the experience a truly unforgettable one",
    title: "Salt Painting Activity",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "10",
    fullDate: "10 February 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic26.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic27.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic28.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic29.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic30.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-2/pic31.jpg",
    ],
    isVideo: false,
    link: "/school-events/space-club-session-2025",
    m: "Feb",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/space-club-session-2025",
    text: "Space Club Session: Exploring the Wonders of the Moon<br/><br/>On the evening of 6th February 2025, Chinmaya Vidyalaya, New Delhi, hosted an engaging Space Club session for its Primary Department students. The event sparked curiosity and excitement among the young astronomers as they embarked on a fascinating journey through the wonders of the Moon.<br/><br/>The Class I-II students began their exploration by learning about the phases of the Moon, marveling at its craters through a telescope. They also delved into the historic Apollo 11 Moon landing, discovering Neil Armstrong's iconic footprint on the lunar surface.<br/><br/>Meanwhile, the Class III-V students ventured deeper into the solar system, enthusiastically observing celestial bodies, including the Moon and various planets, through the telescope.<br/><br/>To reinforce their learning, each student received an interactive puzzle kit and a detailed poster on the Moon and its phases. This enabled them to continue their exploration beyond the session, fostering a deeper understanding and appreciation of the wonders of the Moon.<br/><br/>The Space Club session was a resounding success, inspiring the young minds of Chinmaya Vidyalaya to reach for the stars.",
    title: "Space Club Session",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "10",
    fullDate: "10 February 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-1/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/assembly-by-classes-ic-and-id-on-count-your-blessings-2025",
    m: "Feb",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/assembly-by-classes-ic-and-id-on-count-your-blessings-2025",
    text: 'Assembly on "Count Your Blessings"<br/><br/>On February 10, 2025, the students of Classes I C and I D presented a heartwarming and thought-provoking assembly on the theme "Count Your Blessings". The event aimed to encourage students to cultivate a sense of gratitude and appreciation for the blessings in their lives.<br/><br/>The assembly commenced with a poignant poem, setting the tone for a reflective and inspiring session. A captivating skit, "The Thankful Garden", followed, beautifully illustrating the transformative power of gratitude in our daily lives. Students also shared powerful affirmations, highlighting the positive impact of gratitude on our mindset and overall well-being.<br/><br/>The assembly was a wonderful reminder to cherish life\'s blessings and nurture a grateful heart. The students of Classes IC and ID are to be commended for their outstanding performance, which left a lasting impression on the audience.',
    title: "Assembly by Classes IC and ID on Count Your Blessings",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "06",
    fullDate: "06 February 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-02-25-3/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/emotional-well-being-and-peer-influence-2025",
    m: "Feb",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/emotional-well-being-and-peer-influence-2025",
    text: 'Workshop on Emotional Well-Being and Peer Influence<br/><br/>Chinmaya Vidyalaya, New Delhi, organised a thought-provoking workshop on "Emotional Well-Being and Peer Influence" for Class VIII students on 6th February 2025. The session, facilitated by Ms. Yashvi Bhatnagar, aimed to empower students with essential life skills to manage their emotional well-being and navigate the complexities of peer influence.<br/><br/>Through interactive discussions and engaging activities, students gained valuable insights into understanding emotional health, recognizing positive and negative peer influence, and developing self-regulation skills. The workshop provided a safe and supportive environment for students to share their thoughts and concerns, fostering personal growth and improved emotional awareness.<br/><br/>The session concluded with students feeling confident and equipped to manage their emotional well-being, build supportive peer networks, and make informed choices. The workshop was a testament to Chinmaya Vidyalaya\'s commitment to providing holistic education and promoting the well-being of its students.',
    title: "Emotional Well-Being and Peer Influence",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "01",
    fullDate: "01 February 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-3/pic16.jpg",
    ],
    isVideo: false,
    link: "/school-events/capacity-building-programme-stress-management-2025",
    m: "Feb",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/capacity-building-programme-stress-management-2025",
    text: "Capacity Building Programme on Stress Management<br/><br/>Chinmaya Vidyalaya, New Delhi, hosted a Capacity Building Programme on Stress Management, organized by the Central Board of Secondary Education (CBSE), on 1st February 2025. This informative session aimed to equip teachers with effective stress management techniques to enhance their professional and personal well-being.<br/><br/>The workshop was expertly facilitated by Dr. Manisha Sharma, a CBSE Master Trainer, and Ms. Sukhmeen Kaur Cheema, a Counselling Psychologist. The session focused on identifying stressors specific to the teaching profession and understanding their impact on educators. The facilitators provided valuable insights into distinguishing between positive (eustress) and negative (distress) stress, enabling teachers to develop a deeper understanding of stress management.<br/><br/>Through a series of interactive discussions, real-life case studies, and role-playing exercises, participants gained hands-on experience with practical stress management methods. These included mindfulness, deep breathing, and time management strategies, which empowered teachers to maintain a healthy work-life balance and improve their emotional intelligence.<br/><br/>The Capacity Building Programme on Stress Management was a resounding success, providing teachers with the tools and techniques necessary to create a positive and stress-free environment in both their professional and personal lives. By investing in the well-being of educators, Chinmaya Vidyalaya, New Delhi, reaffirms its commitment to fostering a supportive and inclusive school community.",
    title: "Capacity Building Programme - Stress Management",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "31",
    fullDate: "31 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-2/pic13.jpg",
    ],
    isVideo: false,
    link: "/school-events/celebrating-vasant-panchami-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/celebrating-vasant-panchami-2025",
    text: "Vasant Panchami Celebrations in the Pre-Primary Department<br/><br/>Chinmaya Vidyalaya, New Delhi's Pre-Primary Department joyfully celebrated Vasant Panchami on 31st January, marking the beginning of spring. The festivities commenced with children arriving dressed in vibrant yellow attire, symbolising the colours of the season.<br/><br/>To add to the excitement, the young learners relished delicious yellow-themed snacks, which complemented the festive atmosphere perfectly. A PowerPoint presentation was showcased to help the children understand the significance of Vasant Panchami, highlighting its importance in Indian culture.<br/><br/>The celebration took a creative turn with a hands-on activity, where the children crafted beautiful sunflowers using crumpled paper. This engaging exercise not only encouraged their creativity but also helped them develop their fine motor skills.<br/><br/>The Vasant Panchami celebration in the Pre-Primary Department was a resounding success, striking the perfect balance between learning and enjoyment. The event created a memorable experience for the little ones, fostering their curiosity and enthusiasm for cultural festivals.",
    title: "Celebrating Vasant Panchami",
    videoSrc: "",
    y: "2025",
  },

  {
    d: "31",
    fullDate: "27 - 31 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-02-25-1/pic17.jpg",
    ],
    isVideo: false,
    link: "/school-events/madhubani-workshop-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/madhubani-workshop-2025",
    text: "SPIC MACAY Madhubani Workshop at Chinmaya Vidyalaya, New Delhi<br/><br/>From 27th to 31st January 2025, Chinmaya Vidyalaya, New Delhi, hosted a captivating five-day SPIC MACAY Madhubani Workshop for Class VIII students. The workshop was facilitated by the esteemed Avdhesh Kumar Karn, a master artist of Madhubani art.<br/><br/>Mr. Karn introduced the students to the rich cultural heritage of Madhubani art, delving into the traditional motifs, lines, and colours that characterise this ancient art form. He highlighted the deep connection between Madhubani art and Indian folklore and mythology, demonstrating how this art form transforms canvases into vibrant cultural tapestries.<br/><br/>Under Mr. Karn's expert guidance, the students enthusiastically participated in creating intricate patterns and vibrant motifs, reflecting the distinct style of Madhubani folk art. The facilitator provided hands-on training on various techniques, including the use of paintbrushes, watercolours, and brush-stroking methods, enabling students to appreciate the finesse required to bring Madhubani art to life.<br/><br/>The workshop aimed to promote cultural awareness and heritage preservation, fostering an appreciation for Indian folk art and traditional crafts among the younger generation. Through interactive sessions and practical demonstrations, the workshop inspired students to value and contribute to the preservation of traditional crafts, instilling a deep sense of pride in India's rich artistic legacy.<br/><br/>The SPIC MACAY Madhubani Workshop at Chinmaya Vidyalaya, New Delhi, was a resounding success, providing students with a unique opportunity to engage with India's cultural heritage and develop a deeper appreciation for traditional art forms.",
    title: "Madhubani Workshop",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "30",
    fullDate: "30 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-4/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/special-assembly-on-basant-panchami-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/special-assembly-on-basant-panchami-2025",
    text: "Celebrating the Triumph of Knowledge: Basant Panchami Special Assembly<br/><br/>The students of Classes II C and II D of Chinmaya Vidyalaya, New Delhi, presented a captivating special assembly to commemorate Basant Panchami, a festival celebrating the triumph of knowledge, creativity, and new beginnings.<br/><br/>The assembly commenced with the reverent chanting of a shloka, seeking the blessings of Goddess Saraswati, the embodiment of knowledge and wisdom. This was followed by an insightful talk that delved into the significance of the festival, highlighting its importance in Indian culture.<br/><br/>The students showcased their artistic talents through a soulful Hindi song, beautifully rendered by the class choir. A thought-provoking poem, recited by the learners, awakened the colours of wisdom and joy, setting the tone for a day filled with learning and growth.<br/><br/>The highlight of the assembly was a heartfelt dance performance on Saraswati Vandana, 'Var De Veena Vadini, Var De'. The graceful movements and expressions of the dancers added a spirit of devotion and culture to the event.<br/><br/>The assembly culminated with a pledge, wherein the students committed to seeking knowledge and wisdom, and invoked the blessings of Goddess Saraswati to guide them through the joys of learning.",
    title: "Special Assembly on Basant Panchami",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "27",
    fullDate: "27 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-2/pic24.jpg",
    ],
    isVideo: false,
    link: "/school-events/primary-sports-fiesta-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/primary-sports-fiesta-2025",
    text: "Primary Sports Fiesta: A Celebration of Teamwork and Determination<br/><br/>The Primary Department of Chinmaya Vidyalaya, New Delhi, hosted a thrilling Sports Fiesta 2024-25, showcasing the students' energy, enthusiasm, and sportsmanship. The event commenced with the grand entrance of Prakrama, the lively leopard mascot, who set a cheerful tone for the day.<br/><br/>The Primary Sports Captain (Girls) led the oath ceremony, reaffirming the students' commitment to teamwork and fair play. The school choir then mesmerized the audience with a captivating medley, adding a melodious touch to the event.<br/><br/>Principal Ms. Archana Soni addressed the gathering, encouraging students to strive for excellence in every endeavour. Her insightful words motivated the students to give their best and make the most of the opportunity.<br/><br/>The athletic events were carefully designed to cater to different age groups. The Pre-Primary section participated in exciting events like the 50-meter flat race, hoopla cone race, and yoga demonstrations. Classes I and II showcased their competitive spirit in the 100-meter flat race and stick race. Meanwhile, Classes III and IV demonstrated their energy in the thrilling BIB Exchange and Hoopla Dribble races.<br/><br/>In a heartwarming display of inclusivity, the teaching and facility staff also participated in special running events, adding to the excitement and joyous spirit of the day.<br/><br/>The Sports Fiesta concluded with a heartfelt vote of thanks from the HOD of the Sports Department, acknowledging the collective effort of all participants and supporters. The event was a resounding success, leaving everyone with unforgettable memories of teamwork, determination, and sportsmanship.",
    title: "Primary Sports Fiesta",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "24",
    fullDate: "24 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-3/pic18.jpg",
    ],
    isVideo: false,
    link: "/school-events/republic-day-celebration-for-pre-primary-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/republic-day-celebration-for-pre-primary-2025",
    text: "Republic Day Celebration for Pre-Primary<br/><br/>Chinmaya Vidyalaya, New Delhi, celebrated Republic Day with great enthusiasm on 24th January. The Pre-Primary learners participated in a delightful Fancy Dress activity, dressing up as various national symbols, showcasing their creativity and patriotic spirit.<br/><br/>The facilitator commenced the session by narrating an engaging story that explained the significance of Republic Day, capturing the children's imagination and attention.<br/><br/>The young learners further showcased their love for the nation by performing energetic dances on patriotic songs, filling the atmosphere with joy and national pride.<br/><br/>The celebration concluded on a creative note with a craft activity, where children crafted Republic Day-themed art, taking home memories of a fun-filled and patriotic day.<br/><br/>The event was a resounding success, instilling patriotism and national pride in the young hearts of Chinmaya Vidyalaya's Pre-Primary learners.",
    title: "Republic Day Celebration for Pre-Primary",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "24",
    fullDate: "24 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/31-01-25-1/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/storytelling-workshop-by-ms-arundhati-sundar-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/storytelling-workshop-by-ms-arundhati-sundar-2025",
    text: "Weaving Magic with Words: A Storytelling Workshop<br/><br/>On 24th January 2025, Chinmaya Vidyalaya, New Delhi, hosted a captivating storytelling workshop for its Pre-Primary and Primary Departments. The session was led by Ms. Arundhati Sundar, a physiotherapist by profession and a passionate storyteller at heart.<br/><br/>Using puppets as creative props, Ms. Sundar demonstrated the art of engaging storytelling, inspiring teachers with her unique methods. The workshop proved to be a treasure trove of insights, sparking creativity and fostering critical thinking.<br/><br/>The teachers left the session enriched and inspired, ready to infuse new life into their storytelling practices. The workshop was a resounding success, and Chinmaya Vidyalaya is grateful to Ms. Arundhati Sundar for sharing her expertise.<br/><br/>The event highlighted the school's commitment to providing teachers with innovative training and resources, ultimately benefiting the students and enhancing their learning experience.",
    title: "Storytelling Workshop by Ms. Arundhati Sundar",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "24",
    fullDate: "24 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-3/pic26.jpg",
    ],
    isVideo: false,
    link: "/school-events/sports-fiesta-republic-day-celebrations-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/sports-fiesta-republic-day-celebrations-2025",
    text: "Chinmaya Vidyalaya Celebrates Sports Fiesta with Patriotic Fervour<br/><br/>Chinmaya Vidyalaya, New Delhi, organised a thrilling Sports Fiesta on 24th January 2025, aiming to instill discipline, teamwork, and sportsmanship among its students. The event was a grand success, witnessing enthusiastic participation from students and staff alike.<br/><br/>The Sports Fiesta commenced with a ceremonial lamp lighting by Principal Ms. Archana Soni, followed by the national flag unfurling and patriotic songs, setting the tone for a day filled with excitement and national pride.<br/><br/>In her address, Principal Ms. Archana Soni emphasized the significance of the 76th Republic Day theme, 'Swarnim Bharat - Virasat aur Vikas', highlighting India's rich legacy and scientific achievements. She urged students to cultivate love for their country and serve society and fellow beings with sincerity.<br/><br/>The event featured an array of thrilling competitions, including a baton relay, an inspiring march past by NCC cadets, and various races, engaging students from Classes V to IX and XI. The Vice Sports Captain administered the sports pledge, while mascot 'Parakram' energized the participants.<br/><br/>In a special tug-of-war, students triumphed over staff, showcasing their teamwork and determination. Winners received medals and certificates, with Honesty House claiming the Overall Trophy.<br/><br/>The Sports Fiesta concluded on a high note, reinforcing the key learning outcome of fostering unity, patriotism, and a commitment to national progress through dedication and teamwork.",
    title: "Sports Fiesta & Republic Day Celebrations",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "23",
    fullDate: "23 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-2/pic13.jpg",
    ],
    isVideo: false,
    link: "/school-events/republic-day-assembly-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/republic-day-assembly-2025",
    text: "On 23rd January 2025, a special assembly was conducted by the learners of classes II A and II B of Chinmaya Vidyalaya, New Delhi to commemorate the 76th Republic Day of India. The students took pride in glorifying and celebrating the spirit of unity.<br/><br/>The assembly commenced with a soulful patriotic song, instilling a sense of unity and love for the nation.<br/><br/>An insightful talk was delivered, emphasizing the importance of Republic Day and shedding light on India's national symbols, their significance, and the values they embody, such as strength, unity and peace.<br/><br/>The assembly concluded with a captivating dance performance filled with patriotic fervour, celebrating the spirit of unity and independence. The students were inspired to embrace the values upheld in the Constitution and actively contribute to the progress and betterment of the nation.",
    title: "Republic Day Assembly",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "17",
    fullDate: "17 January 2025",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/25-01-25-1/pic26.jpg",
    ],
    isVideo: false,
    link: "/school-events/aashirwad-ceremony-for-board-classes-x-and-xii-2025",
    m: "Jan",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/aashirwad-ceremony-for-board-classes-x-and-xii-2025",
    text: "Chinmaya Vidyalaya, New Delhi, conducted a poignant Aashirwad Ceremony for students of Board Classes X and XII on 17th January 2025. This solemn event aimed to impart blessings, guidance, and spiritual motivation to students as they embark on their crucial board examinations. The ceremony commenced with a warm welcome for Swami Avyayananda, followed by a meaningful Paduka Pooja Ceremony for Class XII students.<br/><br/>During this ritual, students reaffirmed their commitments by reading Exhortation Cards, seeking divine guidance and blessings. Swami Avyayananda subsequently blessed the students with his wisdom and extended his best wishes for their upcoming examinations and future pursuits.<br/><br/>The Principal addressed the gathering, encouraging students to approach their goals with determination, focus, and perseverance. For Class X students, the ceremony incorporated the chanting of Pujya Gurudev's 108 names and Aarti, creating a spiritually enriching atmosphere. Both sessions concluded with the distribution of prasad and the application of tilak for each student, symbolising divine blessings and protection.<br/><br/>The Aashirwad Ceremony successfully instilled a sense of gratitude, discipline, and spiritual grounding in the students, preparing them to embark on a path of purpose and excellence.",
    title: "Aashirwad Ceremony for Board Classes X and XII",
    videoSrc: "",
    y: "2025",
  },
  {
    d: "31",
    fullDate: "31 December 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-01-25-1/pic21.jpg",
    ],
    isVideo: false,
    link: "/school-events/farewell-function-2024-2025",
    m: "Dec",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/farewell-function-2024-2025",
    text: "As the curtains closed on a memorable chapter, Chinmaya Vidyalaya New Delhi proudly celebrated the culmination of a remarkable journey for its Class XII students.<br/><br/>On 31st December 2024, the school bid farewell to its senior students with a heartfelt programme, filled with nostalgia and gratitude. The Principal encouraged the students to always strive for excellence, viewing failures as stepping stones to success, and to move forward with resilience.<br/><br/>The event also saw the presentation of hampers to Mr. and Ms. Chinmaya, as well as Mr. and Ms. Resplendent, as a token of appreciation. Teachers and students shared heartfelt wishes for a bright future, as the event concluded with a meaningful message inspiring the students to embark on their new journey with determination, values, and a commitment to making a positive impact in the world.",
    title: "Farewell Function 2024-2025",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "24",
    fullDate: "24 December 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-2/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/bls-basic-life-support-and-general-first-aid-demonstration-2024",
    m: "Dec",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/-bls-basic-life-support-and-general-first-aid-demonstration-2024",
    text: "Chinmaya Vidyalaya, New Delhi, Conducts BLS and General First Aid Training for Students As part of its commitment to fostering a safe and responsible community, Chinmaya Vidyalaya, New Delhi, organised a valuable BLS (Basic Life Support) and General First Aid demonstration for Classes VI to XI on 24th December 2024.<br/><br/>The training session, expertly facilitated by Dr. Nikita and Mr. Rajkumar, Special Trainer, aimed to equip students with essential life-saving skills and knowledge. The comprehensive session covered critical topics, including victim assessment using the ABPU framework (Alert, Body, Pain, Unresponsive), distinguishing between normal and accidental unconsciousness, and appropriate remedies for each. Through practical demonstrations and hands-on training, students learned critical techniques, such as managing electrocution with the recovery position, administering CPR at a rate of 100-120 compressions per minute for non-breathing victims, controlling external bleeding while avoiding internal injury intervention, and immobilizing fractures to minimize movement.<br/><br/>Additionally, techniques like the Heimlich maneuver for airway obstructions and various victim transportation methods were also introduced. The facilitators emphasized practical approaches, empowering students to respond confidently and effectively in emergencies.<br/><br/>By providing students with these vital skills, Chinmaya Vidyalaya aims to foster a community of responsible and compassionate individuals who are equipped to make a positive impact in times of need. The BLS and General First Aid training session was a resounding success, and the school looks forward to conducting more such initiatives in the future.",
    title: "BLS (Basic Life Support) and General First Aid demonstration",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "24",
    fullDate: "24 December 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic26.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic27.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic28.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic29.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic30.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic31.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic32.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic33.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/27-12-24-1/pic34.jpg",
    ],
    isVideo: false,
    link: "/school-events/christmas-celebrations-2024",
    m: "Dec",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/-christmas-celebrations-2024",
    text: "Chinmaya Vidyalaya New Delhi Celebrates Christmas with Joy and Enthusiasm<br/><br/>The festive season was in full swing at Chinmaya Vidyalaya New Delhi as the students and staff came together to celebrate Christmas. The celebrations began on 24th December 2024, with the students of Class I presenting a heartwarming and festive assembly. The assembly commenced on a vibrant note with a cheerful rendition of the Christmas carol 'Rudolph the Red Nose reindeer'. The melodious tunes inspired everyone to clap, sing along, and immerse themselves in the holiday cheer. The story of the birth of Jesus Christ was beautifully narrated through a short and engaging skit, leaving the audience touched by its simplicity and message of love and hope. Adding to the festive vibe, a lively group dance full of joy and Christmas cheer was performed. The performance peaked when Santa Claus made a grand entrance, waving to the crowd and spreading smiles as he danced alongside his merry group of reindeer. The assembly perfectly blended music, storytelling, and joy, creating cherished memories for all. To further enhance the festive spirit, the students made a variety of Christmas crafts, decorated their classrooms, and enjoyed party food together. The excitement and joy were palpable as the students revelled in the festive atmosphere.<br/><br/>The Pre-Primary section also joined in the celebrations with great enthusiasm. A PowerPoint presentation was shared with the learners, explaining the significance of Christmas and its traditions. The students enthusiastically created Christmas crafts, including Santa Claus, Christmas bells, and trees, with guidance from their facilitators. A vibrant class party was organized, and the classrooms were decorated by the students, adding a festive charm. The highlight of the celebration was a special visit from Santa Claus, which brought immense delight to the children. The young learners sang melodious Christmas carols, spreading cheer and festive spirit throughout the day.<br/><br/>The Christmas celebrations at Chinmaya Vidyalaya New Delhi were a resounding success, filling the hearts of everyone with joy, love, and festive cheer.",
    title: "Christmas Celebrations",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "02",
    fullDate: "02 December 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/16-12-24-1/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/ad-mad-show-2024",
    m: "Dec",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/ad-mad-show-2024",
    text: "Chinmaya Vidyalaya, New Delhi, collaborated with the Green Dream Foundation to host an engaging and educational event to enhance awareness about air pollution, its effects on human health, and preventive measures.<br/><br/>The event commenced with a quiz on air pollution designed for Class IX students. The quiz began with a team selection round, where students from the audience were quizzed, and those with correct answers formed four teams. The subsequent rounds tested the teams' knowledge of foundational concepts, health impacts, and the Graded Response Action Plan (GRAP).<br/><br/>The activity concluded with a thrilling buzzer round, emphasizing quick thinking and teamwork. In addition to the quiz, the Primary Department's Class V students enthusiastically participated in a series of engaging activities aimed at raising awareness about environmental issues. The students showcased their creativity by designing informative and thought-provoking posters on the theme \"Say No to Pollution\". Furthermore, they participated in an Ad Mad competition, where they demonstrated their talent and ingenuity in promoting eco-friendly products.<br/><br/>The highlight of the event was the jingle presentation competition, where all four sections of Class V presented captivating jingles promoting sustainable living. Class V D emerged as the winner of the competition with their outstanding performance, while Class VB secured the second position, earning well-deserved applause for their efforts.<br/><br/>The event was a resounding success, not only encouraging teamwork and creativity but also instilling a sense of responsibility towards protecting the environment. Chinmaya Vidyalaya, New Delhi, is proud to have provided a platform for its students to engage with environmental issues and develop a deeper understanding of the importance of sustainable living.",
    title: "Ad Mad Show",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "28",
    fullDate: "28 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-12-24-1/pic14.jpg",
    ],
    isVideo: false,
    link: "/school-events/alumni-meet-batch-of-1999-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/alumni-meet-batch-of-1999-2024",
    text: "Chinmaya Vidyalaya, New Delhi, hosted a highly successful 25-year reunion for the Batch of 1999 on 28th November 2024. The event was a resounding triumph, filled with nostalgia, inspiration, and warmth.<br/><br/>The alumni were warmly welcomed with traditional tilak and chants, setting the tone for a memorable day. The Principal's address highlighted the school's achievements and vision, whilst the value education teacher's session on timeless teachings from the Bhagavad Gita resonated deeply with the alumni.<br/><br/>A unique aspect of the event was the counselling session, where a few alumni shared their personal journeys, career insights, and life lessons with Year 11 students. This inspiring interaction motivated students to aim high and make thoughtful life choices.<br/><br/>The alumni also showcased their sporting spirit in a thrilling basketball match against the school team, symbolising unity and sportsmanship. As the event drew to a close, it was clear that the reunion had rekindled old friendships and strengthened ties between the alumni, students, and the school.<br/><br/>Celebrating enduring values inspired students to cherish their roots and aim high. Chinmaya Vidyalaya is grateful to all the alumni who attended the reunion and made it a memorable occasion. The school looks forward to many more such events in the future.",
    title: "Alumni Meet - Batch of 1999",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "14",
    fullDate: "14 November 2024",
    images: ["https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-3/vid1.mp4"],
    isVideo: false,
    link: "/school-events/childrens-day-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/childrens-day-2024",
    text: "Chinmaya Vidyalaya New Delhi commemorated Children's Day with a vibrant array of activities across its Pre-Primary, Primary, and Senior Departments, fostering a spirit of unity, wonder, and inspiration.<br/><br/>The little learners of the Pre-Primary Department embarked on an engaging celebration, beginning with an enlightening video introduction to Pandit Jawaharlal Nehru, affectionately known as \"Chacha Nehru.\" A captivating puppet show in their classrooms left the children spellbound, filling the room with joy and curiosity. The festivities culminated in a yoga session, where teachers and students practiced together, promoting unity and well-being.<br/><br/>Students from Classes III to V enjoyed an exciting outing to PVR Cinemas to watch Despicable Me 4. The trip was filled with laughter and excitement, allowing students to bond with classmates and teachers outside the classroom. Meanwhile, Classes I and II were treated to a hilarious enactment of 'Chhota Bheem' by their teachers, making the day truly special.<br/><br/>The students of Classes VI-XII watched the inspirational movie \"I Am Kalam,\" highlighting perseverance, self-belief, and the importance of education. A thought-provoking discussion followed, encouraging students to reflect on these values and realize the significance of dedication and determination in achieving personal growth and success.<br/><br/>Children's Day celebrations at Chinmaya Vidyalaya, New Delhi, were a resounding success, creating lifelong memories for students across all departments. The school's commitment to fostering a nurturing environment, where students can grow, learn, and thrive, shone brighter than ever.",
    title: "Children's Day",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "14",
    fullDate: "14 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-2/pic6.jpg",
    ],
    isVideo: false,
    link: "/school-events/panchakosha-workshop-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/panchakosha-workshop-2024",
    text: "Chinmaya Vidyalaya, New Delhi, hosted an enlightening workshop on Panchakosha in the National Curriculum Framework.<br/><br/>Facilitated by esteemed Ms. Nanu Rekhi, Territory Head, Delhi-NCR, for Early Childhood Association, the session explored the five layers of human existence: Annamaya, Pranamaya, Manomaya, Vignanamaya, and Anandamaya Kosha.<br/><br/>Faculty members were introduced to innovative activities to integrate these Koshas into their teaching practices, nurturing students' physical, emotional, mental, intellectual, and spiritual dimensions.<br/><br/>The workshop underscored the significance of balancing all aspects of life, leading to overall well-being. Chinmaya Vidyalaya's commitment to holistic education shines brighter than ever!",
    title: "Panchakosha Workshop",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "12",
    fullDate: "12 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic26.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic27.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic28.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic29.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic30.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic31.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic32.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic33.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic34.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic35.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic36.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-5/pic37.jpg",
    ],
    isVideo: false,
    link: "/school-events/gurpurab-celebrations-pre-primary-primary-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/gurpurab-celebrations-pre-primary-primary-2024",
    text: "On Tuesday, 12th November 2024, the students of Pre-Primary and Primary Departments at Chinmaya Vidyalaya New Delhi enthusiastically celebrated Guru Nanak Jayanti, deepening their understanding of Sikh culture and spirituality.<br/><br/>The Pre-Primary learners embarked on a fascinating journey, watching an informative video on Guru Nanak Dev Ji's life, followed by a soulful shabad chanting session. They enthusiastically chanted 'Satnam Waheguru' while walking through the corridors and expressed their creativity through freehand drawings of a Gurudwara.<br/><br/>Students from Nursery to V respectfully bowed before the Guru Granth Sahib, offered prayers, chanted the Mool Mantra, listened to Ardaas, and gratefully received Kadha Prasad.<br/><br/>Through these meaningful activities, Chinmaya Vidyalaya New Delhi nurtured interfaith understanding, tolerance, and spiritual growth among its students, embracing the universal values of love, kindness, and unity that Guru Nanak Dev Ji's teachings embody.",
    title: "Gurpurab Celebrations (Pre-Primary & Primary)",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "11",
    fullDate: "11 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-11-24-1/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/assembly-by-class-iiic-the-power-of-kindness-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/assembly-by-class-iiic-the-power-of-kindness-2024",
    text: `<ul>
  <li>The students of Class III C presented a heart-warming assembly on 11th November 2024 that celebrated the transformative power of kindness.</li>
  <li>The program expressed the importance of empathy, compassion, and goodwill.</li>
  <li>A soulful poem was recited, capturing the essence of kindness and its ripple effect on the world.</li>
  <li>A thought-provoking skit highlighted the power of empathy and understanding and how it can bridge gaps and foster harmony.</li>
  <li>A graceful dance performance mesmerized the audience.</li>
  <li>The assembly concluded with a collective pledge where all the students and staff members vowed to practice acts of kindness in their daily lives.</li>
  <li>The assembly was a resounding success, leaving a lasting impression on everyone present.</li>
</ul>`,
    title: "Assembly by Class III C - The Power of Kindness",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "08",
    fullDate: "08 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-2/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/garbology-workshop-for-students-by-green-dream-foundation-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/garbology-workshop-for-students-by-green-dream-foundation-2024",
    text: "Chinmaya Vidyalaya New Delhi hosted a thought-provoking round table discussion, 'Garbology', focusing on effective waste management practices. Students from the Eco Club and SEWA Club (classes VI-IX) actively participated in the event, conducted in association with the Green Dream Foundation.<br/><br/>Facilitated by Ms. Simran from Green Dream Foundation, three teams explored crucial topics: landfill elimination, in-home waste reduction, and sustainable lifestyles. The engaging discussion encouraged critical thinking and raised awareness about landfill issues and harmful environmental impacts.<br/><br/>The winning team received certificates, while runners-up were awarded badges. This enriching experience inspired students to adopt sustainable practices and develop a deeper understanding of environmental challenges.<br/><br/>Well done to all participants!",
    title: "Garbology workshop for students by Green Dream Foundation",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "05",
    fullDate: "05 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/18-11-24-1/pic19.jpg",
    ],
    isVideo: false,
    link: "/school-events/road-safety-traffic-park-activity-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/road-safety-traffic-park-activity-2024",
    text: "Chinmaya Vidyalaya New Delhi’s Pre-Primary Department took the initiative to educate young learners on essential road safety guidelines through an engaging Traffic Park Activity on November 5, 2024.<br/><br/>During this interactive event, students explored a miniature traffic park to learn about various road signs and their meanings. A detailed presentation on road safety guidelines was also conducted, followed by interactive rhymes on traffic rules to make these concepts easier to understand.<br/><br/>To reinforce their learning, students participated in hands-on craft activities, creating models of traffic lights and illustrating traffic park scenes. This comprehensive approach combined creativity and learning, leaving students with a memorable understanding of road safety in a fun and interactive way.<br/><br/>Kudos to Chinmaya Vidyalaya's Pre-Primary Department for instilling valuable life skills in their young minds!",
    title: "Road safety - Traffic Park Activity",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "05",
    fullDate: "05 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-3/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/prize-distribution-assembly-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/prize-distribution-assembly-2024",
    text: "On 5th November 2024, a special assembly for Classes VI -IX was held at the Basketball Court to celebrate the achievements of students in various Inter-school competitions. The students were honored for their participation in the 28th Interschool Geeta Chanting Competition, AI and Tech competitions, and the NCC Camp, where they received NCC-A category certificates. The students also expressed their pride in Chinmaya Vidyalaya through the segment “I Love Chinmaya Vidyalaya,” emphasizing their deep connection to the school and the values it instills. The Principal congratulated the students, urging them to uphold ethics, values, and righteousness, and praised their commitment to a ‘Green Diwali’ in alignment with the school’s Vision Program",
    title: "Prize Distribution Assembly",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "04",
    fullDate: "04 November 2024",
    images: ["https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-4/vid1.mp4"],
    isVideo: false,
    link: "/school-events/language-fiesta-the-english-week-primary-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/language-fiesta-the-english-week-primary-2024",
    text: '<strong>Language Fiesta- The English Week</strong><br/><br/>The Primary English Department organized an exciting \'Language Fiesta\' that started on November 4, 2024, offering various engaging language-based activities that captivated students from Classes I to V.<br/><br/><strong>Day 1: The Great Grammar Games</strong><br/><br/>The fiesta opened with “The Great Grammar Games,” transforming grammar learning into a fun-filled adventure. Students participated in interactive games like Noun Riddles, Simon Says, Idiom Charades, and the ever-popular Grammar Police. Adding to the fun, two students dressed as "Noun Clowns" visited classes I and II, playfully challenging their peers with noun-based riddles.<br/><br/>Day 2: Fiction Frenzy<br/><br/>The theme "Fiction Frenzy" immersed students in the world of stories. Classes I and II enjoyed animated Karadi sessions, bringing tales to life with vibrant storytelling. Class III contributed with "Tales and Treasures," a presentation of their favorite stories, while Class IV students showcased scenes from their most-loved books in "The Literary Art Gallery," turning classrooms into miniature museums of imagination. Class V students took on the roles of comic puppeteers, delivering laughter and joy with their amusing puppet performances.<br/><br/><strong>Spellbee Carnival</strong><br/><br/>Throughout the fiesta, the Spellbee Carnival allowed students in Classes I to V to build their vocabulary and spelling skills, enriching them with an impressive collection of words.<br/><br/><strong>Finale: Light, Camera, and Popcorn</strong><br/><br/>The Language Fiesta wrapped up on a high note with "Light, Camera, and Popcorn," where students relaxed and enjoyed a movie screening with popcorn, bringing the celebrations to a memorable close.<br/><br/>The Language Fiesta was a delightful blend of creativity, fun, and learning, leaving students enriched and inspired by the joy of language.',
    title: "Language Fiesta - The English Week (Primary)",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-4/vid1.mp4",
    y: "2024",
  },
  {
    d: "04",
    fullDate: "04 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-11-24-1/pic12.jpg",
    ],
    isVideo: false,
    link: "/school-events/visit-of-cultural-exchange-embracing-indian-spiritual-heritage-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/visit-of-cultural-exchange-embracing-indian-spiritual-heritage-2024",
    text: "Chinmaya Vidyalaya New Delhi recently welcomed students and teachers from Germany and Lotus Valley School, creating a vibrant platform for cultural and educational exchange.<br/><br/>The guests were warmly greeted with a traditional tilak and the Hari Om salutation, symbolizing respect and spiritual unity. This was followed by the lighting of the ceremonial lamp and the chanting of the Shiva Sankalpa Sooktam by students, setting the tone for a meaningful interaction.<br/><br/>The school Principal introduced Chinmaya Vidyalaya's values, highlighting its unique blend of modern and traditional learning. Mr. Anand Sharma elaborated on the universal symbol of \"Om\" and led a group chanting session, instilling peace and unity among participants.<br/><br/>The highlight of the meet was an insightful discussion on Chapter 5 of the Bhagavad Gita, Karma Sanyasa Yoga, and a brief introduction to the scripture's teachings. This illustrated the relevance of these timeless wisdoms in overcoming life's challenges.<br/><br/>The visit concluded with a thought-provoking Q&A session and meditative reflection, enhancing understanding of Indian practices, encouraging intercultural dialogue, and showcasing students' knowledge of sacred texts. This exchange fostered mutual respect and admiration for India's rich spiritual heritage.",
    title: "Visit of Cultural Exchange: Embracing Indian Spiritual Heritage",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "04",
    fullDate: "04 November 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-11-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-11-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-11-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-11-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-11-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-11-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-11-24-1/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/assembly-by-class-iv-c-books-are-our-best-friends-2024",
    m: "Nov",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/assembly-by-class-iv-c-books-are-our-best-friends-2024",
    text: "The students of Class IVC in the Primary Department presented an enlightening assembly on the theme, Books Are Our Best Friends, with enthusiasm and creativity.<br/><br/>The assembly began with a lively poem recitation by a group of students, who shared the many joys and benefits that come with reading books.<br/><br/>Following the poem, the students performed a captivating skit titled Books and Adventure, which highlighted the value of reading over video games. The skit even illustrated how video games draw inspiration from books, encouraging children to explore the adventures within the pages of a book.<br/><br/>Adding a rhythmic touch, the students performed an energetic action song celebrating the joy of reading, inspiring everyone to tap their feet along.<br/><br/>The assembly concluded with the National Song, filling everyone with unity and pride.",
    title: "Assembly by Class IV C - Books Are Our Best Friends",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "29",
    fullDate: "29 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic26.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic27.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic28.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic29.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic30.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic31.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-4/pic32.jpg",
    ],
    isVideo: false,
    link: "/school-events/diwali-celebration-primary-pre-primary-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/diwali-celebration-primary-pre-primary-2024",
    text: "On Tuesday, 29th October 2024, Chinmaya Vidyalaya New Delhi's Pre-Primary and Primary departments came alive with the vibrant spirit of Diwali. The young learners enthusiastically participated in various activities, immersing themselves in the festival's significance and traditions.<br/><br/>In the Pre-Primary department, the celebration commenced with a PowerPoint presentation introducing the students to the importance of Diwali. The emphasis on promoting an eco-friendly, Green Diwali resonated deeply with the pupils. A captivating Diwali-themed puppet show retold the epic tale of the Ramayana, captivating the students' imagination and interest.<br/><br/>The Pre-Primary pupils actively participated in classroom decorations and crafted colourful rangoli designs, showcasing their creativity. The festivities culminated in a class party and engaging craft activities focused on the Diwali festival, creating a memorable experience for all.<br/><br/>In the Primary department, each class showcased their unique talents through various activities. Class I's little artists decorated vibrant diyas, adding warmth to the celebrations. Class II students created mini masterpieces by painting diyas in beautiful colours. Class III pupils expressed their thoughts and feelings by writing heartfelt Diwali wishes on handmade cards.<br/><br/>Class IV students collaborated to design stunning rangolis, filling the space with colour and teamwork. Class V students showcased their skills with handcrafted 'torans' that earned admiration from everyone. Each activity infused the department with colour, creativity, and festivity, making this Diwali celebration truly unforgettable.<br/><br/>The Diwali celebrations at Chinmaya Vidyalaya New Delhi successfully fostered a sense of community, creativity, and cultural awareness among the students. The joyous and festive atmosphere will be etched in their memories for a long time.",
    title: "Diwali celebration - Primary & Pre Primary",
    videoSrc: "",
    y: "2024",
  },

  {
    d: "29",
    fullDate: "29 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-3/pic14.jpg",
    ],
    isVideo: false,
    link: "/school-events/rids-activity-the-great-birdie-adventure-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-activity-the-great-birdie-adventure-2024",
    text: "Soaring to New Heights<br/><br/>On 29th October 2024, Class I students from Chinmaya Vidyalaya New Delhi, took to the stage with an engaging presentation, 'The Great Birdie Adventure,' as part of the prestigious British Council's RIDS activity. This captivating event delved into the fascinating realm of iconic avian creatures, showcasing the students' creativity, talent, and knowledge.<br/><br/>The event commenced with an invocation prayer and a melodious Hindi song, setting the tone for a memorable morning. Students then delivered insightful talks on the significance, symbolism, and cultural impact of national birds from Singapore, Kenya, Nepal, and India, demonstrating their understanding and appreciation of diverse cultures.<br/><br/>The highlight of the event was the mesmerising Birdie Fashion Show, where students dressed as iconic avian creatures, showcasing their respective countries with charm and elegance. A vibrant story followed, weaving a tale of freedom and friendship featuring colourful characters, which was brought to life through an expressive performance. The students' energetic 'birdie dance' performance creatively highlighted the theme, with vibrant costumes representing national birds. Their talent and grace captivated the audience, leaving a lasting impression.<br/><br/>The presentation culminated with an inspiring address by Principal Ms. Archana Soni, who commended the students and teachers for their efforts. She emphasised the importance of parental involvement, encouraging parents to spend quality time with their children. Additionally, she appealed to the audience to celebrate a Green Diwali, promoting eco-friendly practices and environmental responsibility. 'The Great Birdie Adventure' was a resounding success, showcasing the students' creativity, knowledge, and talent.<br/><br/>It was a proud moment for Chinmaya Vidyalaya, New Delhi, and a testament to the school's commitment to providing holistic education and fostering creativity and innovation.",
    title: "RIDS activity - The Great Birdie Adventure",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "28",
    fullDate: "28 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-3/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/national-unity-day-assembly-by-class-iii-a-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/national-unity-day-assembly-by-class-iii-a-2024",
    text: "Class III A students at Chinmaya Vidyalaya New Delhi beautifully showcased their creativity and patriotism during an engaging National Unity Day assembly. The programme began with a warm welcome and tribute to Sardar Vallabhbhai Patel, India's first Deputy Prime Minister.<br/><br/>The students then presented a heartfelt Hindi poem recital on unity and patriotism, followed by insightful presentations on Sardar Patel's contributions as the ‘Iron Man of India.’ They highlighted his unification of over 500 states and the iconic Statue of Unity in Gujarat.<br/><br/>The cultural performances were a testament to the students' talent and teamwork. A captivating Bharatnatyam dance performance and a thought-provoking skit titled ‘The Unity Picnic’ promoted teamwork and friendship. The assembly concluded with a resounding sing-along of ‘We Are the World,’ celebrating togetherness.<br/><br/>The National Pledge sealed the assembly, reinforcing unity and harmony among the students, teachers, and staff.",
    title: "National Unity Day - Assembly by Class III-A",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "28",
    fullDate: "28 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-2/pic5.jpg",
    ],
    isVideo: false,
    link: "/school-events/session-on-career-preparedness-after-xii-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/session-on-career-preparedness-after-xii-2024",
    text: "Chinmaya Vidyalaya New Delhi hosted an insightful session on career preparedness for the students of classes XI B, XII B and XII C.<br/><br/>The session was facilitated by Mr. Abhiram Lokanathan, an alumnus and current Masters student in Quantitative Economics at the Indian Statistical Institute, New Delhi.<br/><br/>Mr. Abhiram underscored the impact of quality education and the opportunities available in prestigious institutions. He emphasized lifelong learning and the critical role of numeracy and communication skills in competitive exams and professional success.<br/><br/>The session inspired students to explore their aspirations and align them with strategic career planning, equipping them with essential insights for future readiness.",
    title: "Session on career preparedness after XII",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "28",
    fullDate: "28 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-11-24-1/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/rids-activity-nourish-to-flourish-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-activity-nourish-to-flourish-2024",
    text: "Chinmaya Vidyalaya New Delhi recently hosted 'Nourish to Flourish,' a multi-cuisine cultural fest under the British Council RIDS Activity. Learners from Classes VI to VIII organized this spectacular event, taking attendees on a delightful journey through the diverse cuisines of India, China, Mexico, and Italy.<br/><br/>The event featured a vibrant tapestry of cultural performances, including graceful Italian dances, melodious Chinese songs, energetic Mexican dances, and soulful Indian music and dance. The stage came alive with a kaleidoscope of colours, sounds, and flavours!<br/><br/>Proceeds from the stalls were donated to charity, spreading love, unity, and nourishment. This wonderful initiative showcased the students' creativity, teamwork, and compassion.",
    title: "RIDS activity - Nourish to Flourish",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "25",
    fullDate: "25 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-5/pic13.jpg",
    ],
    isVideo: false,
    link: "/school-events/buzzing-bee-pre-primary-department-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/buzzing-bee-pre-primary-department-2024",
    text: "Chinmaya Vidyalaya New Delhi’s Pre-Primary Department buzzed and shone bright with a captivating poem recitation event.<br/><br/>Nursery students savoured delicious verses on food, while Prep students cultivated creativity with poems on plants. Colourful props added a vibrant touch to their performances.<br/><br/>A morning filled with enthusiasm, laughter, and pride!",
    title: "Buzzing Bee - Pre-Primary Department",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "25",
    fullDate: "22 - 25 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-4/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/inter-house-cricket-match-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/inter-house-cricket-match-2024",
    text: "Students of Chinmaya Vidyalaya New Delhi’s classes IX-XII showcased their exceptional talent and teamwork at the Inter-House Cricket Match. After a nail-biting series, Honesty House emerged victorious, with Friendship House securing second place and Sincerity House claiming third.<br/><br/>This thrilling tournament not only displayed outstanding cricket skills but also promoted invaluable life skills: sportsmanship, unity, and resilience. Congratulations to all participants on a game well played!",
    title: "Inter-House Cricket Match",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "25",
    fullDate: "25 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-3/pic17.jpg",
    ],
    isVideo: false,
    link: "/school-events/joy-of-giving-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/joy-of-giving-2024",
    text: "On 25th October 2024, students from Nursery to Class VIII of Chinmaya Vidyalaya New Delhi, along with devoted SEWA volunteers and teachers, embodied the spirit of the festival through their \"Joy of Giving\" initiative.<br/><br/>With the 'Each One, Donate One' activity, they selflessly collected and donated essential items to the Earth Saviours Foundation.<br/><br/>This heartfelt endeavour taught valuable lessons in service, compassion, and teamwork, reflecting Swami Chinmayanandaji's inspiring vision of selfless service.<br/><br/>Diwali truly came alive as they lit up hearts with kindness, shared joy, and celebrated the warmth of togetherness.",
    title: "Joy of Giving ",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "24",
    fullDate: "23 & 24 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-2/pic14.jpg",
    ],
    isVideo: false,
    link: "/school-events/educational-trip-to-astroport-sariska-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/educational-trip-to-astroport-sariska-2024",
    text: "A group of students from classes III to V, accompanied by teachers, recently embarked on an exciting educational trip to Astroport Sariska.<br/><br/>Under the guidance of experts, they engaged in hands-on telescope activities, identifying planets and celestial bodies in the crystal-clear skies. Rocket-building and launching exercises sparked creativity and enthusiasm for space science, whilst team-building activities promoted collaboration and teamwork.<br/><br/>The evening was filled with traditional Rajasthani folk dance and a bonfire, adding a magical touch to the trip.<br/><br/>On the second day, the students explored the breathtaking Sariska Tiger Reserve, spotting wildlife and connecting with nature. Returning home, they brought back memories and a newfound inspiration for astronomy and wildlife exploration.",
    title: "Educational trip to Astroport Sariska",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "21",
    fullDate: "21 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-7/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/career-fair-at-chinmaya-vidyalaya-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/career-fair-at-chinmaya-vidyalaya-2024",
    text: "On 21st October 2024, Chinmaya Vidyalaya New Delhi welcomed over 32 esteemed national and international universities to its campus. Students from Classes X-XII explored diverse career paths in AI, Robotics, Biotechnology, and more, discovering scholarships and future-ready fields.<br/><br/>This informative event sparked curiosity and confidence, empowering students to navigate emerging opportunities and make informed decisions about their future.",
    title: "Career Fair at Chinmaya Vidyalaya",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "19",
    fullDate: "19 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-6/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-6/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-6/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-6/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-6/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-6/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-6/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/inter-house-football-matches-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/inter-house-football-matches-2024",
    text: "On 19th October 2024, Chinmaya Vidyalaya New Delhi, hosted an electrifying Inter-House Football Match for students of classes VI-VIII. The thrilling contest saw Honesty House claim the championship title, closely followed by Friendship, Freedom, and Sincerity Houses.<br/><br/>The students showcased exceptional teamwork, sportsmanship, and determination, making the event a true celebration of school spirit.<br/><br/>This exciting tournament not only honed teamwork and strategic thinking but also instilled perseverance and healthy competition among the young participants.",
    title: "Inter-House Football matches",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "18",
    fullDate: "18 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/29-10-24-1/pic4.jpg",
    ],
    isVideo: false,
    link: "/school-events/inter-house-coding-competition-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/inter-house-coding-competition-2024",
    text: "Chinmaya Vidyalaya New Delhi’s Department of Computer Science recently hosted an exciting Inter-House Coding Competition for classes XI and XII. The four houses—Freedom, Friendship, Sincerity, and Honesty—demonstrated remarkable coding skills and problem-solving abilities, with Freedom House winning and Sincerity House securing second place.<br/><br/>This event enhanced problem-solving skills, collaboration, and creativity among the students, tackling future challenges with confidence and ingenuity.",
    title: "Inter - House Coding Competition",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "18",
    fullDate: "18 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-5/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-5/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-5/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-5/pic4.jpg",
    ],
    isVideo: false,
    link: "/school-events/photography-videography-workshop-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/photography-videography-workshop-2024",
    text: "On 18th October 2024, Chinmaya Vidyalaya New Delhi hosted a social media photography and videography workshop for staff, led by industry experts Nitya Balagopal and Rishab Pandey.<br/><br/>Nitya Balagopal, marketing strategist and Founder, Black Elephant Digital, shared valuable insights on optimizing event content for a cohesive brand identity and digital journey, while emphasizing the need to set SMART goals for all activations, and sharing a handy checklist to make visual content appealing, especially while shooting with a smartphone.<br/><br/>Renowned film maker Rishab Pandey of COMFED Films delivered technical expertise on aperture, white balance, shutter speed, and focus, elevating staff skills in photography and videography. He also led the staff into a hands-on activity, inviting them to share their best pictures of the space to receive feedback.<br/><br/>This interactive workshop empowered Chinmaya Vidyalaya's staff with practical knowledge to enhance visual content creation, captivating audiences across platforms.",
    title: "Photography & Videography workshop",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "18",
    fullDate: "18 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-4/pic14.jpg",
    ],
    isVideo: false,
    link: "/school-events/palate-fest-farm-to-fork-by-evs-department-classes-i-v-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/palate-fest-farm-to-fork-by-evs-department-classes-i-v-2024",
    text: "As part of the World Food Day activities, the EVS Department of Chinmaya Vidyalaya New Delhi organised an engaging event, 'Palate Fest - Farm to Fork', showcasing the journey of food from the farm to the dinner table. Various booths represented different raw materials, such as fruits, vegetables, lentils, legumes, and grains.<br/><br/>Students and teachers took the lead to explain how the raw materials undergo various processes to become rich cooked food. Attendees enjoyed tasting samples while learning about healthy meal preparations.<br/><br/>A life-like display, featuring a scene of a farmer harvesting crops, helped the students understand the hard work involved in food production. The special highlight of the day was the discussion on Sustainable Development Goals 2 (SDG-2) - Zero Hunger and how sustainable farming methods can help tackle food scarcity. The Palate Fest successfully fostered a deeper understanding of the food system and sustainable farming techniques.<br/><br/>The event was a resounding success, highlighting the critical connections between agriculture, nutrition, and community health. The farm display also depicted a group of students standing and guarding the farm as scarecrows and farmers.",
    title: "Palate Fest - Farm to Fork by EVS Department Classes I-V",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "16",
    fullDate: "16 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-3/pic25.jpg",
    ],
    isVideo: false,
    link: "/school-events/global-handwashing-day-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/global-handwashing-day-2024",
    text: "Chinmaya Vidyalaya New Delhi's Pre-Primary and Primary Departments recently observed Global Handwashing Day with great enthusiasm, emphasizing the vital role of hand hygiene in preventing infectious diseases and promoting healthy habits.<br/><br/>The Pre-Primary Department organised an engaging activity to promote hand hygiene awareness amongst its young pupils. The event began with a PowerPoint presentation introducing the significance of the day. In a fun and interactive twist, pupils dressed up as liquid soap to highlight the importance of handwashing. The pupils then participated in a hands-on activity, learning the 7 steps of handwashing by wearing gloves, applying paint, and observing how their hands became clean.<br/><br/>The Primary Department also joined in the celebrations, with students from Classes I-III watching an engaging dance video illustrating the essential steps for effective handwashing. Classes IV and V showcased their creativity through poster-making and slogan-writing competitions. The young pledges committed to washing their hands properly before and after meals, and after playtime.<br/><br/>Both departments successfully instilled healthy habits and responsible practices in the students. The imaginative exhibits crafted by the students demonstrated their creative thinking and understanding of this crucial aspect of personal hygiene.<br/><br/>Chinmaya Vidyalaya New Delhi is proud to empower its future leaders with essential life skills, promoting a culture of cleanliness and wellness.",
    title: "Global Handwashing Day",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "15",
    fullDate: "14 & 15 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-1/pic14.jpg",
    ],
    isVideo: false,
    link: "/school-events/astroport-trip-to-sariska-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/astroport-trip-to-sariska-2024",
    text: "Chinmaya Vidyalaya students blast off on an astronomical adventure!<br/><br/>On 14th-15th October, learners from Grades VI-XII embarked on a thrilling two-day journey to Astroport, Sariska's stargazing haven. Their odyssey began at the enchanting Bhangarh Fort, followed by a scenic voyage to Astroport.<br/><br/>Through rocket building, balloon races, and telescope explorations, students fostered teamwork, creativity, and curiosity under the starry night sky. A vibrant cultural evening celebrated regional heritage with captivating local performances.<br/><br/>Day two brought an exhilarating jungle safari in Sariska Tiger Reserve, where students spotted majestic tigers and wildlife. As the sun dipped, they returned with hearts full of wonder and cherished memories.",
    title: "Astroport Trip to Sariska",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "14",
    fullDate: "14 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/23-10-24-2/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/investigating-natures-wrath-natural-disasters-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/investigating-natures-wrath-natural-disasters-2024",
    text: "The students of Class IX of Chinmaya Vidyalaya New Delhi, under the esteemed RIDS initiative by the British Council, recently showcased impressive PowerPoint presentations on natural calamities affecting countries such as India, Oman, Bhutan, and the Philippines.<br/><br/>Their comprehensive presentations covered disasters specific to each country, including India's earthquakes, cyclones, floods, and fire hazards; Oman's floods, cyclones, sand and dust storms, and drought; Bhutan's earthquakes, floods, landslides, and windstorms; and the Philippines' earthquakes, typhoons, volcanoes, and landslides.<br/><br/>A thought-provoking group discussion ensued, where students reviewed the problems and suggested practical ways to reduce damage, fostering a deeper understanding of disaster preparedness.<br/><br/>Through this engaging project, the students developed a nuanced grasp of disaster management, analyzing causes, impacts, and mitigation strategies for various natural disasters.<br/><br/>They gained invaluable insights into how proactive planning, preparedness, and safety measures can minimise the devastating effects of these calamities, cultivating a sense of responsibility towards creating resilient communities.",
    title: "Investigating Nature's wrath Natural Disasters",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "14",
    fullDate: "14 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-10-24-1/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/keep-calm-study-hard-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/keep-calm-study-hard-2024",
    text: 'Chinmaya Vidyalaya New Delhi’s Class IV B shines with their inspiring assembly, "Keep Calm and Study Hard", promoting perseverance and dedication.<br/><br/>The talented students began with a powerful recitation of the poem "Try, Try Again", motivating everyone to persist in their efforts until they succeed. This was followed by a lively Radio Jockey Act, Red FM 4B.5, where five students captivated the audience, sharing diverse stories that emphasized the importance of perseverance.<br/><br/>The act was further enriched by a "recipe for success" shared by a Chef, an uplifting motivational thought from a Teacher, and life lessons drawn from the Bhagavad Gita by a Motivational Speaker. The assembly concluded on an energetic note with a dynamic dance performance set to the song \'Do Not Give Up\', inspiring students to remain resilient and work hard, even during challenging times.<br/><br/>Kudos to Class IVB for an unforgettable assembly!',
    title: "Keep Calm & Study Hard",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "09",
    fullDate: "09 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-4/pic19.jpg",
    ],
    isVideo: false,
    link: "/school-events/plastic-waste-collection-drive-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/plastic-waste-collection-drive-2024",
    text: 'Chinmaya Vidyalaya New Delhi recently took a commendable step towards sustainability by organizing a Plastic Waste Collection, in collaboration with the Green Dream Foundation. This event, part of the Stainless Swachhta Abhiyan, aimed to combat plastic waste and promote environmentally friendly practices.<br/><br/>Students from classes I to V, along with their teachers, actively participated by bringing plastic waste from home. Their combined efforts resulted in over 100 kilograms of plastic being collected for recycling—an impressive feat showcasing the power of collective action.<br/><br/>As Helen Keller once said, "Alone we can do so little; together we can do so much." The school also celebrated its young Eco-Warriors: those who contributed 1 kilogram or more were awarded certificates, while others bringing 500-999 grams were gifted plantable seed pencils.<br/><br/>Such gestures not only recognize their contributions but also encourage the growth of environmental responsibility. This initiative marks a crucial step in the journey toward a cleaner, greener planet.<br/><br/>As Mahatma Gandhi once wisely noted, “Be the change that you wish to see in the world.” The students\' efforts embody this spirit, making a positive impact and inspiring others to make sustainable choices to reduce our collective plastic footprint.',
    title: "Plastic Waste Collection Drive",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "09",
    fullDate: "09 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-1/pic4.jpg",
    ],
    isVideo: false,
    link: "/school-events/poster-making-classes-ii-to-xii-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/poster-making-classes-ii-to-xii-2024",
    text: "To mark the UN's International Day for Natural Disaster Risk Reduction on October 13th, Chinmaya Vidyalaya New Delhi’s learners created impactful posters highlighting disaster preparedness.<br/><br/>Students from Classes II-XII showcased tremendous creativity and understanding. Through art, they conveyed the importance of community resilience and individual responsibility in building a safer future.",
    title: "Poster Making (Classes II to XII)",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "09",
    fullDate: "09 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-2/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/sensorial-activity-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/sensorial-activity-2024",
    text: "Chinmaya Vidyalaya New Delhi’s young learners recently embarked on a fascinating Sensorial Activity journey. Nursery students discovered the joys of ‘Feel the Texture’, examining cotton, wool, silk, ice cream, and sandpaper to refine their sense of touch.<br/><br/>Meanwhile, Prep class learners participated in the engaging ‘Touch and Feel’ activity, identifying hidden objects through tactile exploration.<br/><br/>Both activities sparked imagination and curiosity, enhancing tactile sensory skills. A fun-filled day of discovery and learning!",
    title: "Sensorial Activity",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "08",
    fullDate: "08 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-10-24-3/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/animal-race-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/animal-race-2024",
    text: "Chinmaya Vidyalaya New Delhi’s Nursery and Prep students recently unleashed their inner animals in an action-packed race!<br/><br/>Through running, hopping, and playful movements, they developed essential skills like coordination, balance, and teamwork. Physical fitness and fun went hand-in-hand! The young learners shone with energy and enthusiasm, creating unforgettable memories.",
    title: "Animal Race",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "08",
    fullDate: "08 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-5/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-5/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-5/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-5/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-5/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-5/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-5/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-5/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/world-mental-health-day-by-honesty-house-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-mental-health-day-by-honesty-house-2024",
    text: "Chinmaya Vidyalaya marked World Mental Health Day with a special assembly for classes VI-XI. The highlight of the event was a thought-provoking nukkad natak that promoted mental health awareness, accompanied by the chanting of the Medhasuktam, which helps improve concentration and calm the mind.<br/><br/>The school counselor emphasized the importance of self-care for mental well-being, while the headmistress spoke on mindfulness and adapting to challenges. This assembly fostered awareness among students, encouraging them to prioritize mental health and practice mindfulness for personal growth.",
    title: "World Mental Health Day by Honesty House",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "07",
    fullDate: "07 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-4/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/pm-yuva-author-meet-class-viii-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/pm-yuva-author-meet-class-viii-2024",
    text: "Chinmaya Vidyalaya New Delhi recently hosted the NBT PM YUVA Author Meet, featuring acclaimed author Ms. Arushi Maheshwari.<br/><br/>She shared her writing journey, highlighting PM YUVA's impact on nurturing young talent and inspiring students to pursue storytelling, self-expression, and literary excellence.<br/><br/>Ms. Maheshwari's insights on writing challenges and rewards sparked enthusiasm, motivating students to explore opportunities in writing competitions and publishing.<br/><br/>This interactive session fostered creativity, cultural awareness, and confidence, equipping students with skills and knowledge to embark on their own literary journeys!",
    title: "PM YUVA Author Meet (Class-VIII)",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "07",
    fullDate: "07 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-3/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/storytelling-session-class-vii-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/storytelling-session-class-vii-2024",
    text: 'Chinmaya Vidyalaya New Delhi in association with National Book Trust, presented a mesmerizing storytelling session for Class VII students.<br/><br/>Ms. Shikha Garg, co-founder of Nurture Roots, regaled the audience with "Shwetlara and Minaaz", an Uzbek folk tale.<br/><br/>Her engaging storytelling, infused with props and voice modulation, ignited creativity and imagination. Through storytelling, we awaken the joy of learning, one tale at a time!<br/><br/>The session encouraged creativity and imagination, urging students to explore  and craft their narratives.',
    title: "Storytelling Session (Class-VII)",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "05",
    fullDate: "3-5 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-2/pic24.jpg",
    ],
    isVideo: false,
    link: "/school-events/the-28th-inter-school-bhagvad-geeta-chanting-competition-3rd-to-5th-oct-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/the-28th-inter-school-bhagvad-geeta-chanting-competition-3rd-to-5th-oct-2024",
    text: "From 3rd to 5th October 2024, Chinmaya Vidyalaya New Delhi proudly hosted the 28th Inter-School Bhagavad Gita Chanting Competition, bringing together 1080 students from an impressive 84 schools across Delhi NCR.<br/><br/>The Bhagavad Gita, a sacred scripture, offers profound insights into the nature of reality, the soul, and the divine. It provides a framework for understanding life's meaning and our place in the universe. This year's competition focused on Chapter 5, \"Karma Sannyasa Yoga\" – the Yoga of Renunciation.<br/><br/>The three-day event commenced with a ceremonial lamp lighting, invocation prayer, and a soulful Krishna bhajan performed by the school choir, followed by a captivating dance performance on Ganesh Stuti. This set the tone for a spiritual and enriching experience.<br/><br/>On the second day, Swami Avyayananda Ji of Chinmaya Mission Delhi graced the occasion, along with Ms. Shibani Khurana, Manager, Chinmaya Vidyalaya. Swamiji was welcomed with a poorna kumbh. In his address, Swamiji emphasized the importance of Karma Sannyasa Yoga in today's life and encouraged students to embody its teachings in their personal journeys.<br/><br/>The participants showcased remarkable proficiency in chanting shlokas from Chapter 5, demonstrating impeccable memorization, presentation, and pronunciation. The judges from prestigious universities, including SLBSNSU, JNU, and Central Sanskrit University, commended the students' devotion and dedication.<br/><br/>This competition served as a platform for students to deepen their understanding of the Bhagavad Gita's core principles and cultivate a sense of purpose and integrity. By participating in this event, students developed a stronger connection with the sacred text and its timeless wisdom.<br/><br/>Chinmaya Vidyalaya New Delhi congratulates all participants on their outstanding performances and thanks esteemed guests, judges, and organizers for making this event a resounding success.",
    title: "The 28th Inter- School Bhagvad Geeta Chanting Competition (3rd to 5th Oct-2024)",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "01",
    fullDate: "01 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic23.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic24.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic25.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic26.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic27.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-16/pic28.jpg",
    ],
    isVideo: false,
    link: "/school-events/gandhi-jayanti-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/gandhi-jayanti-2024",
    text: "Chinmaya Vidyalaya celebrates Gandhi Jayanti with fervour!<br/><br/>The Pre-Primary Department embarked on a cleanliness drive, embracing Gandhiji's message of cleanliness, and watched an insightful video about his life and principles. Young learners expressed their creativity through freehand drawings of iconic symbols like Gandhiji's glasses and the tricolor, absorbing valuable lessons on cleanliness, non-violence, and patriotism.<br/><br/>Meanwhile, Class III B from the Primary Department delivered a heartfelt special assembly, highlighting Gandhiji's timeless teachings. The soul-stirring choir performance of 'Raghupati Raghav Raja Ram' left the audience spellbound. Students vividly portrayed pivotal moments from Gandhiji's life, including his early education, the Satyagraha movement, and the Quit India Movement.<br/><br/>Senior students attended a special assembly featuring a poignant skit on Gandhian principles: Satya, Ahimsa, Swachhta, and Simplicity. The choir's soulful rendition of 'Vaishnav Jan To' was followed by a Swachhta pledge. The Headmistress emphasized the significance of embodying Gandhiji's values to fulfill his vision for a united India.",
    title: "Gandhi Jayanti",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "01",
    fullDate: "01 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-15/pic11.jpg",
    ],
    isVideo: false,
    link: "/school-events/waste-garbage-given-to-green-dream-foundation-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/waste-garbage-given-to-green-dream-foundation-2024",
    text: "Chinmaya Vidyalaya New Delhi takes action for a greener tomorrow!<br/><br/>On 1st October 2024, the school collaborated with Green Dream Foundation for a Plastic Waste Collection Drive under the Stainless Swachhta Abhiyan.<br/><br/>Students from Classes VI-XII and teachers collectively gathered over 60 kg of plastic waste for recycling. Eco-Warriors who contributed 1 kg+ received certificates, while those who brought 500-999g earned plantable seed pencils.<br/><br/>This initiative embodies Chinmaya Vidyalaya's commitment to sustainability, inspiring collective action for a cleaner planet.",
    title: "Waste Garbage given to Green Dream Foundation",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "01",
    fullDate: "01 October 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-14/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/confluence-career-fair-2024",
    m: "Oct",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/confluence-career-fair-2024",
    text: "Chinmaya Vidyalaya's Class XI students attended Confluence Career Fair 2024 at Tagore International School, Vasant Vihar.<br/><br/>Organized by Envision India Eduservices, this premier event offered a unique platform to explore national and international universities, educational services, and reliable career guidance.<br/><br/>Interactive sessions with renowned experts, including Neha Malhotra from International Image Consulting Institute, shed light on emerging career paths. Students engaged with representatives from prestigious institutions, gaining valuable insights into various educational opportunities.<br/><br/>This enriching experience empowered students to explore, connect, and ignite their career aspirations, making informed decisions about their future.",
    title: "Confluence Career Fair 2024",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "28",
    fullDate: "28 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-11/pic9.jpg",
    ],
    isVideo: false,
    link: "/school-events/sqaaf-session-by-ms-shanti-krishnamurthy-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/sqaaf-session-by-ms-shanti-krishnamurthy-2024",
    text: "Ms Shanti Krishnamurthy, Director of Academics and Administration at Chinmaya International Residential School, delivered an insightful session on the School Quality Assessment and Assurance Framework (SQAAF) at Chinmaya Vidyalaya, New Delhi.<br/><br/>The session commenced with an engaging PowerPoint presentation, showcasing the global reach of the Chinmaya Education Movement and the importance of implementing the Chinmaya Vision Programme. Ms Krishnamurthy explored various programs operating under the Chinmaya Central Management Trust (CCMT EC), emphasizing the influential visionaries who spearhead these initiatives.<br/><br/>Ms Krishnamurthy highlighted the significance of both online and offline resources, particularly for Class XI students, alongside the effective execution of CHYK clubs and Bal Sewak Programmes. She also introduced exciting new initiatives, including the G20 initiative and Generation Global initiative, tailored for all Chinmaya Institutions.<br/><br/>The SQAAF segment delved into crucial aspects of the National Education Policy (NEP), outlining its vision and key recommendations while providing a comparative analysis with the Chinmaya Vision Programme. Ms Krishnamurthy elaborated on the purpose of SQAAF, focusing on the four R's: Review, Reflect, Respond, and Rate, as well as the framework's essential domains.<br/><br/>The session concluded with participants presenting their work, showcasing remarkable teamwork and their grasp of the concepts discussed. Each presentation demonstrated the collaborative spirit and commitment to enhancing the educational framework.",
    title: "SQAAF Session by Ms Shanti Krishnamurthy",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "27",
    fullDate: "27 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-9/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-9/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-9/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-9/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-9/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-9/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-9/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-9/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/vasudhaiva-kutumbakam-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/vasudhaiva-kutumbakam-2024",
    text: "On 27 September 2024, Chinmaya Vidyalaya organised a special assembly for students from Classes VI-XII, centred around the theme 'Vasudhaiva Kutumbakam' - the world is one family. This theme beautifully highlighted the interconnectedness of all living beings, drawing inspiration from Gurudev Swami Chinmayananda's vision: service to society and cultivating good human values.<br/><br/>The programme commenced with a soulful orchestra and a melodious performance of \"Vishva Shanti Ekta Bani Rahe Hardum,\" a song encapsulating the spirit of unity and peace.<br/><br/>The assembly was graced by Ms Shanti Krishnamurthy, Director of CIRS and CCMT Education Cell, who served as the Chief Guest. In her address, Ms Krishnamurthy praised the performers and shared cherished memories with Swami Chinmayananda, emphasising his vision of transforming society through education.<br/><br/>Ms Krishnamurthy reminded the audience that the eligibility to be a teacher lies in loving children and stressed Swamiji's philosophy of creating good individuals to build a better society. She highlighted that Swamiji's founding of schools aimed at character building, not just academics.<br/><br/>Connecting this vision to the National Education Policy 2020, Ms Krishnamurthy emphasised that Chinmaya schools have always pioneered an education system deeply rooted in Indian culture. She explained the importance of Para and Apara Vidya, with Chinmaya Vidyalayas imparting both spiritual knowledge (Yoga, Pranayama) and worldly knowledge.<br/><br/>Ms Krishnamurthy concluded her inspiring speech by urging everyone to nurture the fire within to uplift society.<br/><br/>The programme continued with a soul-stirring Nritya Nirvana dance performance and a thought-provoking skit on Sahishnuta (tolerance). The skit showcased how a proud king learns that true greatness lies in cooperation, empathy, and tolerance, leading his kingdom to thrive through harmony rather than wealth and power.<br/><br/>The assembly concluded with the soulful rendition of the Vidyalaya song, school pledge, and National Anthem, leaving a lasting impact on students and staff.",
    title: "Vasudhaiva Kutumbakam",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "27",
    fullDate: "27 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-7/pic17.jpg",
    ],
    isVideo: false,
    link: "/school-events/soccer-activity-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/soccer-activity-2024",
    text: "Chinmaya Vidyalaya New Delhi, hosted a thrilling Sight Word Soccer and Alphabet Soccer event, wherein Nursery students enhanced letter recognition through Alphabet Soccer, while Prep students boosted reading skills with Sight Word Soccer.<br/><br/>This engaging activity seamlessly merged learning with physical play, leaving both students and teachers excited!",
    title: "Soccer Activity",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "26",
    fullDate: "26 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-6/pic22.jpg",
    ],
    isVideo: false,
    link: "/school-events/rids-class-presentation-by-class-iv-once-upon-a-time-in-oman-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-class-presentation-by-class-iv-once-upon-a-time-in-oman-2024",
    text: "Chinmaya Vidyalaya New Delhi\u2019s Class IV students dazzle with 'Once upon a time in Oman' presentation!<br/><br/>The learners showcased a beautiful presentation of a fable, a story based on two characters - Fadil and Ramadu. The dramatization perfectly blended a famous Omani folktale with its traditions and culture.<br/><br/>Throughout the presentation, students shared insights into Oman's rich history, maintaining audience interest and participation. The audience responded enthusiastically, applauding the students' efforts and creativity.<br/><br/>The presentation concluded with encouraging words from Headmistress Archana Gaur, fostering excitement for future events and performances.",
    title: "RIDS - Class Presentation by Class IV - Once upon a time in Oman",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "25",
    fullDate: "25 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-10/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-10/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-10/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-10/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-10/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-10/pic6.jpg",
    ],
    isVideo: false,
    link: "/school-events/national-stock-exchange-class-xi-commerce-and-economics-students-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/national-stock-exchange-class-xi-commerce-and-economics-students-2024",
    text: `Chinmaya Vidyalaya New Delhi organized an enriching educational visit to the National Stock Exchange (NSE) for Class XI Commerce and Economics students.
    <br/><br/>
Mr Mohd Izhar Ul Islam, Deputy Manager of Investor Awareness, delivered an engaging session on stock market fundamentals and financial literacy, enlightening students on the importance of early investments, risk management, and long-term strategies for financial success.
 <br/><br/>
A quiz conducted by Mr Islam saw several Chinmaya Vidyalaya students showcase their knowledge, earning rewards for their correct answers.
 <br/><br/>
This visit successfully bridged the gap between theoretical understanding and practical application, providing valuable real-world experience.`,
    title: "National Stock Exchange (Class XI Commerce and Economics students)",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "25",
    fullDate: "25 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-8/pic13.jpg",
    ],
    isVideo: false,
    link: "/school-events/rids-class-presentation-the-desert-story-unfolds-by-class-iii-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-class-presentation-the-desert-story-unfolds-by-class-iii-2024",
    text: "The students of Class III of Chinmaya Vidyalaya, New Delhi, showcased a captivating presentation of the fable ‘The Magic Date Tree,’ exploring Omani culture and traditions, as part of the British Council RIDS programme. The performance began with students greeting the audience in Arabic, showcasing their engagement with Omani language and customs.<br/><br/>Throughout the presentation, students shared insights on Oman’s rich history, maintaining audience interest and participation. The story featured vibrant characters like Fatima, the Jinn, and the Tree Spirit, bringing the fable to life with expressive performances.<br/><br/>Through riddles and clever problem-solving, the narrative emphasized themes of kindness, determination, and wisdom, inspiring the audience. The audience responded enthusiastically, applauding the students' efforts and creativity.<br/><br/>The presentation concluded with encouraging words from Headmistress Ms Archana Gaur, fostering excitement for future events and performances.<br/><br/>Well done, Class III!ited!",
    title: "RIDS-Class Presentation (The Desert Story Unfolds) by Class III",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "25",
    fullDate: "25 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-4/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-4/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-4/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-4/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-4/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-4/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-4/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-4/pic8.jpg",
    ],
    isVideo: false,
    link: "/school-events/visit-to-the-parliament-house-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/visit-to-the-parliament-house-2024",
    text: "Chinmaya Vidyalaya's Class XII students embarked on an enlightening journey to the Old and New Parliament Houses of India on Wednesday, 25th September 2024. This educational excursion aimed to introduce students to the Indian parliamentary system, instilling national pride through the exploration of India's rich history, culture, and technological advancements.<br/><br/>Under the guidance of teachers-in-charge, Ms. Nitu Rai and Ms. Nadisha Goswami, 28 students participated in this enriching experience. The tour began with a detailed introduction to the Lok Sabha and Rajya Sabha, providing valuable insights into legislative processes. Students gained a unique understanding of law-making and the role of elected representatives in serving the nation. The newly constructed Parliament building's architectural grandeur left students in awe, showcasing a blend of tradition and modernity. They were impressed by the intricate design, symbolic elements, and cutting-edge technology embedded in the structure, reflecting India's progress.<br/><br/>This exposure deepened their appreciation for India's unity in diversity. Through this visit, students developed a deeper understanding of India's governance, legislative procedures, and democratic values. The experience fostered patriotism, instilling pride in India's democratic processes and cultural diversity. It also contributed to intellectual development, enhancing students' knowledge of parliamentary functions and legislative processes.<br/><br/>The key learning outcomes of this visit included understanding parliamentary functions, gaining insight into legislative processes, appreciating democratic values, developing cultural awareness and national unity, and drawing inspiration from technological and architectural progress. This hands-on learning experience will undoubtedly impact the students' civic consciousness and responsibility, shaping committed and dedicated citizens who take pride in serving the nation.",
    title: "Visit to the Parliament House",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "24",
    fullDate: "24 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-2/pic7.jpg",
    ],
    isVideo: false,
    link: "/school-events/a-teachers-journey-of-self-discovery-staff-visit-to-chinmaya-mission-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/a-teachers-journey-of-self-discovery-staff-visit-to-chinmaya-mission-2024",
    text: "Chinmaya Vidyalaya New Delhi, has recently undertaken a pioneering initiative, organizing visits to the esteemed Chinmaya Center of World Understanding at the Lodhi Centre. This enriching experience aimed to immerse the school's teaching staff in the profound philosophy of Gurudev Swami Chinmayananda, equipping them with the tools to inspire and nurture their pupils.<br/><br/>Under the expert guidance of facilitators Mr. Shyam and Ms. Ruma, the teachers delved into the life and teachings of Gurudev, illuminating the path to spiritual enlightenment. Through interactive sessions, they explored the essence of Chinmayatva, uncovering its significance for both educators and students.<br/><br/>The facilitators emphasized the importance of holistic development, nurturing the perceptive, feeling, and thinking aspects of every individual. By leading by example and striving for personal growth, teachers can create a ripple effect of positive influence, shaping young minds and fostering a harmonious learning environment.<br/><br/>The session culminated with a powerful reminder of the school's guiding motto: \"To bring maximum happiness to the maximum number of people for the maximum amount of time.\" This inspiring message serves as a beacon, encouraging the teachers to dedicate their lives to the well-being and spiritual growth of their pupils.<br/><br/>Through this orientation programme, Chinmaya Vidyalaya New Delhi reaffirmed its commitment to fostering a culture of compassion, harmony, and spiritual growth amongst its students and staff. After all, education is not solely about imparting knowledge, but about shaping lives and creating a brighter future.",
    title: "A Teacher's Journey of Self-Discovery (Staff visit to Chinmaya Mission)",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "24",
    fullDate: "24 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-1/pic12.jpg",
    ],
    isVideo: false,
    link: "/school-events/interhouse-mine-show-assembly-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/interhouse-mine-show-assembly-2024",
    text: "Chinmaya Vidyalaya New Delhi, in partnership with the British Council, organised the thought-provoking 'RIDS' activity, themed \"Shoot Us with Cameras, Not Guns!\".<br/><br/>The Inter-House Mime Show, featuring students of classes VIII-XII, poignantly highlighted the devastating consequences of poaching and deforestation.<br/><br/>Through captivating performances, the students portrayed the heart-wrenching extraction of elephant tusks, tiger skin poaching, and habitat loss threatening various species.<br/><br/>This powerful initiative not only raised awareness about wildlife conservation but also instilled a sense of responsibility among students for environmental sustainability.<br/><br/>By participating in this British Council programme, Chinmaya Vidyalaya New Delhi reaffirms its commitment to nurturing empathetic, environmentally conscious global citizens.",
    title: "Interhouse Mine Show Assembly",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "23",
    fullDate: "23 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/09-10-24-1/pic6.jpg",
    ],
    isVideo: false,
    link: "/school-events/evacuation-mock-drills-from-classes-nursery-to-xii-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/evacuation-mock-drills-from-classes-nursery-to-xii-2024",
    text: "As part of the British Council's RIDS project, Chinmaya Vidyalaya New Delhi conducted a comprehensive evacuation drill. Students from Nursery to XII promptly evacuated the premises, following their designated staircase routes and demonstrating their preparedness for emergency situations.<br/><br/>Teacher supervisors ensured a swift and efficient evacuation process. The drill's purpose was to familiarize students with effective escape procedures in the event of a disaster.<br/><br/>The meeting point for the entire school was the green field. Through such initiatives, learners will be able to evacuate the school building safely and efficiently in case of an emergency.",
    title: "Evacuation Mock Drills from classes Nursery to XII",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "23",
    fullDate: "23 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-5/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/gratitude-should-be-the-attitude-assembly-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/gratitude-should-be-the-attitude-assembly-2024",
    text: "Chinmaya Vidyalaya New Delhi\u2019s Class V D inspires with 'Gratitude should be the attitude' Assembly! Beautiful thoughts were shared by the children, bringing forth the message of appreciating all the little things in life.<br/><br/>The highlight of the program was an enactment titled 'The Thankful Tree'. The talented students projected the value that we should appreciate and show gratitude towards our parents, teachers, and friends who are like trees that nurture selflessly without expecting anything in return.<br/><br/>A foot-tapping dance culminated the program in the most interesting way, leaving the audience energized and inspired.<br/><br/>It was a very thought-provoking assembly that shared the message that mindfulness and gratitude make life abundant!",
    title: "Gratitude should be the Attitude Assembly",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "20",
    fullDate: "20 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-10-24-3/pic23.jpg",
    ],
    isVideo: false,
    link: "/school-events/world-peace-day-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-peace-day-2024",
    text: "Chinmaya Vidyalaya New Delhi\u2019s students. across all age groups, came together to promote harmony and unity on International Peace Day.<br/><br/>Students of Pre-Primary viewed an engaging PowerPoint presentation, introducing them to the significance of peace. They creatively expressed their thoughts through dove artwork using sponge printing and spray-painting techniques, symbolizing peace. Their energetic dance performance to 'I Got Peace in My Soul' filled the air with joy.<br/><br/>Primary School students took a pledge to become messengers of peace, learning valuable lessons on conflict resolution, compassion, and tolerance. They resolved to create a world where everyone feels safe and valued.<br/><br/>Senior School students led a special assembly, highlighting the United Nations' pivotal role in promoting global harmony. They presented insightful talks on key organizations maintaining peace, including the UN Security Council, International Court of Justice, and Economic and Social Council. The assembly concluded with a powerful call to action, encouraging all to become global peace citizens.<br/><br/>Through these collective efforts, Chinmaya Vidyalaya New Delhi reaffirmed its commitment to fostering a culture of peace, compassion, and harmony among its students, inspiring them to become responsible global citizens.",
    title: "World Peace Day",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "18",
    fullDate: "18 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-10-24-1/pic10.jpg",
    ],
    isVideo: false,
    link: "/school-events/11th-national-level-exhibition-and-project-competition-nlepc-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/11th-national-level-exhibition-and-project-competition-nlepc-2024",
    text: "Chinmaya Vidyalaya New Delhi’s Class X students visited the 11th National Level Exhibition and Project Competition (NLEPC) under INSPIRE-MANAK at ITPO, Delhi.<br/><br/>Showcasing cutting-edge science projects from across India, the exhibition highlighted practical solutions to real-world challenges. Our inquisitive students engaged with project presenters, delving into innovative applications of STEM concepts.<br/><br/>This enriching experience bridged the gap between theory and practice, illustrating how academic knowledge can transform into impactful, real-world solutions.<br/><br/>Chinmaya Vidyalaya New Delhi is committed to inspiring the next generation of innovators!",
    title: "11th National Level Exhibition and Project Competition (NLEPC)",
    videoSrc: "",
    y: "2024",
  },
  {
    title: "Grandparents Day Celebration",
    text: `Grandparents are a family's greatest treasure and guiding lights for future generations.
<br/><br/>
Honouring this cherished bond, the Pre-Primary Department at Chinmaya Vidyalaya New Delhi, celebrated Grandparents' Day with fervour and joy.
<br/><br/>
The festivities commenced with a warm welcome and traditional tilak ceremony, followed by an array of joyful activities, music, and dance.
<br/><br/>
The youngsters were enthralled by their grandparents' enchanting stories, showcasing their role as ultimate storytellers.
<br/><br/>
As a token of appreciation, each learner presented a heartfelt card to their grandparent.
A wonderful celebration of love, gratitude, and intergenerational connection!`,
    fullDate: "17 September 2024",
    d: "17",
    m: "Sep",
    y: "2024",
    link: "/school-events/grandparents-day-celebration-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 20; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-09-24-07/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/grandparents-day-celebration-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Capacity Building Workshop",
    text: `Chinmaya Vidyalaya New Delhi recently organised a Capacity-Building Workshop on Art Integration, empowering educators to harness the power of art in diverse subjects.
<br/><br/>
Renowned resource persons, Ms. Vibha Khosla and Ms. Pragya Nopany, led the workshop, distinguishing between Art Enhanced Learning and Art Integration, and aligning it with Bloom's Taxonomy.
<br/><br/>
Through interactive activities, discussions, and audiovisual presentations, participants explored the significance of incorporating artistic elements to address multiple intelligences, as outlined by Howard Gardner.
<br/><br/>
Ms. Nopany emphasized the crucial distinction between learning outcomes and objectives in lesson planning.
<br/><br/>
The workshop culminated in innovative, interdisciplinary lesson plans, crafted by educators in collaborative groups, fostering constructive feedback and knowledge exchange.
<br/><br/>
A stimulating professional development experience, enhancing teaching excellence and student engagement!`,
    fullDate: "17 September 2024",
    d: "17",
    m: "Sep",
    y: "2024",
    link: "/school-events/capacity-building-workshop-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 18; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-09-24-06/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/capacity-building-workshop-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "World Ozone Day",
    text: `Chinmaya Vidyalaya New Delhi marked International Ozone Day with a special assembly for classes VI-X, focusing on ozone layer awareness and environmental conservation.
  <br/><br/>
The highlight of the assembly was a captivating skit featuring an interview with Dr. Melvia Maric, an environmental scientist, who shed light on ozone depletion, its causes, and the pivotal role of the Montreal Protocol.
 <br/><br/>
The Headmistress emphasized the urgency of protecting the ozone layer, stating, "A planet without it is like a house without a roof."
 <br/><br/>
The enlightening session encouraged students to adopt sustainable practices, reduce vehicle emissions, and plant trees, inspiring proactive steps towards a greener future.
 <br/><br/>
Chinmaya Vidyalaya New Delhi is at the forefront - raising awareness, inspiring action!`,
    fullDate: "17 September 2024",
    d: "17",
    m: "Sep",
    y: "2024",
    link: "/school-events/world-ozone-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 7; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-09-24-05/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-ozone-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Space Club Session-I",
    text: `Chinmaya Vidyalaya, New Delhi, hosted a thrilling Space Club session for its Primary learners on 13th September 2024. 
    <br/><br/>
The event captured young minds with the wonders of space exploration, dividing the students into two groups for tailored sessions. The younger explorers from Classes I-II discovered the fundamental concepts of light through an engaging session titled "ABC of Light." Through an animated story and interactive games, including a laser light activity and board game, students learned that light travels in straight lines and is essential for vision. A captivating demonstration of shadows further enriched their understanding. Each student received a Shadow Show kit and Shadow Story sheet to reinforce their learning. 
<br/><br/>
Meanwhile, Classes III-V adventurers embarked on "The Martian Lab" journey, exploring the significance of searching for life beyond Earth. Delving into the fascinating world of the Mars Curiosity Rover, students gained insights into its mission, components, and advanced research instruments. A hands-on puzzle activity brought the Curiosity rover to life, allowing students to piece together its intricate design. To further deepen their knowledge, each student received a 3D Curiosity Rover model kit. 
<br/><br/>
The Space Club session proved an overwhelming success, igniting curiosity and enthusiasm among Chinmaya Vidyalaya's Primary learners. The school reinforced its commitment to fostering a love for science, technology, engineering, and mathematics (STEM) education by combining interactive learning with take-home resources. The event's impact will undoubtedly inspire future explorers and innovators, propelling them toward a brighter, more enlightened tomorrow.`,
    fullDate: "13 September 2024",
    d: "13",
    m: "Sep",
    y: "2024",
    link: "/school-events/space-club-session-I-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 19; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-09-24-04/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/space-club-session-I-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Hindi Diwas",
    text: `Rejoicing in the rhythm of language and culture, Chinmaya Vidyalaya New Delhi, commemorated Hindi Diwas on 13th September 2024 with a vibrant array of events.
 <br/><br/>
The celebrations began with the Pre-Primary students' impressive Hindi poem recitations. Nursery students mesmerized the audience with poems on nature, colors, seasons, and animals, showcasing their confidence and creativity. Prep students left everyone in stitches with their hilarious Hasya Kavi Sammelan performances, proving laughter is the best medicine.
 <br/><br/>
Students from Classes III-IV also delighted audiences with their 'Hasya Kavi Sammelan', presenting a sidesplitting array of poems accompanied by clever props. Meanwhile, Class V students inspired all with powerful orations on 'Youth Power', showcasing their passion and potential.
 <br/><br/>
The senior school students (Classes VI-XI) attended a special assembly highlighting Hindi's vital role in unifying the nation and preserving cultural identity. A soulful rendition of a Hindi song beautifully encapsulated the language's significance. Students then showcased their literary prowess in an Inter-House quiz competition, impressively identifying poetic lines, authors, idioms, and proverbs.
 <br/><br/>
This celebratory event instilled pride in the students' linguistic heritage, highlighting the beauty and importance of Hindi.`,
    fullDate: "13 September 2024",
    d: "13",
    m: "Sep",
    y: "2024",
    link: "/school-events/hindi-diwas-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 27; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-09-24-03/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/21-09-24-03/vid1.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/hindi-diwas-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "A Bootcamp on Design Thinking for Class X",
    text: `Fostering creativity and innovation ✨
 <br/><br/>
Chinmaya Vidyalaya hosted an enlightening workshop on design thinking for Class X students on 13th September 2024.
 <br/><br/>
Facilitated by Sharp Pencil Design Studio's co-founders, Vaishnavi Mane and Nishant Tripathi (NIFT Delhi alumni), the session explored the fusion of logic and creativity in design.
 <br/><br/>
Nishant Tripathi introduced design thinking concepts, highlighting the interplay between art and logic. Vaishnavi Mane discussed exciting career paths in design, including UCEED, NIFT, and NID.
 <br/><br/>
Students showcased analytical and creative skills through a newspaper-based fashion design challenge.
 <br/><br/>
This engaging experience broadened students' perspectives on design's real-world applications.`,
    fullDate: "13 September 2024",
    d: "13",
    m: "Sep",
    y: "2024",
    link: "/school-events/a-bootcamp-on-design-thinking-for-class-x-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-09-24-02/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/a-bootcamp-on-design-thinking-for-class-x-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    d: "11",
    fullDate: "11 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-13/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-13/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-13/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-13/pic4.jpg",
    ],
    isVideo: false,
    link: "/school-events/rids-monumental-marvels-trip-to-humayuns-tomb-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-monumental-marvels-trip-to-humayuns-tomb-2024",
    text: "Where heritage meets learning!<br/><br/>Chinmaya Vidyalaya New Delhi’s Class VII students embarked on an enriching educational excursion to Delhi's historic Humayun's Tomb.<br/><br/>As part of RIDS' Monumental Marvels, they discovered the stunning architecture of this World Heritage Site, India's first garden tomb. The students creatively expressed their learning through posters, making it an enjoyable and educational experience.",
    title: "RIDS (Monumental Marvels - Trip to Humayun's Tomb",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "11",
    fullDate: "11 September 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-12/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-12/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-12/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-12/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-10-24-12/pic5.jpg",
    ],
    isVideo: false,
    link: "/school-events/excursion-to-purana-qila-old-fort-visit-2024",
    m: "Sep",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/excursion-to-purana-qila-old-fort-visit-2024",
    text: "Delhi's hidden treasures revealed!<br/><br/>Chinmaya Vidyalaya New Delhi’s Class VII students embarked on an enriching educational excursion to Delhi's historic Purana Qila. They explored the Sher Mandal, a two-storied octagonal tower built by Sher Shah Suri, later used by Emperor Humayun, and the magnificent Qila-i-Kuhna Mosque, known for its exquisite Indo-Islamic architecture.<br/><br/>The students also visited the grand Humayun Gate, one of the main entrances, and the mysterious Talaqi Gate, or the Forbidden Gate. It was an educational and enjoyable outing, fostering a deeper appreciation for India's heritage.",
    title: "Excursion to Purana Qila (Old Fort) Visit",
    videoSrc: "",
    y: "2024",
  },
  {
    title: "Book Fair by National Book Trust (NBT) Pustak Parikrama",
    text: `Reading opens doors to new worlds ✨
 <br/><br/>
Chinmaya Vidyalaya welcomed the NBT Pustak Parikrama: Books on Wheels on 9th September 2024.
 <br/><br/>
The National Book Trust's (NBT) mobile book exhibition catered to students from Classes VI to XII, showcasing a diverse array of fiction, non-fiction, children's literature, and more.
 <br/><br/>
Students from Chinmaya Vidyalaya New Delhi enthusiastically engaged with the exhibition, purchasing books on science, mystery, and thrillers that sparked their imagination.
 <br/><br/>
This successful event fostered a deeper love for reading beyond the classroom, encouraging students to explore new genres and authors.
 <br/><br/>
The visit was a resounding success, instilling a lifelong passion for literature and learning.`,
    fullDate: "09 & 10 September 2024",
    d: "10",
    m: "Sep",
    y: "2024",
    link: "/school-events/nbt-pustak-parikarma-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-09-24-01/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/nbt-pustak-parikarma-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Ganpati Puja & Assembly",
    text: `Chinmaya Vidyalaya New Delhi celebrated Ganesh Chaturthi with reverence and gusto!
 <br/><br/>
The programme were thoughtfully designed around activities highlighting the divine significance and symbolism of Lord Ganesha.
  <br/><br/>
A PowerPoint Presentation was shown to the children that encapsulated the information on the meaning of each part of the physical form of Lord Ganesh, and the composition of Ganesh Vandana.
  <br/><br/>
Students of Class III made Ganesha idols using colourful clay, the students of class IV made and distributed coconut laddoos that fostered the sense of sharing and community. The students of class V enjoyed participating in Rangoli Making Competition.
  <br/><br/>
Class VI students created Ganesha idols from clay, while Classes VII and VIII participated in a puzzle activity focused on Ganesha's names.
  <br/><br/>
The students of Classes IX to XII presented research projects on eco-friendly celebrations and the preservation of traditional idol-making techniques.
  <br/><br/>
The Puja ceremony was conducted at 9:00 am, concluding with the Ganpati Visarjan at 11:30 am. The celebration was both meaningful and enriching for all.
`,
    fullDate: "07 & 09 September 2024",
    d: "09",
    m: "Sep",
    y: "2024",
    link: "/school-events/ganpati-puja-and-assembly-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 14; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-09-24-03/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/ganpati-puja-and-assembly-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Inter House Hindi Poetry Recitation Competition",
    text: `
    Chinmaya Vidyalaya's Inter-House Hindi Poetry Recitation Competition for Classes VI-VIII was a resounding success!
 <br/><br/>
With 'Veer Ras' as the theme, young poets from all four houses brought alive the essence of courage, valor, and patriotism through their captivating recitations.
 <br/><br/>
The event was a testament to the students' exceptional oratory skills and their ability to evoke the heroic spirit. By immersing themselves in the richness of Hindi literature, our students deepened their appreciation for the language and its expression of heroic emotions.
 <br/><br/>
Kudos to all participants for their outstanding performances.`,
    fullDate: "07 September 2024",
    d: "07",
    m: "Sep",
    y: "2024",
    link: "/school-events/inter-house-hindi-poetry-recitation-competition-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-09-24-04/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/inter-house-hindi-poetry-recitation-competition-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Teacher's Day",
    text: `
    Chinmaya Vidyalaya, New Delhi, commemorated Teachers' Day on 3rd September 2024 with a series of heartfelt tributes, captivating performances, and joyful celebrations.
    <br/><br/>
The school's Pre-Primary Department marked the occasion with a delightful celebration, wherein young pupils crafted beautiful cards as tokens of love and appreciation. An interactive presentation highlighted the significance of the day, rendering it a memorable experience for both pupils and teachers. Furthermore, the youngsters participated by portraying their favourite teachers.
 <br/><br/>
Meanwhile, Class 5 students hosted a special assembly, presenting their teachers with interesting titles and heartfelt messages written inside beautifully crafted cards.
 <br/><br/>
The graduating class paid a sentimental homage to their teachers through a captivating cultural extravaganza, showcasing their musical and dance talents. The Principal, Ms Archana Soni, felicitated the school's stalwart pioneers - Ms Reeni Gulati, Mr H.N. Rao, and Mr Bisht - honouring their legacy with heartfelt accolades. Pupils bestowed unique and personalised titles upon each teacher, reflecting their individual contributions and impact.
 <br/><br/>
To extend the celebrations, the staff gathered at Panchseel Rendezvous for a day filled with fun and excitement. Teachers participated in interactive games, including song and movie trivia, bangle games, dumb charades, and the balancing bottle challenge. Retro tunes and DJ mashups created a lively atmosphere, with everyone enjoying a dance. The day concluded with a delightful feast and joyful dancing, forging lasting memories.
 <br/><br/>
The Teachers' Day celebrations at Chinmaya Vidyalaya demonstrated the deep appreciation and gratitude pupils and staff hold for their esteemed faculty members. The festivities will be cherished by all, underscoring the significance of teachers in shaping young minds.`,
    fullDate: "05 September 2024",
    d: "05",
    m: "Sep",
    y: "2024",
    link: "/school-events/teachers-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 48; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-09-24-05/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/teachers-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    d: "30",
    fullDate: "30 August 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic18.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic19.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic20.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic21.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic22.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-01-25-1/pic23.jpg",
    ],
    isVideo: false,
    link: "/school-events/rids-activity-herb-wall-exhibition-2024",
    m: "Aug",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-activity-herb-wall-exhibition-2024",
    text: 'A Botanical Showcase - "Heal with Herbs" Exhibition<br/><br/>Chinmaya Vidyalaya New Delhi hosted a captivating RIDS exhibition, "Heal with Herbs," on Friday, 30th August 2024. This event showcased the healing power of plants through innovative student-led projects, highlighting the importance of environmental stewardship and herbal remedies.<br/><br/>As part of their RIDS holiday homework, students from Classes IV and V actively participated in a tree-planting initiative, promoting eco-friendliness and responsible environmental practices. The students\' green initiatives were proudly displayed alongside informative catalogues detailing the medicinal properties of various herbs.<br/><br/>The exhibition featured a stunning Herb Wall, showcasing the plants grown during the plantation drive. This unique display provided a platform for students to share their knowledge and passion for herbal remedies with parents and visitors. Attendees were impressed by the diverse plant projects and meticulous catalogues, gaining a deeper appreciation for the therapeutic potential of nature.<br/><br/>The "Heal with Herbs" exhibition was a resounding success, promoting environmental awareness, botanical knowledge, and community engagement. The event demonstrated Chinmaya Vidyalaya, New Delhi\'s commitment to fostering holistic education and responsible citizenship.',
    title: "RIDS Activity - Herb Wall Exhibition",
    videoSrc: "",
    y: "2024",
  },
  {
    d: "30",
    fullDate: "28-30 August 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-2/pic18.jpg",
    ],
    isVideo: true,
    link: "/school-events/rids-activity-show-and-tell-for-pre-primary-2024",
    m: "Aug",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-activity-show-and-tell-for-pre-primary-2024",
    text: "Pre-Primary Students Shine in Show and Tell Activity<br/><br/>As part of the RIDS initiative, the Pre-Primary section at Chinmaya Vidyalaya New Delhi recently hosted a delightful Show and Tell activity. The event was conducted on 28th August for Nursery students and on 30th August 2024 for Prep students.<br/><br/>This year's theme, \"Feathered Sovereigns: A Tribute to Avifauna,\" sparked the young learners' curiosity and enthusiasm. Dressed in vibrant attire and equipped with creatively crafted props, the students confidently presented their knowledge of the National Birds of India, Nepal, Kenya, and Singapore.<br/><br/>The activity was a resounding success, with participants thoroughly enjoying the experience. The event helped build the students' confidence and public speaking skills and left a lasting impression on both the students and teachers.",
    title: "RIDS activity - Show and Tell for Pre-Primary",
    videoSrc: "",
    y: "2024",
  },
  {
    title: "Inter House Janmashtami Dance Competition",
    text: `
    Our tiny tots from classes I-II stole the show with their adorable dance moves at the Inter House Janmashtami Dance Competition!
 <br/><br/>
With synchronized steps and beaming smiles, each house showcased their spirit and discipline, celebrating the divine love of Radha and Krishna.
 <br/><br/>
This delightful competition not only fostered camaraderie among our young learners but also highlighted the power of teamwork in achieving success!`,
    fullDate: "29 August 2024",
    d: "29",
    m: "Aug",
    y: "2024",
    link: "/school-events/inter-house-janmashtami-dance-competition-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 9; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-09-24-03/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/inter-house-janmashtami-dance-competition-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Financial Safety in Cyberspace",
    text: `
    Encrypt today, secure tomorrow!
 <br/><br/>
Chinmaya Vidyalaya New Delhi recently hosted a workshop on Financial Safety in Cyberspace.
 <br/><br/>
The workshop was led by Brijesh Loshali, Harpreet Kaur, and Saroj Bidhuri, and highlighted the alarming rise in cybercrime, including financial frauds such as tax evasion, identity theft, phishing, and fake police scams. 
 <br/><br/>
The safety measures and solutions included using the National Cyber Crime Reporting Portal, helpline 1930, SEBI resources, and the Cyber Yodha app.
 <br/><br/>
The participants gained essential knowledge on identifying scams and safeguarding their financial and personal information in the digital age.`,
    fullDate: "29 August 2024",
    d: "29",
    m: "Aug",
    y: "2024",
    link: "/school-events/financial-safety-in-cyberspace-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 7; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-09-24-02/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/financial-safety-in-cyberspace-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },

  {
    title: "Fitness Fun at Chinmaya Vidyalaya on National Sports Day",
    text: `
    The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi, celebrated National Sports Day with an engaging Fitness Station activity.
    <br/><br/>
Nursery and Prep students actively participated in a variety of exercises, such as agility ladders, zig-zag runs, straight-line walks, ring jumps, and standing broad jumps.
 <br/><br/>
These fun-filled activities helped the children enhance their footwork, speed, balance, and leg strength. The event was a spirited success, with the young learners enthusiastically embracing the opportunity to build essential athletic skills.
`,
    fullDate: "29 August 2024",
    d: "29",
    m: "Aug",
    y: "2024",
    link: "/school-events/national-sports-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-09-24-01/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-09-24-01/vid1.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-09-24-01/vid2.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-09-24-01/vid3.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-09-24-01/vid4.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-09-24-01/vid5.mov");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/national-sports-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },

  {
    d: "27",
    fullDate: "27 August 2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic7.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic8.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic9.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic10.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic11.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic12.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic13.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic14.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic15.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic16.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic17.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/14-01-25-1/pic18.jpg",
    ],
    isVideo: false,
    link: "/school-events/rids-activity-class-ii-conducted-feathered-sovereigns-2024",
    m: "Aug",
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/rids-activity-class-ii-conducted-feathered-sovereigns-2024",
    text: "Students Take Flight with Feathered Sovereigns Project<br/><br/>On Tuesday, 27th August 2024, Class II at Chinmaya Vidyalaya New Delhi embarked on an exciting educational journey as part of the RIDS activity under the British Council.<br/><br/>The Feathered Sovereigns: A Tribute to Avifauna project commenced with an engaging PowerPoint presentation, expertly delivered by their class teacher, introducing students to the fascinating world of National Birds from around the globe. Building on this foundational knowledge, the students participated in a creative follow-up activity on 29th August 2024. Under the guidance of their teacher, they crafted vibrant puppet representations of the National Birds of India, Nepal, Kenya, and Singapore.<br/><br/>This dynamic and interactive classroom experience enhanced the students' understanding and fostered their creativity and enthusiasm. This innovative project showcases Chinmaya Vidyalaya New Delhi's commitment to providing engaging and holistic learning experiences that nurture students' curiosity and love for learning.",
    title: "RIDS activity - Class II conducted Feathered Sovereigns",
    videoSrc: "",
    y: "2024",
  },
  {
    title: "Shri Krishna Janmashtami",
    text: `
    Krishna – divine love and eternal wisdom personified!
<br/><br/>
The Pre-Primary Department of Chinmaya Vidyalaya New Delhi, celebrated Janmashtami with enthusiasm and joy!
<br/><br/>
The learners were introduced to the life and teachings of Lord Krishna and learned that this joyous festival promotes goodwill and the establishment of Dharma.
<br/><br/>
The little ones from Nursery and Prep classes engaged in creative activities, making peacock feathers, mukuts, and bansuris. Dressed in traditional attires, the young learners participated in a tableau where they joyfully swung Lord Krishna.
<br/><br/>
The Primary Department students, Classes I and II, decorated the cut-outs of matkis with sequins and colours.
<br/><br/>
Their involvement in the celebrations was truly commendable, blending devotion, creativity, and enjoyment.`,
    fullDate: "26 August 2024",
    d: "26",
    m: "Aug",
    y: "2024",
    link: "/school-events/janmashtami-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 27; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-08-24-01/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/janmashtami-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "EXCURSION (MOVIE)",
    text: `On 22nd August 2024, Chinmaya Vidyalaya, Vasant Vihar organized a delightful movie excursion at a nearby cinema for the little ones to watch Inside Out 2. The young learners were captivated by the journey through Riley's mind, gaining valuable life lessons along the way. The movie inspired engaging discussions about emotions and effective ways to manage them. Such excursions offer a fantastic opportunity for students to bond and learn outside the classroom.`,
    fullDate: "22 August 2024",
    d: "22",
    m: "Aug",
    y: "2024",
    link: "/school-events/excursion-movie-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 11; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-08-24-02/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/29-08-24-02/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/29-08-24-02/vid2.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/29-08-24-02/vid3.mov");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/excursion-movie-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "A Day of Fun and Imagination (MOVIE)",
    text: `“Bing Bong, Bing Bong, Bing Bong...!”<br/><br/>Chinmaya Vidyalaya New Delhi’s young learners of Classes I and II recently embarked on a magical journey to the world of emotions with the screening of Inside Out 2.
<br/><br/>
The movie, filled with vibrant colors and lovable characters, captivated the little minds, igniting their imagination. The children experienced a rollercoaster of emotions alongside the characters!
<br/><br/>
It was a delightful outing that not only entertained, but also provided valuable lessons about understanding and managing emotions.The students returned to school with sparkling eyes and excited chatter, sharing their favorite moments and characters.
<br/><br/>
All in all, a fun and educational experience was had by all!`,
    fullDate: "21 August 2024",
    d: "21",
    m: "Aug",
    y: "2024",
    link: "/school-events/a-day-of-fun-and-imagination-movie-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 30; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-08-24-03/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/a-day-of-fun-and-imagination-movie-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Sanskrit Diwas Celebrations",
    text: `
Chinmaya Vidyalaya New Delhi celebrated Sanskrit Diwas with a special assembly.
 <br/><br/>
The students showcased various skits, beginning with Surya Siddhanta, which offered insights into astronomy, time calculation using the sun's shadow, and the positioning of celestial bodies.
<br/><br/>
The second skit explored the methodology of creating explosives through Rasayanik Vigyan, highlighting ancient chemical science.     
 <br/><br/>
The third skit demonstrated the Pythagorean theorem via the Baudhayan Sutra.
 <br/><br/>
The Headmistress in her speech, emphasized the beauty of Sanskrit, comparing its purity to river Ganga and calling it Dev Vaani, the language of the Gods.       
<br/><br/>
She further compared Sanskrit to a sea of vast knowledge that includes ethics, astronomy, geography, and science, wherein one gets enlightened the more one delves into it.    <br/><br/>
The assembly concluded with the song "Avni Talam Purana Trihasyat", symbolizing our divine lineage and the guidance via Sanskrit aids in reaching new heights.`,
    fullDate: "19 August 2024",
    d: "19",
    m: "Aug",
    y: "2024",
    link: "/school-events/sanskrit-divas-assembly-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 14; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/24-08-24-02/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/sanskrit-divas-assembly-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Independence Day Assembly - Pre Primary",
    text: `Chinmaya Vidyalaya New Delhi’s little learners came dressed in tricolour attires for a special assembly celebrating Independence Day.
    <br/><br/>
The students soulfully sang "Teen Rang Ka Jhanda Apna," followed by a captivating dance performance on "Nanha Munna Rahi Hun." The children also paid tribute to freedom fighters like Mahatma Gandhi, Rani Lakshmi Bai, and Bal Gangadhar Tilak by sharing their iconic quotes.
 <br/><br/>
Additionally, the students enjoyed making beautiful crafts and singing and dancing on various patriotic songs. May the spirit of freedom ignite the flame of excellence in all!`,
    fullDate: "13 August 2024",
    d: "13",
    m: "Aug",
    y: "2024",
    link: "/school-events/independence-day-pre-primary-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 11; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/17-08-24-03/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/independence-day-pre-primary-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Primary Department Celebrates Independence Day",
    text: `The students of Class III presented a special assembly on the theme of ' Independence Day', with a choir presentation on the values of liberty and unity.
 <br/><br/>
A selection of students also presented a unique skit, ‘I am Independent’, highlighting the tenets of being independent yet responsible.
 <br/><br/>
A dance presentation by the students celebrated our nation's rich cultural diversity and unity. The assembly culminated with a pledge that filled everyone with immense pride for our country. Jai Hind!`,
    fullDate: "13 August 2024",
    d: "13",
    m: "Aug",
    y: "2024",
    link: "/school-events/independence-day-primary-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 9; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/17-08-24-02/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/independence-day-primary-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Independence Day Assembly",
    text: `Chinmaya Vidyalaya, New Delhi, celebrated the 78th Independence Day with a tribute to freedom fighters, expressing deep love for the motherland and the unity of Bharatiya.
 <br/><br/>
The event commenced with flag hoisting followed by the National Anthem.
 <br/><br/>
Ms Archana Soni, Principal, lauded Pujya Gurudev's role in the freedom struggle, his dedication to promoting love for the country, and emphasized the importance of preserving its culture and heritage.
<br/><br/>
She also urged everyone to introspect on their love for India and to incorporate Bharat into their dreams and aspirations. The event concluded with an inspiring quote from Prime Minister Narendra Modi.   
 <br/><br/>
The students from Classes VI to X watched 'The Legend of Bhagat Singh' and classes XI -XII watched 'Veer Savarkar' to further instill patriotism.`,
    fullDate: "13 August 2024",
    d: "13",
    m: "Aug",
    y: "2024",
    link: "/school-events/independence-day-assembly-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/17-08-24-01/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/independence-day-assembly-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Global Herb Plantation Drive",
    text: `The students of Classes IV and V at Chinmaya Vidyalaya, New Delhi, engaged in a distinctive herb plantation drive under the RIDS project. This initiative aimed to foster environmental awareness, promote sustainable practices, and encourage healthy living. 
<br/><br/>
By cultivating a diverse array of herbs from various countries worldwide, the students were able to delve into the intricacies of our planet's botanical diversity, explore the medicinal benefits of these plants, and acquire practical knowledge about organic gardening.
 <br/><br/>
As outlined in the RIDS Action Plan, the students embarked on a journey of global botanical exploration. They carefully selected and nurtured herbs native to different countries, thereby expanding their understanding of the rich tapestry of plant life across the globe. 
<br/><br/>
This hands-on experience not only enriched their scientific knowledge but also instilled in them a deep appreciation for the interconnectedness of all living organisms.`,
    fullDate: "20 August 2024",
    d: "20",
    m: "Aug",
    y: "2024",
    link: "/school-events/global-herb-plantation-drive-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-09-24-02/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/global-herb-plantation-drive-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "PRS YOUTH PARLIAMENT",
    text: `Where youth voices rise, and future leaders emerge!
 <br/><br/>
A Student Parliament was recently organized at the Chinmaya Vidyalaya New Delhi Library, in collaboration with PRS Legislative Research. 
  <br/><br/>
It was a highly informative introduction to the intricacies of the Indian parliamentary system for classes IX to XII.
  <br/><br/>
Through interactive sessions, students gained knowledge about parliamentary procedures, including Question Hour, Zero Hour, and the bill-to-law process.
  <br/><br/>
Students were assigned roles as parliamentarians and engaged in mock parliamentary sessions. They researched, drafted, and presented bills, while also scrutinizing and debating those proposed by peers. 
  <br/><br/>
This hands-on experience fostered critical thinking, research skills, and an understanding of the democratic process. The event concluded with a deeper appreciation for parliamentary democracy and its role in governance.`,
    fullDate: "09 August 2024",
    d: "09",
    m: "Aug",
    y: "2024",
    link: "/school-events/prs-youth-parliament-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/24-08-24-01/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/prs-youth-parliament-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Bucket Ball Toss Activity",
    text: `The Pre-Primary Department of Chinmaya Vidyalaya New Delhi, exuberantly participated in the Bucket Ball Toss Activity in a span of two days on Thursday, August 8th, 2024 and Friday, August 9th, 2024.
 <br/><br/>
The learners had fun with the bucket ball toss activity, attempting to throw the ball into the bucket to receive a reward.
 <br/><br/>
The activity enhances the learner's strength and endurance, increases focus and concentration while aiming for the target, and boosts confidence and self-esteem with successful throws.
 <br/><br/>
The students of Nursery and Prep catch the fun by Mastering Skills with Every Toss in Our Bucket Ball Activity.`,
    fullDate: "08-09 August 2024",
    d: "09",
    m: "Aug",
    y: "2024",
    link: "/school-events/bucket-ball-toss-activity-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 11; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/14-08-24-01/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/14-08-24-01/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/14-08-24-01/vid2.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/bucket-ball-toss-activity-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Inter House Drill Competition Session",
    text: `An  Inter House Drill Competition was recently conducted at Chinmaya Vidyalaya New Delhi,  for students of classes I and II.
    <br/><br/>
Each house enthusiastically came to the basketball court to showcase their coordination, discipline and house spirit through well-rehearsed synchronized drill routines. It was a treat to watch a demonstration of their hard work and dedication through precise movements and coordinated steps.
 <br/><br/>
Teachers and fellow students cheered as the young participants performed various exercises in perfect sync.
 <br/><br/>
The competition not only fostered a sense of camaraderie among the learners but also highlighted the importance of physical fitness and collective effort.`,
    fullDate: "07 August 2024",
    d: "07",
    m: "Aug",
    y: "2024",
    link: "/school-events/inter-house-drill-competition-session-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 14; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-08-24-3/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/inter-house-drill-competition-session-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Super powers of Being Human Assembly",
    text: `The learners of Class IV D delivered a captivating assembly on the theme ‘Being Human’.
 <br/><br/>
The assembly highlighted the superpowers of being human: Kindness, Creativity, Diversity, Teamwork, and Empathy.
 <br/><br/>
Students conveyed a powerful message, creatively illustrating how kindness, creativity, diversity, teamwork, honesty, and courage can shape a better world.
 <br/><br/>
The children sang a heartfelt song, highlighting how we can brighten the world with our actions, centered on harmony and peace. The song envisioned a world united in love and harmony, where people come together to sing a timeless melody of peace. It dreamt of a land filled with nature’s beauty and collective goodwill.
 <br/><br/>
The assembly successfully conveyed the message that embracing humanity can truly transform the world.`,
    fullDate: "05 August 2024",
    d: "05",
    m: "Aug",
    y: "2024",
    link: "/school-events/superpower-of-being-human-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 7; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-08-24-2/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/superpower-of-being-human-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "GURUDEV'S MAHASAMADHI DIWAS",
    text: `Celebrating the life and legacy of Pujya Gurudev Swami Chinmayananda.
 <br/><br/>
Chinmaya Vidyalaya celebrated the Chinmaya Aradhana Day with a special assembly encapsulating Pujya Gurudev’s inspiring journey.
 <br/><br/>
His Mahasamadhi Diwas is a an opportunity to explore Vedantic values propounded by Him by studying the Upanishads, and engage in sewa activities and learn the importance of leading an intellectually and spiritually balanced life.
 <br/><br/>
The event was a heartfelt homage, with everyone expressing enthusiam in following in His footsteps towards self-realization and spiritual growth. A key highlight of the assembly was the chanting of Namavali in unison, reciting 11 names of Pujya Gurudev.
 <br/><br/>
Ms Archana Soni, Principal, urged students to thank Gurudev for blessing them with a body, mind, and intellect, and for having a family that nurtures their true selves. She encouraged students to express love for Gurudev, pledge to be good human beings, make their country proud, and serve both the nation and humanity.
 <br/><br/>
The special assembly concluded with a soulful aarti, leaving a deep sense of devotion among the participants. This was followed by Paduka Puja at Chinmaya Vidyalaya's reception, where Ms Soni, Anand Sir,  sewa volunteers, and the student council actively participated. The students of Primary Department watched a video presentation and learnt about the significance of a prayer, and delighted in singing a song in His praise.
 <br/><br/>
The students of class VIII also visited the Chinmaya Mission, engaging in Abhishek and chanting of Shivasankalpa Suktam, Tapovan Astakam and Guru Strotram.
 <br/><br/>
The Chairman of the school  Anil Sachdeva shared his personal experiences that he had with Pujya Gurudev, further enriching the occasion.`,
    fullDate: "03 August 2024",
    d: "03",
    m: "Aug",
    y: "2024",
    link: "/school-events/gurudevs-mahasamadhi-diwas-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 14; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/06-08-24-01/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/gurudevs-mahasamadhi-diwas-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Friendship Day Celebration",
    text: `True friendship is a circle, because circles never end.
 <br/><br/>
Students of Chinmaya Vidyalaya New Delhi celebrated Friendship Day with delight and enthusiasm!
 <br/><br/>
The little learners of Pre-Primary learnt the significance of the bonds of true friendship through engaging stories, and explored the ‘golden rules’ of friendship.
 <br/><br/>
This was followed by crafting and exchanging friendship bands with their peers, and completing a collaborative friendship tree project!
 <br/><br/>
The students of Primary Department watched a special video presentation on the heartwarming story of Krishna and Sudama, highlighting the timeless value of true friendship.
 <br/><br/>
Students of classes III-V  crafted handmade  friendship bands, bookmarks. and button bands - each craft was unique in its design!`,
    fullDate: "30 July 2024",
    d: "30",
    m: "Jul",
    y: "2024",
    link: "/school-events/friendship-day-celebration-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 13; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-08-24-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/friendship-day-celebration-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "International Tiger day",
    text: `Roaring young voices for tiger conservation!
<br/><br/>
Students of Pre-Primary celebrated International Tiger Day with a plethora of activities celebrating the keystone species.
<br/><br/>
The little ones enacted a story for the special assembly, highlighting various facts and legends about tiger conservation. Students also crafted a tiger mask and headgear to showcase their creativity, and participated in a lively tiger dance!
<br/><br/>
Students of the Primary Department watched a video encapsulating the Tiger Anthem, with an online quiz on a variety of important facts related to different species of tigers. 
<br/><br/>
The students also made a Tiger face mask and wore them with immense joy! All in all, the day and the events of the day instilled a sense of wonder and appreciation for wildlife amongst the young learners, and emphasized the importance of tiger conservation.`,
    fullDate: "29 July 2024",
    d: "29",
    m: "Jul",
    y: "2024",
    link: "/school-events/international-tiger-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 19; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/01-08-24-04/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/01-08-24-04/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/01-08-24-04/vid2.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/01-08-24-04/vid2.mov");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/international-tiger-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Career Counselling Session",
    text: `Chinmaya Vidyalaya New Delhi recently conducted a career guidance session for students of Class IX and X.
    <br/><br/>
The session was facilitated by career experts Mr. Avi Arora and Mr. Prateek Sharma from MENIIT. Bringing over two decades of experience in career path guidance, the team emphasized the importance of aligning career choices with personal interests, goals, and personality traits.
 <br/><br/>
The session was highly informative, interactive, and motivating, encouraging students to focus on career paths that resonate with their aspirations.`,
    fullDate: "26 July 2024",
    d: "26",
    m: "Jul",
    y: "2024",
    link: "/school-events/career-counselling-session-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/01-08-24-03/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }
      /* 
      imgArray.push(
        "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/vid1.mov"
      );
      imgArray.push(
        "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/vid2.mp4"
      ); */

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/career-counselling-session-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Kargil Diwas",
    text: `Chinmaya Vidyalaya New Delhi celebrated Kargil Diwas with special commemorative activities for all classes.
 <br/><br/>
Students of Classes VI to XI attended a Kargil Diwas assembly, learning about the significance of the day, and the sacrifices and valour of the Indian armed forces in recapturing high-altitude outposts from Pakistani forces in Kargil.
 <br/><br/>
The choir sang "Takat Watan Ki," encapsulating the spirit of unity and strength.
 <br/><br/>
The students of Class IV A also presented a special assembly with patriotic fervour, paying special tribute to our brave soldiers. A student recited a poem titled "Bharat ke Veer Sipaahi," which beautifully expressed the ultimate sacrifice of soldiers, highlighted how they protect our borders day and night. The program concluded with a patriotic dance performance by the students dressed as soldiers.
 <br/><br/>
Overall, the session was impactful, teaching the values of unity, courage, and sacrifice as the cornerstones of a strong and resilient nation.`,
    fullDate: "25 July 2024",
    d: "25",
    m: "Jul",
    y: "2024",
    link: "/school-events/kargil-diwas-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/01-08-24-02/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }
      /* 
      imgArray.push(
        "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/vid1.mov"
      );
      imgArray.push(
        "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/vid2.mp4"
      ); */

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/kargil-diwas-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Puppet Show Enthralls our young learners",
    text: `The Pre-Primary Department of Chinmaya Vidyalaya New Delhi recently organised an engaging Puppet Show for the young learners. 
    <br/><br/>
Through a captivating story titled “The Friendly Forest”, the puppet characters imparted valuable lessons on peaceful co-existence and mutual assistance, illustrating he qualities of a good friend!
 <br/><br/>
The students were highly enthusiastic and actively participated, making the event a lively and enjoyable experience. 
 <br/><br/>
The show was marked by fun, interaction, and positive engagement, which delighted the young learners.`,
    fullDate: "24 July 2024",
    d: "24",
    m: "Jul",
    y: "2024",
    link: "/school-events/puppet-show-enthralls-our-young-learners",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 4; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/vid1.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/vid2.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/puppet-show-enthralls-our-young-learners",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Cyber Safety Awareness Session",
    text: `Chinmaya Vidyalaya New Delhi recently conducted a cyber safety awareness workshop for Class VIII students.
    <br/><br/>
The facilitators, Adv. Nikhil and Adv. Sanchit from Delhi High Court educated students on the importance of safe and responsible internet use.
<br/><br/>
The areas for insight sharing were online privacy, social media safety, cyberbullying, phishing scams, and the risks of sharing personal information.
 <br/><br/>
The session featured interactive activities via real-life examples, and discussions to engage the students, emphasizing the need for constant vigilance in cyberspace.`,
    fullDate: "22 July 2024",
    d: "22",
    m: "Jul",
    y: "2024",
    link: "/school-events/cyber-safety-awareness-session-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 4; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-05/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/cyber-safety-awareness-session-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "ECO Club activity",
    text: `Youth for a greener future!
 <br/><br/>
Chinmaya Vidyalaya New Delhi recently participated in a cleanliness drive and tree plantation event at the local community park as an Eco Club Activity.
  <br/><br/>
Students of Classes VI – XII were guided by environmental experts, in a joint initiative by UNESCO and USO aiming to promote environmental awareness and community service. 
  <br/><br/>
By following the Biosphere Reserve Project guidelines, they cleaned various sections of the park and planted saplings.
  <br/><br/>
The event not only enhanced the park's beauty but also taught students the importance of maintaining public spaces and fostering greenery.`,
    fullDate: "20 July 2024",
    d: "20",
    m: "Jul",
    y: "2024",
    link: "/school-events/eco-club-activity-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 20; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/01-08-24-01/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      /*  imgArray.push(
        "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/vid1.mov"
      );
      imgArray.push(
        "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-06/vid2.mp4"
      ); */

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/eco-club-activity-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Celebrating Gurus – the guiding lights of life’s journey.",
    text: `The students of Chinmaya Vidyalaya New Delhi celebrated Guru Purnima with deep gratitude, enthusiasm and fervour!
    <br/><br/>
The Pre-Primary students were shown a presentation highlighted the significance of Guru Purnima and the importance of respecting teachers and elders. They also engaged in an enjoyable craft activity!
<br/><br/>
Students of the Primary Department viewed a presentation encapsulating the significance of the day, with a special message by Swami Swaroopananda Ji shedding light on offering gratitude towards our Gurus.
<br/><br/>
In keeping with our ancient traditions and timeless wisdom, learners recited the Guru Stotram and Guru Bhajan. Through a formal dialogue, they elucidated the significance of this auspicious occasion concluded with a soul stirring Aarti.
<br/><br/>
The Principal, Ms. Archana Soni delivered an address highlighting the profound significance of a Guru in our lives. A special puja was performed at the reception area expressing our deepest gratitude to our revered Gurus who have always shown us the path of righteousness and noble living.`,
    fullDate: "19-20 July 2024",
    d: "19",
    m: "Jul",
    y: "2024",
    link: "/school-events/celebrating-gurus-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/24-07-24-01/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/celebrating-gurus-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },

  //   {
  //     title: "SAY NO TO TOBACCO, SAY NO TO DRUGS",
  //     text: `The Primary school students of Chinmaya Vidyalaya New Delhi recently conducted a lemonade distribution session for the school's support staff as part of the Sewa programme.
  //     <br/><br/>
  // The children learned the importance of kindness in action and provided a refreshing treat to express appreciation to those who work hard, especially in the scorching heat and humidity.
  // <br/><br/>
  // A video of a story demonstrating the ripple effects of acts of kindness and community service was also viewed by the students, and this left a lasting impression and profound impact on the children. A digital presentation on the significant impact of small acts of selfless service was also shared, followed by a discussion on various ways to show kindness and engage in Sewa.
  // <br/><br/>
  // Examples included offering water to delivery personnel, distributing water bottles to people living on pavements, making water bowls for birds, and providing water to domestic helpers.
  // <br/><br/>
  // Chinmaya Vidyalaya New Delhi is committed to fostering a spirit of service for the holistic development of each student.`,
  //     fullDate: "12 July 2024",
  //     d: "12",
  //     m: "Jul",
  //     y: "2024",
  //     link: "/school-events/say-no-to-tobacco-say-no-to-drugs-2024",
  //     images: (function () {
  //       let imgArray = [];
  //       for (let i = 1; i <= 3; i++) {
  //         let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-04/pic${i}.JPG`;
  //         imgArray.push(imgUrl);
  //       }

  //       return imgArray;
  //     })(),
  //     isVideo: false,
  //     shareLink:
  //       "https://chinmayavvdelhi.ac.in/school-events/say-no-to-tobacco-say-no-to-drugs-2024",
  //     videoSrc:
  //       "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  //   },
  {
    title: "Sewa session",
    text: `The Primary school students of Chinmaya Vidyalaya New Delhi recently conducted a lemonade distribution session for the school's support staff as part of the Sewa programme.
    <br/><br/>
The children learned the importance of kindness in action and provided a refreshing treat to express appreciation to those who work hard, especially in the scorching heat and humidity.
<br/><br/>
A video of a story demonstrating the ripple effects of acts of kindness and community service was also viewed by the students, and this left a lasting impression and profound impact on the children. A digital presentation on the significant impact of small acts of selfless service was also shared, followed by a discussion on various ways to show kindness and engage in Sewa.
<br/><br/>
Examples included offering water to delivery personnel, distributing water bottles to people living on pavements, making water bowls for birds, and providing water to domestic helpers.
<br/><br/>
Chinmaya Vidyalaya New Delhi is committed to fostering a spirit of service for the holistic development of each student.`,
    fullDate: "12 July 2024",
    d: "12",
    m: "Jul",
    y: "2024",
    link: "/school-events/sewa-session-july-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-03/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/sewa-session-july-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Mental Health and Emotional well-being",
    text: `Chinmaya Vidyalaya New Delhi recently hosted an interactive workshop on mental health and emotional well-being for the students of Class X.
<br/><br/>
The session was facilitated by Ms. Aprajita Dixit, a consultant Clinical Psychologist specializing in Child and Adolescent Psychology and family counselling at Institute of Mental Health, Medicity , New Delhi.             
<br/><br/>                                                  
The students were taken through an explainer video on mental health, highlighting the importance of recognising and managing emotions effectively. This was followed by a Q&A segment, with students participating enthusiastically to learn how to handle various scenarios in a healthy way for mental health.
<br/><br/>
Overall, it was an enlightening session that fostered awareness and understanding of mental health, encouraging students to seek support when needed and to practice mindfulness and positive emotional habits in their daily lives.`,
    fullDate: "12 July 2024",
    d: "12",
    m: "Jul",
    y: "2024",
    link: "/school-events/mental-health-and-emotional-well-being-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-02/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/mental-health-and-emotional-well-being-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "ASSEMBLY - Class-V C - DISCIPLINE - The Foundation of Success",
    text: `Students of Class V C presented an informative assembly on 'Discipline-The Foundation of Success' with immense enthusiasm.
    <br/><br/>
An insightful skit 'The Little Master in the Making' conveyed the message of becoming disciplined to bridge the gap between goals and accomplishments. A melodious song on self-discipline was also delivered by a selected group of students.
 <br/><br/>
The assembly culminated with the students pledging to incorporate self-discipline for a fulfilling and successful life.`,
    fullDate: "08 July 2024",
    d: "08",
    m: "Jul",
    y: "2024",
    link: "/school-events/the-foundation-of-success-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-01/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/the-foundation-of-success-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  //   {
  //     title: "Space Club Orientation Session",
  //     text: `Exploring the cosmos, reaching for the stars!
  // <br/><br/>
  // Students of Class I – V recently attended a fascinating Space Club orientation session, and came away with their interest in astronomy and space exploration highly enhanced.
  // The session featured captivating presentations, hands-on activities, and interactive sessions that made learning about the universe fun and exciting.
  // <br/><br/>
  // Students received the opportunity to engage with experts, ask questions and participate in hands-on activities to augment their understanding of concepts. They even constructed an icy model of a comet using dry ice!
  // <br/><br/>
  // The highlight of the session was the model rocket launching, which left learners awestruck and effectively demonstrated the principles behind rocket launches. It was a delightful and educational experience for everyone.
  // <br/><br/>
  // At Chinmaya Vidyalaya Vasant Vihar, students receive exposure to the latest developments in science and technology to supplement their skills, understanding and outlook as future leaders.`,
  //     fullDate: "05 July 2024",
  //     d: "05",
  //     m: "Jul",
  //     y: "2024",
  //     link: "/school-events/space-club-orientation-session-2024",
  //     images: (function () {
  //       let imgArray = [];
  //       for (let i = 1; i <= 4; i++) {
  //         let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/18-07-24-01/pic${i}.JPG`;
  //         imgArray.push(imgUrl);
  //       }

  //       return imgArray;
  //     })(),
  //     isVideo: false,
  //     shareLink:
  //       "https://chinmayavvdelhi.ac.in/school-events/space-club-orientation-session-2024",
  //     videoSrc:
  //       "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  //   },
  {
    title: "Connecting with Community 🇮🇳 ⚖️",
    text: `Chinmaya Vidyalaya New Delhi recently hosted an informative session, led by the Police Station – Vasant Vihar Southwest District, to promote awareness on the implementation of the new laws.
    <br/><br/>
    The session apprised the students of classes X-XII on the amendments in Indian Penal Code, the Criminal Procedure Code, and the Indian Evidence Act.
     <br/><br/>
    The esteemed guests included Shri R. K. Wadhwa, Senior Lawyer and Ex President at Patiala House Court Bar Association, Inspector Sher Singh, SHO, Vasant Vihar and Inspector Sahi Ram.
     <br/><br/>
    The Sub-inspectors discussed the importance of following rules and regulations like cyber and driving rules and urged the students to have an emotional sharing with their Parents and Teachers. They shared insights on the rights, obligations, and duties of a disciplined student.
     <br/><br/>
    Mr. Wadhwa in his address informed that the recent amendments in the Act are not only victim-friendly but also complainant friendly and emphasized on the importance of discipline in life. He shared an insight on the 3 new laws: Indian Penal code (IPC )to be replaced by Bhartiya Nyaya Sanhita (BNS) 2023, Criminal Procedure Code (CrPC ) to be replaced by Bhartiya Nagrik Suraksha Sanhita (BNSS) 2023 and Indian Evidence Act (IEA) to be replaced by Bhartiya Sakshya Adhiniyam (BSA) 2023.
     <br/><br/>
    The Principal, Ms. Archana Soni urged the students to be aware of the new laws, be responsible and responsive citizens.`,
    fullDate: "01 July 2024",
    d: "01",
    m: "Jul",
    y: "2024",
    link: "/school-events/connecting-with-community-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/05-07-24-01/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/connecting-with-community-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Welcome Back to School",
    text: `School bells are ringing loud and clear; summer vacations are over and school days are here!
Students were warmly welcomed back to school with a plethora of engaging activities to set the tone for an exciting term ahead.
  <br/><br/>
Cartoon characters including Doraemon, Donald Duck, and Panda were there to greet the young learners of Pre-Primary! The children played hopscotch, participated in a pattern walk, and crafted headgear too.
<br/><br/>
Class V presented a back to school Talent Fiesta, showcasing their skills in dance, song, poems, riddles and jokes!
 <br/><br/>
Class IV had a blast mastering the game “Head, Shoulder, Knees and Grab” while Class III expressed their excitement about returning to school by drawing wonderful smiley faces and sharing them with their friends.
 <br/><br/>
The students of Class II created vibrant and distinctive caterpillars representing their summer favourites.
 <br/><br/>
Class I learners enjoyed the tactile experience of working with paint and created a unique craft through hand-printing activity.
 <br/><br/>
The senior students were welcomed back with an assembly, with Classes VI to XII performing a routine drill including stretching exercises. 
 <br/><br/>
The Principal warmly welcomed the students, enlightened them about the discipline rules and regulations, and wished them a great session ahead.
 <br/><br/>
The assembly concluded with the national anthem, setting a positive tone for the upcoming academic year.`,
    fullDate: "01 July 2024",
    d: "01",
    m: "Jul",
    y: "2024",
    link: "/school-events/welcome-back-to-school-activity-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 17; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-07/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      for (let i = 1; i <= 13; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/26-07-24-07/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/welcome-back-to-school-activity-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Father's Day",
    text: `A father is someone to look up to, no matter how tall you are.
 <br/><br/>
The students of Chinmaya Vidyalaya New Delhi celebrated Father’s Day with aplomb. 
 <br/><br/>
The little learners from Nursery and Prep handcrafted cards and headbands expressing their love and gratitude. 
 <br/><br/>
Classes I and II students made paper iPads with beautiful messages, and the learners of Class III made vibrant ‘My Dad, My Superhero’ cards. The doting Dads of Class V students received ‘Best Dad’ trophies made with coloured paper. 
 <br/><br/>
Each little learner planned a Playdate with their fathers to make their doting Dads feel special, and the fathers were delighted to receive their handmade presents from the little ones.`,
    fullDate: "16 June 2024",
    d: "16",
    m: "Jun",
    y: "2024",
    link: "/school-events/fathers-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 18; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/20-06-24-01/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/20-06-24-01/vid1.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/fathers-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "World Environment Day",
    text: `Keeping green to keep the planet clean🌱
     <br/><br/>
    Chinmaya Vidyalaya New Delhi observed World Environment Day with acts of green to protect the environment.
     <br/><br/>
    The little learners of Nursery made water bowls for birds and planted saplings, to learn the importance of caring for our ecosystem. The Prep students made bird feeders, and adopted plants, pledging to nurture them the entire year.
       <br/><br/>
    Students from Classes I to III made bird feeders using waste materials, and filled these with seeds to pamper the avian visitors. The students of classes IV and V made seed bombs and gifted them to their friends in small paper bags.
       <br/><br/>
    These hands-on activities were enjoyable and educational, and emphasised the importance of preserving our natural resources. They also delivered the mighty message that all of us have a role to play in keeping the planet green!`,
    fullDate: "05 June 2024",
    d: "05",
    m: "Jun",
    y: "2024",
    link: "/school-events/world-environment-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 43; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/07-06-24-03/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/07-06-24-03/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/07-06-24-03/vid2.mp4");

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/07-06-24-03/vid3.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-environment-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "No Tobacco Day",
    text: `Chinmaya Vidyalaya New Delhi observed No Tobacco Day with an online awareness session for classes IX-XII.
       <br/><br/>
    The students were taken through a detailed presentation on the numerous adverse effects nicotine has on the body and mind. They were apprised of the toxic chemicals in tobacco products, and urged to collectively and individually strive for a smoke-free world where everyone can breathe clean and fresh air.
       <br/><br/>
    The session concluded with the students sharing their views on ways to spread awareness among the masses, as young and responsible members of society.`,
    fullDate: "31 May 2024",
    d: "31",
    m: "May",
    y: "2024",
    link: "/school-events/no-tobacco-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/07-06-24-02/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/no-tobacco-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Language Literacy Development",
    text: `Chinmaya Vidyalaya New Delhi recently organized a workshop on ‘Foundational Literacy and Numeracy’, with Ms Nanu Rekhi, Territory Head, Delhi- NCR at Early Childhood Association, and Ms Upasana Dembla, an Early Childhood Care and Education Professional.
    <br/><br/>
    Ms Nanu Rekhi shed light on the significance of Care before Education in early childhood. She also focused on choosing learning to live over existing.
     <br/><br/>
    Some basic assumptions in the ECE programme were highlighted and the concept of experiential learning was explained in detail. The teachers were taken through the various ways to understand the learners and a variety of activities involving Play-Way Method of learning were also demonstrated under ECE.
     <br/><br/>
    Ms Upasana Dembla further demonstrated a plethora of activities that involved basic literacy and numeracy in an interesting way.
     <br/><br/>
    It was an insightful workshop to strengthen the teaching of fundamentals!`,
    fullDate: "28 May 2024",
    d: "28",
    m: "May",
    y: "2024",
    link: "/school-events/language-literacy-development-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 7; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/07-06-24-01/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/language-literacy-development-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "NASA Exploration Session",
    text: `Chinmaya Vidyalaya New Delhi recently organized an enlightening virtual space workshop for students of Class IX, in collaboration with Nikolas Tesla Technologies!
    <br/><br/>
    Students embarked on an extraordinary journey of space via cutting-edge VR headsets, exploring the solar system, space stations and distant galaxies – and gaining a 360-degree view of celestial bodies!
     <br/><br/>
    They learnt about the daily lives of astronauts, and observed zero gravity on the International Space Station, and were apprised on the latest advancements and scientific experiments in space exploration in an interactive and engaging format.  
     <br/><br/>
    The workshop enhanced their understanding of spatial relationships, celestial characteristics and interdisciplinary connections.
    <br/><br/>
    It ignited student curiosity and passion for space exploration, and the potential future of human endeavours beyond our planet. The mechanics of space travel definitely inspired many to consider careers in the fields of space science and technology.
    <br/><br/>
    A VR experience that was truly out of this world! The experience left a lasting impression on students and faculty alike – opening up a universe of possibilities!`,
    fullDate: "20 May 2024",
    d: "20",
    m: "May",
    y: "2024",
    link: "/school-events/nasa-exploration-session-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 7; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-5/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/nasa-exploration-session-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Trip to Jim Corbett and Nainital",
    text: `“The book of nature has no beginning, as it has no end.” ~ Jim Corbett
    <br/><br/>
    Corbett Tiger Reserve, established in 1936 as Hailey National Park, was Asia’s first National Park. It continues to be renowned for its biodiversity and is testament to successful wildlife conservation efforts.
     <br/><br/>
    A group of 32 students of Class VII-XI recently went on a 3-day excursion that was as educational as it was rejuvenating!
     <br/><br/>
    The morning of Day 1 consisted of exciting adventures at Dev Bhoomi Outdoor Adventure Activity Park, including zip-lining, fly cycling, free fall, and wall-climbing. This was followed by an informative astronomy session that provided insights into cosmos and hydraulic rocket-making.
     <br/><br/>
    On the second day the students visited the Aryabhatta Research Institute of Observational Sciences (ARIES) in Nainital for an astronomy session, to observe the sun and other celestial objects via the 105 Sampurnanda Telescope. The evening consisted of a leisurely stroll through the Mall Road Market and a fun DJ night, followed by a prize distribution to encourage excellence and camaraderie.
     <br/><br/>
    The third and last day started with an early morning Jungle Safari at Jim Corbett, where the group sighted majestic elephants! Later, a rocket flight activity was conducted to demonstrate the application of theoretical aerodynamics.
     <br/><br/>
    The summer trip blended adventure, learning, team bonding and cultural exploration, making it a memorable experience for all.`,
    fullDate: "16 - 18 May 2024",
    d: "18",
    m: "May",
    y: "2024",
    link: "/school-events/trip-to-jim-corbett-and-nainital-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 18; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-6/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-6/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-6/vid2.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/trip-to-jim-corbett-and-nainital-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Workshop on Toy Pedagogy",
    text: `The National Education Policy (NEP) 2020 envisions a joyful and flexible approach to make learning more experiential and enjoyable. 
    <br/><br/>
    Chinmaya Vidyalaya New Delhi recently organized a workshop on Toy-Based Pedagogy for the faculty members teaching classes Nursery to Class V.
     <br/><br/>
    A team of passionate educators from Bal Bharati Public School, Noida led the session and shared innovative practices of teaching using reusable objects and toys made from paper craft.
     <br/><br/>
    Pre-Primary teachers received hands-on experience in integrating music and toys to make learning more engaging for the little learners. 
    <br/><br/>
    The teachers of the Primary Department collaborated on innovative ways of integrating Mathematics, Science, and English with the aid of toys and simple objects of daily use.
    <br/><br/>
    It was an enriching workshop aimed at enhancing the learning experience for fun, joy, and holistic development. `,
    fullDate: "18 May 2024",
    d: "18",
    m: "May",
    y: "2024",
    link: "/school-events/workshop-on-toy-pedagogy-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-3/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-3/vid1.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/workshop-on-toy-pedagogy-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Workshop on Preparedness for Medical Emergencies",
    text: `Emergency first aid – for when every second counts!
    <br/><br/>
    Chinmaya Vidyalaya New Delhi recently hosted an upskilling workshop on emergency first-aid to enhance the school team’s preparedness.
     <br/><br/>
    Mr. Rajkumar, a certified First Aid Trainer from the Red Cross Society, elucidated the 7 Golden Rules for administering first-aid and provided insights on positive affirmations at the time of emergencies.
     <br/><br/>
    He took the team through the techniques of administering CPR, performing the Heimlich Maneuver in case of choking, and different ways to stop internal and external bleeding.
     <br/><br/>
    Dr Nikita Naik explained how to best support students who suffer from fits and seizures, and help them manage their condition at school. She also provided mitigation measures for students suffering from heatstroke due to the rising temperatures.
     <br/><br/>
    It was an informative session that instilled skills and confidence.`,
    fullDate: "17 May 2024",
    d: "17",
    m: "May",
    y: "2024",
    link: "/school-events/workshop-on-preparedness-for-medical-emergencies-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      // imgArray.push(
      //   "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-7/vid1.mp4"
      // );

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/workshop-on-preparedness-for-medical-emergencies-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Experiential Learning Workshop for School Faculty",
    text: `Chinmaya Vidyalaya New Delhi recently hosted an experiential learning workshop for the school faculty, facilitated by Mr Abhinav Singhal, renowned STEM Catalyst and Innovator.
    <br/><br/>
    His commitment to revolutionise education through experiential learning is well-known! The workshop provided valuable insights and hands-on activities for engaging and interactive teaching of Science, Social Science and Mathematics. 
    <br/><br/>
    The thrust was on developing curiosity and a spirit of enquiry amongst students, and discovering the magic in the mundane. Mr Singal shared real-life examples, such as monuments and their relationship with mathematics, making the session intriguing and informative. The concepts of flow of electricity, currents and circuits were demonstrated, as well as simple mathematics calculations by observations of patterns. 
    <br/><br/>
    He also decoded the concept behind the 1300 year-old ‘Bhim Ka Matka’ in Jammu, that never goes dry!
    <br/><br/>
    Overall it was a highly enlightening experience for the faculty, and will enrich the teaching methods for STEM subjects.`,
    fullDate: "16 May 2024",
    d: "16",
    m: "May",
    y: "2024",
    link: "/school-events/experiential-learning-workship-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 9; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      // imgArray.push(
      //   "https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-7/vid1.mp4"
      // );

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/experiential-learning-workship-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Mother's Day",
    text: `The Pre-Primary and Primary Departments of Chinmaya Vidyalaya came together to celebrate Mother's Day. The day was marked by heartfelt activities and gestures, demonstrating love and appreciation for all the incredible mothers.
    <br/><br/>
    The learners crafted heartfelt cards for their mothers, serenaded them with songs, and engaged in lively action dances. These activities fostered a sense of creativity and expression while strengthening the bond between children and their mothers.
    <br/><br/>
    A beautiful story about Mother's Day highlighted the day’s significance and the endless love and sacrifice of mothers. It successfully instilled gratitude and respect for them.
    <br/><br/>
    The Mother's Day celebration at Chinmaya Vidyalaya was a resounding success, filled with love, laughter, and appreciation for the incredible mothers who play a vital role in shaping everyone’s lives. `,
    fullDate: "13 May 2024",
    d: "13",
    m: "May",
    y: "2024",
    link: "/school-events/mothers-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 18; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-7/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-7/vid1.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/mothers-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Senior Investiture Ceremony",
    text: `Chinmaya Vidyalaya New Delhi conducted the Investiture Ceremony – ‘Netritva’, stressing the importance of leadership initiative for success in all circumstances. 
    <br/><br/>
    The Programme commenced with an Invocation Song by the School Choir, followed by a symphony of melodious tunes ‘Choona Hai Aasman’. This was followed by an aesthetic dance on Guru Vandana.
     <br/><br/>
    The Principal, Ms Archana Soni, delivered an empowering speech addressing the student council and entrusting them with the responsibility and authority to lead by example. She also reiterated the importance of humility in dealing with challenges, for success.
     <br/><br/>
    The newly elected student council members were conferred with badges, sashes, and new responsibilities!
     <br/><br/>
    Ms Nadisha led the council in the oath of allegiance to the Vidyalaya. The Head Girl and Head Boy delivered their Vote of Thanks, and the Ceremony concluded with the National Anthem. 
     <br/><br/>
    The momentous ceremony is an essential component of school life, honing the leadership skills of the next generation of achievers.`,
    fullDate: "10 May 2024",
    d: "10",
    m: "May",
    y: "2024",
    link: "/school-events/senior-investiture-ceremony-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 14; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/23-05-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/senior-investiture-ceremony-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Chess Inaugural Session",
    text: `Chinmaya Vidyalaya New Delhi recently conducted an Inaugural Chess Session for the young chess prodigies from classes IX – XII.
    <br/><br/>
    The session was presided over by the School Manager, Ms Shibani Khorana, and the esteemed Guest, Mr Hariharan Balagopal, a veteran National Level Chess Player.
     <br/><br/>
    Ms Khorana initiated the first move on the reference board the the young learners simultaneously made the same move on their chess board, following which Mr Balagopal singlehandedly played with each learner, moving across tables.
     <br/><br/>
    He suggested finer strategic points to each learner, and elucidated some strategic concepts including Opening Theory, Defensive Position, Correct Combinations, Kingside Castling, Queenside Castling, and the special pawn move capture – En Passant. 
     <br/><br/>
    Learners had a fun-filled, hands-on learning session to ignite their passion for the game even more! `,
    fullDate: "09 May 2024",
    d: "09",
    m: "May",
    y: "2024",
    link: "/school-events/chess-inaugural-session-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-05-2024-4/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/chess-inaugural-session-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Primary Investiture Ceremony",
    text: `Chinmaya Vidyalaya New Delhi conducted the annual Investiture Ceremony for the new generation of leaders. The Ceremony recognized and celebrated the newly elected student council members, conferring them with badges, sashes, and new responsibilities!
    <br/><br/>
    The Programme commenced with an invocation. The Principal Ms Archana Soni addressed the students, encouraging the elected leaders to be dutiful and responsible. A captivating dance performance ignited a sense of solemnity, achievement, and confidence. The Prefectorial Ceremony was a proud moment for all!
    <br/><br/>
    The Head Boy presented an inspiring speech to lead by example, and the Programme concluded with the oath led by the Head Girl. The council donned their mantle enthusiastically, promising to discharge their duties to the best of their abilities. Congratulations to the young achievers!`,
    fullDate: "09 May 2024",
    d: "09",
    m: "May",
    y: "2024",
    link: "/school-events/primary-investiture-ceremony-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 18; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/23-05-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/primary-investiture-ceremony-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Pass the Ball Activity - Pre-Primary",
    text: `Chinmaya Vidyalaya recently organised a 'Pass the Ball' activity for the young learners of the Pre-Primary Section. 
    <br/><br/>
    The objective of the session was to promote the development of physical and gross motor skills among the students, enhancing their coordination, balance, and control over larger muscle groups. 
    <br/><br/>
    The activity received an enthusiastic response from the students and was a great success. 
    <br/><br/>
    It combined fun with learning and emphasised the importance of movement in daily life. 
    <br/><br/>
    Such initiatives play a vital role in nurturing well-rounded, academically proficient, physically fit, and socially adept individuals.`,
    fullDate: "09 May 2024",
    d: "09",
    m: "May",
    y: "2024",
    link: "/school-events/pass-the-ball-activity-pre-primary-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 3; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-6/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-6/vid1.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-6/vid2.mov");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/pass-the-ball-activity-pre-primary-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Sewa Divas (108th Gurudev Jayanti)",
    text: `Chinmaya Vidyalaya marked a significant milestone as it commemorated the 108th Jayanti of Pujya Gurudev Swami Chinmayananda, also celebrated as Sewa Diwas, with a remarkable special assembly.
    <br/><br/>
    Students, faculty, and staff converged in unity to honour his life and wisdom. Through insightful presentations, they illuminated the path paved by Pujya Gurudev, highlighting his unwavering dedication to disseminating the timeless wisdom of Vedanta.
    <br/><br/>
    In a harmonious display of reverence, students joined together in chanting his 18 names, followed by a soul-stirring rendition of the Bhajan - Jai Guru Omkara. 
    <br/><br/>
    Ms Archana Soni, the Principal, delivered a heartfelt address, portraying Gurudev as a visionary pioneer who simplified the profound teachings of Vedanta and the Bhagwad Gita. 
    <br/><br/>
    She underscored the paramount importance of Sewa (selfless service) and karma as the guiding ethos of life, echoing the timeless wisdom imparted by Pujya Gurudev.
    <br/><br/>
    The assembly culminated with a serene Aarti dedicated to Pujya Gurudev, symbolising the illumination of his divine presence in the hearts and minds of all present. 
    <br/><br/>
    The learners of the Primary Wing watched a captivating video presentation, encapsulating the essence of Swami Chinmayananda's life and teachings. They also engaged in a focused meditation by writing 'Om Shree Chinmaya Sadgurave Namaha', allowing them to internalise the divine presence of Gurudev.
    <br/><br/>
    Little learners of the Pre-Primary Department watched a vibrant PowerPoint Presentation, designed to introduce them to the life and teachings of Pujya Gurudev. Their rendition of the hymns - Hari Om Gurudev Hari Om and Humare Gurudev, added a touch of innocence and purity to the proceedings.
    <br/><br/>
    Through this commemoration, Chinmaya Vidyalaya reaffirmed its commitment to upholding the timeless teachings of Swami Chinmayananda, inspiring generations to come to walk the path of knowledge, service, and spiritual growth.`,
    fullDate: "08 May 2024",
    d: "08",
    m: "May",
    y: "2024",
    link: "/school-events/sewa-divas-108th-gurudev-jayanti-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 26; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-5/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-5/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-5/vid2.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/sewa-divas-108th-gurudev-jayanti-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Role Play Activity",
    text: `The Prep class of Chinmaya Vidyalaya recently engaged in a delightful and enriching role-play activity centred around the theme of ‘My Favourite Family Member’.
    <br/><br/>
    Each learner enthusiastically participated in this interactive session, showcasing their creativity, confidence, and expressive skills.
    <br/><br/>
    The learners came to school dressed as their beloved family members and carried props to enhance their portrayal. 
    <br/><br/>
    They transformed into miniature versions of their chosen characters by mimicking mannerisms and emulating speech patterns.
    <br/><br/>
    Under the guidance of their teachers, the learners took turns stepping into the spotlight, delivering speeches with confidence and poise. 
    <br/><br/>
    Their words painted vivid portraits of the family members they admired, evoking a sense of warmth and affection.
    <br/><br/>
    The role-play activity fostered creativity and imagination and provided a platform for the learners to hone their communication and presentation skills in a fun and engaging manner.`,
    fullDate: "06 May 2024",
    d: "06",
    m: "May",
    y: "2024",
    link: "/school-events/role-play-activity-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 3; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-4/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-4/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-4/vid2.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/role-play-activity-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Inter House English Poetry Recitation Competition (Classes VI- VIII)",
    text: ` An Inter-House English Poetry Recitation Competition was recently held for the students of classes VI to VIII.
    <br/><br/>
    The competition commenced with participants from Class VI, who delivered stirring recitations on the theme of ‘Mother and Family.’ Their heartfelt renditions evoked emotions and depicted the deep bonds within familial relationships.
    <br/><br/>
    Following this, students from Class VII took the stage to recite poetry themed around ‘Nature, Environment, and Adventure.’ Their verses painted vivid imagery of the natural world, highlighting the importance of preserving and appreciating the environment.
    <br/><br/>
    The final segment of the competition featured participants from Class VIII, who presented poetry infused with humour and satire. Their witty and clever compositions entertained the audience while delivering insightful commentary on various aspects of life.
    <br/><br/>
    Participants were rigorously assessed on various criteria including voice and articulation, pace, rhythm, intonation, pronunciation, memorisation, and body language, ensuring a fair evaluation of their performances.
    <br/><br/>
    A palpable sense of camaraderie and healthy competition permeated the atmosphere, as students cheered on their peers and supported their respective houses.`,
    fullDate: "04 May 2024",
    d: "04",
    m: "May",
    y: "2024",
    link: "/school-events/inter-house-english-poetry-recitation-competition-classes-vi-viii-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-3/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/inter-house-english-poetry-recitation-competition-classes-vi-viii-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Class XII Presentation (Kartavya Parayan)",
    text: `The students of Class XII conducted a captivating presentation centred around the concept of dutifulness, titled ‘Kartavya Parayan’.
    <br/><br/>
    The presentation focused on the theme of Kartavya - an individual's duty towards parents, peers, and society, and was an insightful exploration of moral responsibility and ethical conduct.
    <br/><br/>
    Various forms of expression were employed to convey the significance of fulfilling duties and responsibilities. Poetry was utilised to articulate the importance of honouring one's obligations, while a skit provided profound insights into the life and teachings of Swamiji.
    <br/><br/>
    The students’ efforts were lauded by the Principal, who delivered a speech praising their stellar performance and the depth of insight they brought to the presentation.
    <br/><br/>
    Overall, the Class XII presentation on Kartavya Parayan was a resounding success, leaving a lasting impression on the audience.`,
    fullDate: "30 April 2024",
    d: "30",
    m: "Apr",
    y: "2024",
    link: "/school-events/class-xii-presentation-kartavya-parayan-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 16; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/class-xii-presentation-kartavya-parayan-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Red day Nursery",
    text: `The Nursery Department of Chinmaya Vidyalaya, New Delhi, recently celebrated Red Day enthusiastically. 
    <br/><br/>
    This vibrant event aimed to engage young learners in exploring the colour red through engaging activities.
    <br/><br/>
    The students arrived at the school in cheerful red attire and brought red-coloured objects with them. They explored the world of colour through objects such as tomatoes and roses, allowing students to connect with the colour tangibly. 
    <br/><br/>
    An interesting craft activity added a touch of artistry to the day’s festivities. The students crafted adorable ladybugs by cotton dabbing and bindi pasting and also sang red-themed rhymes.
    <br/><br/>
    No celebration is complete without delicious treats, and Red Day was no exception. Students had the opportunity to make and enjoy the Roohafza drink.
    <br/><br/>
    The Red Day was a resounding success as it engaged the students in a fun and educational celebration of colours.`,
    fullDate: "30 April 2024",
    d: "30",
    m: "Apr",
    y: "2024",
    link: "/school-events/red-day-nursery-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 11; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-05-24-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/red-day-nursery-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "World Dance Day",
    text: `The World Dance Day celebrations at Chinmaya Vidyalaya, were a resounding success, showcasing the school's vibrant spirit and commitment to fostering talent and cultural appreciation among its students. 
    <br/><br/>
    The Senior School kicked off the festivities with an invigorating workshop led by renowned dancer Mr Shivam Chauhan, a National Award Winner and Youth Icon, focusing on Jazz and Hip Hop. 
    <br/><br/>
    The interactive session engaged students from classes VI-VII, immersing them in dynamic dance routines and igniting their passion for movement. 
    <br/><br/>
    Meanwhile, in the Primary Department, students presented a scintillating assembly that featured an impromptu flash mob to the lively tune of 'Itni si Khushi'. 
    <br/><br/>
    The assembly, further enlivened by the participation of teachers, transformed into a joyful celebration of dance and unity. 
    <br/><br/>
    In the Pre-Primary Department, young learners were treated to captivating storytelling sessions that highlighted the significance of dance in our lives, followed by an exploration of various Indian dance forms, enriching their understanding of cultural diversity. 
    <br/><br/>
    The day concluded with a lively class dance and an adorable flash mob performance by the little ones. 
    <br/><br/>
    Overall, the World Dance Day celebrations exemplified Chinmaya Vidyalaya's dedication to holistic education and the promotion of artistic expression among its students.`,
    fullDate: "29 April 2024",
    d: "29",
    m: "Apr",
    y: "2024",
    link: "/school-events/world-dance-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 20; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-7/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-7/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-7/vid2.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-dance-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Class X Presentation (Karma - The Echoes of Duty)",
    text: `Class X students of Chinmaya Vidyalaya recently delivered a compelling presentation titled ‘Karma - The Echoes of Duty’, resonating with timeless wisdom and spiritual insight.
    <br/><br/>
    The presentation was inspired by the teachings of the Bhagavad Gita and emphasised the essence of performing one's duty without being attached to the outcomes.
    <br/><br/>
    Through a skilfully crafted skit, the students eloquently expressed their perspectives on the importance of karma in one's life and the journey of becoming a Karmayogi.
    <br/><br/>
    Ms Archana Soni, the Principal, in her address, commended the students for their dedication to exploring profound philosophical concepts.
    <br/><br/>
    Foot-tapping music and scintillating dance performances added another dimension of beauty and depth to the presentation.
    <br/><br/>
    As part of commemorating the 108th Anniversary of Swami Chinmayananda Ji, the skit portrayed the invaluable guidance provided by Swami Ji in embodying the principles of Karma and being a true Karmayogi. 
    <br/><br/>
    This presentation not only showcased the intellectual and artistic talents of the students but also left a lasting impression on all attendees, inspiring reflection and contemplation on the significance of duty and karma in one's life journey.`,
    fullDate: "29 April 2024",
    d: "29",
    m: "Apr",
    y: "2024",
    link: "/school-events/karma-the-echoes-of-duty-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-8/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/karma-the-echoes-of-duty-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Run-O-Mania Activity",
    text: `Chinmaya Vidyalaya, New Delhi's Pre-Primary department organised a lively event titled 'Run-O-Mania' to promote physical activity, refine motor skills, and cultivate agility among the young learners.
    <br/><br/>
    The event witnessed enthusiastic participation from the children who thoroughly enjoyed engaging in various activities such as the agility ladder and hoopla run. 
    <br/><br/>
    These activities not only brought immense joy but also contributed significantly to enhancing their movement abilities and fostering better body control.
    <br/><br/>
    Run-O-Mania proved to be a resounding success, providing an atmosphere of fun-filled learning for the little ones. 
    <br/><br/>
    It also played a pivotal role in nurturing cognitive and social development among the participants. 
    The event was a testament to the school's commitment to holistic education and the overall well-being of its students.`,
    fullDate: "25 April 2024",
    d: "25",
    m: "Apr",
    y: "2024",
    link: "/school-events/run-o-mania-activity-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-6/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-6/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-6/vid2.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-6/vid3.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-6/vid4.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-6/vid5.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-6/vid6.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/run-o-mania-activity-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "ATL Community Day",
    text: `Chinmaya Vidyalaya recently hosted ATL Community Day within its premises by welcoming 26 participants from Lalit Mahajan School for an engaging workshop. 
    <br/><br/>
    During the event, students delved into the fundamentals of electronics, explored IoT projects, and immersed themselves in the principles of design thinking. 
    <br/><br/>
    They actively participated in Project Design Thinking sessions centred around crucial themes such as agriculture, education, and health and wellness, fostering innovative ideas and solutions. 
    <br/><br/>
    The day's highlight was the impressive showcase of various working models including water level detectors, obstacle detectors, smart home systems, technology aiding the visually impaired, and smart parking solutions. 
    <br/><br/>
    This collaborative effort provided valuable insights and skills to the students and showcased their creativity and dedication towards addressing real-world challenges.`,
    fullDate: "24 April 2024",
    d: "24",
    m: "Apr",
    y: "2024",
    link: "/school-events/alt-community-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 15; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-5/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/alt-community-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Hanuman Jayanati",
    text: `Chinmaya Vidyalaya, New Delhi, celebrated Hanuman Jayanti with a series of enriching and reverential activities. 
    <br/><br/>
    A special assembly was conducted by the Senior Section, focusing on the numerous meaningful names of Lord Hanuman, followed by a collective recitation of Hanuman Chalisa by the school choir and the students. 
    <br/><br/>
    The Principal, Ms Archana Soni, delivered a poignant address, emphasising Hanuman Ji's extraordinary deeds and the transformative power of the Hanuman Chalisa in overcoming challenges and fostering inner peace. A presentation showcasing five key characteristics attained through reciting Lord Hanuman's name offered deeper insights into His revered qualities.
    <br/><br/>
    The Primary students watched a captivating movie on Hanuman Ji's birth followed by a soulful chanting of the Hanuman Chalisa. They also delved into the significance of the various names of Lord Hanuman, enriching their understanding of the deity's multifaceted nature.
    <br/><br/>
    The Pre-Primary students listened to the Hanuman Chalisa and watched a short movie on Hanuman Ji. They also enjoyed a creative craft activity centred around Hanuman Ji's iconic weapon, the Gada.`,
    fullDate: "23 April 2024",
    d: "23",
    m: "Apr",
    y: "2024",
    link: "/school-events/hanuman-jayanti-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 27; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-4/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-4/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-4/vid2.mov");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-4/vid3.mov");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/hanuman-jayanti-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "World Earth Day",
    text: `Chinmaya Vidyalaya, New Delhi, celebrated World Earth Day 2024 with resounding enthusiasm across all departments. 
    <br/><br/>
    The Senior School embraced the global theme 'Planet vs Plastic' with zest, engaging students in thought-provoking activities. Starting with an illuminating video on the origin and significance of World Earth Day, students from grades VI to XII showcased their dedication to environmental advocacy.
    <br/><br/>
    Grades VI, VII, and VIII created impactful badges and posters advocating 'Save Our Planet' and 'Beat Plastic Pollution', while grades IX and X delved into the detrimental effects of plastic pollution through presentations and discussions. Grades XI and XII contributed by presenting innovative eco-friendly alternatives to plastic, inspiring peers towards sustainable living.
    <br/><br/>
    Meanwhile, in the Primary Department, students demonstrated their commitment to environmental stewardship through a variety of engaging activities. Class VB led the charge with a skit aimed at combating plastic pollution, supplemented by a pledge to 'Say no to Plastics'. Classes I and II danced to an awareness song and engaged in creative crafts like stick puppets and Earth Mosaic, instilling environmental consciousness from a young age. Class III showcased their creativity with decorative paper bags, while classes IV and V adorned themselves with Earth Day Crowns, symbolizing unity in sustainability.
    <br/><br/>
    The Pre-Primary Department fostered a love for nature through a range of hands-on activities. From collage making to recycling treasure hunts, planting saplings, and games like trash sorting and tearing and pasting, the little learners immersed themselves in eco-friendly adventures with boundless enthusiasm. Their actions today lay the groundwork for a greener, more sustainable future, showcasing Chinmaya Vidyalaya's commitment to nurturing environmentally conscious citizens.`,
    fullDate: "22 April 2024",
    d: "22",
    m: "Apr",
    y: "2024",
    link: "/school-events/world-earth-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 30; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-3/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-earth-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Educational trip to Infosys Noida",
    text: `Class XII students of Chinmaya Vidyalaya recently went on an enlightening educational trip to Infosys, Noida to experience the innovative realm of Infosys Springboard. 
    <br/><br/>
    This initiative, forming a pivotal part of the Infosys ESG Tech for Good charter, is designed to empower students with crucial digital and life skills.
    <br/><br/>
    Infosys experts conducted interactive demonstrations to pique curiosity among students with practical applications of energy conversion, polarity, and circuitry. 
    <br/><br/>
    Engaging in presentations and live experiments helped students gain insights into complex scientific principles in a simplified manner.
    <br/><br/>
    Guided by skilled mentors, the students actively participated in assembling a circuit that transformed electrical energy into sound waves. 
    <br/><br/>
    This practical exercise reinforced theoretical knowledge and instilled a sense of accomplishment among the students.`,
    fullDate: "16 April 2024",
    d: "16",
    m: "Apr",
    y: "2024",
    link: "/school-events/educational-trip-to-infosys-noida-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-2/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/educational-trip-to-infosys-noida-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Ram Navami Assembly",
    text: `Chinmaya Vidyalaya, New Delhi, immersed itself in the spirit of devotion and reverence as it celebrated Ram Navami through a special assembly. The assembly commenced with a collective Ram Naam Sankeertan, filling the air with divine vibrations and setting the tone for the day's festivities.
    <br/><br/>
    Throughout the assembly, the spotlight was on highlighting the timeless teachings of Lord Ram, as depicted in the Ramayana Chaupais. Emphasis was placed on their relevance in today's world, urging individuals to awaken the Rama within for personal and societal upliftment. 
    <br/><br/>
    In a poignant address Ms Archana Soni, the Principal, underscored the importance of mental focus and calmness amidst life's challenges, advocating the reading of Ramayana as a source of strength and solace.
    <br/><br/>
    The Primary Department students gained insight into the significance of the festival through an enlightening video. They were inspired by the qualities of Lord Ram, the embodiment of righteousness and courage, showcased in another impactful video. Engaging in a beautiful activity called 'Writing Meditation,' students wrote the name of Lord Ram several times to foster a spiritual connection.
    <br/><br/>
    Even the little learners of Pre-Primary were introduced to the importance of Ram Navami. They watched a video highlighting the virtues of Lord Rama and chanted hymns.`,
    fullDate: "16 April 2024",
    d: "16",
    m: "Apr",
    y: "2024",
    link: "/school-events/ram-navami-assembly-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 16; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/22-04-24-3/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/ram-navami-assembly-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Sewa Session - Primary Department",
    text: `The Primary Department of Chinmaya Vidyalaya, New Delhi, recently organised an introductory Sewa Session to cultivate a spirit of compassion and service among the students. 
    <br/><br/>
    The session focused on imparting the significance of serving others with warmth and care. Students were provided with a comprehensive briefing on various ways they could contribute to society, emphasising the importance of selfless acts of kindness.
    <br/><br/>
    A highlight of the session was the screening of a poignant video illustrating the value of sharing and caring, intended to inspire empathy and altruism among the young learners. 
    <br/><br/>
    The overarching goal of the presentation was to instil in students a sense of kindness and compassion towards others. 
    <br/><br/>
    By nurturing these values from a young age, Chinmaya Vidyalaya aims to foster individuals who understand the importance of service and contribute positively to their communities.`,
    fullDate: "15 April 2024",
    d: "15",
    m: "Apr",
    y: "2024",
    link: "/school-events/sewa-session-primary-department-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-05-24-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/sewa-session-primary-department-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "World Art Day",
    text: `Chinmaya Vidyalaya recently conducted a World Art Day extravaganza.
    <br/><br/>
    The Art Department of the Primary Wing orchestrated a kaleidoscope of artistic activities to mark the day. 
    <br/><br/>
    The students of class V bedecked themselves with elegant sashes bearing the artistic inscription of "World Art Day," radiating creativity and spirit. While the students of class IV  crafted charming badges, showcasing their artistic prowess with delight.
    <br/><br/>
    Class III students fashioned vibrant headbands, while class II delved into the realm of imaginative headgear creation. For the learners of class I, little fingers became brushes of joy during the Colour Splash activity and painted their world with boundless creativity.
    <br/><br/>
    In the Senior School, students and parents of Pre-Primary learners participated in a jubilant celebration of art, partaking in doodling sessions and captivating live art performances.
    <br/><br/>
    The event reached its zenith with a mesmerising showcase of artistic expressions, a testament to the vibrant creativity thriving within the Chinmaya Vidyalaya community.`,
    fullDate: "15 April 2024",
    d: "15",
    m: "Apr",
    y: "2024",
    link: "/school-events/world-art-day-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 9; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/22-04-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-art-day-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Baisakhi Celebration",
    text: `Chinmaya Vidyalaya’s Pre-Primary department celebrated Baisakhi on 12th April 2024, enveloping the day in a vibrant and festive atmosphere.
    <br/><br/>
    The cultural significance of Baisakhi and harvest festivals was explained to the students through an interactive session.
    <br/><br/>
    Rhythmic beats of the dhol infused the air with exuberance and the young learners celebrated the occasion through a spirited dance.
    <br/><br/>
    Children enthusiastically participated in creative activities such as cotton dabbing and pasting paper balls on cobs that combined learning and fun.
    <br/><br/>
    The festivities reached a delicious climax as everyone savoured sweet rice and barfi, adding a flavorful touch to this memorable occasion.`,
    fullDate: "12 April 2024",
    d: "12",
    m: "Apr",
    y: "2024",
    link: "/school-events/baishakhi-celebration-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/22-04-24-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/baishakhi-celebration-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Nursery Adaptation Day 3",
    text: `Nursery Adaptation Programme concluded its third exciting day for the little learners of the Pre-Primary department.
    <br/><br/>
    The students came dressed in vibrant floral dresses and were thrilled to be welcomed by the cheerful Doremon.
    <br/><br/>
    Throughout the day, the children engaged in various activities designed to foster their social, emotional, and cognitive development. 
    <br/><br/>
    They delighted in the Hoola Hoop activity, jumping with enthusiasm and laughter, and enjoyed the fascinating stories and rhymes.
    <br/><br/>
    A hands-on craft activity allowed them to express their creativity by making beautiful cards adorned with dry leaves.
    <br/><br/>
    The highlight of the day was the mesmerising magic show, which left the children spellbound with wonder and excitement. 
    <br/><br/>
    A wonderful nature walk allowed them to explore their new school environment and discover the beauty of their surroundings.
    <br/><br/>
    The children were treated to goody bags filled with surprises, bringing smiles of delight to their faces and concluding another successful day of the adaptation programme.`,
    fullDate: "9 April 2024",
    d: "09",
    m: "Apr",
    y: "2024",
    link: "/school-events/nursery-adaptation-day-3-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/14-04-24-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/14-04-24-1/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/14-04-24-1/vid2.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/nursery-adaptation-day-3-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "My Health My Right Assembly",
    text: `Class V A of Chinmaya Vidyalaya recently conducted a Special Assembly on the occasion of World Health Day.
    <br/><br/>
    The theme of the Assembly ‘My Health, My Right’ was in line with the stated theme for the year by WHO. 
    <br/><br/>
    A positive note was struck at the beginning of the Assembly by chanting the Universal sound, Om. Holistic healing practices consider Om chanting to be therapeutic.
    <br/><br/>
    The students had the privilege of receiving invaluable advice on maintaining good health from an expert via a news channel. The insights shared provided practical tips and guidelines to foster a healthy lifestyle and habits.
    <br/><br/>
    The students drew inspiration from the Bhagavad Gita emphasising the importance of harmony between the body, mind, and soul for overall well-being.
    <br/><br/>
    A captivating dance presentation centred around physical drills added a vibrant touch to the Assembly.
    <br/><br/>
    The students were provided with essential knowledge and preventive measures to combat health threats like Chikungunya, Dengue, and Malaria. 
    <br/><br/>
    Class V A's World Health Day Assembly was a resounding success and inspired everyone to embrace a healthier lifestyle.`,
    fullDate: "8 April 2024",
    d: "08",
    m: "Apr",
    y: "2024",
    link: "/school-events/my-health-my-right-assembly-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/10-04-24-4/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/my-health-my-right-assembly-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Cyber Security Workshop for teacher",
    text: `Chinmaya Vidyalaya recently conducted a dynamic Capacity-Building Workshop on Cyber Security and Safety for its staff members.
    <br/><br/>
    Ms. Sarika Kaushal, PGT DPS RK Puram, and Ms. Akansha Arora, a prominent innovator in Flip at Microsoft facilitated the one-day workshop.
    <br/><br/>
    The facilitators delved into the intricate world of cyber attacks, shedding light on various types of threats that schools encounter in cyberspace. From phishing scams to zero-click attacks, participants gained valuable insights into the evolving landscape of cyber crimes.
    <br/><br/>
    With cyber-attacks becoming more sophisticated, the facilitators stressed the significance of authorisation and two-step authentication as crucial measures to fortify account security. 
    <br/><br/>
    Participants were equipped with practical strategies to safeguard against unauthorised access and protect their personal information.
    <br/><br/>
    The facilitators underscored the importance of creating a supportive environment for addressing cyber safety concerns. They advised setting up a dedicated cyber cell within the school to provide timely assistance to students who may be victims of cyber crimes.
    <br/><br/>
    Chinmaya Vidyalaya is committed to fostering a safe and secure digital environment for staff and students.
    `,
    fullDate: "6 April 2024",
    d: "06",
    m: "Apr",
    y: "2024",
    link: "/school-events/cyber-security-workshop-for-teacher-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/10-04-24-3/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/cyber-security-workshop-for-teacher-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Nursery Adaptation Day 2",
    text: `Day 2 of the Nursery Adaptation Programme was festive, positive and vibrant. The students arrived in colourful attire that showcased their unique personalities.
    <br/><br/>
    The learners received a cheerful welcome from none other than Donald Duck!
    <br/><br/>
    A delightful balloon painting activity offered the students a chance to unleash their creativity alongside their parents.
    <br/><br/>
    Engaging sessions of rhymes and storytelling, and a creative session of making adorable finger puppets of elephants, left the learners delighted.
    <br/><br/>
    The highlight of the day was a captivating puppet show using the finger puppets created by the children.
    <br/><br/>
    Each child received a delightful goody bag filled with surprises and treats, serving as a memorable conclusion to a day filled with laughter, learning, and fun.`,
    fullDate: "5 April 2024",
    d: "05",
    m: "Apr",
    y: "2024",
    link: "/school-events/nursery-adaptation-day-2-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 2; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/10-04-24-2/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/10-04-24-2/vid1.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/10-04-24-2/vid2.mp4");
      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/10-04-24-2/vid3.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/nursery-adaptation-day-2-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Nursery Adaptation Day 1",
    text: `On the first day of Nursery Adaptation, the little learners were welcomed into the school with an abundance of warmth and affection. The children were dressed in vibrant outfits in blue and pink colour.
    <br/><br/>
    A beloved cartoon character, Panda, made a special appearance and added an extra dose of delight to the first day of school. With its playful antics and friendly demeanour, Panda instantly captured the children's hearts, spreading smiles and laughter wherever it went.
    <br/><br/>
    Families created cherished memories to treasure for years to come through a fun photo booth.
    <br/><br/>
    The students enjoyed captivating sessions of storytelling, rhymes and craft activities, followed by a positive and enthralling dance session.
    <br/><br/>
    As the day drew to a close, each child was presented with a beautiful goody bag that added to their joy of being in school.`,
    fullDate: "4 April 2024",
    d: "04",
    m: "Apr",
    y: "2024",
    link: "/school-events/nursery-adaptation-day-1-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 3; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/10-04-24-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      imgArray.push("https://chinmayavvdelhi.ac.in/assets/images/calendar/10-04-24-1/vid1.mp4");

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/nursery-adaptation-day-1-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Orientation Program for Nur to XII",
    text: `Chinmaya Vidyalaya recently conducted a special orientation session for parents.
    <br/><br/>
    The event commenced with the class teachers introducing themselves and the focus areas that define the school's ethos. They also emphasised the importance of fostering a conducive learning environment by adhering to the ground rules upheld by the institution.
    <br/><br/>
    A highlight of the session was the introduction of the Bal Sewak Certificate, a distinctive initiative pioneered by Chinmaya Vidyalaya. 
    <br/><br/>
    This unique accolade recognises and celebrates selfless community service undertaken by Chinmaya Vidyalaya students, instilling in them values of empathy and social responsibility.
    <br/><br/>
    Parents gained valuable insights into the Vidyalaya's assessment methodology, ensuring transparency in the evaluation process.
    <br/><br/>
    An engaging Q&A session addressed all queries from the parents, fostering open communication and collaboration between the school and parents.`,
    fullDate: "3 April 2024",
    d: "03",
    m: "Apr",
    y: "2024",
    link: "/school-events/orientation-program-for-nur-to-xii-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/orientation-program-for-nur-to-xii-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Orientation Program For New Students",
    text: `Chinmaya Vidyalaya recently conducted a Parents’ Orientation Session for the new students.
    <br/><br/>
    The programme began on a divine note with a soulful bhajan dedicated to Lord Ganesha, setting an auspicious tone for the event.
    <br/><br/>
    Ms. Archana Soni, the Principal, welcomed the new students and parents and shared valuable inputs about the Chinmaya Vision Programme. She helped them gain a deeper understanding of the Vidyalaya’s ethos, curriculum, and commitment to nurturing holistic development in every child.
    <br/><br/>
    Ms. Jyotsna Bharadwaj, renowned educationist and psychologist, graced the occasion as the Chief Guest. Her valuable insights and guidance enriched the gathering, leaving a lasting impact on all present.
    <br/><br/>
    A student ambassador took the stage to provide a brief introduction about the school, giving parents a deeper understanding of the Vidyalaya’s ethos and offerings.
    <br/><br/>
    The programme concluded on a fun note with an interactive game for parents, fostering camaraderie and connection within the Vidyalaya community. They also received an overview of the school's rules and regulations to ensure a smooth transition to the Chinmaya Vidyalaya education method.`,
    fullDate: "1 April 2024",
    d: "01",
    m: "Apr",
    y: "2024",
    link: "/school-events/orientation-program-for-new-students-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/05-04-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/orientation-program-for-new-students-2024",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Masti ki Pathshala",
    text: `Chinmaya Vidyalaya&#39;s &quot;Masti ki Pathshala&quot; for classes VI-VIII, held on March 5-6,
    2024, provided a rich tapestry of experiences. The students delved into academic
    subjects like English and Math alongside engaging in co-curricular activities such as
    Chanting, Sports , Dance, and Music. The Chanting sessions included recitals of
    Santa Karam, Shiva Sankalpa Suktam, Naam Kirtan, and Meghasuktam. The Sports
    session included warm-up along with basketball , football , kho-kho and dodgeball. In
    English, they absorbed basic grammar concepts through interactive games like mad
    lib and wordshake. The Math sessions involved interactive activities like musical
    chairs and kaleidoscope using origami. The Dance session showcased freestyle
    Western movements, while the Music session pulsated with dynamic rhythms and
    body percussion. The day concluded with students brimming with newfound
    knowledge and joyful memories, embracing the holistic learning experience.`,
    fullDate: "5-6 March 2024",
    d: "5-6",
    m: "Mar",
    y: "2024",
    link: "/school-events/masti-ki-pathshala-march-2024",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/videos/school-events/10-03-24-1/masti-ki-pathshala-Class-VI.mp4",
      "https://chinmayavvdelhi.ac.in/assets/videos/school-events/10-03-24-1/masti-ki-pathshala-Class-VII.mp4",
      "https://chinmayavvdelhi.ac.in/assets/videos/school-events/10-03-24-1/masti-ki-pathshala-Class-VIII.mp4",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/masti-ki-pathshala-march-2024/",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Karadi Tales Workshop",
    text: `Chinmaya Vidyalaya recently held The Karadi Tales Workshop for its educators to enhance English language learning outcomes for the students. 
    <br/><br/>
    Storytelling is a powerful educational tool that creates a dynamic learning environment in the classroom.
    <br/><br/>
    Throughout the workshop, participants explored various aspects of Karadi tales, including storytelling techniques, language enrichment activities, and interactive learning exercises. The facilitators gained valuable insights into ways to promote literacy skills among students.
    <br/><br/>
    Chinmaya Vidyalaya remains committed to providing its educators with the tools and resources necessary to empower students and enrich their academic experiences.`,
    fullDate: "02 March 2024",
    d: "02",
    m: "Mar",
    y: "2024",
    link: "/school-events/karadi-tales-workshop-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 4; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/12-03-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/karadi-tales-workshop-2024/",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Workshop on Video Editing (Clipchamp)",
    text: `Chinmaya Vidyalaya recently conducted a staff workshop on the Clipchamp video editing app.
    <br/><br/>
    Video content creates a more interactive and dynamic learning environment to engage the students. The use of the Clipchamp video editing app is a great way to integrate technology into teaching practices.
    <br/><br/>
    By mastering such tools, teachers can create customised content tailored to their students' needs and learning styles, thereby improving learning outcomes.
    <br/><br/>
    This proactive approach ensures that students are exposed to cutting-edge tools and resources, preparing them for the demands of the modern world.
    <br/><br/>
    Chinmaya Vidyalaya is committed to the professional development of its educators and an enriching education experience for its students.`,
    fullDate: "29 Feb 2024 - 01 March 2024",
    d: "01",
    m: "Mar",
    y: "2024",
    link: "/school-events/workshop-on-video-editing-clipchamp-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/12-03-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/workshop-on-video-editing-clipchamp-2024/",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Workshop on Digital Tools of Interactive Panel",
    text: `Chinmaya Vidyalaya recently conducted a staff workshop on the Clipchamp video editing app.
    <br/><br/>
    Video content creates a more interactive and dynamic learning environment to engage the students. Using the Clipchamp video editing app is a great way to integrate technology into teaching practices.
    <br/><br/>
    By mastering such tools, teachers can create customised content tailored to their students' needs and learning styles, thereby improving learning outcomes.
    <br/><br/>
    This proactive approach ensures that students are exposed to cutting-edge tools and resources, preparing them for the demands of the modern world.
    <br/><br/>
    Chinmaya Vidyalaya is committed to the professional development of its educators and an enriching education experience for its students.`,
    fullDate: "28-29 February 2024",
    d: "28-29",
    m: "Feb",
    y: "2024",
    link: "/school-events/workshop-on-digital-tools-of-interactive-panel-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/20-03-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/workshop-on-digital-tools-of-interactive-panel-2024/",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/masti-ki-pathshala.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "District Park Excursion",
    text: `Chinmaya Vidyalaya recently conducted a visit to the District Park for the students of the Pre-Primary Wing.
    <br/><br/>
    Under the watchful eyes of the facilitators, every moment was filled with laughter and camaraderie amidst the lush green lawns. The students relished the delicious snacks and enjoyed the games. 
    <br/><br/>
    Such outings provide a break from routine and instil a sense of appreciation for nature and the importance of maintaining cleanliness in public spaces.
    <br/><br/>
    The excursion left a lasting impact on the students, fostering a sense of joy and a newfound commitment to environmental stewardship.`,
    fullDate: "29 February 2024",
    d: "29",
    m: "Feb",
    y: "2024",
    link: "/school-events/district-park-excursion",
    images: ["https://chinmayavvdelhi.ac.in/assets/videos/district-park-excursion-thumbnail.png"],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/district-park-excursion/",
    videoSrc: "https://chinmayavvdelhi.ac.in/assets/videos/district-park-excursion.mp4", // If there's a video, you can provide the source URL
  },
  {
    title: "Masti Ki Pathshala - CLASS-IX",
    text: `Chinmaya Vidyalaya recently conducted a 5-day interactive learning programme, Masti Ki Pathshala.
    <br/><br>
    The programme was designed to make learning enjoyable and engaging for students while also promoting holistic development and a deeper understanding of concepts.
    <br/><br>
    Innovative undertakings in sports, dance, music, sewing, chanting, and academic subjects like English and Maths not only enriched the academic knowledge of the learners but also nurtured their creativity and self-expression.
    <br/><br>
    These diverse activities were tailored to accommodate different learning styles and skills, thereby promoting a holistic educational experience that transcends conventional methodologies.
    `,
    fullDate: "27 February 2024",
    d: "27",
    m: "Feb",
    y: "2024",
    link: "/school-events/masti-ki-pathshala-class-ix-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 35; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-feb-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/masti-ki-pathshala-class-ix-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "The Kiddies kitchenette",
    text: `Chinmaya Vidyalaya recently held a No Fire Cooking Activity for the Pre-Primary students called ‘The Kiddies Kitchenette’.
    <br/><br/>
    The young learners took on the role of professional chefs, proudly presenting their culinary creations at colourful food stalls set up for the occasion.
    <br/><br/>
    From brainstorming recipes to delegating tasks and collaborating on the cooking process, the activity provided ample opportunities for the learners to hone their teamwork and communication skills.
    <br/><br/>
    The event was a celebration of creativity and imagination, encouraging the students to think outside the box and experiment with flavours and textures.
    <br/><br/>
    A big round of applause to all the little chefs for their enthusiasm, creativity, and culinary talents.`,
    fullDate: "27 February 2024",
    d: "27",
    m: "Feb",
    y: "2024",
    link: "/school-events/the-kiddies-kitchenette-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-feb-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/the-kiddies-kitchenette-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Vasant Panchami - Saraswati Pooja",
    text: `Chinmaya Vidyalaya celebrated the festival of Basant Panchami with joy and devotion.
<br/><br/>
    The young learners of the Pre-Primary department came to school dressed in shades of yellow and brought yellow food, in keeping with the festival’s traditions.
    <br/><br/>
    A captivating presentation explained the significance of Basant Panchami to the students. The learners engaged their creativity and created lotuses, sunflowers, and kites using the tear-and-paste technique. 
    <br/><br/>
    The students of classes I and II immersed themselves in the joy of crafting paper tulips, infusing the surroundings with colourful blooms and creative energy.
    <br/><br/>
    A reverential Saraswati Pooja was conducted by the students and teachers of the Senior Wing. The ceremony included soulful bhajans, chanting the 108 names of the Goddess, and Prasad distribution.
    <br/><br/>
    The Basant Panchami celebrations at Chinmaya Vidyalaya were a beautiful blend of tradition, creativity, and devotion, enriching the hearts and minds of all participants.`,
    fullDate: "14 February 2024",
    d: "14",
    m: "Feb",
    y: "2024",
    link: "/school-events/vasant-panchami-saraswati-pooja-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 17; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/19-feb-2024-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/vasant-panchami-saraswati-pooja-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Interactive Session By Swami Swaroopananda Ji",
    text: `Chinmaya Vidyalaya recently played host to Swami Swaroopananda Ji for an interactive session on ‘Unlocking Gen Z - Cracking the Codes’.
    <br/><br/>
    The session was attended by the teachers of the Vidyalaya and was moderated by Shri Vinay Bharadwaj.
    <br/><br/>
    Swami Ji shared his profound insights on understanding and connecting with the younger generation. The current generation is unique in terms of exposure to technology and information.
    <br/><br/>
    He guided the teachers on ways to bridge the generational gap and form a meaningful connection with the students. He underlined the pivotal role teachers play in mentoring learners and helping them discover themselves and achieve their highest potential.
    <br/><br/>
    Swami Ji answered all the questions patiently and encouraged the educators to support the students in pursuing their passion and being their authentic selves.
    <br/><br/>
    The session was very well-received, and all the participants felt empowered and equipped to forge the next generation of leaders.`,
    fullDate: "13 February 2024",
    d: "13",
    m: "Feb",
    y: "2024",
    link: "/school-events/interactive-session-by-swami-swaroopananda-ji-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 2; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/19-feb-2024-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/interactive-session-by-swami-swaroopananda-ji-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Unleashing Imagination Through Puppetry",
    text: `Chinmaya Vidyalaya recently played host to a dazzling Puppet Show by the students of class II.
    <br/><br/>
    The creative learners chose the tales of Panchatantra as their subject, created colourful puppets and made the best use of expressions and voice modulation to convey the profound stories.
    <br/><br/>
    It was not just a performance but a journey where students learned important lessons on collaboration, teamwork, creative thinking and social skills.
    <br/><br/>
    The learners performed all their tasks joyfully and set new benchmarks in creativity.
    `,
    fullDate: "09 February 2024",
    d: "09",
    m: "Feb",
    y: "2024",
    link: "/school-events/unleashing-imagination-through-puppetry-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 3; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/13-feb-24-2/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/unleashing-imagination-through-puppetry-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Safe - Unsafe Touch",
    text: `Chinmaya Vidyalaya recently conducted an informative session on Safe-Unsafe Touch for the students of the Pre-Primary section.
<br/><br/>
    A dedicated special educator led an interactive session to sensitively introduce the concepts of 'Good touch' and 'Bad touch.' 
    <br/><br/>
    The objective was to provide the children with the knowledge and understanding to differentiate between positive and inappropriate physical contact.
    <br/><br/>
    Learners engaged in a series of activities involving giving thumbs up or thumbs down for various situations which made the session engaging and helped the children grasp the concepts in a practical way.
    <br/><br/>
    A creative activity was also conducted where learners coloured a worksheet highlighting the private parts of their bodies. It served as a visual aid, reinforcing the importance of recognising and respecting personal boundaries.
    <br/><br/>
     The students also created their Safe circle in which they drew and wrote about their trusted adults.
     <br/><br/>
    This activity is a crucial step towards creating a nurturing environment and reaffirms the Vidyalaya’s commitment to creating a safe space for all the learners.
    `,
    fullDate: "02 February 2024",
    d: "02",
    m: "Feb",
    y: "2024",
    link: "/school-events/safe-unsafe-touch-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 4; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/06-feb-24-2/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/safe-unsafe-touch-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Community Helpers Visit",
    text: `Chinmaya Vidyalaya recently conducted a Community Helpers Visit activity to help children gain an understanding of the important role each helper plays in supporting everyday life for everyone.
    <br/><br/>
    Various helpers from the community graciously visited the school to enlighten the young learners about their professions and the crucial roles they play in society. 
    <br/><br/>
    The diverse group of helpers included gardeners, cleaners, electricians, security guards and more.
    <br/><br/>
    It was heartwarming to witness the genuine appreciation and respect the students displayed towards these everyday heroes who contribute significantly to the well-being and smooth functioning of society.
    <br/><br/>
    Chinmaya Vidyalaya believes that such initiatives play a crucial role in nurturing well-rounded individuals with a deep understanding of the world around them.
    `,
    fullDate: "01 February 2024",
    d: "01",
    m: "Feb",
    y: "2024",
    link: "/school-events/community-helpers-visit-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/06-feb-24-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/community-helpers-visit-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Khel Mela",
    text: `The Primary and Pre-Primary departments of Chinmaya Vidyalaya recently held their Sports Day, Khel Mela.
    <br/><br/>
    Parakram, the leopard mascot representing agility, delighted the children with its presence.
    <br/><br/>
    The event began with the students taking an inspiring Oath of Sportsmanship under the leadership of the Sports Captain.
    <br/><br/>
    Ms. Archana Soni, the Principal of the Vidyalaya address the participants and spectators and highlighted the importance of integrity and fair play.
    <br/><br/>
    Pre-Primary students took the first step with a Novelty Walk, spreading the message of environmental conservation and green living.
    From Flat Races to 'Clear the Track', the little athletes from Nursery and Prep showcased their speed and agility with enthusiasm. An innovative Caterpillar Race gave the lesson of the value of team work and collaboration.
    <br/><br/>
    Classes I and II displayed incredible energy in Flat Races and Relay Races, representing their houses with pride and determination. While classes III to IV participated in various running events, including Flat Races, Relay Races, and the exciting Hoopla Skipping Race.
    <br/><br/>
    The teachers and facility staff joined in the fun with their own sprinting and fun-filled races, showing their support for the students' efforts.
    <br/><br/>
    A heartfelt vote of thanks from the Primary Headmistress, Ms. Archana Gaur expressed gratitude to all participants, organizers, and supporters.
    `,
    fullDate: "30 January 2024",
    d: "30",
    m: "Jan",
    y: "2024",
    link: "/school-events/khel-mela-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 29; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/13-feb-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/khel-mela-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Pariksha Pe Charcha",
    text: `The students of classes IX to XII of Chinmaya Vidyalaya tuned into the live telecast of the 7th edition of Prime Miniter’s Pariksha Pe Charcha.
    <br/><br/>
    PM Modi highlighted the growing performance stress on children and the negative consequences of it. He highlighted the importance of competing with oneself rather than others.
    <br/><br/>
    He also stressed the importance of a strong bond and trust between parents, children, and students and teachers. This bond can act as a support for students in difficult times.
    <br/><br/>
    The Prime Minister also discussed the significance of good health and sleep, particularly during exam time.
    <br/><br/>
    He also addressed exam-related concerns and shared tips on preparing for the upcoming exams. He also cautioned parents against excessive comparison.
    <br/><br/>
    The session was very well-received and appreciated by the students.`,
    fullDate: "29 January 2024",
    d: "29",
    m: "Jan",
    y: "2024",
    link: "/school-events/pariksha-pe-charcha-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/03-feb-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/pariksha-pe-charcha-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "75th Republic Day Celebration",
    text: `Chinmaya Vidyalaya celebrated the 75th Republic Day through multiple activities that highlighted the vibrant democratic values of India.
    <br/><br/>
    The Pre-Primary department conducted a fancy dress competition on the National Symbols and their significance. The importance of the day was explained to the children through an engaging story and drawing the National Symbols. 
    <br/><br/>
    A child dressed up as Dr Ambedkar, the architect of the Constitution, visited all the classrooms and explained its salient features.
    <br/><br/>
    The Primarry department celebrated by conducting a Special Assembly which included a patriotic song underlining the virtues of liberty and unity, and a special talk on the Constitution and the Parliamentary system. 
    <br/><br/>
    An enthralling dance performance showcased the diversity of the nation, and a talk show conducted by the students discussed the new Parliament building.
    <br/><br/>
    The Senior Section of the school unfurled the Tiranga and discussed the Constitutional ideals of the nation.
    <br/><br/>
    Ms. Archana Soni addressed the Assembly and stressed on the importance of discipline in building a strong character which in turn is a positive contributor to nation-building.
    <br/><br/>
    A patriotic song and informative video on the formation and implementation of the Constitution completed the celebrations.`,
    fullDate: "25 January 2024",
    d: "25",
    m: "Jan",
    y: "2024",
    link: "/school-events/75th-republic-day-celebration",
    images: (function () {
      let imgArray = [];
      for (let i = 2; i <= 41; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/30-jan-24-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/75th-republic-day-celebration/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Shri Ram Pujan in the school",
    text: ` Chinmaya Vidyalaya joined the nation in celebrating the consecration of the Ram Mandir at Ayodhya.
    <br/><br/>
    The students and teachers immersed themselves wholeheartedly in the joyous celebrations. The devotion and divinity made the moments even more memorable.
    <br/><br/>
    Naam Ramayana, soulful Bhajans and Bhagavan Ram’s Aarti reverberated through the school.
    <br/><br/>
    The Principal, Ms Archana Soni highlighted the lessons to be learnt from Shri Ram’s life and exhorted the students to discover the transformative power of faith and channel it to create positivity and goodness in the world.`,
    fullDate: "20 January 2024",
    d: "20",
    m: "Jan",
    y: "2024",
    link: "/school-events/shri-ram-pujan-in-the-school",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 11; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/25-jan-24-3/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/shri-ram-pujan-in-the-school/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Ashirwad Ceremony of class 12th & 10th",
    text: `Blessings from elders and the learned add a dimension of happiness and gratitude to life.
    <br/><br/>
    Chinmaya Vidyalaya recently held an Aashirwad ceremony to seek positivity and grace for the students of class XII.
    <br/><br/>
    The students received blessings from Swami  Prakarshananda Ji for success in the upcoming Board exams and all their future endeavours.
    <br/><br/>
    Swami Ji highlighted the importance of challenges in achieving personal growth and advised the students to approach them with a steady mind and steely focus.
    <br/><br/>
    The event also featured a reverential Paduka Pooja wherein the students sought blessings from Pujya Gurudev and the entire Guru Parampara lineage.`,
    fullDate: "18 January 2024",
    d: "18",
    m: "Jan",
    y: "2024",
    link: "/school-events/ashirwad-ceremony-of-class-12th-&-10th-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/25-jan-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/ashirwad-ceremony-of-class-12th-&-10th-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Gayatri Havan on Makarsankranti",
    text: `Chinmaya Vidyalaya conducted a Gayatri Havan to mark the auspicious occasion of Makar Sankranti.
    <br/><br/>
    Makar Sankranti is a festival with immense cultural, astronomical and scientific significance.
    <br/><br/>
    Gayatri Mantra is an ancient Mantra from Rigveda and is dedicated to the Sun God. It is believed to be a universal prayer for enlightenment.
    <br/><br/>
    The Havan was marked by 108 offerings and the Gayatri Mantra and saw enthusiastic participation from teachers and students alike. The Purna Ahuti of the Havan was followed by the Shanti Path which invoked divine blessings and positivity for everyone.
    <br/><br/>
    Ms. Shibani Khorani, the Manager of the school explained the significance of the Gayatri Mantra and its innate link to positivity.
    <br/><br/>
    The students also delved into the multiple facets of the Makar Sankranti festival and its mode of celebration.`,
    fullDate: "15 January 2024",
    d: "15",
    m: "Jan",
    y: "2024",
    link: "/school-events/gayatri-havan-on-makarsankranti-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 18; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/18-jan-24-4/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/gayatri-havan-on-makarsankranti-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Lohri Celebration of Pre-Primary - Online Session",
    text: `The Pre-Primary Department of Chinmaya Vidyalaya held their Lohri celebrations online due to the prevailing cold weather conditions.
    <br/><br/>
    The event began with a prayer to invoke positivity and blessings for everyone. The significance of the harvest festivals, particularly Lohri and Makar Sankranti was discussed through interesting stories.
    <br/><br/>
    Students were dressed in their traditional best and participated in the celebration enthusiastically.
    <br/><br/>
    Enthralling Bhangra and delicious Lohri snacks made the event truly special.
    <br/><br/>
    The session ended with a craft activity of making and colouring a dhol. All the learners appreciated it.`,
    fullDate: "14 January 2024",
    d: "14",
    m: "Jan",
    y: "2024",
    link: "/school-events/lohri-celebration-of-pre-primary-online-session-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 2; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/18-jan-24-3/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/lohri-celebration-of-pre-primary-online-session-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "National Youth Day Assembly",
    text: `Chinmaya Vidyalaya conducted a Special Assembly on National Youth Day to honour Swami Vivekananda.
    <br/><br/>
    He remains one of India’s foremost thinkers and philosophers who emphasised on the responsibility of the youth towards nation-building. He was committed to serving the needy and destitute, universal brotherhood and the revival of Indian culture.
    <br/><br/>
    The students shared inspiring messages from other youth icons who have proved their mettle. 
    <br/><br/>
    Ms. Archana Gaur, the Headmistress, addressed the Assembly and hailed the learners as the future of the nation.
    <br/><br/>
    The Assembly inspired the children to internalize the message of dedicating themselves to the service of the nation and society and working continuously to create a better future.`,
    fullDate: "12 January 2024",
    d: "12",
    m: "Jan",
    y: "2024",
    link: "/school-events/national-youth-day-assembly-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 9; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/18-jan-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/national-youth-day-assembly-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "National Science Centre Visit",
    text: `The students of class XII of Chinmaya Vidyalaya recently visited the National Science Centre.
    <br/><br/>
    It was an engaging, educational and entertaining visit for the learners as they saw the scientific principles in action through interactive exhibits like the Magic tap and Tesla coils.
    <br/><br/>
    Fun with the Science Gallery was the highlight of the visit since it offered a diverse range of experiences including a 3-D show, hall of mirrors, and multiple interactive science games. 
    <br/><br/>
    The visit successfully imparted knowledge, explored the scientific temperament of our civilisation and emphasised its link to our cultural heritage.`,
    fullDate: "07 January 2024",
    d: "07",
    m: "Jan",
    y: "2024",
    link: "/school-events/national-science-centre-visit-2024",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 9; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/25-jan-24-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/national-science-centre-visit-2024/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Farewell to 12th class Student",
    text: `Chinmaya Vidyalaya recently hosted a Farewell Function for the students of Class XII.
    <br/><br/>
    It was an emotional event as students gave heartfelt speeches, shared their memories, and reminisced about shared experiences and achievements.
    <br/><br/>
    The Principal, Ms. Archana Soni, addressed the graduating class and shared the true meaning of success which goes beyond material and financial gains. 
    <br/><br/>
    She also encouraged them to adopt social causes and contribute a portion of their earnings and time to them.
    <br/><br/>
    Mr. and Ms. Chinmaya were felicitated with badges, sashes and hampers.
    <br/><br/>
    The students and teachers expressed their gratitude towards the graduating students and wished them a bright and successful future.`,
    fullDate: "29 December 2023",
    d: "29",
    m: "Dec",
    y: "2023",
    link: "/school-events/farewell-to-class-12-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 16; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/18-jan-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/farewell-to-class-12-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Junior Class - Annual Prize Distribution Ceremony",
    text: `The Primary Wing of Chinmaya Vidyalaya held its Prize Distribution Ceremony, Kal Aaj Kal.
  <br/><br/>
  Shri Naveen Kumar Shah, IFS, Chairman and MD of NDFDC, was the Chief Guest and Dr Garima Tiwari, ACP, South West District, was the Guest of Honour.
  <br/><br/>
  The young achievers in multiple domains and the credit winners received prizes for their superb performance.
  <br/><br/>
  Ms. Archana Soni, the Principal, presented the Annual Report. The Chief Guest addressed the students and encouraged them to work hard and achieve greater heights.
  <br/><br/>
  A glittering cultural programme that included Ganesh Vandana, melodious songs and a delightful dance drama highlighting India’s rich culture and history followed.
  <br/><br/>
  The event was a huge success and every performance met with resounding cheers.
  <br/><br/>
  Ms. Archana Gaur, the Headmistress of the Primary Wing proposed the Vote of Thanks.`,
    fullDate: "28 December 2023",
    d: "28",
    m: "Dec",
    y: "2023",
    link: "/school-events/junior-class-annual-prize-distribution-ceremony-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 38; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/09-jan-24-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/junior-class-annual-prize-distribution-ceremony-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Senior Class - Annual Prize Distribution Ceremony",
    text: `The Senior Wing of Chinmaya Vidyala recently held a glittering Award Ceremony, Aaj Ka Arjun.
<br/><br/>
    Shri Vikram K Porwal, Deputy Commissioner of Police graced the occasion as the Chief Guest.
    <br/><br/>
    He acknowledged the achievements of the students, applauding their dedication, hard work, multifaceted talents, and outstanding performance in both academic and co-curricular realms. 
    <br/><br/>
    Shri Porwal was greatly inspired by Swami Chinmayananda and emphasised the importance of integrating sports, values, and spiritual upliftment in nurturing well-rounded individuals.
    <br/><br/>
    The event celebrated the teachers who have completed 15 and 25 years of exceptional service. Their dedication has played a pivotal role in shaping the academic and cultural landscape of the Vidyalaya.
    <br/><br/>
    The school orchestra set the stage aglow with harmonious melodies while a captivating fusion dance created a visual delight.
    <br/><br/>
    The programme's highlight was the gripping play, 'Aaj Ka Arjun’ which delved into the timeless narrative of Arjuna’s moral dilemma and juxtaposed it with the issues faced by the youth today. It was a thought-provoking exploration of morality and decision-making.
    <br/><br/>
    A seamless integration of dance within the play added another dimension to the performance.`,
    fullDate: "28 December 2023",
    d: "28",
    m: "Dec",
    y: "2023",
    link: "/school-events/senior-class-annual-prize-distribution-ceremony-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 43; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/09-jan-24-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/senior-class-annual-prize-distribution-ceremony-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Assembly on Tapovan & Geeta Jayanti by Middle & Sr Classes",
    text: `Geeta Jayanti and Tapovan Jayanti celebrations are a hallmark of Chinmaya Vidyalaya.
    <br/><br/>
    The Special Assembly commenced with the ceremonial lighting of the Diya and an exposition on Swami Tapovan Maharaj’s life.
    <br/><br/>
    A skit transformed the school stage into the battleground of Kurukshetra with Lord Krishna sharing the wisdom of Bhagavad Geeta with all present.
    <br/><br/>
    It also highlighted the messages of the importance of duty, renunciation of desire, and the significance of purity of thoughts and purpose.
    <br/><br/>
    The Principal, Ms. Archana Soni, emphasised on Geeta’s message on ways to lead a purposeful life. 
    <br/><br/>
    Calling the Srimad Bhagavad Geeta the Science of Living, Ma'am expressed great satisfaction at the students of the Vidyalaya being well-versed in it. Geeta’s message of being detached from the outcomes of the efforts helps one in facing disappointments.
    <br/><br/>
    The Assembly concluded with a Geeta Bhajan honouring Swami Tapovan Maharaj and the Srimad Bhagavad Geeta.
    `,
    fullDate: "22 December 2023",
    d: "22",
    m: "Dec",
    y: "2023",
    link: "/school-events/assembly-on-tapovan-and-geeta-jayanti-by-middle-and-senior-classes-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/28-dec-23-3/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/assembly-on-tapovan-and-geeta-jayanti-by-middle-and-senior-classes-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Assembly on Christmas by Primary",
    text: `Chinmaya Vidyalaya celebrated Christmas in a Special Assembly conducted by the enthusiastic learners of class I.
    <br/><br/>
    The celebrations started with the lyrical ‘Rudolph the Red-Nosed Reindeer’ and was followed by an interesting skit depicting the Nativity scene that explained the story of the birth of Christ.
    <br/><br/>
    A deep and informative talk explained the significance and true essence of Christmas. It was followed by a mesmerising dance performance on “Jingle Bells’.
    <br/><br/>
    Children’s favourite moment was when Santa Claus made an appearance on his sleigh.
    <br/><br/>
    The event was a resounding success, with the learners cheering and clapping after each performance.
    <br/><br/>
    They also learned important life lessons on sharing and giving.`,
    fullDate: "21 December 2023",
    d: "21",
    m: "Dec",
    y: "2023",
    link: "/school-events/assembly-on-christmas-by-primary-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 11; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/28-dec-23-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/assembly-on-christmas-by-primary-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Visit at SOIL, Gurugram",
    text: `The students of Chinmaya Vidyalaya recently attended the India@100 Initiatives Conference at SOIL Institute of Management.
    <br/><br/>
    Selected students from XI and XII participated in the 15th Inspired Leadership Conference that aimed at spelling out Vision 2047 for India.
    <br/><br/>
    The participants in the Conference included professionals, educators and students- all stakeholders in the nation’s progress.
    <br/><br/>
    There is an increasing need to adopt sustainable development as the way forward. It can be achieved only by achieving equilibrium across the key focus areas of economic growth, social inclusion and environmental protection.
    <br/><br/>
    Chinmaya Vidyalaya students actively participated in the discussions and contributed to creating India's Vision for 2047, per SDGs.`,
    fullDate: "18-19 December 2023",
    d: "18-19",
    m: "Dec",
    y: "2023",
    link: "/school-events/visit-at-soil-gurugram-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/12-jan-24-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/visit-at-soil-gurugram-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Assembly on Class Presentation (The Majestic Nature) by Nursery",
    text: `The Nursery students of Chinmaya Vidyalaya recently gave a Class Presentation to highlight the beauty and importance of nature, titled ‘The Majestic Nature’.
    <br/><br/>
    It is vital to conserve nature to protect and propagate the native flora, fauna, the biodiversity of an ecosystem. It is essential for the survival of the human race.
    <br/><br/>
    The students showcased the value of nature through a mellifluous song and enthralling dance performances.
    <br/><br/>
    Ms. Archana Soni, the Principal of the Vidyalaya was highly appreciative of the presentation and commended the students on their hard work.
    <br/><br/>
    The parents and Ms. Archana Gaur, the Headmistress also complimented the young learners.
    <br/><br/>
    Ms. Gurajan Kaur presented the vote of thanks. The event culminated with the National Song.
    <br/><br/>
    Chinmaya Vidyalaya believes in inculcating respect for nature in all learners and encourages sustainable practices.
    `,
    fullDate: "19 December 2023",
    d: "19",
    m: "Dec",
    y: "2023",
    link: "/school-events/the-majestic-nature-by-nursery-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 7; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/28-dec-23-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/the-majestic-nature-by-nursery-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "National Mathematics Day",
    text: `National Mathematics Day is celebrated to mark the birth anniversary of one of India’s most famous mathematicians, Srinivasa Ramanujan.
    <br/><br/>
    The Primary Wing of Chinmaya Vidyalaya held a Special Assembly to honour him and introduce the learners to his life and works. The critically acclaimed movie ‘The Man Who Knew Infinity’ was a biography based on him.
    <br/><br/>
    Ramanujan made substantial contributions to the analytical theory of numbers and worked on elliptic functions, continued fractions, and infinite series. 
    <br/><br/>
    During the assembly, children performed Angle Yoga which combined the Yogasanas with geometrical shapes.
    <br/><br/>
    The students also learned about the number zero and the fascinating facts associated with it.
    `,
    fullDate: "18 December 2023",
    d: "18",
    m: "Dec",
    y: "2023",
    link: "/school-events/national-mathematics-day-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/22-dec-23-2/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/national-mathematics-day-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Chandigarh Trip for the students of classes IV and V",
    text: `Chandigarh is unique for being the only city that is the capital of two states and being the first planned city of independent India.
    <br/><br/>
    The learners absorbed culture and knowledge at the Government Museum of Art. The beautiful paintings, sculptures, and artifacts were a wonder to behold.
    <br/><br/>
    Rock Garden fascinated the students with its interesting artwork of recycled household, electrical, and ceramic waste. They understood the need to segregate, recycle, and upcycle the waste.
    <br/><br/>
    Pinjore Garden with its vibrant greenery and refreshing fountains was a delight for the children.
    <br/><br/>
    Mohendra Chaudhry Zoological Park or as it is popularly known, Chhatbir Zoo, captivated the children with its wide variety of birds, mammals, and reptiles.
    <br/><br/>
    The trip was a thrilling experience for all the children and they returned with pleasant memories.
    `,
    fullDate: "15 December 2023",
    d: "15",
    m: "Dec",
    y: "2023",
    link: "/school-events/chandigarh-trip-classes-iv-v-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 20; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/22-dec-23-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/chandigarh-trip-classes-iv-v-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Bhartiya Bhasha Diwas",
    text: `Chinmaya Vidyalaya, New Delhi recently conducted a Special Assembly on Bhartiya Bhasha Diwas.
    <br/><br/>
    It is a day to honour renowned Tamil poet and freedom fighter Mahakavi Chinnaswami Subramania Bharati, a polyglot who spoke 18 languages.
    <br/><br/>
    He exemplified the rich language traditions of India by translating notable literary works from several Indian languages to Tamil.
    <br/><br/>
    The learners were encouraged to speak in their native language to showcase India’s linguistic diversity and highlight its inspiring unity.
    <br/><br/>
    The Assembly culminated with the mellifluous and patriotic song ‘Dhitang Dhitang Bole’ by Jeet Ganguly which inspired the learners to dedicate themselves to the nation and its growth.`,
    fullDate: "12 December 2023",
    d: "12",
    m: "Dec",
    y: "2023",
    link: "/school-events/bhartiya-bhasha-diwas-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/16-dec-23-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/bhartiya-bhasha-diwas-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "International Day of Persons with Disabilities",
    text: `Chinmaya Vidyalaya conducted a Special Assembly on World Disability Day in keeping with the school’s beliefs on inclusivity and sensitivity.
    <br/><br/>
    The Assembly highlighted the importance of recognising abilities over disabilities.
    <br/><br/>
    Vidyalaya’s Special Educator cleared several misapprehensions regarding disabilities while the Counsellor brought out the significance of empathy and kindness towards those with disabilities.
    <br/><br/>
    The learners were also briefed about the Rights of Persons with Disabilities Act 2016, and its provisions.
    <br/><br/>
    The underlying message of the Assembly was equality and treating everyone with dignity.`,
    fullDate: "07 December 2023",
    d: "07",
    m: "Dec",
    y: "2023",
    link: "/school-events/international-day-of-persons-with-disabilities-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-dec-23-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/international-day-of-persons-with-disabilities-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Prize Distribution Ceremony",
    text: `A Prize Distribution Ceremony was held recently to honour and applaud the young achievers of Chinmaya Vidyalaya.
<br/><br/>
    The school’s culture of encouraging sports and co-scholastic activities results in stupendous achievements in the interschool achievements.
    <br/><br/>
    A special recognition was given to Prachi Tokas, a class X student, who won the Silver Medal at the IBA Junior World Boxing Championship.
    <br/><br/>
    Chinmaya Vidyalaya is exceedingly proud of each of its champions who have brought laurels to the school.`,
    fullDate: "05 December 2023",
    d: "05",
    m: "Dec",
    y: "2023",
    link: "/school-events/price-distribution-ceremony-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 3; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-dec-23-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/price-distribution-ceremony-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "World Disability Day Assembly",
    text: `Chinmaya Vidyalaya and Tamana Special School collaborated to celebrate the International Day of Persons with Disabilities.
    <br/><br/>
    The joint celebrations kicked off with an inclusion walk carrying messages highlighting positivity and acceptance for everyone.
    <br/><br/>
    A brilliant Nukkad Natak shared the powerful yet vital message of empathy over sympathy towards people with disabilities. It was followed by a soulful song and an enthralling dance performance.
    <br/><br/>
    Senior Headmistress expressed gratitude to Tamana School, on behalf of the Vidyalaya, for the collaborative celebration.
    <br/><br/>
    The Vidyalaya believes in fostering a culture of support and sensitivity and the universal right to a life with dignity.`,
    fullDate: "05 December 2023",
    d: "05",
    m: "Dec",
    y: "2023",
    link: "/school-events/world-disability-day-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-dec-23-3/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-disability-day-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Shape-O-Mania Activity",
    text: `Chinmaya Vidyalaya conducted a special activity to explain the concept of Shapes to Pre-Primary students.
<br/><br/>
    Learning about shapes is vital to future learning as it helps children recognise and organise visual information. It also improves their reading skills and comprehension of STEM subjects.
    <br/><br/>
    The learners were taught about the shapes using cut-outs and encouraged to identify and sort them.
    <br/><br/>
    They had fun making trains with interesting shapes. It was a wonderful way to channel their creativity.`,
    fullDate: "01 December 2023",
    d: "01",
    m: "Dec",
    y: "2023",
    link: "/school-events/shape-o-mania-activity",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 6; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/06-nov-23-4/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/shape-o-mania-activity/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Alumni Connect Session with Tonoy Ghosh",
    text: `Our alumni are our best ambassadors.
    <br/><br/>
    A recent Alumni Connect Session featured Sh. Tonoy Ghosh, an international restaurateur and F&B consultant.
    <br/><br/>
    Tonoy holds a degree in International Hospitality and Tourism Management from Singapore and has spent considerable time with the international hospitality chain Marriott.
    <br/><br/>
    He shared his insights on various aspects of life and highlighted the importance of mindfulness and balance. He also discussed being healthy internally and externally and the value of a positive outlook.
    <br/><br/>
    The session was an illuminating experience for the learners of XI and XII as it carried insights from the professional world and valuable life lessons.`,
    fullDate: "01 December 2023",
    d: "01",
    m: "Dec",
    y: "2023",
    link: "/school-events/alumni-connect-session-december-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 4; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/06-nov-23-3/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/alumni-connect-session-december-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Karadi Path Workshop of Science language learning",
    text: `Chinmaya Vidyalaya, New Delhi recently conducted a workshop on Karadi Path Methodology for its Primary and Pre-Primary educators.
<br/><br/>
    Karadi path methodology is an award-winning pedagogy for language learning through an immersive multi-modal learning environment.
    <br/><br/>
    Dr. Kalpesh Bordawekar, Sr VP of Karadi Path Education conducted the workshop on the Science of Language Learning and an Introduction to Karadi Path.
    <br/><br/>
    The teachers were trained on innovative teaching practices that included music, storytelling, and activities.`,
    fullDate: "01 December 2023",
    d: "01",
    m: "Dec",
    y: "2023",
    link: "/school-events/karadi-path-workshop",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/06-nov-23-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/karadi-path-workshop/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Good Touch, Bad Touch",
    text: `Forewarned is forearmed!
<br/><br/>
    Keeping children safe is a major concern for parents and the school as the danger can come in unforeseen forms.
    <br/><br/>
    It is important to inform the children and enable them to recognize the danger and act accordingly.
    <br/><br/>
    Small children are particularly susceptible hence Chinmaya Vidyalaya conducted this workshop for the pre-primary wing.
    <br/><br/>
    The learners were informed about stranger danger, ways to identify good and bad touches, their control over their body, how to handle such situations, and the Child Helpline number 1098.
    <br/><br/>
    The entire concept was then reinforced through a role-play exercise.`,
    fullDate: "30 November 2023",
    d: "30",
    m: "Nov",
    y: "2023",
    link: "/school-events/safe-and-unsafe-touch-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/06-nov-23-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/safe-and-unsafe-touch-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Gurpurab Celebration",
    text: `                           
    Guru Nanak Dev’s Prakash Utsav or birth anniversary is celebrated with a lot of devotion and reverence.
<br/><br/>
    His entire life signifies harmony and service to humanity
    . Chinmaya Vidyalaya, New Delhi celebrated the occasion by spreading his message of brotherhood among the students.
    <br/><br/>
    The learners from Pre-Primary and Primary wings watched a video on his life and teachings and held a Prabhat Feri in the school corridors which highlighted the importance of reflecting on God, taking His name and meditating on His aspects.
    <br/><br/>
    The principles of Sikhism were explained to the students along with a free-hand drawing of a Gurudwara. The learners understood the significance of the Langar and universal brotherhood while enjoying the piping hot Kadha prasad.
    <br/><br/>
    Guru Nanak Dev’s life and ideals are a source of inspiration for all Indians.`,
    fullDate: "24 November 2023",
    d: "24",
    m: "Nov",
    y: "2023",
    link: "/school-events/gurpurab-celebration-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/29-nov-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/gurpurab-celebration-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Workshop - Posture Matters A Journey to Overall Well-Being",
    text: `                           
    Dr. Renu Mahtani, the Founder of Autoimmunity Treatment Centre and Param Yoga in Pune , conducted an enlightening one-hour session on body posture for Chinmaya staff. Emphasizing on the crucial link between posture and overall well-being, Dr. Renu highlighted the significance of parallel feet while standing, doing knee-stabilizing exercises and quad-strengthening poses. Sheding light on the impact of prolonged laptop and mobile phone usage on posture, she also discussed the pivotal role of vitamin D in muscle and skin health. The Guest Speaker, Mr. Chetan Sharma, underscored the benefits of tic-tac breathing for mental rejuvenation. The session offered valuable insights on maintaining correct body posture for holistic well-being.`,
    fullDate: "20 November 2023",
    d: "20",
    m: "Nov",
    y: "2023",
    link: "/school-events/posture-matters-a-journey-overall-well-being",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 10; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/22-nov-2/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/posture-matters-a-journey-overall-well-being/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "JOY OF GIVING - A SMALL STEP, A BIG SMILE",
    text: `<strong>“We make a living by what we get, but we make a life by what we give. Only a life lived for others is a life worthwhile.”</strong> <br/><br/>                             
    Chinmaya Vidyalalya, New Delhi, as a part of its 'Joy of Giving' initiative took a small step of 'Each One Donate One' activity that made the students embrace the spirit of service. The students from classes I-VIII happily donated dry ration items and the little learners of Pre-Primary contributed diyas,candles and sweets.The contributions were handed over to the Earth Saviour Foundation, temples and facility staff.
    <br/><br/> 
The students of Primary Department gifted painted and decorated diyas, handmade paper lanterns and torans to their helpers at home. The students participated enthusiastically in all the activities and learnt that true happiness lies in giving, and not getting.`,
    fullDate: "4, 7 & 9 November 2023",
    d: "04",
    m: "Nov",
    y: "2023",
    link: "/school-events/joy-of-giving-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 17; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/22-nov-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      for (let i = 1; i <= 9; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/22-nov-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/joy-of-giving-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Fun & Frolic Sports Week",
    text: "Sports has the power to change the world. Students participated wholeheartedly and enthusiastically.<br/><br/>Our exhilarating Sports Week at School was filled with thrilling events and enthusiastic participation. The little learners from Pre-primary showcased their athleticism and teamwork in a series of exciting events like Aerobics, Hoopla walk, and Hurdle walk! The school grounds echoed with cheers as young athletes raced freely, embracing the spirit of camaraderie. Students showcased their Motor skills, demonstrating precision and teamwork, exhibiting their sports prowess and strategic play.",
    fullDate: "25 October 2023",
    d: "25",
    m: "Oct",
    y: "2023",
    link: "/school-events/fun-frolic-sports-week-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-nov-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      for (let i = 1; i <= 4; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/15-nov-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/fun-frolic-sports-week-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Dussehra Celebration",
    text: "Dussehra celebrates the victory of good over evil.<br/><br/>The Pre-Primary and Primary Departments of Chinmaya Vidyalaya, New Delhi, celebrated the festival of Dussehra on 20th October 2023 by engaging the learners in some interesting activities. The little learners of Pre-Primary learned about the qualities of Lord Rama through a video presentation and enjoyed coloring the picture of Lord Rama. The learners of Primary classes enjoyed making Ravana using paper cups, sticks, and origami. They also made Dussehra cards and beautifully mentioned the message of the victory of good over evil inside them. The activities enlightened them about the significance of the festival.",
    fullDate: "20 October, 2023",
    d: "20",
    m: "Oct",
    y: "2023",
    link: "/school-events/dussehra-celebration-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/31-oct-2/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/dussehra-celebration-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Class I Presentation - Wild About Animals",
    text: "The little learners of class I of Chinmaya Vidyalaya, New Delhi hosted their Class Presentation, Wild About Animals, on 18th October 2023 with great zeal and excitement. The occasion was graced by Shri Atul Karanjakar, the Zonal Director, CCMT Education Cell.<br/><br/>The programme included a melodious rendition of ‘Rang Birangi Dharti, a skit on the significance of teamwork and an energetic and scintillating dance performance that enthralled everyone.<br/><br/>Addressing the audience, Ms. Archana Gaur, the Primary Headmistress, offered valuable insights on conserving nature and its wildlife. The Principal, Ms. Archana Soni, applauded the students for their efforts and shed light on the role of the Vidyalaya in developing resilient and happy individuals.<br/><br/>The presentation culminated with a message that saving wildlife is more than just an expression of compassion; it is a legacy we bequeath to future generations.",
    fullDate: "18 October, 2023",
    d: "18",
    m: "Oct",
    y: "2023",
    link: "/school-events/wild-about-animals-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/2-nov-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/wild-about-animals-2023/",
    videoSrc: "", // If there's a video, you can provide the source URL
  },
  {
    title: "Global Handwashing Day",
    text: `<strong>"Cleanliness is next to Godliness"</strong>
    <br><br>
    The Pre-Primary Department of Chinmaya Vidyalaya New Delhi organised a Global Hand Washing activity on 13th October 2023.” The pepper and soap experiment”, wherein how soap destroys viruses was shown to learners through this activity and to acquaint the little learners with the significance of keeping their hands germ-free a demo of proper step by step hand washing was given.
    <br><br>
    Educating children about the importance of washing hands in a proper manner is the key to promote good health and well-being`,
    fullDate: "13 October, 2023",
    d: "13",
    m: "Oct",
    y: "2023",
    link: "/school-events/global-handwashing-day-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 7; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/18-oct-2/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/global-handwashing-day-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Matr Pitr Abhinandan",
    text: `Chinmaya Vidyalaya , New Delhi, organized a signature event, "Matr-Pitra Abhinandan," as a tribute to the very source of our existence-our parents. During the event, students paid homage to their parents and expressed their love and care for their parents by worshipping them. The parents expressed their commitment to nurture their children. This emotional moment was further enriched as students bowed in deep gratitude and acknowledged the love and care that their parents offer unconditionally. The Principal, Ms.Archana Soni, emphasized the significance of strengthening familial bonds in today's fast-paced world. This event also instilled in students a deeper sense of duty towards their parents and a profound appreciation for the boundless affection they receive from them. Such solemn events transform students into devoted and responsible individuals who understand the true essence of our Indian culture.`,
    fullDate: "05-06 October, 2023",
    d: "05",
    m: "Oct",
    y: "2023",
    link: "/school-events/matr-pitr-abhinandan",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 15; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/18-oct-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/matr-pitr-abhinandan/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Gandhi Jayanti Celebration",
    text: `<strong>“A man is but a product of his thoughts. What he thinks he becomes.” – Mahatma Gandhi</strong>
    <br/><br/>
    Chinmaya Vidyalaya, New Delhi, celebrated the birth anniversary of the Father of the Nation - Mohandas Karamchand Gandhi by conducting a myriad of activities. 
The students of Senior School initiated a cleanliness and plantation drive to spread the message of clean and green environment.Additionally, they enjoyed a soulful bhajan and it was followed by the screening of a movie- The Mahatma Returns. 
<br/><br/>
The students of classes I and II presented a special assembly which showcased a soulful bhajan 'Raghupati Raghav Raja Ram',  a captivating dance performance and a solo song ‘Dedi Hume Azadi' on harmonium. The assembly helped the students learn the values of honesty, non-violence and love for humanity.
<br/><br/>
The Pre-Primary Department conducted a Cleanliness Drive. The students watched a video about Gandhiji's life and principles. The little learners  enjoyed freehand drawings on Gandhiji's glasses, spinning wheel and the tricolor.Through these activities, the students learnt the values of cleanliness, non-violence, and patriotism.`,
    fullDate: "02 October, 2023",
    d: "02",
    m: "Oct",
    y: "2023",
    link: "/school-events/gandhi-jayanti-celebration-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 17; i++) {
        if (i === 9) continue;
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/6-oct-2/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      for (let i = 1; i <= 14; i++) {
        if (i === 14 || i === 10) continue;
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/6-oct-2/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/gandhi-jayanti-celebration-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Grandparents' Day Celebration",
    text: `<strong>“Grandparents are a family's greatest treasure and the footsteps to the future generations.”</strong>
    <br/><br/>
    To honour and thank the beloved grandparents for their unconditional love, the learners of classes I-II and Pre- Primary Department of Chinmaya Vidyalaya, New Delhi celebrated Grandparents' Day – Grand Masti with Grandparents.
    <br/><br/>
Our learners of classes I and II welcomed the grandparents with the auspicious tilak ceremony. This was followed by a myriad of joyful activities, music, dance and creative craft. Our munchkins were fascinated by the riveting stories told by the greatest storytellers, the grandparents. They lent a helping hand to their Nanis and Dadis while preparing finger-licking and healthy recipes as part of the non-fire cooking activity. 
<br/><br/>
The learners in Pre- Primary Department enjoyed story time with their grandparents  wherein they learnt the lessons about being kind and good. They also enjoyed dancing with their grandparents.`,
    fullDate: "15 September, 2023",
    d: "15",
    m: "Sep",
    y: "2023",
    link: "/school-events/grandparents-day-celebration-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 22; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-sep-4/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/grandparents-day-celebration-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "हिंदी दिवस समारोह",
    text: `भारत की राजभाषा हिंदी की महत्ता को प्रतिपादित करते हुए प्रतिवर्ष 14 सितंबर के दिन हिंदी दिवस का आयोजन विद्यालय में किया जाता है। इस वर्ष भी  हिंदी दिवस बड़े ही हर्षोल्लास से मनाया गया । जिसके अंतर्गत  हिंदी भाषा के महत्त्व को दर्शाया गया । इसी क्रम में माध्यमिक एवं उच्च-माध्यमिक विभाग द्वारा सर्वप्रथम हिंदी भाषा के महत्त्व को प्रदर्शित करते हुए गीत का आयोजन किया गया। तत्पश्चात भारतीय संस्कृति एवं हिंदी के महत्त्व को बताते हुए एक नुक्कड़ नाटक का मंचन  भी किया गया। इसी अवसर पर प्रधानाचार्या महोदया  और प्रधान अध्यापिका ने अपने-अपने सुविचारों से विद्यार्थियों को सम्बोधित करते हुए भारतीय भाषाओं एवं बोलियों के महत्त्व को समझाया। राष्ट्रीय गीत के साथ  समारोह का समापन हुआ। विद्यालय के प्राथमिक विभाग द्वारा इस अवसर पर सभी कक्षाओं में विभिन्न प्रकार की गतिविधियाँ करवाई गईं। जिसमें नारा लेखन, कविता लेखन, पोस्टर निर्माण आदि प्रमुख थीं।पूर्व प्राथमिक विभाग में शिक्षार्थियों ने हिंदी कहानी वाचन तथा कविता पाठ आदि गतिविधियों में भाग लिया तथा अपने वाक् कौशल तथा आत्मविश्वास का प्रदर्शन किया। बच्चों का यह प्रयास सराहनीय रहा ।`,
    fullDate: "14 September, 2023",
    d: "14",
    m: "Sep",
    y: "2023",
    link: "/school-events/hindi-diwas-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/6-oct-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/hindi-diwas-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "World Literacy Day",
    text: `<strong>"Literacy is not just about educating, it is a unique and powerful tool to eradicate poverty and a strong means for social and human progress."</strong><br/><br/>
    The World Literacy Day was celebrated by the Pre- Primary department of Chinmaya Vidyalaya, New Delhi, on 6th September 2023. It aimed at helping little learners to raise awareness about the value and importance of literacy. They were shown an educational moral story *“Education Counts”*which is an effective way to convey the message about the importance of literacy in an engaging and relatable manner for young minds and the inclusion of a fun filled hopscotch game in the celebration added an element of enjoyment and interaction for the children. Combing learning with play can make the concept of literacy more appealing and memorable for them.
    The day was full of learning , fun and frolic for all the learners.`,
    fullDate: "06 September, 2023",
    d: "06",
    m: "Sep",
    y: "2023",
    link: "/school-events/world-literacy-day-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 8; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-sep-3/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/world-literacy-day-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Krishna Janmashtami Celebrations",
    text: `The learners of the Primary Department of Chinmaya Vidyalaya, New Delhi celebrated Janmashtami with great fervour and gaiety on 6th September 2023.
    <br/><br/>
    The learners were apprised about the life and teachings of Krishna.The students also learnt that the joyous festival symbolises the encouragement of goodwill in order to establish Dharma.
    <br/><br/>
    The little munchkins of classes I-II made peacock feather paper-headgears and decorated cutouts of matkis (pots) with sequins, mirrors and colourful stones. They relished drinking Krishna’s favourite drink, buttermilk. The learners of classes III enjoyed making beautiful Janmasthami cards. The students of classes IV-V transformed the school corridors into a land of joy with their colourful rangolis made with colours, flowers and leaves.
    <br/><br/>
    The little learners of Pre- Primary came in traditional attires and relished parantha with butter. They were shown a tableau that depicted the scene of Janmashtami.
    <br/><br/>
    The involvement of the students in the celebrations was worth applauding and brought devotion, creativity and enjoyment all together.`,
    fullDate: "06 September, 2023",
    d: "06",
    m: "Sep",
    y: "2023",
    link: "/school-events/krishna-janmashtami-celebration-2023/",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 13; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-sep-1/pic${i}.jpg`;
        imgArray.push(imgUrl);
      }

      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-sep-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }
      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/krishna-janmashtami-celebration-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Teacher's Day Celebrations",
    text: `<strong> A good teacher can awaken joy in a student and leave a positive impression that lasts a lifetime.</strong><br/><br/>
On the auspicious occasion of Teachers' Day, the senior students of Chinmaya Vidyalaya, New Delhi, exhibited their deep reverence and admiration for their teachers by bestowing them with special titles that served as a heartfelt tribute to the educators. The Principal of the school, Ms. Archana Soni, expressed her profound gratitude to the teachers. She eloquently highlighted their pivotal role in nurturing and shaping the future of the students. The event was marked by an array of captivating moments with an outstanding dance performance. Additionally, the students lent their voices to a melodious medley of songs, which served as a poignant expression of their gratitude towards their dedicated teachers. The grand finale was a mesmerizing display of dance performances that celebrated the endearing bond between students and teachers .`,
    fullDate: "05 September, 2023",
    d: "05",
    m: "Sep",
    y: "2023",
    link: "/school-events/teachers-day-celebration-2023/",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/11-sep-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }
      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/teachers-day-celebration-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "CLASS VII PRESENTATION-ANUGOONJ...THE ECHO OF NEW INDIA",
    text: `A thought provoking presentation was staged on 2nd September 2023 in Chinmaya Vidyalaya, New Delhi, by the students of class VII. The event beautifully depicted our motherland's history, from its golden era to foreign invasions, colonial rule, and the inspiring journey to modern digital India through poetry, skits, songs, mimes, and dance. It rekindled love for the country, highlighting India's global contributions from concept  of zero to Chandrayaan. Principal Ms. Archana Soni praised it's insight into contemporary issues and stressed parental role modeling in teaching children their responsibilities. The event instilled strong national pride and optimism for our progressive future.`,
    fullDate: "02 September, 2023",
    d: "02",
    m: "Sep",
    y: "2023",
    link: "/school-events/the-echo-of-new-india",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 9; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-sep-2/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/the-echo-of-new-india/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "CLASS VI PRESENTATION - ARANYA RAKSHAK - JADHAV PAYENG",
    text: `<strong>"TEACH YOUR CHILDREN TO LOVE NATURE, AND THE REST WILL HAPPEN ON ITS OWN "</strong><br/><br/>       
    The students of class VI showcased a remarkable presentation to highlight the incredible power and determination of Jadhav Payeng, a popular Padma Shri Awardee, who transformed a barren land into a thriving Malai Forest. Through an informative skit and a mesmerising dance performance, they portrayed Jadhav Payeng's journey from sorrow and depression to becoming a forest crusader. The Principal of the school, Ms Archana Soni, emphasized the importance of holistic development of students and instilled a sense of responsibility towards nature, reminding us that nature nurtures us in return. This event showcased the values of hard work, determination, and patience, inspiring all to make positive changes in our environment.`,
    fullDate: "02 September, 2023",
    d: "02",
    m: "Sep",
    y: "2023",
    link: "/school-events/aranya-rakshak-jadhav-payeng",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 12; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-sep-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/aranya-rakshak-jadhav-payeng/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "CLASS V PRESENTATION - ATULYA BHARAT, AMULYA BHARAT",
    text: `An incredible moment of learning and inspiration unfolded on 1st September 2023 on the grounds of Chinmaya Vidyalaya when the students of class V presented the glorious achievements of India by means of a stage presentation.A scintillating dance drama highlighted the important scientific inventions that India has contributed to the world.The performances kindled love and patriotism for the country when it reminisced about the great inventions of some Indian personalities  because of which space travel and the study of mathematics and surgery is possible today. The Primary Headmistress, Ms Archana Gaur, thanked the gathering for their presence.The Principal of the school, Ms Archana Soni, addressed the gathering with her profound words and praised the efforts of the children.The event promoted a strong sense of national identity and extended an emphatic message of the progressive future of our country.`,
    fullDate: "01 September, 2023",
    d: "01",
    m: "Sep",
    y: "2023",
    link: "/school-events/atulya-bharat-amulya-bharat",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 13; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/20-sep-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/atulya-bharat-amulya-bharat/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "ALUMNI CONNECT SESSION",
    text: `Our journey may have taken us far and wide,but our hearts forever belong to the place where it all began.
    In order to inspire the young minds, Chinmaya Vidyalaya, New Delhi, conducted Alumni Connect Session for classes IX-XII on 22nd August,2023. The session was highly inspiring and enriching for the students. <br/><br/>
    Dr Riddhi Gulati, the CEO of Aesthetics, shared her successful professional journey of hard work and determination. She answered the questions put forth by the students of classes IX-XII and  motivated the students to follow their dreams through consistent efforts and sincere hard work.`,
    fullDate: "22 August, 2023",
    d: "22",
    m: "Aug",
    y: "2023",
    link: "/school-events/alumni-connect-session-2023",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 4; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/21-sep-5/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }

      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/alumni-connect-session-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Puppet show",
    text: `<strong>”When we teach through puppets we give children something to remember the story with.”</strong><br/><br/>
    keeping this in mind the Pre - Primary Department of Chinmaya Vidyalaya, New Delhi organised a ‘Puppet show’ on 22nd august 2023. The facilitator depicted the story ‘Will you be my friend?’ through animal puppets. It aimed at enhancing the learner’s communication and social skills by providing structured opportunities to interact, imagine, and most importantly convey a moral message that “Friends come in all shapes and sizes!. The young learners enjoyed the show eminently.`,
    fullDate: "22 August, 2023",
    d: "22",
    m: "Aug",
    y: "2023",
    link: "/school-events/puppet-show/",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 5; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/5-sep-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }
      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/puppet-show/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Class IV Presentation - Global Climate Awakening",
    text: `The class IV students of Chinmaya Vidyalaya , New Delhi, showcased a stage presentation on 18th August '23  that encapsulated a thought-provoking discussion on raising awareness about protecting the environment, a skit on the human activities that result into depletion of our natural resources,a mesmerizing group song on preserving the environment and a dance that appreciated the beauty of nature and the need to preserve it.
    <br/><br/>
    The Primary Headmistress, Ms Archana Gaur, addressed the gathering and sensitized everyone on the significance of preserving the environment. The Principal of the school, Ms Archana Soni, in her address, thanked the parents and shed light on their role in spreading awareness in children in order to keep the planet green and clean.
    <br/><br/>
    The presentation served as a  catalyst to spread awareness on environmental issues for a brighter and greener future.`,
    fullDate: "18 August, 2023",
    d: "18",
    m: "Aug",
    y: "2023",
    link: "/school-events/class-iv-global-climate-awakening/",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 16; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/24-aug-1/pic${i}.JPG`;
        imgArray.push(imgUrl);
      }
      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/class-iv-global-climate-awakening/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Azadi ka Amrit Mahotsav at Chinmaya Vidyalaya, New Delhi.",
    text: `Honoring the past, embracing the present and envisioning the glorious future for our beloved India, Chinmaya Vidyalaya,New Delhi, celebrated the 77th Independence Day by engaging the students and the parents in a plethora of patriotic activities under the 'Har Ghar Tiranga' initiative.
    <br/><br/>
    The Pre- Primary Department interacted with the parents of the little learners and enlivened the discussion with a quiz on National symbols, famous patriotic  songs, leaders and the National Flag.
    <br/><br/>
   The students of Primary Department enjoyed preparing tri- coloured food items, drawing and colouring activities. The parents and the students sang songs in praise for their beloved nation and preserved their moments of togetherness, love and pride in short videos.
   The Middle and Senior School students posted their selfies with a 'Tiranga' and deepened their connect with the National Flag.`,
    fullDate: "14 August, 2023",
    d: "14",
    m: "Aug",
    y: "2023",
    link: "/school-events/azadi-ka-amrit-mahotsav-2023/",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 17; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/16-aug-2/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }
      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/azadi-ka-amrit-mahotsav-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Independence Day Celebrations",
    text: `<strong>“A nation’s strength ultimately lies in what it can do on its own and not in what it can borrow from others.”</strong>
<br/><br/>
Chinmaya Vidyalaya, New Delhi, celebrated India’s 77th Independence Day with great fervour and enthusiasm. The students of the Senior School presented an assembly that commenced with the hoisting of the National Flag followed by the National Anthem. Captain Ajay Kumar Bahl from Indian Navy, graced the occasion as the Honourable Chief Guest. In his motivational address, he urged the students to value the sacrifices made by the Indian freedom fighters who made us breathe in free India.The students, in their vibrant attires, presented India’s cultural diversity and religious unity in a cultural program.The Principal of the school, Ms Archana Soni, in her invigorating address,laid emphasis on the values of responsibility and unity. The cultural program in the assembly conducted by the Primary Wing witnessed a soulful rendition and an enthralling dance performance by the students. A group of little learners of Pre-Primary Wing came dressed as brave soldiers and freedom fighters and spoke about their famous slogans. Apart from a patriotic song and a dance, the children also enjoyed savouring the ' Tricoloured Foods' <br/><br/>
in their tiffins to experience the taste of India in the colours of India. The celebrations rekindled  patriotism and reminded everyone of their responsibilities as citizens.
<br/><br/>
Chinmaya Vidyalaya, New Delhi, wishes everyone a very Happy Independence Day.`,
    fullDate: "14 August, 2023",
    d: "14",
    m: "Aug",
    y: "2023",
    link: "/school-events/independence-day-celebration-2023/",
    images: (function () {
      let imgArray = [];
      for (let i = 1; i <= 84; i++) {
        let imgUrl = `https://chinmayavvdelhi.ac.in/assets/images/calendar/16-aug-1/pic${i}.jpeg`;
        imgArray.push(imgUrl);
      }
      return imgArray;
    })(),
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/independence-day-celebration-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  //   {
  //     title: "Pujya Guruji's visit to Chinmaya Vidyalaya, New Delhi",
  //     text: `<strong>‘There is no deity superior to the Guru, no gain better than Guru’s grace and no state higher than the meditation on the Guru.'</strong>
  // <br/><br/>
  //     Enlightening the minds of people all over the world with his knowledge, service and innate wisdom, Pujya Guruji Swami Tejomayanandaji, with his deific presence, filled the premises of Chinmaya Vidyalaya, New Delhi, with immense joy and devotion. Fondly called Guruji, Swami Tejomayanandaji was accorded a warm and gracious welcome with a Poorna Kumbh. Swami Prakarshanandaji, Swami Avyayanandaji, Management Committee members, Ms Kalpana Vaswani and Shri Jujhar Singhji, were also given a cordial welcome. A student sang a soulful Marathi hymn in praise of Lord Ganesha. The students chanted Medha Suktam in praise of the benevolent nature of Goddess Medha. It was followed by an interactive session by Guruji wherein he enriched the students with his talk on 6A’s- Aptitude, Aspiration, Ability, Application, Altitude, and Altar of Dedication.<br/><br/>
  //     Guruji interacted with the teachers and in his address, he highlighted the role of a teacher in a student’s life. He motivated the teachers and advised them to take pride in their profession. The teachers chanted ‘Shiv Sankalp Suktam’ in order to foster mental purity and harmony. The Principal of the school, Ms Archana Soni, proposed the vote of thanks and expressed that the students and the staff would look forward to more of his visits for their spiritual enrichment.<br/><br/>
  //     The session culminated with prasad distribution.`,
  //     fullDate: "05 August, 2023",
  //     d: "05",
  //     m: "Aug",
  //     y: "2023",
  //     link: "/school-events/pujya-gurujis-visit-to-chinmaya-vidyalaya/",
  //     images: [
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic1.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic2.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic3.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic4.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic5.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic6.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic7.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic7.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic8.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic9.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic10.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic11.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic12.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic13.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic14.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic15.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic16.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic17.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic18.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic19.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic20.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic21.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic22.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic23.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic24.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic25.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic26.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic27.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic28.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic29.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic30.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic31.JPG",
  //       "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-aug-1/pic32.JPG",
  //     ],
  //     isVideo: false,
  //     shareLink:
  //       "https://chinmayavvdelhi.ac.in/school-events/pujya-gurujis-visit-to-chinmaya-vidyalaya/",
  //     videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  //   },
  {
    title: "Yellow Day Celebrations",
    text: `The 'Yellow Day' was celebrated by the Pre-Primary Department on 31 July 2023. It aimed at helping the little learners recognise the color ' Yellow' . They learnt to relate the colour with the things around them. The craft activity of sponge dabbing on sun was done to develop the fine motor skills of the learners. The learners were dressed up in yellow attires and enjoyed drinking their favourite summer drink frooti.<br/><br/>
    It was a wonderful learning experience for them. They were happy and enjoyed the activity to the fullest.`,
    fullDate: "31 July, 2023",
    d: "31",
    m: "July",
    y: "2023",
    link: "/school-events/yellow-day-celebrations/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-2/pic1.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-2/pic2.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-2/pic3.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-2/pic4.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-2/pic5.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-2/pic6.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-2/pic7.jpeg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/yellow-day-celebrations/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "International Tiger Day",
    text: `<strong>A TIGER IS A SYMBOL OF BEAUTY, BRAVERY, AND STRENGTH. 
    SAVE TIGER, SAVE THE NATION'S PRIDE.</strong><br/><br/>
    The International Tiger Day, was celebrated by the Pre-Primary learners of Chinmaya Vidyalaya, New Delhi on 28th July 2023. The learners were shown a video to explain tiger conservation and did free hand drawing of tiger, a skit on the topic-" Save The Tiger" was performed by the learners to create awareness among the learners about protection and conservation of this beautiful species.The facilitators and learners wore different shades of orange.The enthusiasm of the learners was overwhelming and they also became aware of this noble cause.`,
    fullDate: "28 July, 2023",
    d: "28",
    m: "July",
    y: "2023",
    link: "/school-events/international-tiger-day/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-3/pic11.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/international-tiger-day/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Friendship Day",
    text: `<strong>”FRIENDS ARE THE PEOPLE WHO MAKE YOU SMILE BRIGHTER, LAUGH LOUDER
    AND LIVE BETTER.”</strong><br/><br/>
    Friendship day was celebrated on 26th July 2023 by the pre - primary learners of Chinmaya Vidyalaya, New Delhi. The day is meant to celebrate meaningful relationships formed with our peers. Keeping this in mind our kindergarteners sang the friendship song , created a friendship craft and bought friendship bands to give to their friends. The whole day was aimed at strengthening socio - emotional development,communication, cooperation, sharing and empathy amongst the tiny- tots. The young ones relished quality time spent with peers.`,
    fullDate: "26 July, 2023",
    d: "26",
    m: "July",
    y: "2023",
    link: "/school-events/friendship-day/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic1.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic2.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic3.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic4.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic5.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic6.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic7.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic8.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-aug-1/pic9.jpeg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/friendship-day/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Kargil Vijay Diwas - A Symbol of Pride and Glory",
    text: `Chinmaya Vidyalaya, New Delhi organized a special assembly on Kargil Vijay Diwas to pay tribute to the brave soldiers who fought valiantly during the Kargil War. The assembly showcased an impactful discussion on the essence of Kargil Diwas, a powerful song “Taaqat Watan Ki Hum Mein Hai”, an enactment of the podcast ‘Echoes of Kargil’ and a poem that celebrated the bravery and sacrifices of our patriotic heroes. The students pledged to uphold the integrity and unity of the nation and to stand with the armed forces in times of need. The students of the Primary Department were shown a video presentation highlighting the significance of Kargil Diwas and some important information associated with the day. The students made gratitude cards for soldiers and collages on the diet and healthy food habits of  soldiers. They also made a soldier's tricolor cap.<br/><br/>
    The Principal, Ms Archana Soni, delivered an inspiring talk, wherein she expressed her gratitude and respect for the families of the army personnel. She acknowledged the sacrifices made not only by the soldiers but also by their families.`,
    fullDate: "26 July, 2023",
    d: "26",
    m: "July",
    y: "2023",
    link: "/school-events/kargil-vijay-diwas/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic1.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic2.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic3.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic4.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic5.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic6.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic7.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic8.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic9.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic10.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic11.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic12.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-1/pic13.jpeg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/kargil-vijay-diwas/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Primary Investiture Ceremony 2023-24",
    text: `
    <strong>Leadership is the capacity to transform vision into reality.</strong>
    <br/><br/>
    To inculcate leadership qualities in the students,the Primary Investiture ceremony was conducted at Chinmaya Vidyalaya,New Delhi on 25.7.2023.<br/><br/>
    The newly elected council members were conferred with badges and sashes by the Principal Ms.Archana Soni and Headmistress Ms.Archana Gaur.<br/><br/>
    The council thereafter took an oath to discharge their duties to the best of their abilities.It was a moment of immense pride for the Vidyalaya.`,
    fullDate: "25 July, 2023",
    d: "25",
    m: "July",
    y: "2023",
    link: "/school-events/primary-investiture-ceremony-2023/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic12.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic13.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic14.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic15.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/28-july-2/pic16.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/primary-investiture-ceremony-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Splish - Splash",
    text: `<strong>“We should all do what, in the long run, gives us joy, even if it is only sorting the unsorted”</strong> <br/><br/>

    Keeping this in mind , the tiny tots of the Pre-Primary Department of Chinmaya Vidyalaya , New - Delhi enjoyed participating in the ‘Splish - Splash’ activity on 21st July 2023 . The passionate learners engaged with great zeal and elation in the shape, number and alphabet sorting activity .The learners were encouraged to pick out several letters , numbers and shapes floating on water and drop in an empty tub. The activity aimed at enhancing fine - motor skills, identification, hand-eye coordination and organisational skills. The youngsters relished the activity immensely.`,
    fullDate: "07 July, 2023",
    d: "21",
    m: "July",
    y: "2023",
    link: "/school-events/splish-splash/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-july-1/pic1.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-july-1/pic2.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-july-1/pic3.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-july-1/pic4.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-july-1/pic5.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-july-1/pic6.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-july-1/pic7.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/26-july-1/pic8.jpeg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/splish-splash/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "First Day Fun",
    text: `The Pre-Primary and Primary Department of Chinmaya Vidyalaya, New Delhi, welcomed the students with a plethora of fun- filled activities.
<br/><br/>
    The little learners of Pre-Primary enjoyed online activities like listening stories, singing and tossing the balloon. They enjoyed dancing on the beats of songs.<br/><br/>
    The students of Primary Department showcased their talent in dance, singing and storytelling. They also enjoyed Maze activity that helped them reach their classrooms. The activity on spin the wheel made them share their best memories of holidays.<br/><br/>
    It was a wonderful day where everyone spent beautiful moments of love and togetherness .`,
    fullDate: "07 July, 2023",
    d: "07",
    m: "July",
    y: "2023",
    link: "/school-events/first-day-fun/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic1.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic2.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic3.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic4.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic5.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic6.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic7.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic8.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic9.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic10.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic11.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic12.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic13.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic14.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic15.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic16.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic17.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-2/pic18.jpeg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/first-day-fun/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Green Day Celebration",
    text: `<strong>"Green is a mix of blue and yellow which symbolizes glory and energy.</strong>"<br/><br/>
    Green Day was celebrated with great zeal and enthusiasm by the Pre Primary learners of Chinmaya Vidyalaya, New Delhi on 6th July, 2023. It aimed at helping the little learners recognise the colour and relate it to things around them.  The children and teachers, dressed in green coloured attire, enjoyed talking about Nature and the green objects around them. This was followed by a non fire cooking activity of a healthy green salad to develop their fine motor skills. It was a wonderful learning experience for them. They were happy and enjoyed the activity to the fullest.`,
    fullDate: "06 July, 2023",
    d: "06",
    m: "July",
    y: "2023",
    link: "/school-events/green-day-celebration-2023/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-1/pic1.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-1/pic2.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-1/pic3.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-1/pic4.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-1/pic5.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-1/pic6.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-1/pic7.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/13-july-1/pic8.jpeg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/green-day-celebration-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Guru Purnima Celebrations",
    text: `Paying homage to the revered Gurus on the occasion of Guru Purnima, Chinmaya Vidyalaya, New Delhi, enlightened the students about the importance of Guru Purnima and the role of gurus in shaping their lives. 
    The celebrations commenced with a talk wherein the significance of Guru Purnima in our culture and the value of expressing gratitude to our gurus was explained. <br/><br/>
    Ms. Archana Soni, the Principal of the school, enlightened the students about the significance of respecting gurus and having faith in them. <br/><br/>
    The celebrations proceeded with a solemn worship ceremony, known as the Paduka Puja, to honor all the gurus. Towards the culmination of the celebrations, 108 names of Pujya Gurudev Swami Chinmayanandaji were chanted as a medium to connect with his teachings and seek his blessings. The celebrations helped students gain a deeper understanding of their cultural heritage. The students learned the importance of showing respect and expressing gratitude to their gurus for their invaluable guidance and support.`,
    fullDate: "03 July, 2023",
    d: "03",
    m: "July",
    y: "2023",
    link: "/school-events/guru-purnima-celebrations-2023/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic10.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic11.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic12.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic13.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic14.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic15.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic16.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic17.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic18.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic19.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic20.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic21.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic22.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic23.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic24.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic25.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic26.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-july-2023/pic27.jpeg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/guru-purnima-celebrations-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "FIRST AID AND BLS WORKSHOP",
    text: `In order to enhance awareness amongst the staff members with regard to the first aid measures to be taken in critical situations, Chinmaya Vidyalaya, New Delhi,conducted an informative workshop on 30th June 2023. The staff was shown a demonstration on the appropriate ways by which an accidental electric shock can be handled. It was followed by a short demonstration on the remedial measures for the problem of choking among children.A step by step and detailed demonstration on administering CPR and artificial breathing was also shared.`,
    fullDate: "30 June, 2023",
    d: "30",
    m: "June",
    y: "2023",
    link: "/school-events/first-aid-and-bls-workshop/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-2/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-2/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-2/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-2/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-2/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-2/pic6.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/first-aid-and-bls-workshop/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Workshop on POCSO and POSH",
    text: `Chinmaya Vidyalaya, New Delhi, conducted an informative workshop on POCSO and POSH Acts that enlightened the staff about the criticality of child safety and equipping them with effective strategies to address it. <br/><br/>
    The workshop provided valuable insights on different forms of child sexual harassment, elucidating the corresponding punishments under IPC Acts. In addition to it, the importance of monitoring sudden changes in a child's behavior, academic performance, and class participation as potential indicators of alarming situations was emphasized.<br/><br/>
    The session also shed light on the POSH Act of 2013, its objective of prevention, protection, and redressal and the concept of Quid Pro Quo. The workshop concluded with an engaging interactive questionnaire that was based on real-life case histories. This allowed the participants to apply their newfound knowledge and understanding of the POCSO and POSH Acts to practical scenarios. The questionnaire provided an opportunity to the staff to discuss and analyse different approaches to handling child sexual abuse and gender safety issues.<br/><br/>
    The Principal, Ms. Archana Soni, underscored the role of these codes in promoting a safe and respectful atmosphere that supports the well-being and professional growth of all staff members.`,
    fullDate: "30 June, 2023",
    d: "30",
    m: "June",
    y: "2023",
    link: "/school-events/workshop-on-pocso-and-posh/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/17-july-1/pic11.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/workshop-on-pocso-and-posh/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Father's Day Celebrations",
    text: `<strong>"When you need real understanding, when you need someone to care, when you need someone to guide you ... A father is always there."</strong><br/><br/>

    The learners of Pre-Primary and Primary Department of Chinmaya Vidyalaya, New Delhi, celebrated Father's Day in order to make their doting fathers feel special. The little learners paid respect and expressed gratitude towards their fathers in a spectacular way on 18th June. The tiny tots, with the help of their mothers, made a beautiful craft and yummy Oreo shake with ice cream as a gift for their beloved fathers.
    The students of classes I and II made beautiful cards and wrote a short note of gratitude inside them. The goodie bags made by classes III to V students contained a few of their father's favourite eatable things. The students made their daddies feel special.`,
    fullDate: "18 June, 2023",
    d: "18",
    m: "June",
    y: "2023",
    link: "/school-events/fathers-day-celebration-2023/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic1.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic2.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic3.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic4.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic5.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic6.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic7.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic8.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic9.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic10.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic11.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic12.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic13.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic14.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic15.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic16.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic17.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic18.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic19.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic20.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic21.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic22.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic23.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic24.jpeg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-3/pic25.jpeg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/fathers-day-celebration-2023/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Workshop on 'Reflections on School Practices in alignment with NEP 2020'",
    text: `With an aim to reflect on the school practices and examine their alignment with National Education Policy 2020, Chinmaya Vidyalaya, New Delhi, conducted a professional development program for its staff members on 31st May 2023. Ms. Kalpana Kapoor, an eminent leadership coach and a mentor opened the day long session throwing light on the National Education Policy and the paradigm shift in education. <br/>

    She talked about the key principles of NEP 2020 and emphasized upon the importance of curriculum that must focus on the academic knowledge of the learners and also develop their skills, abilities and values for lifelong learning. She also shared the objectives to foster global citizenship and ultimately achieve sustainable development goals.  <br/>
    
    Her inputs on pedagogies aimed at empowering teachers to adopt varied innovative teaching and learning approaches catering to the diverse needs of the learners, emphasizing on Competency based learning over rote learning and creating a conducive environment for joyful learning.
    <br/>
    The resource person also shared information about ‘SQAAF’- School Quality Assessment & Assurance Framework explaining about its seven domains. 
    <br/>
    The staff of the Vidyalaya understood the key principles of NEP 2020 and explored the methodologies to make classes more relevant for the learners.`,
    fullDate: "31 May, 2023",
    d: "31",
    m: "May",
    y: "2023",
    link: "/school-events/workshop-on-reflections-on-school-practices-in-alignment-with-nep-2020/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic12.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic13.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic14.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic15.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic16.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic17.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/workshop-on-reflections-on-school-practices-in-alignment-with-nep-2020/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Workshop on 'Reflections on School Practices in alignment with NEP 2020'",
    text: `With an aim to reflect on the school practices and examine their alignment with National Education Policy 2020, Chinmaya Vidyalaya, New Delhi, conducted a professional development program for its staff members on 31st May 2023. Ms. Kalpana Kapoor, an eminent leadership coach and a mentor opened the day long session throwing light on the National Education Policy and the paradigm shift in education. <br/>

    She talked about the key principles of NEP 2020 and emphasized upon the importance of curriculum that must focus on the academic knowledge of the learners and also develop their skills, abilities and values for lifelong learning. She also shared the objectives to foster global citizenship and ultimately achieve sustainable development goals.  <br/>
    
    Her inputs on pedagogies aimed at empowering teachers to adopt varied innovative teaching and learning approaches catering to the diverse needs of the learners, emphasizing on Competency based learning over rote learning and creating a conducive environment for joyful learning.
    <br/>
    The resource person also shared information about ‘SQAAF’- School Quality Assessment & Assurance Framework explaining about its seven domains. 
    <br/>
    The staff of the Vidyalaya understood the key principles of NEP 2020 and explored the methodologies to make classes more relevant for the learners.`,
    fullDate: "31 May, 2023",
    d: "31",
    m: "May",
    y: "2023",
    link: "/school-events/workshop-on-reflections-on-school-practices-in-alignment-with-nep-2020/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic12.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic13.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic14.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic15.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic16.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/19-june-2/pic17.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/workshop-on-reflections-on-school-practices-in-alignment-with-nep-2020/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "CLASS IX - COUNTING STEPS TOWARDS NET ZERO",
    text: `As part of the G20 endeavors to keep the checks and balances on environmental degradation and restoration, the students of Class IX, showcased a Class Presentation on the topic – ‘Counting Steps towards Net Zero’. The presentation commenced with a Welcome Song in Garhwal dialect signifying the importance of trees. The thought-provoking skit depicting the Flash Flood and Cloudbursts caused due to ecological imbalance (i.e. rapid melting of ice and snow on mountains) in Kedarnath was the highlight of the show. The show was concluded with a practical solution of ‘counting your carbon emission steps’ i.e., Carbon Foot printing.  The parents were able to imbibe the fact that we must apply our theoretical information to practical life`,
    fullDate: "30 May, 2023",
    d: "30",
    m: "May",
    y: "2023",
    link: "/school-events/counting-steps-towards-net-zero/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic01.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic02.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic03.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic04.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic05.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic06.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic07.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic08.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic09.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic12.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic13.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic14.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic15.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic16.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic17.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic18.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic19.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-2/pic20.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/counting-steps-towards-net-zero/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "CLASS XI PRESENTATION: LIVING ONENESS",
    text: `To raise awareness regarding the association between humans and the natural world, the class XI of Chinmaya Vidyalaya, New Delhi, showcased a Class Presentation on the theme – Living Oneness, depicting the importance to thrive in harmony with humans and nature. The presentation commenced with the Ganesh Vandana and it was followed by the Welcome Song – ‘Vasudhaiva Kutumbakam’ (World is one Family). The Dance performance on  ‘Vishwa Shanti’ depicted the destruction of evil forces and collation with good forces. The students presented a  ‘Global Trade’ Conference wherein they played the role of representatives of different countries discussing the trade restrictions and barriers faced by countries and solutions to them. The show concluded with the Food Stalls under the project ‘Learn to Earn – Learning Entrepreneurship to Live ’ that served various delicacies from across the world. The money earned from the stalls was donated for the contribution of underprivileged children.`,
    fullDate: "30 May, 2023",
    d: "30",
    m: "May",
    y: "2023",
    link: "/school-events/living-oneness/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic01.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic02.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic03.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic04.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic05.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic06.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic07.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic08.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic09.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic12.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic13.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic14.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic15.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic16.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic17.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic18.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic19.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic20.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic21.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic22.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic23.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic24.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic25.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/8-june-1/pic26.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/living-oneness/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "CLASS XII PRESENTATION: KARTAVYA PATH",
    text: `To encourage the students to proactively explore their the 'Path of Duty' by engaging themselves in constructive activities with focus on ethical values and principles, the Class XII of Chinmaya Vidyalaya,New Delhi, showcased a Class Presentation on the topic – ‘Kartavya Path – Path of Duty’. The presentation commenced with a dance on Saraswati Vandana.  A skit portraying Modern Krishna guiding teenager Arjuna about the ways to deal with  the issues caused by peer pressure, social media influence and drug abuse enriched everyone with the principles  that resonate with our inner calling – our Dharma. A rap performance elucidating the distractions as a barrier faced by teenagers while staying on the right path left  was greatly appreciated by the audience. The parents were able to appreciate the fact that teenagers are faced with a variety of social, physical and psychological problems in life and it's their duty to support their child during hardships.`,
    fullDate: "30 May, 2023",
    d: "30",
    m: "May",
    y: "2023",
    link: "/school-events/kartavyapath/",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic01.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic02.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic03.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic04.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic05.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic06.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic07.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic08.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic09.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic12.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic13.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic14.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic15.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic16.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic17.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic18.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic19.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic20.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic21.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic22.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic23.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic24.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic25.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic26.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic27.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic28.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic29.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/7-june-1/pic30.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/kartavyapath/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Mock Fire Drill- A step towards Safety",
    text: `<strong>Safety starts with awareness and awareness starts with you</strong>
    <br/><br/>
    In order to familiarize and reinforce the proper evacuation routes and practices to its staff and
    students, Chinmaya Vidyalaya, New Delhi, organised a Mock Fire Drill on 2nd May 2023.<br/><br/>
    The drill commenced with a fire alarm that made the building occupants evacuate their classrooms
    and assemble in the football field as instructed in the evacuation plan. The gathering of the staff and
    the students was briefed by the District Fire Officer and the station officers. They endeavoured to
    create awareness among the students about firefighting techniques and the ways to respond swiftly
    in times of such emergency situations.`,
    fullDate: "02 May, 2023",
    d: "02",
    m: "May",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-2/pic1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-2/pic2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-2/pic3.jpg",
    ],
    isVideo: false,
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Presentation by Class-X",
    text: `<strong>Education brings Oneness.</strong>
    <br/><br/>
    To commemorate India&#39;s Presidency of G20 summit and to bring it closer to
    the students, staff and public at large, the students of class 10th
    presented a mesmerising and inspiring Class Presentation on 29th April
    2023. The show that comprised of a song, dance and a skit, eugolised the
    theme- Vasudhaiva Kutumbhkum - One Earth One Family One Future.<br/>
    The scintillating performance of the students skillfully portrayed and
    honoured the contributions of activists such as Jyotiba Phule, Savitribai
    Phule and Malala who advocated the cause of parity in Education, that is,
    education for women. The skit reverberated the idea that ultimately the
    goal of oneness in education is to create a more peaceful and harmonius
    world, where communities can work together to build a brighter future for
    all as one family.<br/>
    The presentation unfolded the true potential of every child and opened
    new vistas of learning important life skills for them.`,
    fullDate: "29 April, 2023",
    d: "29",
    m: "Apr",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/22-may-1/pic11.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Orientation Session (2023-24)",
    text: `<strong>A fresh start. A new chapter in life waiting to be written. New aspirations are
    to be embraced and new milestones are to be set.</strong><br/><br/>
    Chinmaya Vidyalaya, New Delhi, organised the Orientation Session 2023- 24 to
celebrate the beginning of the new academic year with new members.<br/><br/>
They were welcomed with a beautiful song and dance. An informative session on
Parenting was conducted by the Chief Guest Ms.Rita Kaul, who is a renowned
educationist and psychologist. There was a session on value based learning
followed in the Vidyalaya. The parents were also apprised about the powerful
philosophy of Pujya Gurudev Swami Chinmayanandaji. The event familiarized the
parents with the ethos of the school.`,
    fullDate: "05 April, 2023",
    d: "05",
    m: "Apr",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/01-Orientation-Session-(2023-24).JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-Orientation-Session-(2023-24).JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-Orientation-Session-(2023-24).JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-Orientation-Session-(2023-24).JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-Orientation-Session-(2023-24).JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-Orientation-Session-(2023-24).JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/07-Orientation-Session-(2023-24).JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/08-Orientation-Session-(2023-24).JPG",
    ],

    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Annual Prize Distribution",
    text: `<strong>True awakening takes place within and knowing yourself is the best
    enlightenment.</strong>
    Chinmaya Vidyalaya, New Delhi, organized its Annual Prize Distribution
    Ceremony 2022 &#39;Anubhooti&#39; on 18th March 2023.<br/><br/>
    The scintillating evening began with the genial welcome of the members of PTA
    Executive Committee who graced the occasion with their presence. It was followed
    by a soulful musical performance infused with the promises and aspirations of
    young minds. A group of dynamic dancers performed Gotipua Dance, a traditional
    dance of Odisha. The Principal of the school, Ms Archana Soni welcomed the
    gathering and appreciated the innovation brought in the Swagatam Dance. The
    teachers who completed their 25 and 15 years with the Vidyalaya and the
    meritorious students from IX to XII were felicitated with certificates and awards.
    The colorful cultural extravaganza culminated with a dance ballet that filled
    everyone with a great sense of hope and positivity. The event was a perfect
    platform to recognize the hard work of the meritorious students and hone the innate
    talent of the students.`,
    fullDate: "18 March, 2023",
    d: "18",
    m: "Mar",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/01-Annual-Prize-Distribution-Ceremony.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/02-Annual-Prize-Distribution-Ceremony.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/03-Annual-Prize-Distribution-Ceremony.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/04-Annual-Prize-Distribution-Ceremony.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/05-Annual-Prize-Distribution-Ceremony.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/06-Annual-Prize-Distribution-Ceremony.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/07-Annual-Prize-Distribution-Ceremony.JPG",
    ],

    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Class I Presentation: Spring- A New Beginning",
    text: `The students of class I enjoyed every moment of their presentation on the theme
    &#39;Spring- A new beginning&#39; on 14th March 2023. The little learners began with a
    melodious song ‘Nanhe Munhe pyare’ and mesmerized everyone with their
    actions and expressions. The yoga poses, silent meditation and guided relaxation
    showcased by them helped them in gaining awareness and mindfulness of their
    breath and body.<br/>
    The parents appreciated the talent and skills revealed in each performance. The
    dance on “Rut aa gyi re&#39; made everyone tap their feet.`,
    fullDate: "14 March, 2023",
    d: "14",
    m: "Mar",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-1/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-1/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-1/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-1/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-1/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-1/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-1/pic7.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Presentation by Class-2",
    text: `Life is a kaleidoscope of colours:<br/>
    Intricate…<br/>
    Unexpected…<br/>
    Beautiful!<br/>
    <br/>
    The students of Class II of Chinmaya Vidyalaya, New Delhi hosted their Class
    Presentation ‘Kaleidoscope’ on 23rd February 2023. The programme, an ode to the
    vibrant colors that bring happiness, hope, positivity and joy to our lives, was an
    enchanting amalgamation of heart-warming performances such as song, dance,
    drama, chanting and yoga.
    <br/>
    The enthusiastic children performed with unprecedented enthusiasm and enthralled
    everyone with their scintillating dance performances and beautiful renditions. The
    Principal Ms. Archana Soni appreciated the students for their unique presentations
    and applauded them for their commendable efforts.`,
    fullDate: "23 Feb, 2023",
    d: "23",
    m: "Feb",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/11-may-2/pic9.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Presentation by Class 3: A Journey Through India.",
    text: `The class III students of Chinmaya Vidyalaya, New Delhi showcased a
    Presentation on 10th of February,2023 with great zeal and enthusiasm. The
    students took the audience to a journey through various Indian states by presenting
    their tableaus and dance performances. The Grand Finale brought all students
    together on one stage showcasing the Unity in Diversity which left the audience
    spellbound. It was indeed a visual treat for everyone.`,
    fullDate: "10 Feb, 2023",
    d: "10",
    m: "Feb",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/4-may-1/pic12.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Presentation by Class-V: Manikarnika",
    text: `The class V students of Chinmaya Vidyalaya, New Delhi, showcased the inspiring
    journey of the Queen of Jhansi from Manu to Manikarnika by means of a stage
    presentation on 10th February, 2023.<br/>
    Shri P K Mehta, President of Society for Happiness, Shri JK Mehta, President of
    Society for Happiness, Ms.Kajal Kapoor, General Secretary, Society for Happiness
    and Shri Vijay Narayan Pandey, Former Chairman- Jharkhand State Electricity
    Board graced the occasion as eminent guests.<br/>
    The group song &#39; Khoob Ladi Mardani&#39; infused everyone with valour and a Yoga
    Presentation depicting how the Queen strengthened her troops physically, enriched
    the students with information on her life. A Dance Drama on the journey of the
    Queen from Manu to Manikarnika mesmerized everyone.<br/>
    It was a moment of immense pleasure and pride for the school to receive &#39;
    Happiness Award&#39; from the team of Society for Happiness. The Principal, Ms
    Archana Soni, addressed the parents with her profound words.<br/>
    The event provided a deep insight on the life, struggles and bravery of the Queen
    of Jhansi.`,
    fullDate: "10 Feb, 2023",
    d: "10",
    m: "Feb",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-2/pic12.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Presentation by Class-IV : Panchtatva",
    text: `Everyone has talent, it&#39;s just a matter of moving around until you&#39;ve discovered
    what it is.<br/><br/>
    To unleash the inherent talent of the learners in myriad ways, the class IV students
    of Chinmaya Vidyalaya, New Delhi presented a mélange of thoughts, ideas and
    expressions by means of a stage presentation on 2nd February,2023.A beautiful
    winter morning unfolded into an assortment of melodious songs, dance ,skit and
    poetry celebrating nature and its five elements. The highlight of the programme
    was the demonstration of the Yogic Five Mudras and the Ayurveda stall which
    provided deep insight on how to maintain balance of the Five elements in our
    body. The event was not only enjoyable, but also extremely informative. It was
    immensely lauded by the parents.`,
    fullDate: "02 Feb, 2023",
    d: "02",
    m: "Feb",
    y: "2023",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic1.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic2.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic3.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic4.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic5.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic6.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic7.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic8.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic9.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/calendar/3-may-1/pic11.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "CLASS X PRESENTATION",
    text: `Class X worked together as a team and presented a melange of thoughts, ideas, and expression (dance and music performance, skit) in their Class Presentation held on 30th September 2022 wherein parents were invited to witness the efforts of their wards.<br/><br/>
    The theme of the programme - Women Empowerment was brought out through the skit “Samar Shesh Hai”. The skit delivered the strong message that empowering women is essential to the health and social development of the families, communities and countries.
    <br/><br/>
    Visual Art and ATL work display were also much appreciated by the parents.`,
    fullDate: "03 October, 2022",
    d: "03",
    m: "Oct",
    y: "2022",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/01.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/02.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/03.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/04.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/05.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/06.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/07.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/08.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/09.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/10.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/11.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/12.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/13.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/14.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/15.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/16.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/17.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/class-x-presentation/18.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "GANDHI JAYANTI CELEBRATIONS",
    text: `Guided by this inspiring quote, Chinmaya Vidyalaya, New Delhi, celebrated the birth anniversary of the Father of the Nation- Mohandas Karamchand Gandhi by conducting a special assembly and a few activities that enlightened the students with his teachings.
<br/><br/>
    The students of Class VIII organised a special assembly wherein they enacted the famous quotes of Mahatma Gandhi and presented their practical application in real life situations. The soulful Bhajan 'Vaishnav Janato' infused all with deep respect for Mahatma Gandhi who always preached non-violence and love for all beings. The Pre-Primary Department imbibed the spirit of cleanliness by organizing Swachh Bharat Campaign wherein they cleaned their classrooms and playground with the help of their teachers. It was followed by a free hand drawing and a bhajan. A follow-up activity was also given to them in which they cleaned their study tables at home and organised their play area. The Primary students enjoyed singing the bhajan 'Raghupati Raghav RajaRam'. The assembly culminated with the enactment of Dandi March in which a group of students led by Gandhiji visited the corridors and classrooms to spread the teachings of Mahatma Gandhi.`,
    fullDate: "02 October, 2022",
    d: "02",
    m: "Oct",
    y: "2022",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/gandhi-jayanti/01.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/gandhi-jayanti/02.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/gandhi-jayanti/03.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/gandhi-jayanti/04.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/gandhi-jayanti/05.JPG",
      "https://chinmayavvdelhi.ac.in/assets/images/gandhi-jayanti/06.JPG",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "VEDIC MATHEMATICS WORKSHOP",
    text: `Chinmaya Vidyalaya, New Delhi, in association with Pratham Institute, organised an enriching Vedic Mathematics Workshop for the students of classes VI-VIII. The workshop aimed at sharing the secrets of Vedic Maths for easier mathematical calculations. The session highlighted the importance of Vedic Maths in Indian Culture and introduced it as an effective way of making quicker calculations in real life. The workshop motivated the students to incorporate the intellectual excellence of our rich ancient culture to make lives comfortable.`,
    fullDate: "20 September, 2022",
    d: "20",
    m: "Sep",
    y: "2022",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/Maths-Workshop1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/Maths-Workshop2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/Maths-Workshop3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/Maths-Workshop4.jpg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "NATIONAL SPORTS DAY 2022",
    text: `Chinmaya Vidyalaya, New Delhi celebrated National Sports Day on 29th August 2022 with zest and zeal. The day was observed to encourage the students to enthusiastically participate in sports and games. The Pre- primary students were shown a digital presentation on the importance of sports followed by their active engagement in fun-filled games. The students of Primary Department performed a set of physical exercises and aerobics that took them a step forward towards their physical fitness. An informative presentation and slogans on sports enlightened them about various types of sports and famous sports personalities.
    <br/><br/>
    The students of the Senior Department organised a special assembly to celebrate the spirit of sportsmanship. They energetically participated in head-to-toe physical exercises.
    <br/><br/>
    The celebrations of the day motivated the students to work relentlessly towards physical and mental fitness and agility.`,
    fullDate: "29 August, 2022",
    d: "29",
    m: "Aug",
    y: "2022",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/sports-day/sports-day-2022-1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/sports-day/sports-day-2022-2.jpg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Tablet Distribution Programme For EWS Students August 2022",
    text: `To facilitate hybrid education, Chinmaya Mission distributed tablets to about 109 students of the Primary Department of Chinmaya Vidyalaya from the economically weaker section. The Director of Education, GNCT of Delhi, Shri Himanshu Gupta kindly consented to grace the event as the chief guest. In his address, he stated that a delicate balance should be maintained between online and offline education and gadgets should be used to enhance the Teaching-Learning process. He also emphasized on aligning the mind and body to derive the most out of life. The Guest of Honour- Deputy Director of Education, GNCT of Delhi, Dr Sanjay Chaturvedi and distinguished guest- Deputy Director of Education, GNCT of Delhi, Shri Sushil Kumar also graced the occasion. Trustee, Delhi Chinmaya Sewa Trust and a member of Chinmaya Vidyalaya Managing Committee, Shri Jujhar Singh, the Manager, Ms. Shibani Khorana and the Principal, Ms Archana Soni were also present for the programme. The eminent guests motivated the audience to follow their dreams based on the real essence of education, which is, value creation.`,
    fullDate: "23 August, 2022",
    d: "23",
    m: "Aug",
    y: "2022",
    images: [
      "https://chinmayavvdelhi.ac.in/assets/images/ews/table-aug-2022-img1.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/ews/table-aug-2022-img2.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/ews/table-aug-2022-img3.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/ews/table-aug-2022-img4.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/ews/table-aug-2022-img5.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/ews/table-aug-2022-img6.jpg",
      "https://chinmayavvdelhi.ac.in/assets/images/ews/table-aug-2022-img7.jpg",
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "25th Inter School Geeta Chanting Competition",
    text: "The 25th Inter School Geeta Chanting Competition was held online by Chinmaya Vidyalaya, New Delhi from 22nd – 24th December 2021.The three-day event witnessed an overwhelming participation of 412 students from 40 schools across Delhi and NCR from classes Nursery- X. They enthusiastically chanted the verses from Chapter 2 - Sankhya Yog that condenses the teachings of the entire Bhagwad Geeta.<br>The three day ceremonious event culminated with the Felicitation Ceremony held on 28th December 2021, announcing the results. The overall trophy was won by Chinmaya Vidyalaya, New Delhi. Being the host school, the trophy was handed over to Amity International School, Noida, which stood second.<br>Such events make life a celebration and ensure a perennial flow of absolute and imperishable knowledge.",
    fullDate: "29 December, 2021",
    d: "29",
    m: "Dec",
    y: "2021",
    images: [dec_29_21_1, dec_29_21_2, dec_29_21_3, dec_29_21_4, dec_29_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Christmas Celebration - Pre Primary",
    text: "Christmas is a festival of joy, sharing and giving. To spread this message amongst one and all, the students of Pre-Primary Department celebrated  Christmas on virtual mode on Friday, 24.12.2021.<br>The students dressed in red and white with santa caps joined the session.<br>To teach the real meaning of ‘CHRISTMAS”,the students were shown stories on “Birth Of Jesus” and “Santa Claus”. A student sung a christmas carol that brought the spirit and gaiety of Christmas alive. It was followed by a foot tapping dance number that filled the hearts of children with cheer and joy.<br>The celebrations ended with a virtual tour to Delhi’s famous churches.<br>All in all, it was a fun- filled session for all.",
    fullDate: "25 December, 2021",
    d: "25",
    m: "Dec",
    y: "2021",
    images: [dec_25_21_2_1, dec_25_21_2_2, dec_25_21_2_3, dec_25_21_2_4, dec_25_21_2_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Christmas Celebration - Primary",
    text: "*Christmas is the tenderness of the past, courage for the present and hope for the future.* <br>The students of the Primary Department of Chinmaya Vidyalaya, New Delhi, celebrated the festival of Christmas virtually on 24.12.21. The assembly began with the significance of the festival and it was followed by a story that taught the history of the festival. A Christmas Carol enlivened the session and made everyone sing along. A student played a Carol on piano and a dance performance made all the students tap their feet.<br>All in all, it was an interactive, informative and joyful session.",
    fullDate: "25 December, 2021",
    d: "25",
    m: "Dec",
    y: "2021",
    images: [dec_25_21_1, dec_25_21_2, dec_25_21_3, dec_25_21_4, dec_25_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Show and Tell Activity - Nursery",
    text: "Show and Tell activity around Community Helpers theme is both fun and an opportunity to learn about the different helpers. The Pre – Primary Department of Chinmaya Vidyalaya, New Delhi conducted a Show and Tell activity on the theme ‘Community Helpers’. The little ones came dressed up in costumes and enacted their favorite community helper. The activity helped the kids use their creativity and imagination. It also strengthened their communication skills.",
    fullDate: "24 December, 2021",
    d: "24",
    m: "Dec",
    y: "2021",
    images: [dec_24_21_2_1, dec_24_21_2_2, dec_24_21_2_3, dec_24_21_2_4, dec_24_21_2_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "National Mathematics Day",
    text: "Chinmaya Vidyalaya observed National Mathematics Day on Wednesday, 21st December , to commemorate the birth anniversary of Mathematics genius Sir Srinivas Ramanujan.<br>Classes IX, X and XI put up the show through PPT presentation on the given topics.",
    fullDate: "24 December, 2021",
    d: "24",
    m: "Dec",
    y: "2021",
    images: [dec_24_21_1, dec_24_21_2, dec_24_21_3, dec_24_21_4, dec_24_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Geeta Jayanti and Tapovan Jayanti Celebrations",
    text: "To mark the origin of the holy book 'Bhagavad Geeta', Chinmaya Vidyalaya, New Delhi, celebrated Geeta Jayanti by conducting online special assembly from Classes I to XII. On this day, Tapovan Jayanti was also observed to commemorate the life and teachings of the great sage Tapovan Maharaj, the 'Guru' of Swami Chinmayanandaji.<br>On this day Lord Krishna gave discourse to Arjuna on how to face the challenges of life and perform one's duties with love and affection.<br>The assembly aimed at highlighting the relevance of the teachings of the holy scriptures in the present scenario.",
    fullDate: "16 December, 2021",
    d: "16",
    m: "Dec",
    y: "2021",
    images: [dec_16_21_1, dec_16_21_2, dec_16_21_3, dec_16_21_4, dec_16_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "EXCURSION OF FIRE STATION",
    text: "Chinmaya Vidyalaya, New Delhi organized a virtual tour to a Fire Station for the learners of class Nursery and Prep on 10th December 2021. The little ones were amazed to see the Fire Station virtually. They were enthralled to see a fire truck and the tools used by firemen. Everyone thoroughly enjoyed the excursion. Our little learners were also briefed on wearing a mask and sanitizing their hands. They were also told not to talk to strangers. The session ended with a craft activity which the kids enjoyed a lot.",
    fullDate: "11 December, 2021",
    d: "11",
    m: "Dec",
    y: "2021",
    images: [dec_11_21_1, dec_11_21_2, dec_11_21_3, dec_11_21_4, dec_11_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "The Beauty Of Art",
    text: "I H Art Competition Class I<br>The Beauty Of Art<br>To explore the creative potential of Class I learners, an Inter-House Art Competition was conducted by Chinmaya Vidyalaya, New Delhi on 7th December 2021. The learners showcased their talent by using different types of printing impressions like cotton dabbing, vegetable and ear bud printing to make a beautiful scenery. They participated whole heartedly in the event which brought forth amazing results for everyone to see.",
    fullDate: "09 December, 2021",
    d: "09",
    m: "Dec",
    y: "2021",
    images: [dec_09_21_1, dec_09_21_2, dec_09_21_3, dec_09_21_4, dec_09_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Sewa Session - Pitr Yagna",
    text: "In its pursuit to inculcate the  value of Sewa among the students,the Primary Department of Chinmaya Vidyalaya ,New Delhi conducted a session  to  apprise them about Pitr Yagna and the activity associated with it. <br>Pitr Yagna is a form of sewa which is rendered towards our ancestors .The students pledged to take care of their parents and grandparents and perform good deeds as taught to them by their ancestors.",
    fullDate: "07 December, 2021",
    d: "07",
    m: "Dec",
    y: "2021",
    images: [dec_07_21_1, dec_07_21_2, dec_07_21_3, dec_07_21_4, dec_07_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Fit With Every Sip",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi organized an online session on “Hot Soup Activity” on 3rd December 2021 for the little learners under the supervision of their parents. The learners were apprised with all the material required for the soup- hot water, soup sachet, soup bowl, mat, apron etc. The learners were instructed by the facilitator about how to make the soup by mixing the soup sachet in hot water and stirring it for a minute. The soup was relished by the learners with their peers. The learners were made aware of the benefits of soup. The activity also helped in developing fine motor skills, eye-hand coordination,  following instructions and understanding safety rules.",
    fullDate: "04 December, 2021",
    d: "04",
    m: "Dec",
    y: "2021",
    images: [dec_04_21_1, dec_04_21_2, dec_04_21_3, dec_04_21_4, dec_04_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "National Pollution Prevention Day",
    text: "To sensitize students about the alarming increase in air pollution,the Primary wing of Chinmaya Vidyalaya New Delhi observed National Pollution Prevention Day on 2nd December 2021.This day holds special significance as it is observed in remembrance of all the people who lost their lives in the Bhopal Gas tragedy in 1984. Ways of preventing pollution and improving the environment were discussed with the learners to create awareness among them. They also participated in  activities such as plant a sapling,  paper bag making and creating a green corner with indoor plants.",
    fullDate: "03 December, 2021",
    d: "03",
    m: "Dec",
    y: "2021",
    images: [dec_03_21_1, dec_03_21_2, dec_03_21_3, dec_03_21_4, dec_03_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "FUN WITH NUMBERS",
    text: "To give hands-on experience to the little learners , the teachers of Pre- Primary organized an online session 'Fun with Numbers' on 29th November 2021. The activity aimed at identification, recognition and recapitulation of numbers and pre-number concepts to enlighten them with the different Math activites.",
    fullDate: "30 November, 2021",
    d: "30",
    m: "Nov",
    y: "2021",
    images: [nov_30_21_1, nov_30_21_2, nov_30_21_3, nov_30_21_4, nov_30_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Samvidhan Diwas",
    text: "Constitution Day also known as ‘Samvidhan Divas’, is celebrated in our country on 26 November every year to commemorate the adoption of the constitution of India. The students of Pre- Primary Department of Chinmaya Vidyalaya, New Delhi celebrated Indian Constitution Day on 26.11.2021 on virtual mode. The students were taught about Indian constitution, meaning and importance of rules and laws through various stories, poems and songs. Overall,it was an enriching session for all.",
    fullDate: "26 November, 2021",
    d: "26",
    m: "Nov",
    y: "2021",
    images: [nov_26_21_1, nov_26_21_2, nov_26_21_3, nov_26_21_4, nov_26_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Body Safety Rules",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi organised an online session the little ones to explain them about the safety rules and safe circle. It was conducted to make them aware about how to keep themselves safe. The students understood the concept with the help of  pictures and a PowerPoint Presentation that was shown to them. It was followed by a few examples of good touch and bad touch which gave them a better clarity on the concept. A few questions were asked from the students at the end of the session for recapitulation of the concept.",
    fullDate: "25 November, 2021",
    d: "25",
    m: "Nov",
    y: "2021",
    images: [nov_25_21_1, nov_25_21_2, nov_25_21_3, nov_25_21_4, nov_25_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Shape-O-Mania",
    text: "Learning shapes not only helps children identify and organize visual information, it also helps them learn skills in other curriculum areas. The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi organised an activity on shapes for the little learners wherein they were dressed in their favourite shapes and spoke a few lines on it. It helped in boosting their confidence and improved their oral skills.",
    fullDate: "24 November, 2021",
    d: "24",
    m: "Nov",
    y: "2021",
    images: [nov_24_21_1, nov_24_21_2, nov_24_21_3, nov_24_21_4, nov_24_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Guru Nanak Jayanti",
    text: "Guru Nanak Jayanti is celebrated to mark the birth of Guru Nanak Dev ji. It is celebrated with great zeal in India. The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi celebrated Gurpurab on 18.11.2021 on virtual mode. The students were taught about  the life history and teachings of Guru Nanak Dev ji. A serene and calm atmosphere was created by the soothing 'Shabad'.<br/>The session enriched the students with the teachings of Guru Nanak Dev ji.",
    fullDate: "19 November, 2021",
    d: "19",
    m: "Nov",
    y: "2021",
    images: [nov_19_21_1, nov_19_21_2, nov_19_21_3, nov_19_21_4, nov_19_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Virtual Tour - Traffic Park",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya,New Delhi organized a virtual tour of Traffic Park.It was a uniquely designed and interactive online activity wherein the important information regarding traffic rules and regulations was shared with the little learners.The objective was to encourage our young learners to learn basic road safety rules in a  'Fun Way'.They also enjoyed the craft on transportation .It was a fun- filled session enjoyed by learners with great enthusiasm.",
    fullDate: "18 November, 2021",
    d: "18",
    m: "Nov",
    y: "2021",
    images: [nov_18_21_1, nov_18_21_2, nov_18_21_3, nov_18_21_4, nov_18_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Virtual Tour - Traffic Park",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya,New Delhi organized a virtual tour of Traffic Park.It was a uniquely designed and interactive online activity wherein the important information regarding traffic rules and regulations was shared with the little learners.The objective was to encourage our young learners to learn basic road safety rules in a  'Fun Way'.They also enjoyed the craft on transportation .It was a fun- filled session enjoyed by learners with great enthusiasm.",
    fullDate: "18 November, 2021",
    d: "18",
    m: "Nov",
    y: "2021",
    images: [nov_18_21_1, nov_18_21_2, nov_18_21_3, nov_18_21_4, nov_18_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "RHYME-O-MANIA",
    text: "Rhymes enhance the awareness of a child and recitation helps to develop memorization skills. Guided by these thoughts,  Chinmaya Vidyalaya, New Delhi organised Rhyme-O-Mania activity on 15th November 2021 in which the learners had to recite the rhymes sung by their teachers. The little ones came up with different props related to the rhyme of their choice and recited them with great enthusiasm.",
    fullDate: "17 November, 2021",
    d: "17",
    m: "Nov",
    y: "2021",
    images: [nov_17_21_1, nov_17_21_2, nov_17_21_3, nov_17_21_4, nov_17_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Children's Day Celebrations",
    text: "The Mathematics Department of the Primary wing of Chinmaya Vidyalaya, New Delhi organised a virtual trip to Udaipur and Amritsar for the students of Classes I -V to celebrate the occasion of Children's Day. The students of I and II were dressed as tourists while visiting Udaipur and III- V learners were in  Punjabi attire while visiting Amritsar. They went sightseeing ,visited local markets for souvenirs and learnt about  the different festivals, cuisines and folk dances of their respective states. It was an exhilarating experience for the children ,giving them exposure to the cultural diversity of our country.",
    fullDate: "14 November, 2021",
    d: "14",
    m: "Nov",
    y: "2021",
    images: [nov_14_21_1, nov_14_21_2, nov_14_21_3, nov_14_21_4, nov_14_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Ready! Let set go!",
    text: "An online session was conducted by the Pre-Primary Department of Chinmaya Vidyalaya, New Delhi for the little learners. They participated enthusiastically in various games which helped them to balance and increase their concentration span. The children thoroughly enjoyed the activity.",
    fullDate: "13 November, 2021",
    d: "13",
    m: "Nov",
    y: "2021",
    images: [nov_13_21_1, nov_13_21_2, nov_13_21_3, nov_13_21_4, nov_13_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Inter House Art Competition",
    text: "“Art is an expression of internal imagination.“ – Vincent van Gogh<br/> To provide a platform for exploring the creative potential of the Class II learners, a virtual Inter House Pattern Art Competition was organized by Chinmaya Vidyalaya, New Delhi on 9th November 2021. The budding artists showcased their artistic skills by creating vibrant patterns to design the landscape scenery. The young learners participated in the competition with immense zeal and enthusiasm and impressed everyone with their artwork.",
    fullDate: "11 November, 2021",
    d: "11",
    m: "Nov",
    y: "2021",
    images: [nov_11_21_1, nov_11_21_2, nov_11_21_3, nov_11_21_4, nov_11_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Tessellation Patterns",
    text: "Teaching patterns to young learners requires the right tools and activities. This skill in Mathematics serves as an essential foundation in number sense. The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi organised an activity on Patterns for the little learners. While learning it, the learners saw examples of patterns, identified their characteristics and predicted what would come next. This helped them apply that knowledge to other Mathematical situations and also develop their number sense and observation skills.",
    fullDate: "09 November, 2021",
    d: "09",
    m: "Nov",
    y: "2021",
    images: [nov_09_21_1, nov_09_21_2, nov_09_21_3, nov_09_21_4, nov_09_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Awareness that blooms even in a child as young as a Grade I student",
    text: "<div>Ayaana Pandey from grade I pours her understanding of SDGs through a video for the 1 SDG Fest 2021-Bringing SDGs to life. The little wise child surely wins our hearts.</div>",
    fullDate: "08 November, 2021",
    d: "08",
    m: "Nov",
    y: "2021",
    images: ["https://chinmayavvdelhi.ac.in/assets/home/awareness-that-blooms.png"],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://www.youtube.com/embed/6iYCvcko7o8",
  },
  {
    title: "Sewa Session- Rishi Yagna",
    text: "In its endeavour to keep  the light of Sewa burning ,the Primary wing of Chinmaya Vidyalaya ,New Delhi<br>conducted a session to apprise the students about Rishi Yagna and the activity associated with it. This yagna is observed to show reverence to our Spiritual Masters and their teachings.Shlokas from Chapter 12 of Bhagawad Geeta were shared with the students, for them to learn and imbibe . The session was quite  enriching as it provided a deep insight about the Yagna.",
    fullDate: "08 November, 2021",
    d: "08",
    m: "Nov",
    y: "2021",
    images: [nov_08_21_1, nov_08_21_2, nov_08_21_3, nov_08_21_4, nov_08_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "HAPPY DIWALI",
    text: "Tamso Ma Jyotirgamaya<br/>Allow the Inner Light to remove the darkness of ignorance. Deepawali symbolizes positivity, hope and celebrations. Students from Pre-Primary to Senior wing celebrated Diwali with a special online assembly. The celebrations were marked by prayers and obeisance as the world moves towards light from the darkness.  A talk by Swami Chinamayanadaji was the highlight of the Senior School programme.  The  Primary students were encouraged to participate in charity towards the needy which is the true essence of the festival. The motto embraced by the students was : ‘Green Diwali, Clean Diwali’, to mark a pollution free festival. They showcased the spirit of Diwali through bhajans, poems and dance performances which added joy in their celebrations. The young learners of Pre -Primary also celebrated  by enthusiastically participating in the 'Joy of Giving' activities like decorating and gifting diyas.",
    fullDate: "04 November, 2021",
    d: "04",
    m: "Nov",
    y: "2021",
    images: [nov_04_21_1, nov_04_21_2, nov_04_21_3, nov_04_21_4, nov_04_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Puppet and Me",
    text: "The students of Class IV of the Primary wing of  Chinmaya Vidyalaya, New Delhi enjoyed an interesting English activity -'Puppet and me'. The children made a hand puppet of a fairy and presented a dialogue conversation, during which they asked the fairy to fulfil  some of their innermost wishes.The children came up with novel ways to present their act. The activity  was enjoyed by all the students as it provided them with an opportunity to express themselves freely.",
    fullDate: "01 November, 2021",
    d: "01",
    m: "Nov",
    y: "2021",
    images: [nov_01_21_1, nov_01_21_2, nov_01_21_3],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Celebrating Unity- Rashtriya Ekta Diwas",
    text: "As an endeavour to build the bond of oneness and unity, the Primary Wing of Chinmaya Vidyalaya, New Delhi celebrated the birth anniversary of Sardar Vallabhbhai Patel as Rashtriya Ekta Diwas (National Unity Day). A special online assembly was conducted on 29th October in the honour of the Iron Man of India. A biopic on the life of Sardar Vallabhbhai Patel was shared with the learners to highlight the major role of the great leader in the integration of India. They learnt about the diverse traditions and cultures of various states of India through an interactive session. This was followed by a patriotic song and an oath taking ceremony where the teachers and the students pledged to dedicate themselves to preserve the unity, integrity and internal security of the nation. The assembly ended with great enthusiasm with the students promising to strive hard and follow the vision of Sardar Vallabhbhai Patel.",
    fullDate: "31 October, 2021",
    d: "31",
    m: "Oct",
    y: "2021",
    images: [oct_31_21_1, oct_31_21_2, oct_31_21_3, oct_31_21_4, oct_31_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Speech is power: Speech is to persuade,to convert and to compel",
    text: "The Primary Department of Chinmaya Vidyalaya, New Delhi organised an Inter House Declamation Competition for the students of Class IV on the topic-'Technology makes people lonely'.The students participated keenly and expressed their views emphatically ,stressing on the merits and demerits of technology.The activity aimed at honing the oratory skills of the students and provided them with a platform to showcase their talent.",
    fullDate: "29 October, 2021",
    d: "29",
    m: "Oct",
    y: "2021",
    images: [oct_29_21_1, oct_29_21_2, oct_29_21_3],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Fun with colours",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi, organized an “Online Fun with Colours Activity”. The young learners enjoyed watching mixing of colours through an experiment on fun with colourful Cadbury Gems. They also enjoyed the rhyme played during the online session on colours. The learners were able to recognize primary and secondary colours through this activity which enriched their learning.",
    fullDate: "24 October, 2021",
    d: "24",
    m: "Oct",
    y: "2021",
    images: [oct_24_21_1, oct_24_21_2, oct_24_21_3, oct_24_21_4, oct_24_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Orange Day",
    text: "Colours are the smiles of nature, so is the colour Orange. Orange combines the energy of Red and the happiness of Yellow. On 22nd October, 2021 the little learners of Nursery celebrated Orange Day virtually with great zeal at Chinmaya Vidyalaya . They were amazed to create the hues and tints of this colour by blending Red and Yellow. They relished the orange snacks/ fruit / juice which they had and beautified their picture of Pumpkin by dabbing a piece of cotton in Orange colour.  It was a great learning activity which helped the children understand the concept of secondary colours. The kids enjoyed a lot and it was indeed a pleasure to witness little ones dressed up in orange bubbling with energy and fascination.",
    fullDate: "23 October, 2021",
    d: "23",
    m: "Oct",
    y: "2021",
    images: [oct_23_21_1, oct_23_21_2, oct_23_21_3, oct_23_21_4, oct_23_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Clean hands for all",
    text: "Washing hands with soap the right way plays a vital role in preventing a disease. In order to spread this awareness, the Primary Department of Chinmaya Vidyalaya, New Delhi, organized a special session on the occasion of ' Global Handwashing Day' wherein the theme of the day in 2021 and its significance were explained to the students. The students also learnt the message conveyed by the logo, benefits of handwashing and the seven appropriate steps of handwashing. Poster making on the theme of Global Handwashing Day 2021'Our future is at hand- Let's move forward together' reinforced their learning.",
    fullDate: "15 October, 2021",
    d: "15",
    m: "Oct",
    y: "2021",
    images: [oct_15_21_1, oct_15_21_2, oct_15_21_3, oct_15_21_4, oct_15_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Triumph of Good Over Evil",
    text: "Dussehra, a festival to celebrate the victory of good over evil, was celebrated by the students of Pre-Primary Department of Chinmaya Vidyalaya, New Delhi on 12th October 2021 with a lot of religious zeal and fervour. The program began with a prayer and a message on Dussehra. This was followed by “Ram Stuti” bhajan and a story on why we celebrate Dussehra. The celebrations not only enriched the students' learning but also filled the atmosphere with divine adoration.",
    fullDate: "14 October, 2021",
    d: "14",
    m: "Oct",
    y: "2021",
    images: [oct_14_21_1, oct_14_21_2, oct_14_21_3, oct_14_21_4, oct_14_21_5, oct_14_21_6, oct_14_21_7],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Inter House Fitness Challenge",
    text: "The Sports Department of Chinmaya Vidyalaya, New Delhi, organised an online Inter House Fitness Challenge, Feet Touch & Up, for the students of Class I on 6th October 2021 to promote physical activity among children. The competition focused on bending and stretching exercises to promote children’s flexibility. All participants competed with each other with a lot of zeal and fervor.",
    fullDate: "11 October, 2021",
    d: "11",
    m: "Oct",
    y: "2021",
    images: [oct_11_21_2_1, oct_11_21_2_2, oct_11_21_2_3, oct_11_21_2_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Be Active, Be Healthy, Be Happy",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi  celebrated Health Week to educate the children about healthy habits. During the week-long celebrations, the children inculcated the importance of healthy habits in their daily routine. Each day of the week was dedicated to a specific healthy habit. The Day 1 was dedicated to oral health and the learners were taught the right ways of brushing their teeth.The Day 2 focused on personal hygiene and children were encouraged to practice the habit of keeping themselves neat and clean. The Day 3 culminated the Health Week with an early morning yoga online session planned for all kids by our sports teachers.On Day 4, the learners were taught more about healthy eating through a story followed  by a  free-hand drawing on healthy and unhealthy food. The online session on non-fire cooking was conducted to give them the experience of healthy eating.",
    fullDate: "11 October, 2021",
    d: "11",
    m: "Oct",
    y: "2021",
    images: [oct_11_21_1, oct_11_21_2, oct_11_21_3, oct_11_21_4, oct_11_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "हिंदी है भारत की शान, आओ मिलकर बढ़ाए इसका स्वाभिमान।।",
    text: "हरि ओम,<br/>चिन्मय विद्यालय नई दिल्ली,<br/>प्राथमिक विभाग के विद्यार्थियों ने सितंबर मास में आयोजित की गई विविध  गतिविधियों में अत्यन्त उत्साह एवं उमंग के साथ भाग लेकर अपनी प्रतिभा का  उत्तम प्रदर्शन किया । जिससे उनके भाषा कौशल का सम्यक् विकास हुआ। ज्ञानवर्धक एवं रोचक गतिविधियां  छात्रों में हिंदी भाषा के प्रति अनुराग उत्पन्न करने में  सहायक सिद्ध हुईं। प्रमुख गतिविधियाँ कुछ इस प्रकार थी आओ कहानी बुनें, शब्द अंताक्षरी, कठपुतली क्या कहती है?, देखो मेरा देश और कठपुतली द्वारा कहानी वाचन।",
    fullDate: "08 October, 2021",
    d: "08",
    m: "Oct",
    y: "2021",
    images: [oct_08_21_1, oct_08_21_2, oct_08_21_3, oct_08_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Navratri Celebrations",
    text: "Students of Chinmaya Vidyalaya, classes   VI to  XII  welcomed the nine days of Navratri Celebrations with a special assembly. The colourful assembly heralded Ma Durga with an invocation. A poignant  message was conveyed to the students via video by Swami Supriyanandaji for classes VI to VIII and Swami Chinmayanandaji for classes IX to XII. Students came to know about the spiritual, mental and physical wellbeing, which is a part of the festivities.<br/>The children of the Junior department started the assembly with a prayer. They learned about the significance of the day and also enjoyed a Garba dance. A special Devi Prayer was followed by a concluding prayer.",
    fullDate: "07 October, 2021",
    d: "07",
    m: "Oct",
    y: "2021",
    images: [oct_07_21_1, oct_07_21_2, oct_07_21_3, oct_07_21_4, oct_07_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "The World of Animals",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi conducted various activities on ‘Animals’. A number of different integrated activities were planned for the learners. They made beautiful animals with finger painting, origami and clay. These activities not only helped the little ones to improve their eye-hand coordination but also enhanced their fine motor skills and aesthetic sense.",
    fullDate: "06 October, 2021",
    d: "06",
    m: "Oct",
    y: "2021",
    images: [oct_06_21_2_1, oct_06_21_2_2, oct_06_21_2_3, oct_06_21_2_4, oct_06_21_2_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Session on Yagna",
    text: "The Primary Department of Chinmaya Vidyalaya, New Delhi conducted a session on  ' Yagnas' as a part of Sewa activities. The teachers briefed the students about Deva Yagna. The session concluded with the Gayatri Mantra and its benefits.",
    fullDate: "06 October, 2021",
    d: "06",
    m: "Oct",
    y: "2021",
    images: [oct_06_21_1, oct_06_21_2, oct_06_21_3, oct_06_21_4, oct_06_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Gandhi Jayanti Celebration",
    text: "Chinmaya Vidyalaya, Vasant Vihar, celebrated Gandhi Jayanti on the virtual platform with a special assembly on his life, marking it as a day of tribute and veneration. Born on October 2, 1869. The assembly in the Senior Department commenced with an invocation followed by a virtual tour of Sabarmati Ashram. Classes VI - VIII also viewed an informative video on the Salt March held in the year 1931 and an inventive depiction of it in Gyarah Murti, located in the heart of the city. Students of classes IX - XII emersed themselves in  a documentary on the Swadeshi Movement and a talk on non - violence. Follow-up actives were also a part of the day’s programme, which included: poster -making, craftwork with Khadi material and creating PPT. The ever enthusiastic little learners of the  Primary department paid colourful homage to the great leader by putting up a puppet show: Mohan se Mahatma, highlighting some of the incidents from his life. A poem on cleanliness and a soulful bhajan: ‘Raghupati Raghav’ marked the day. An evocative music and dance recital was collated by the cultural department and was the highlight of the programme.",
    fullDate: "03 October, 2021",
    d: "03",
    m: "Oct",
    y: "2021",
    images: [oct_03_21_2_1, oct_03_21_2_2, oct_03_21_2_3, oct_03_21_2_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Gandhi Jayanti Celebration - Pre Primary",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi celebrated Gandhi Jayanti. The little ones were introduced to Gandhi ji and his principles through a story and it was followed by a small talk on Gandhi ji by our young learners. This was followed by a  song “Gandhi ji ke teen Bandar”. The value of cleanliness and the campaign of Swacch Bharat  was imparted in the young learners. The parents clicked the photographs of the children while they were cleaning their toys and bed. An action song depicting how cleanliness is important and how we can keep our surroundings clean was shared with them. The session concluded with an art and craft activity.",
    fullDate: "03 October, 2021",
    d: "03",
    m: "Oct",
    y: "2021",
    images: [oct_03_21_1, oct_03_21_2, oct_03_21_3, oct_03_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "It is the health which is the real wealth",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi conducted an online session for its young learners. The learners participated enthusiastically in various stretching exercises which helped them in increasing their flexibility and improving the stability of body posture. The children thoroughly enjoyed the activity.",
    fullDate: "01 October, 2021",
    d: "01",
    m: "Oct",
    y: "2021",
    images: [oct_01_21_1, oct_01_21_2, oct_01_21_3, oct_01_21_4, oct_01_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Animal Kingdom",
    text: "Fancy dress activity around animal theme is both fun and an opportunity to learn about animals. The Pre – Primary Department of Chinmaya Vidyalaya, New Delhi conducted a fancy dress activity on the theme ‘Animals’. The little ones came dressed up in colourful costumes and enacted their favorite animals. The activity helped the kids use their creativity and imagination. It also strengthened their communication skills.",
    fullDate: "24 September, 2021",
    d: "24",
    m: "Sep",
    y: "2021",
    images: [sep_24_21_1, sep_24_21_2, sep_24_21_3, sep_24_21_4, sep_24_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "The Best Of Virtual Tours",
    text: "The EVS Department of the Primary Wing of Chinmaya Vidyalaya, New Delhi took its students to various places with the help of virtual tours. The students dressed as a tourist and carried their munchies to make their experience feel real. The students enjoyed their trips to South India, Jaipur, Agra and Delhi and explored these places along with the explanation of the various facts associated with them.",
    fullDate: "18 September, 2021",
    d: "18",
    m: "Sep",
    y: "2021",
    images: [sep_18_21_1, sep_18_21_2, sep_18_21_3, sep_18_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "A New Way to Look at Arithmetic",
    text: "<div>Arthmetician Namit Singh presented a new way to look at Arithmatic by adding up the strengths and subtracting the negativities to stop Corona by making a wall and to make our country stand tall.</div>",
    fullDate: "18 October, 2021",
    d: "18",
    m: "Sep",
    y: "2021",
    images: ["https://chinmayavvdelhi.ac.in/assets/home/a-new-way-to-look-at-arithmetic.png"],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://www.youtube.com/embed/hrHERDzvnaI",
  },

  {
    title: "The Best Of Virtual Tours",
    text: "The EVS Department of the Primary Wing of Chinmaya Vidyalaya, New Delhi took its students to various places with the help of virtual tours. The students dressed as a tourist and carried their munchies to make their experience feel real. The students enjoyed their trips to South India, Jaipur, Agra and Delhi and explored these places along with the explanation of the various facts associated with them.",
    fullDate: "18 September, 2021",
    d: "18",
    m: "Sep",
    y: "2021",
    images: [sep_17_21_2_1, sep_17_21_2_2, sep_17_21_2_3, sep_17_21_2_4, sep_17_21_2_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Fun Tour",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi, organised a virtual ‘Fun Tour’. It was a uniquely designed interactive online activity wherein interesting information about our different fun places of Delhi was shared with the young learners. They enjoyed the fun tour with great enthusiasm.",
    fullDate: "17 September, 2021",
    d: "17",
    m: "Sep",
    y: "2021",
    images: [sep_17_21_2_1, sep_17_21_2_2, sep_17_21_2_3, sep_17_21_2_4, sep_17_21_2_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Hop a little, jump a little!",
    text: "The Sports Department of Chinmaya Vidyalaya, New Delhi organised an online Inter House Competition, Jumping Jacks, for the students of Class II on 16th September 2021 to promote fitness amongst the little ones and to make them strong at mind and heart. The competition focused on making the participants achieve the maximum number of jumps within one minute. The enthusiastic participants competed with each other with a lot of zeal and fervor.",
    fullDate: "17 September, 2021",
    d: "17",
    m: "Sep",
    y: "2021",
    images: [sep_17_21_1, sep_17_21_2, sep_17_21_3, sep_17_21_4, sep_17_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "मन की भाषा. प्रेम की भाषा| हिंदी है जन- जन की भाषा||",
    text: "चिन्मय विद्‌यालय, नई दिल्ली के पूर्व प्राथमिक विभाग ने 'हिंदी दिवस' के उपलक्ष्य पर ऑनलाइन कविता पाठ का आयोजन किया। कक्षा नर्सरी और प्रेप के छात्र व छात्राओं ने उत्साहपूर्वक हिन्दी भाषा के प्रति प्रेम को कविताओं के माध्यम से उजागर किया। उनका यह प्रयास अतुलनीय एवं प्रशंसनीय रहा।",
    fullDate: "14 September, 2021",
    d: "14",
    m: "Sep",
    y: "2021",
    images: [sep_14_21_1, sep_14_21_2, sep_14_21_3, sep_14_21_4, sep_14_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Ganpati Bappa Moraya - Pre Primary",
    text: "To seek the blessings of Lord Ganesha, Ganesh Chaturthi was celebrated by the students of Pre- Primary Department of Chinmaya Vidyalaya, New Delhi in a unique way on Friday, 10.09.2021. The students made eco-friendly Ganesha at home. They were explained about the significance of the festival and the importance of eco-friendly ways of celebrating the festival. During the online session, the students performed dance, sang bhajans and shared their views on why Lord Ganesha is their favourite. The celebrations filled the atmosphere with divine adoration. Overall it was a joyful day for all.",
    fullDate: "10 September, 2021",
    d: "10",
    m: "Sep",
    y: "2021",
    images: [sep_10_21_1, sep_10_21_2, sep_10_21_3, sep_10_21_4, sep_10_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: '"You took my hand, opened my mind and touched my heart."',
    text: "The Primary Department of Chinmaya Vidyalaya, New Delhi celebrated Teachers' Day on virtual mode by organizing class parties wherein the students and teachers could interact and have fun over delicious munchies. The students made beautiful greeting cards and expressed their gratitude and love towards their teachers. The students also showcased their talents in different activities by means of a talent hunt. The teachers were honoured with titles and a few words of appreciation.",
    fullDate: "05 September, 2021",
    d: "05",
    m: "Sep",
    y: "2021",
    images: [sep_05_21_2_1, sep_05_21_2_2, sep_05_21_2_3, sep_05_21_2_4, sep_05_21_2_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Wishing All Teachers A Happy Teachers’ Day",
    text: "'Let us remember: one book, one pen, one child, and one teacher can change the world.' - Malala Yousafzai. Teachers’ Day is a special day to mark the birth anniversary of Dr S. Radhakrishnan. On this day students across the nation get together  to thank and remember  teachers who are instrumental in shaping their futures by giving them knowledge, wisdom and leading them  to contribute towards nation building. Students of class XII  showed  their appreciation for their teachers via a special online celebration. It was an  entertaining bouquet of music, dance and individual performances.",
    fullDate: "05 September, 2021",
    d: "05",
    m: "Sep",
    y: "2021",
    images: [sep_05_21_1, sep_05_21_2],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Holistic Development",
    text: "<div>The Vidyalaya offers ample opportunities for holistic development and Avni Pandey&#39;s performance proves the same.</div>",
    fullDate: "01 September, 2021",
    d: "01",
    m: "Sep",
    y: "2021",
    images: ["https://chinmayavvdelhi.ac.in/assets/home/Holistic-Development.png"],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://www.youtube.com/embed/OgNIomWwhoM",
  },
  {
    title: "Janmashatami Celebrations",
    text: "A splendidly colorful program was organized by the Pre-Primary students of Chinmaya Vidyalaya, New Delhi. Dressed up in ethnic wear as Radha and Krishna, the students gathered for the virtual event. The students of Nursery class also made beautiful crowns, makhan matki and flutes which were very dear to our little Krishna. During the online session, the students presented bhajan, performed aarti and did an art & craft activity. The children were made aware of the mythological story on Krishna’s birth through a video.",
    fullDate: "30 August, 2021",
    d: "30",
    m: "Aug",
    y: "2021",
    images: [aug_30_21_2_1, aug_30_21_2_2, aug_30_21_2_3, aug_30_21_2_4, aug_30_21_2_5, aug_30_21_2_6],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Janmashtami - Lord Krishna is born.",
    text: "The birth anniversary of  Lord Krishna is a special day and the Primary and Senior students of  Chinmaya Vidyalaya, New Delhi celebrated it with full mirth and joy. Dressed up in traditional attire the  learners attended virtual assemblies which were an ensemble of beautiful bhajans , prayers and audio visuals on the life and teachings of Lord Krishna. The Primary students were apprised about the significance and  importance of the day. On the other hand the senior students gained deep insight and knowledge on why Shri Krishna took different avatars in different yugas? The celebration was not only entertaining but also enriched the students with different facts related to the festival.",
    fullDate: "30 August, 2021",
    d: "30",
    m: "Aug",
    y: "2021",
    images: [aug_30_21_1, aug_30_21_2, aug_30_21_3, aug_30_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Khel Utsav",
    text: "On the occasion of the National Sports Day, Chinmaya Vidyalaya, New Delhi organized ‘Khel Utsav’. The much-awaited virtual sports event of the Pre-Primary Department made everyone showcase immense enthusiasm as the little athletes stunned everyone with their amazing prowess and energy. They participated in Zumba Dance and Fun physical activities. The parents beamed in delight seeing their kids performing with perfection.",
    fullDate: "29 August, 2021",
    d: "29",
    m: "Aug",
    y: "2021",
    images: [aug_29_21],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/WJ3DyBodB4Y",
  },

  {
    title: "Dance is the hidden language of the soul",
    text: "With the prime purpose of enhancing the dancing skills of the young learners of classes I-II, a virtual Inter House Freestyle Solo Dance Competition was organized by Chinmaya Vidyalaya, New Delhi on 24th August 2021. The theme of the competition was ‘Save Trees, Save Nature’. The graceful dancers, clad in colourful costumes along with appropriate props, whirled and twirled to the music, depicting the plight and pleas of the trees. The promising dancers enthralled the spectators with their enthusiasm and energy. Such competitions are a great way to build coordination, mobility and emotional resilience in children.",
    fullDate: "25 August, 2021",
    d: "25",
    m: "Aug",
    y: "2021",
    images: [aug_25_21_1, aug_25_21_2, aug_25_21_3, aug_25_21_4, aug_25_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Dance is the hidden language of the soul",
    text: "With the prime purpose of enhancing the dancing skills of the young learners of classes I-II, a virtual Inter House Freestyle Solo Dance Competition was organized by Chinmaya Vidyalaya, New Delhi on 24th August 2021. The theme of the competition was ‘Save Trees, Save Nature’. The graceful dancers, clad in colourful costumes along with appropriate props, whirled and twirled to the music, depicting the plight and pleas of the trees. The promising dancers enthralled the spectators with their enthusiasm and energy. Such competitions are a great way to build coordination, mobility and emotional resilience in children.",
    fullDate: "25 August, 2021",
    d: "25",
    m: "Aug",
    y: "2021",
    images: [aug_25_21_1, aug_25_21_2, aug_25_21_3, aug_25_21_4, aug_25_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Curiosity is the very basic of Education",
    text: "A fun-filled and engaging activity ‘Magical Flower Experiment’ was organised on 23rd August, 2021 for the little learners of Chinmaya Vidyalaya, New Delhi.<br/><br/>A few interesting facts were shared with them. The virtual activity was enjoyed by all the learners.",
    fullDate: "24 August, 2021",
    d: "24",
    m: "Aug",
    y: "2021",
    images: [aug_24_21_2_1, aug_24_21_2_2, aug_24_21_2_3, aug_24_21_2_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Blue Day Celebration",
    text: "The Pre - Primary Department of Chinmaya Vidyalaya, New Delhi celebrated the Blue Day on 23rd August,2021. Excitement was visible everywhere. Clad in blue dresses, kids were made to recognize blue colour through a series of activities  to make learning fun for them. Early identification of colours helped to create the cognitive link between visual clues and words which is an important part of a child’s development.",
    fullDate: "24 August, 2021",
    d: "24",
    m: "Aug",
    y: "2021",
    images: [aug_24_21_1, aug_24_21_2, aug_24_21_3, aug_24_21_4, aug_24_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "A Bond of Love, A Bond of Togetherness",
    text: "Rakshabandhan, a much awaited Indian traditional festival was celebrated by the Pre-Primary students of Chinmaya Vidyalaya, New Delhi with full enthusiasm.<br/><br/>The students virtually gathered to celebrate the special day wearing traditional clothes. The students were told about the sacred bond between a brother and a sister through a story, a poem and a traditional song.<br/><br/>The session culminated with an activity of chocolate ladoo making.",
    fullDate: "22 August, 2021",
    d: "22",
    m: "Aug",
    y: "2021",
    images: [aug_22_21_1, aug_22_21_2, aug_22_21_3, aug_22_21_4, aug_22_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "A Bond of Love, A Bond of Togetherness",
    text: "Rakshabandhan, a much awaited Indian traditional festival was celebrated by the Pre-Primary students of Chinmaya Vidyalaya, New Delhi with full enthusiasm.<br/><br/>The students virtually gathered to celebrate the special day wearing traditional clothes. The students were told about the sacred bond between a brother and a sister through a story, a poem and a traditional song.<br/><br/>The session culminated with an activity of chocolate ladoo making.",
    fullDate: "22 August, 2021",
    d: "22",
    m: "Aug",
    y: "2021",
    images: [aug_22_21_1, aug_22_21_2, aug_22_21_3, aug_22_21_4, aug_22_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Kahaniyon Ki Potli",
    text: "The young learners of the Pre-Primary Department enthusiastically participated in the 'Online Kahaniyon Ki Potli Activity' wherein they got an opportunity to exhibit their talent and confidence. The young learners narrated their favourite stories with beautiful props.",
    fullDate: "19 August, 2021",
    d: "19",
    m: "Aug",
    y: "2021",
    images: [aug_19_21_1, aug_19_21_2, aug_19_21_3, aug_19_21_4, aug_19_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "I am the Champion",
    text: "<div>With an objective to enable the students to learn about various concepts from different subjects like Mathematics, English, Social Science and Value Education in a fun filled way, the little champion Jatin Chaudhary created his own game - I am the Champion.</div>",
    fullDate: "16 August, 2021",
    d: "16",
    m: "Aug",
    y: "2021",
    images: ["https://chinmayavvdelhi.ac.in/assets/home/i-am-the-champion.png"],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://www.youtube.com/embed/BkbAtvbkMC8",
  },

  {
    title: "Special Assembly on Independence Day",
    text: "Marking the freedom and glory of  the Nation,the Pre-Primary Department of Chinmaya Vidyalaya,New Delhi organised a special assembly on Independence Day with patriotic fervour and zeal. The students participated in a dance presentation with immense enthusiasm. It was followed by a patriotic song and an informative talk on Independence Day. The children learnt about the significance of this historic day.They were motivated to be an ideal citizen of India.<br/><br/>The virtual assembly culminated with the National Anthem.",
    fullDate: "15 August, 2021",
    d: "15",
    m: "Aug",
    y: "2021",
    images: [aug_15_21],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/rYUd0pRE8Uc",
  },

  {
    title: "Monsoon Magic",
    text: "The Pre – Primary Department of Chinmaya Vidyalaya, New Delhi organized an activity on monsoon season. The students were explained about the beauty of the Monsoon season. The Nursery and Prep children made a collage on rainy season.The children expressed their excitement by showing their colorful umbrellas to their friends and teachers.",
    fullDate: "07 August, 2021",
    d: "07",
    m: "Aug",
    y: "2021",
    images: [aug_07_21_1, aug_07_21_2, aug_07_21_3, aug_07_21_4, aug_07_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Health Experts",
    text: "<div>Surabhi Sameesh from Nur-A shares the secret of her Organic Mantra and finds her way not only to our hearts but also to our kitchens.</div>",
    fullDate: "06 August, 2021",
    d: "06",
    m: "Aug",
    y: "2021",
    images: ["https://chinmayavvdelhi.ac.in/assets/home/health-experts.png"],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://www.youtube.com/embed/vVHDrK3h18w",
  },

  {
    title: "Exploring air and space",
    text: "The EVS Department of Chinmaya Vidyalaya, New Delhi organized an array of S.T.E.M. activities for Classes III-V to allow students to explore concepts beyond their textbooks. Interesting activities on the theme -'My Air ,My Space' were conducted to provide deeper understanding and knowledge about the concept.The students enjoyed making parachutes, fruit rockets, and  phases of the moon on Oreo biscuits.Such hands-on experiential activities not only create interest in the subject but also provide moments of fun and joy.",
    fullDate: "04 August, 2021",
    d: "04",
    m: "Aug",
    y: "2021",
    images: [aug_04_21_1, aug_04_21_2, aug_04_21_3, aug_04_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "SADHANA DIWAS (Gurudev Swami Chinmayanandaji’s Maha Samadhi Day)",
    text: "Chinamaya Vidyalaya, New Delhi observed the pious occasion of Gurudev’s Maha Samadhi as a day of remembrance and prayer. Students from Pre- primary to class XII marked  the occasion with various activities, culminating in an online assembly in the morning. Student’s learned about Gurudev’s contribution towards worldly upliftment, universal knowledge and individual wisdom. Children honoured the day through various endeavours like chanting his 108 names and Arti; writing essay on his vibrant personality; conducting an invigorating class discussion on his philosophy and understanding. The young learner’s participated in listening to stories related to Gurdev’s life, meditating and stringing together a garland to instill faith.In a quiet but determined way the students of the Vidyalaya remembered his message - a legacy to be carried within.",
    fullDate: "03 August, 2021",
    d: "03",
    m: "Aug",
    y: "2021",
    images: [aug_03_21_1, aug_03_21_2, aug_03_21_3, aug_03_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Our Success Stories: 2020-21",
    text: "Here is the list of  the meritorious students from our Vidyalaya who have passed the CBSE class 12 exams with flying colours.<br>Congratulations and we wish you all tremendous success in the coming years. Through you, the lamp of our school will remain forever burning, illuminating the road for others.",
    fullDate: "31 July, 2021",
    d: "31",
    m: "July",
    y: "2021",
    images: [july_31_21],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "When Disaster Strikes...",
    text: "We cannot stop natural disasters but we can arm ourselves with knowledge. With this in mind, a myriad of fun-filled and engaging activities were organised from 26th to 30th July, 2021 on the virtual platform for the learners of classes I and II of Chinmaya Vidyalaya, New Delhi.<br/><br/> Fun projects, activities and games were undertaken to make learning about earthquakes, floods and landslides engaging for the students. They actively participated in the online evacuation drill and prepared a First-Aid box for their family.<br/><br/>The online sessions aimed at making the young learners aware of the ways of preparing themselves for a disaster and how to respond once the immediate danger had passed.",
    fullDate: "31 July, 2021",
    d: "31",
    m: "July",
    y: "2021",
    images: [july_31_21_2_1, july_31_21_2_2, july_31_21_2_3, july_31_21_2_4, july_31_21_2_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Colour of Nature's Heart",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi organized Green Day with great zeal and enthusiasm for the little learners of the Vidyalaya on 30th July ’21. Bubbling with enthusiasm in their vibrant green costumes, the little ones created a pleasant and refreshing aura.",
    fullDate: "31 July, 2021",
    d: "31",
    m: "July",
    y: "2021",
    images: [july_31_21_1, july_31_21_2, july_31_21_3, july_31_21_4, july_31_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Save tigers, Save our national animal",
    text: "Global Tiger Day also known as International Tiger Day is an annual celebration to raise awareness for tiger conservation. The Pre - Primary students of Chinmaya Vidyalaya, New Delhi celebrated the 'World Tiger Day' on 29th July, 2021. The students were shown a video to explain tiger conservation.It was followed by a few interesting facts about tigers and the reasons of their decline.The students and teachers wore different shades of orange or yellow for the session.",
    fullDate: "29 July, 2021",
    d: "29",
    m: "July",
    y: "2021",
    images: [july_29_21_1, july_29_21_2, july_29_21_3, july_29_21_4, july_29_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Chinmaya Vidyalaya - Virtual Tour",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi, organised a virtual tour of ‘Chinmaya Vidyalaya’. It was a uniquely designed interactive online activity wherein interesting information about our Vidyalaya was shared with the young learners. They enjoyed the school tour with great enthusiasm.",
    fullDate: "28 July, 2021",
    d: "28",
    m: "July",
    y: "2021",
    images: [july_28_21_1, july_28_21_2, july_28_21_3, july_28_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Guru: The path towards enlightenment",
    text: "On the auspicious occasion of Guru Purnima, Chinmaya Vidyalaya wishes everyone a day of grace and new possibilities. ‘Guru’ is the supreme, the benevolent and all encompassing. When one finds the true ‘Guru’ then life’s purpose becomes articulated . Students  of the Primary, Middle and Senior wing joined together to pay homage to the Guru . It was a  day marked with prayer, shlokas and colourful activities. Students stated their love and respect for their Gurus through songs and poetry . The true essence of the day was highlighted with help of talks, discussions and it was indeed a truly enriching experience.",
    fullDate: "24 July, 2021",
    d: "24",
    m: "July",
    y: "2021",
    images: [july_24_21_3_1, july_24_21_3_2, july_24_21_3_3, july_24_21_3_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Show and Tell",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi, organised an online Show and Tell activity on the theme ‘Food’. The young learners chose their favourite food items and spoke a few lines about them. They used beautiful props while describing their food items.",
    fullDate: "24 July, 2021",
    d: "24",
    m: "July",
    y: "2021",
    images: [july_24_21_2_1, july_24_21_2_2, july_24_21_2_3, july_24_21_2_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Physical fitness is the most important key to a healthy body.",
    text: "An online session on fitness was conducted for the students of  Pre - Primary Department of Chinmaya Vidyalaya, New Delhi. The young learners performed various balancing exercises and played many balancing games. The children learnt to control and stabilize their body positions. The activity was enjoyed with great enthusiasm by all the children.",
    fullDate: "24 July, 2021",
    d: "24",
    m: "July",
    y: "2021",
    images: [july_24_21_1, july_24_21_2, july_24_21_3, july_24_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Celebrate the taste of summer with the king of fruits.",
    text: "The Primary Department of Chinmaya Vidyalaya, New Delhi celebrated the Mango festival on virtual mode. Dressed in vibrant yellow and green attires with beautiful head gears , the students enjoyed the activities based on mango recipes. The students learnt about the significance of Mango festival, the nutritive value of mangoes and the various ways of consuming it. The activity on the various names of mangoes and the stories of their origin enriched the students with interesting details about them.",
    fullDate: "22 July, 2021",
    d: "22",
    m: "July",
    y: "2021",
    images: [july_22_21_2_1, july_22_21_2_2, july_22_21_2_3, july_22_21_2_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Your body belongs to you",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya,New Delhi organised  an online session on ‘Good touch and bad touch’. It was conducted to make the little ones  aware about their safety.The students understood the concept with the help of a video that was shown to them.  It was followed by a few examples of good touch and bad touch which gave them a better clarity on the concept. A home assignment was also given in which the children were asked to draw a safe circle and paste the picture of their most trusted family member.",
    fullDate: "22 July, 2021",
    d: "22",
    m: "July",
    y: "2021",
    images: [july_22_21_1, july_22_21_2, july_22_21_3, july_22_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Road to Enhance My Senses",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi, planned a SENSORIAL WEEK from 12th July - 15th July to celebrate the gift of senses.",
    fullDate: "17 July, 2021",
    d: "17",
    m: "July",
    y: "2021",
    images: [july_17_21_1, july_17_21_2, july_17_21_3, july_17_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Bhajan – a path to devotion and bliss.",
    text: "Devotional singing induces faith and helps us to imbibe spiritual values. The students of Classes III-V of Chinmaya Vidyalaya , New Delhi showcased their talent in the Inter House Solo “Bhajan Competition” wherein they offered their love to the Almighty by singing  soulful bhajans of Lord Rama, Krishna and Shiva.The melodious chants reverberated in the air producing an aura of peace and tranquility. Participants of each house tried to outdo each other by their spectacular performances. The event helped the students to connect to Indian values and culture.",
    fullDate: "16 July, 2021",
    d: "16",
    m: "July",
    y: "2021",
    images: [july_16_21_2_1, july_16_21_2_2, july_16_21_2_3, july_16_21_2_4, july_16_21_2_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Conserve Water, Conserve Life",
    text: "The learners of the Pre-Primary Department of Chinmaya Vidyalaya, New Delhi, were apprised  about the importance and uses of water. Through a story, the kids were shown the various uses of water and the results of wasting it. The little ones learnt the significance of water and the different ways to save it. This was followed by a craft activity.The children also promised to spread the message of SAVE WATER amongst their family members.",
    fullDate: "16 July, 2021",
    d: "16",
    m: "July",
    y: "2021",
    images: [july_16_21_1, july_16_21_2, july_16_21_3, july_16_21_4, july_16_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Fitness helps us think better, feel better and move better.",
    text: "The Primary Department of Chinmaya Vidyalaya, New Delhi, organized an Inter House Fitness Planks Competition for class V on virtual mode. The fitness enthusiasts displayed a perfect balance of body and stamina during the competition. The participants were adjudged on the basis of perfection in body posture and the time taken. The students learnt to strengthen their spine and the proper posture helped them align their bones.",
    fullDate: "09 July, 2021",
    d: "09",
    m: "July",
    y: "2021",
    images: [july_09_21_1, july_09_21_2, july_09_21_3, july_09_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Tablet Distribution Programme For EWS Students",
    text: "To ensure uninterrupted online education for the EWS  students especially during the challenging times of Covid Pandemic, Delhi Chinmaya Sewa Trust, in association with WIKA, distributed tablets to the EWS  students of  classes VI to XI of Chinmaya Vidyalaya.",
    fullDate: "6-8 July, 2021",
    d: "6-8",
    m: "July",
    y: "2021",
    images: [ews4, ews1, ews2, ews3, ews5, ews6, ews7, ews8, ews9, ews10, ews11, ews12, ews13, ews14, ews15, ews16, ews17],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },

  {
    title: "Red Day Celebration",
    text: "The Pre Primary Department of Chinmaya Vidyalaya, New Delhi celebrated the 'Red Day' with young learners of Nursery. It was a wonderful session which helped the children to sort and classify objects based on colours. The faces of the young learners beamed in delight. The activity helped them sort and classify objects based on colours and reinforced their cognitive skills.",
    fullDate: "02 July, 2021",
    d: "02",
    m: "July",
    y: "2021",
    images: [july_02_21_2_1, july_02_21_2_2, july_02_21_2_3, july_02_21_2_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Let your creative talent sparkle at its zenith.",
    text: "Creativity flourishes in an atmosphere of serenity and liveliness. Classes IV &V of Chinmaya Vidyalaya, New Delhi participated in an Inter House Animal  Mask Making Competition which provided them with a platform to give vent to their  imagination.Masking offers a unique opportunity to have lot of fun and the students dived passionately into the spirit  of healthy competition, creating beautiful animal masks. The ideas and amazing creations of the students were a vivid reflection of their immense talent. The event was an enriching experience that was enjoyed by all.",
    fullDate: "02 July, 2021",
    d: "02",
    m: "July",
    y: "2021",
    images: [july_02_21_1, july_02_21_2, july_02_21_3, july_02_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "National Doctors' Day",
    text: "The Primary Department of Chinmaya Vidyalaya, New Delhi, celebrated 'National Doctors' day' to honour the excellent and selfless services of the front line warriors of the society. The activities enriched the students with information on tools of the doctors and abbreviations used by them in prescriptions. The students also expressed their gratitude to their family doctors by writing a thank you note inside a greeting card. It was an enriching experience for all.",
    fullDate: "01 July, 2021",
    d: "01",
    m: "July",
    y: "2021",
    images: [july_01_21_1, july_01_21_2, july_01_21_3, july_01_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Innovation is where imagination meets ambition.",
    text: "Chinmaya Vidyalaya, New Delhi, organized an Inter House Computer Competition ' Pecha Kucha 2021' for the students of class V of the Primary Department on virtual mode. Guided by the teachers of the computer department and the House Wardens, the participants designed innovative power point presentations on the theme  'Innovation and Life' using 'Pecha Kucha' platform, a Japanese way of storytelling with visuals. <br/><br/>The event introduced the participants to an innovative and extraordinary way of making presentations and enhanced their creative thinking.",
    fullDate: "29 June, 2021",
    d: "29",
    m: "June",
    y: "2021",
    images: [june_29_21_1, june_29_21_2, june_29_21_3, june_29_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Music - The universal language of mankind",
    text: "The  Primary Section and the Senior Section of Chinmaya Vidyalaya, New Delhi, organised virtual sessions to celebrate the World Music Day on 21st June 2021. The vital role of music in the holistic development of the learners was highlighted during the sessions. The promising musicians from the Primary section made the day more musical and melodious by singing along with their music teacher whereas the senior students took everyone to the world of music by sharing information on famous musicians. The special day provided a great opportunity for our budding artists to showcase their talent in the field of music.",
    fullDate: "21 June, 2021",
    d: "21",
    m: "June",
    y: "2021",
    images: [june_21_21_2_1, june_21_21_2_2, june_21_21_2_3],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "International Yoga Day",
    text: "Chinmaya Vidyalaya, New Delhi celebrated International Yoga Day by holding morning yoga sessions from 8th to 21st June 2021. It was attended by the students , parents and staff members. The attendees were able to benefit from the various asanas that they performed during each session. The principles of Yoga were reinforced to prove that a healthy body is the key to a healthy overall sustenance.",
    fullDate: "21 June, 2021",
    d: "21",
    m: "June",
    y: "2021",
    images: [june_21_21_1, june_21_21_2, june_21_21_3],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "A Day with My Daddy",
    text: "The Pre-Primary students of Chinmaya Vidyalaya, in order to make their doting fathers proud and pay filial respect and gratitude, celebrated Father’s Day in a spectacular way. Students made cards as a gift for their beloved fathers and played various games with them strengthening their bond.",
    fullDate: "19 June, 2021",
    d: "19",
    m: "June",
    y: "2021",
    images: [june_19_21_1, june_19_21_2, june_19_21_3, june_19_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "A Slice Of Summer",
    text: "An interesting online session was conducted by the Pre-Primary department,Chinmaya Vidyalaya, New Delhi  for the students. Children were asked to dress in summer clothes while teachers presented various facts about the summer season. Children were also asked to care for the environment and plant more trees to reduce the heat. Children with the help of parents created a delicious Pudding Cake made of sponge cake, mangoes and custard.",
    fullDate: "16 June, 2021",
    d: "16",
    m: "June",
    y: "2021",
    images: [june_16_21_1, june_16_21_2, june_16_21_3, june_16_21_4, june_16_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Gratitude Bestows Reverence",
    text: "Chinmaya Vidyalaya, New Delhi reopened virtually after the summer break on 10th June 2021, with a 'Welcome Assembly' for Classes VI to XII on the theme - Gratitude Bestows Reverence. <br/>The past few months have left a stressful impact on our lives and we feel humbled by the fact that we are able to meet and greet each other. ",
    fullDate: "10 June, 2021",
    d: "10",
    m: "June",
    y: "2021",
    images: [june_10_21_3_1, june_10_21_3_2, june_10_21_3_3, june_10_21_3_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Keep the smile on....",
    text: "The sounds of laughter and joy reverberated through the virtual classrooms of the Primary Department of Chinmaya Vidyalaya, New Delhi, when the students were welcomed back to school after the summer break with an assembly on the theme of happiness. Students shared some interesting insights about what makes them happy. Back in the company of their friends they sang songs, chanted, meditated, enjoyed laughter exercises and short stories on happiness.",
    fullDate: "10 June, 2021",
    d: "10",
    m: "June",
    y: "2021",
    images: [june_10_21_2_1, june_10_21_2_2, june_10_21_2_3, june_10_21_2_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Kiddos Funshala",
    text: "Pre-Primary teachers of Chinmaya Vidyalaya welcomed their young learners after summer vacations with various fun filled activities. Students enjoyed dancing on the tune of the song 'If you are happy and you know it...'. The students shared a happy face emoji to highlight the joy of joining back to the virtual platform. They enjoyed every moment of the assembly that brought happiness and cheer for all.",
    fullDate: "10 June, 2021",
    d: "10",
    m: "June",
    y: "2021",
    images: [june_10_21_1, june_10_21_2, june_10_21_3, june_10_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "World Environment Day",
    text: "On World Environment Day, the young learners of Pre-Primary Department, Chinmaya Vidyalaya, New Delhi promise to fulfil this responsibility by laying emphasis on Reduce, Re-use and Recycle.",
    fullDate: "05 June, 2021",
    d: "05",
    m: "June",
    y: "2021",
    images: [june_05_21],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/D7wCE0lrfDE",
  },

  {
    title: "“The Earth is what we all have in common” - Wendell Berry",
    text: "The Primary Department of Chinmaya Vidyalaya, New Delhi, celebrated the World Environment Day by engaging the learners in a few activities that aimed at spreading awareness for the safety of green planet. The learners enjoyed making the clay model of the Earth, an eco- friendly paper bag, handmade paper using old newspaper and activities based on energy conservation. The activity 'Water Inspectors' was conducted on water conservation. <br/>The activities helped the learners gain information on the ways to conserve the environment.",
    fullDate: "05 June, 2021",
    d: "05",
    m: "June",
    y: "2021",
    images: [june_05_21_1, june_05_21_2, june_05_21_3, june_05_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Gurudev’s 105 Jayanti - Om Bharatagauravaya Namah!",
    text: "On the occasion of Gurudev's Jayanti, the students of Chinmaya Vidyalaya of classes Nursery-XII, delved deeper to understand the true essence of Sewa and cherished Gurudev's  teachings. Our students displayed exemplary mental strength by coming up with ideas, words and creativity that spread positivity and love.<br/> <br/>Chinmaya Vidyalaya, New Delhi also organised a 'Session' on 8th May 2021 based on the theme ‘Om Bharatagauravaya Namah’ to seek Gurudev's blessings and pay humble prostrations at His lotus feet.",
    fullDate: "08 May, 2021",
    d: "08",
    m: "May",
    y: "2021",
    images: [may_08_21_1, may_08_21_2, may_08_21_4, may_08_21_3],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Humble Prostrations At The Feet Of Lord Hanuman",
    text: "Chinmaya Vidyalaya, New Delhi, virtually organised a special session on Hanuman ji on 27th April 2021 to commemorate the auspicious birth of Sri Hanuman, an ardent devotee and eternal servitor of Lord Sri Ramachandra.<br/>The Pre-primary and  Primary school students got an insight into the life and qualities of Lord Hanuman through an informative video presentation. They also chanted prayers. The Middle and Senior school students connected to the occasion by singing bhajans, chanting Hanuman Chalisa, and participating in an interactive discussion on the importance of ‘Faith’ in one’s life.<br/>The auspicious day infused all with the courage to face the difficult times with faith, hope, and optimism.",
    fullDate: "27 April, 2021",
    d: "27",
    m: "April",
    y: "2021",
    images: [april_27_21_1, april_27_21_2, april_27_21_3, april_27_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Let’s restore our planet Earth and value its worth",
    text: "Chinmaya Vidyalaya, New Delhi, celebrated Earth day by conducting a special online assembly for Classes I to XII. <br/>The assembly aimed at making the children aware of the ways of protecting our planet and emphasizing the significance of Reduce,Reuse and Recycle in daily lives. An informative video on 22 inventions all over the world to conserve the planet enriched everyone.<br/><br/>A myriad of activities were undertaken during the assembly to celebrate the day. The Primary students expressed their views on the ways of protecting the planet and made a pencil stand using a can or a bottle. The Middle and Senior school students created awareness by making e-cards, e-posters, planting a tree and analyzing the causes of wetland degradation.The activities helped in spreading awareness on the ways to restore our planet Earth.",
    fullDate: "22 April, 2021",
    d: "22",
    m: "April",
    y: "2021",
    images: [april_22_21_1, april_22_21_2, april_22_21_3, april_22_21_4, april_22_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Together we can Act and Save our Mother Earth",
    text: "In a bid to raise awareness on protecting our Mother Earth, the Pre-Primary children of Chinmaya Vidyalaya, New Delhi took the initiative of spreading the message of 'Together we can Act and Save our Mother Earth'",
    fullDate: "22 April, 2021",
    d: "22",
    m: "April",
    y: "2021",
    images: [april_22_21],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/vBmxxAqGAd4",
  },

  {
    title: "Ram Navami Celebrations",
    text: "To mark the birth of Lord Rama, Chinmaya Vidyalaya, New Delhi, celebrated Ram Navami by conducting special online assembly for classes Nursery to XII. <br/><br/>The assembly aimed at highlighting the relevance of celebrating this auspicious festival. Important virtues learnt from Lord Rama's life, such as obedience, respect and many more were discussed and also the need to imbibe these values, was stressed upon. <br/><br/>A plethora of activities were undertaken during the assembly to celebrate the occasion. The atmosphere was filled with positivity and harmony as the Pre-Primary and Primary students chanted ‘Ram Naam’ 21 times and sang a devotional bhajan on Shri Ram. Students of Middle section expressed their devotion through their drawings of Lord Ram. A discussion on the importance of values in life and respecting parents was undertaken by the Senior students. The multiple activities partaken helped in instilling spiritual and moral values amongst the learners.",
    fullDate: "21 April, 2021",
    d: "21",
    m: "April",
    y: "2021",
    images: [april_21_21_1, april_21_21_2, april_21_21_3, april_21_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Online Orientation of SheCodes Innovation Challenge",
    text: "An Orientation of SheCodes Innovation Challenge was conducted online for the Girl students of Chinmaya Vidyalaya, New Delhi from Classes VI to X on 16th April 2021.<br/><br/>Mr. Neeraj Sharma, Lead Consultant in Learning Links Foundation in association with AIM, NITI Aayog conducted and introduced the session.<br/><br/>SheCodes Innovation Challenge, is an initiative launched by Atal Innovation Mission(AIM), NITI Aayog, Government of India in collaboration with Dell Technologies and Learning Links Foundation to help the girl students to make effective use of the disruptive technology tools available in the ATLs & support them to be at par with their male counterparts.",
    fullDate: "17 April, 2021",
    d: "17",
    m: "April",
    y: "2021",
    images: [april_17_21_1, april_17_21_2, april_17_21_3],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Celebrating Hope, Harmony And Harvest",
    text: "The Primary Department of Chinmaya Vidyalaya, New Delhi, celebrated the harvest festival of Baisakhi on virtual mode. <br/><br/>A special assembly was held and it aimed at apprising the learners of the significance of the festival. An animated video on the history of Baisakhi and discussion on various harvest festivals of India enlivened the session. The learners enjoyed tapping their feet on two punjabi songs. The vibrant punjabi attires of the learners made the dance session a visual treat for the eyes.",
    fullDate: "13 April, 2021",
    d: "13",
    m: "April",
    y: "2021",
    images: [april_13_21_1, april_13_21_2, april_13_21_3, april_13_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Health for All",
    text: "World Health Day was celebrated by the young learners of class Prep on 7th April, 2021. An interactive session was organized for the little ones, wherein the Pre-Primary teachers enacted as grannies and shared the benefits of good health. They emphasized on good eating habits, made healthy fruit salad and also shared the importance of physical exercises. The activity was indeed informative as it touched upon significant facts about good health and well being.",
    fullDate: "08 April, 2021",
    d: "08",
    m: "April",
    y: "2021",
    images: [april_08_21_1, april_08_21_2, april_08_21_3, april_08_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Fun Filled Week",
    text: "To make the last week of the session a memorable one for the young learners, the Pre-primary Department of Chinmaya Vidyalaya, New Delhi organized a 'Fun Filled Week'. <br/><br/>During the week long celebrations, the learners enjoyed various activities like Virtual Tour of Disneyland, Puppet Show, Cooking without Flame and many exciting games along with a class party. They enjoyed these activities with zeal and enthusiasm, sharing their happiness of completing another milestone in their lives.",
    fullDate: "16 March, 2021",
    d: "16",
    m: "Mar",
    y: "2021",
    images: [mar_16_21_1, mar_16_21_2, mar_16_21_3, mar_16_21_4, mar_16_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Buzzing Bees",
    text: "The young learners of the Pre-Primary Department enthusiastically participated in the 'Online Rhyme Recitation Activity' wherein they got an opportunity to exhibit their talent and confidence. They came up with different rhymes and beautiful props on the theme 'Nature'.",
    fullDate: "08 March, 2021",
    d: "08",
    m: "Mar",
    y: "2021",
    images: [mar_08_21_2_1, mar_08_21_2_2, mar_08_21_2_3, mar_08_21_2_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Virtual ATL Community Day",
    text: "Chinmaya Vidyalaya hosted a webinar on ‘Coding and Artificial Intelligence’ on 5th March 2021 which was followed by the announcement of the ATL TinkerFest Results.<br/><br/> Mr Aman Upadhyay, Sr. Innovation Engineer from StemRobo was the educator for the day and several concepts of Artificial Intelligence and Coding were taken up.<br/><br/> Around fifty participants from different Schools joined the webinar and benefitted from the session.",
    fullDate: "08 March, 2021",
    d: "08",
    m: "Mar",
    y: "2021",
    images: [mar_08_21_1, mar_08_21_2, mar_08_21_3],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Indoor Sports Fun Activity Day",
    text: "The Pre -Primary Department of Chinmaya Vidyalaya, New Delhi organized an 'INDOOR SPORTS FUN ACTIVITY DAY' for the energetic young learners. They participated enthusiastically in various events which helped them in building their stamina and agility. It was followed by an activity wherein the parents participated along with their children. It not only made them feel more connected but also strengthened the bond between them.",
    fullDate: "06 March, 2021",
    d: "06",
    m: "Mar",
    y: "2021",
    images: [mar_06_21],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/l2iVwS11Hng",
  },
  {
    title: "The Wonder of Play Dough",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi organized a clay moulding activity for the young learners of Nursery class. They made beautiful aquatic animals using clay. The activity not only helped the little ones to improve their eye-hand coordination but also enhanced their fine motor skills and aesthetic sense.",
    fullDate: "25 February, 2021",
    d: "25",
    m: "Feb",
    y: "2021",
    images: [feb_25_21_1, feb_25_21_2, feb_25_21_3, feb_25_21_4, feb_25_21_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Budding Artists",
    text: "Drawing is a form of visual art which helps to express feelings and exhibit one's artistic talent.<br/><br/>The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi organized an online drawing and colouring activity for the young learners, wherein they drew and coloured beautiful drawings on the theme, 'My Garden'. <br/><br/>The activity not only helped the little ones to improve their eye-hand coordination but also enhanced their concentration power and creativity.",
    fullDate: "18 February, 2021",
    d: "18",
    m: "Feb",
    y: "2021",
    images: [feb_18_21_1, feb_18_21_2, feb_18_21_3, feb_18_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    title: "Yoga: The Mind-Body Connection",
    text: "Chinmaya Vidyalaya, New Delhi, conducted an Inter House Vrikshasana Challenge for the learners of class V. The competition aimed to improve the posture, balance and focus of the learners. The participants performed the asanas with perfection proving their strength and stamina.The agility and equilibrium maintained by the participants of each house during the event was praiseworthy.",
    fullDate: "08 February, 2021",
    d: "08",
    m: "Feb",
    y: "2021",
    images: [feb_08_21_1, feb_08_21_2, feb_08_21_3],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Inter House Baal Geet Competition",
    text: "Chinmaya Vidyalaya, New Delhi organised an Inter House Baal Geet Competition on 30th January, 2021 for the young singers of Classes I and II to showcase their singing talent on a virtual platform. The competition helped in promoting participation, self expression and confidence in the budding artists. The participants from the four houses put forth their enthralling performances, singing the songs with confidence and zest. All the participants left the audience fascinated with their voice modulation and rhythm, which was greatly appreciated by all.",
    fullDate: "30 January, 2021",
    d: "30",
    m: "Jan",
    y: "2021",
    images: [jan_30_21_1, jan_30_21_2, jan_30_21_3],

    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },
  {
    title: "Ready for the New Normal",
    text: "As we enter 2021, adapting into the 'New Normal', we welcome our dear students and usher them in after a long gap. All preparations have been done, precautions have been taken and standards have been met as we start the partial resumption of classes XII and X. We wish our students loads of success and a happy journey into the world of learning.",
    fullDate: "27 January, 2021",
    d: "27",
    m: "Jan",
    y: "2021",
    images: [jan_27_21],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/de28vOZWSUM",
  },

  {
    fullDate: "26 January, 2021",
    title: "Republic Day Celebration - Pre Primary Department",
    text: "The Pre Primary Department of Chinmaya Vidyalaya, New Delhi celebrated Republic Day by conducting a special assembly with great patriotic spirit and fervour. The young learners were informed about many facts associated with the day.",
    d: "26",
    m: "Jan",
    y: "2021",
    images: [jan_01_21],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/jakP0_hN5lE",
  },

  {
    fullDate: "14 January, 2021",
    title: "Special Assembly on Makar Sankranti",
    text: "Chinmaya Vidyalaya, New Delhi organised a special virtual assembly on the auspicious occasion of Makar Sankranti on Thursday 14th January 2021, to welcome the New Year with chanting of the auspicious 'Gayatri Mantra' for 108 times and prayed for the well being of everyone.",
    d: "14",
    m: "Jan",
    y: "2021",
    images: [jan_14_21],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/puAEyTQX9Tc",
  },

  {
    fullDate: "13 January, 2021",
    title: "Chinmaya Vidyalaya wishes 'Happy Lohri' to everyone.",
    text: "The Pre-Primary Department of Chinmaya Vidyalaya, New Delhi celebrated the festival of 'LOHRI' virtually. The significance of this popular Punjabi harvest festival was shared with the young learners through a video. The learners were also briefed about the way this festival is celebrated with bonfire, songs, dances and savouries.",
    d: "13",
    m: "Jan",
    y: "2021",
    images: [jan_13],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/FliLTXgjAN8",
  },

  {
    fullDate: "12 January, 2021",
    title: "Youth in Action - Needs Direction",
    text: "\"You have to grow from inside out. There is no other teacher but your own soul' <br/>This inspirational message from Swami Vivekananda was the very essence of National Youth Day 12th January 2021. <br/>Students from classes I to XII of Chinmaya Vidyalaya, New Delhi celebrated this day with an array of activities to pay tribute to the great leader on his birth anniversary.<br/> An assembly was organized around the theme 'Hum se hai nayi shuruaat', which commenced with a Yoga session after which age appropriate videos of Swami Vivekananda's life were shared with the learners. It was followed by activities like creating slogans, making bookmarks, composing short poems, writing essays, group discussions etc.\"",
    d: "12",
    m: "Jan",
    y: "2021",
    images: [jan_12_21_1, jan_12_21_2, jan_12_21_3, jan_12_21_4],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/puAEyTQX9Tc",
  },
  {
    title: "Geeta Jayanti and Tapovan Jayanti Celebrations",
    text: "Bhagavad Geeta is the source of eternal spiritual wisdom. To mark the birth of the holy book 'Bhagavad Geeta', Chinmaya Vidyalaya, New Delhi, celebrated Geeta Jayanti by conducting online special assembly from Classes I to XII. On this day, Tapovan Jayanti was also observed to commemorate the life and teachings of the great sage Tapovan Maharaj, the 'Guru' of Swami Chinmayanandaji. This day is celebrated as the origin of Bhagwad Geeta as on this day Lord Krishna gave discourse to Arjuna on how to face the challenges of life and perform one's duties with love and affection. The assembly aimed at highlighting the relevance of the teachings of the holy scriptures in the present scenario.",
    fullDate: "25 December 2020",
    d: "25",
    m: "Dec",
    y: "2020",
    images: [geetajayanti1, geetajayanti2, geetajayanti3, geetajayanti4, geetajayanti5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
  {
    fullDate: "4-6 December 2020",
    title: "24th Inter School Geeta Chanting Competition 2020",
    text: "The 24th Inter School Geeta Chanting Competition was held online by Chinmaya Vidyalaya, New Delhi from 4th -6th December 2020.The three-day event witnessed an overwhelming participation of 433 students from 54 schools. The students chanted the verses from Chapter 2 - Sankhya Yog of Bhagwad Geeta which reveals the immortality of soul and importance of karma. A webinar was conducted by Mr. Anil Sachdev, the Chairman, Managing Committee, Chinmaya Vidyalaya, and the Founder of SOIL, The School of Inspired Leadership on ‘Learning Agility: Finding the Roots in Bhagwad Geeta’.  He elaborated on the seven dimensions of Learning Agility that are- Curiosity, Self-Awareness, Mental Agility, People Agility, Adaptability, Resilience and Resourcefulness. It was an enriching webinar where he urged the young generation to find strength and clarity in the timeless teachings of Bhagwad Geeta.",
    d: "4-6",
    m: "Dec",
    y: "2020",
    images: [dec_06_20],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/r8FgELMxjgY",
  },
  {
    title: "Senior Felicitation Ceremony 2020",
    text: "‘Difficult roads often lead to beautiful destinations.’<br/>The senior section of Chinmaya Vidyalaya organized an Online Felicitation Ceremony - 2020 'Prashast Path’ to appreciate and applaud the efforts of the meritorious students.<br/>Dr. Dhananjay Huilgol, Post - Doctoral Fellow at Cold Spring Harbor Laboratory, New York, an Alumnus of Chinmaya Vidyalaya, New Delhi was the Chief Guest of the day.<br/>Mr. Anil Sachdev, Chairman of School Managing Committee, in his address congratulated the Principal, staff, students, and parents for their exemplary teamwork and efforts put in to rise above the crisis and urged the students to invoke the highest in themselves by practicing compassion, gratitude and collaboration to create peaceful hearts. He also highlighted six effective dimensions to become an agile learner which are:  curiosity to learn like a child, honouring one's natural talent, thinking with the whole mind, learning to deal with the people who are in pain, learning how to adapt to different situations and learning to work as a team to face challenging times.<br/>The Principal, Ms. Archana Soni, in her 'Principal's School Report' shared accolades and achievements of the Vidyalaya.<br/>The mesmerising cultural performances by students were appreciated by the parents. The event inspired the students to keep their spirits high even in these unprecedented times.",
    fullDate: "29 November 2020",
    d: "29",
    m: "Nov",
    y: "2020",
    images: [nov_29_20],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/FSLHWnI_qjk",
  },
  {
    title: "Primary Felicitation Ceremony 2020",
    text: "A man cannot discover new oceans unless he has the courage to lose sight of the shore.<br/><br/>The Primary Department of Chinmaya Vidyalaya, New Delhi, organized the Online Annual Felicitation Ceremony-2020 ' Haunsalon Ki Udaan'. Mr. Kapil Singh Director, State Nutrition Mission, Lucknow U.P, an Alumnus of Chinmaya Vidyalaya, New Delhi, graced the occasion as the Chief Guest. The Chairman of the school Management Committee Mr. Anil Sachdev, gave an inspirational address and also complimented the students and staff for their efforts. The Principal, Ms. Archana Soni, in her 'Principal's School Report' shared the accolades and achievements of the Vidyalaya. The credit winners and young achievers were honoured. The mesmerizing cultural programme was widely appreciated by the parents.",
    d: "29",
    m: "Nov",
    y: "2020",
    fullDate: "29 November 2020",
    images: [nov_29_20_2],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/MFf8EpNSjg4",
  },
  {
    fullDate: "3 October 2020",
    title: "Geometrical Yoga",
    text: "The innovative activity of blending yoga with Mathematical angles was organised for class V students of Chinmaya Vidyalaya, New Delhi. The beautiful union of mind, body and Mathematics brought together the physical and mental harmony of the students and the angles created by means of yogic asanas helped them to understand the concepts of different forms of angles .The students were also briefed about the benefits of meditation and Saatvik diet to make the session more informative.A powerpoint presentation  was shared amongst the students ,one day prior to the session to arouse  the curiosity of young learners.",
    d: "03",
    m: "Oct",
    y: "2020",
    images: [yoga1, yoga2, yoga3, yoga4, yoga5, yoga6, yoga7, yoga8, yoga9, yoga10, yoga11, yoga12, yoga13],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
  {
    fullDate: "2 October 2020",
    title: "Spontaneous Overflow of Reverence",
    text: "A video presentation on the bhajan - 'Vaishnav Jan To', amalgamating orchestra, music and dance, showcased the profound emotions of the students.<br/> Chinamaya Vidyalaya, New Delhi offered heartfelt respect to the 'Father of the Nation' on the occasion of Gandhi Jayanti. Bhajans have been a medium of expressing faith since time immemorial.",
    d: "02",
    m: "Oct",
    y: "2020",
    images: [oct_02_20],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/YGRrVFiBhc0",
  },
  {
    fullDate: "14 September 2020",
    title: "Hindi Diwas",
    text: "हरि ॐ १४ सितम्बर- हिन्दी भाषा को राजभाषा के रूप में सम्मानित किया गया। प्रतिवर्ष इस विशेष दिवस को 'हिन्दी दिवस' के रूप में मनाया जाता है।हिंदी भाषा के महत्त्व, उसकी समृद्धि को उजागर करते हुए आज की इस विशेष वेला में चिन्मय  विद्‌यालय , नई दिल्ली के सौजन्य से हिंदी ई-न्यूज लेटर प्रकाशित किया जा रहा है। आशा है हमारा यह प्रयास सराहनीय सिद्ध होगा।",
    d: "14",
    m: "Sep",
    y: "2020",
    images: [sept_14_20],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/dFT22C9kjak",
    download: hindiDiwasPdf,
  },
  {
    fullDate: "15 August 2020",
    title: "Arise, Awake and Stop not till the goal is reached.",
    text: "On the occasion of 74th Independence Day, Chinmaya Vidyalaya, New Delhi, honours every patriot without whom freedom would not have been possible. The staff and students salute their priceless contribution in building independent India and making us proud citizens of this incredible nation.",
    d: "15",
    m: "Aug",
    y: "2020",
    images: [aug_15_20],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/4L_Dqf77z7g",
  },
  {
    fullDate: "15 August 2020",
    title: "Saluting the Tricolour",
    text: "Celebrating the glory of free India and upholding the pride and honour of being an Indian, the Principal of the Chinmaya Vidyalaya, New Delhi, Ms. Archana Soni, unfurled the tricolour for flag hoisting ceremony which concluded with offering salutes to the National flag.",
    d: "15",
    m: "Aug",
    y: "2020",
    images: [aug_15_20_2],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/na1xd-pWD8M",
  },
  {
    fullDate: "03 August 2020",
    title: "Pouring Devotion...  Faith...",
    text: "Chinmaya Vidyalaya, New Delhi put together its efforts to pay homage to Pujya Gurudev Swami Chinmayanandaji on Mahasamadhi Day and brought out a video expressing their undying devotion.",
    d: "03",
    m: "Aug",
    y: "2020",
    images: [aug_03_20],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/aKEtj2X5jjg",
  },
  {
    fullDate: "05 July 2020",
    title: "Guru Purnima",
    text: "Students of Chinmaya Vidyalaya New Delhi bow down in reverence to the entire Guru Parampara and Pujya Gurudev Swami Chinmayanandji on the auspicious occasion of Guru Purnima.",
    d: "05",
    m: "July",
    y: "2020",
    images: [july_05_20],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/YpI4ir6gLPo",
  },
  {
    fullDate: "21 June 2020",
    title: "Learnt about summer Solstice and the concept of solar eclipse",
    text: "On 21st June 2020 the students of Chinmaya Vidyalaya of Classes IV - X learnt about summer Solstice and the concept of solar eclipse by means of a few interesting activities - How to make a pinhole camera, toys from trash and craft activity.",
    d: "21",
    m: "June",
    y: "2020",
    images: [
      june_21_20_1,
      june_21_20_2,
      june_21_20_3,
      june_21_20_4,
      june_21_20_5,
      june_21_20_6,
      june_21_20_7,
      june_21_20_8,
      june_21_20_9,
      june_21_20_10,
      june_21_20_11,
    ],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },

  {
    fullDate: "08 May 2020",
    title: "Lockdown Learning: Message From The Principal",
    text: "A multitude of online scholastic and co-scholastic activities are being conducted under the lockdown, under the guidance of the Principal and teachers. The photos below provide a small glimpse into the activities carried out by the Pre-Primary, Secondary and Senior Secondary students. School buildings may be closed, but the school ecosystem is working harder than ever. The teaching-learning process continues, with a stronger resolve than ever before.",
    d: "08",
    m: "May",
    y: "2020",
    images: [may_08_20_message],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/zPagv4FUUXs",
  },

  {
    fullDate: "08 May 2020",
    title: "Founder's Day",
    text: "Chinmaya Vidyalaya celebrates its 104th Jayanti of our beloved Pujya Gurudev Swami Chinmayanandaji, the Founder's Day of the institutions.",
    d: "08",
    m: "May",
    y: "2020",
    images: [may_08_20],
    isVideo: true,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "https://youtube.com/embed/Z2mKcqX5P0o",
  },

  {
    fullDate: "2 May 2020",
    title: "Healthsetgo - Activity Primary",
    text: "‘To touch, to move, to inspire – this is the true gift of dance.’ Students of Classes I and II put on their dancing shoes on Saturday 2nd May 2020 to participate in an energetic Bollywood Dance Fitness session with choreographer, Ms. Anushruti ",
    d: "02",
    m: "May",
    y: "2020",
    images: [may_02_20_1, may_02_20_2, may_02_20_3, may_02_20_4, may_02_20_5, may_02_20_6],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
  {
    fullDate: "1 May 2020",
    title: "Fun Craft Session by Ms Nishi Srivastava",
    text: "“Art enables us to find ourselves and lose ourselves at the same time.” With this thought in mind, young learners of class l and ll attended an engaging and enjoyable fun craft session conducted by Ms Nishi Srivastava, Founder and CEO of The Craftsutra on 1st May 2020. ",
    d: "01",
    m: "May",
    y: "2020",
    images: [may_01_20_1, may_01_20_2, may_01_20_3, may_01_20_4, may_01_20_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
  {
    fullDate: "30 April 2020",
    title: "Brushing Teeth - Primary",
    text: "For those giggles and pearly whites, students of Classes I and II participated in Talkathon Thursdays’ HealthSetGo initiative on 30th April 2020 to promote proper techniques for washing hands and of maintaining good dental hygiene. The children learnt the basics of washing hands and brushing teeth through a fun-filled live session with Dr. Sarita Agarwal, a dentist.",
    d: "30",
    m: "Apr",
    y: "2020",
    images: [april_30_20_1, april_30_20_2, april_30_20_3, april_30_20_4, april_30_20_5, april_30_20_6],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
  {
    fullDate: "27 April 2020",
    title: "Earth Day",
    text: "Innocent concern manifested itself in form of Pre-primary students of Chinmaya Vidyalaya participating enthusiastically in various activities to commemorate our benevolent Mother Earth on EARTH DAY.",
    d: "27",
    m: "Apr",
    y: "2020",
    images: [april_27_20_1, april_27_20_2, april_27_20_3, april_27_20_4, april_27_20_5],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
  {
    fullDate: "24 April 2020",
    title: "Red Day - Pre Primary",
    text: "The colour of love and smiles illuminates the air with vigour and exuberance. The Pre-Primary wing organized RED DAY on Friday 24th April 2020, for Nursery children. The shades of red made our young learners feel bright, lively and cheerful. ",
    d: "24",
    m: "Apr",
    y: "2020",
    images: [april_24_20_1, april_24_20_2, april_24_20_3, april_24_20_4, april_24_20_5, april_24_20_6],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
  {
    title: "Chinmaya Brigade - Charged  to fight COVID19",
    text: "Students from Chinmaya Vidyalaya unleashed their creativity with the strokes of their brushes on colourful posters creating awareness about COVID 19, showing their solidarity, sense of oneness and responsibility in these trying times.",
    fullDate: "20 April 2020",
    d: "20",
    m: "Apr",
    y: "2020",
    images: [april_20_20_1, april_20_20_2, april_20_20_3, april_20_20_4, april_20_20_5, april_20_20_6, april_20_20_7, april_20_20_8],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
  {
    fullDate: "11 April 2020",
    title: "Action4masks - Mask making activity",
    text: "Care and concern are abstract till the time they find a shape in form of action. The students of the vidyalaya participated in the unique initiative ACTION4MASKS wherein the students made hygienic, homemade masks and distributed it to the people in need.",
    d: "11",
    m: "Apr",
    y: "2020",
    images: [april_11_20_1, april_11_20_2, april_11_20_3, april_11_20_4, april_11_20_5, april_11_20_6],
    isVideo: false,
    shareLink: "https://chinmayavvdelhi.ac.in/school-events/",
    videoSrc: "",
  },
];

export default data;
